// c:\workspace\ila\frontend\src\constants\codelists.ts
export interface CountryOption {
  key: string;
  text: string; // Initially Czech, to be translated to English
}

export const countryOptions: CountryOption[] = [
  { key: "", text: "Neuvedeno" },
  { key: "NZL", text: "NOVÝ ZÉLAND" },
  { key: "FJI", text: "FIDŽI" },
  { key: "PNG", text: "PAPUA NOVÁ GUINEA" },
  { key: "GLP", text: "GUADELOUPE" },
  { key: "STP", text: "SVATÝ TOMÁŠ" },
  { key: "MHL", text: "MARSHALLOVY OSTROVY" },
  { key: "WLF", text: "WALLIS A FUTUNA" },
  { key: "CUB", text: "KUBA" },
  { key: "SDN", text: "SÚDÁN" },
  { key: "GMB", text: "GAMBIE" },
  { key: "MYS", text: "MALAJSIE" },
  { key: "MYT", text: "MAYOTTE" },
  { key: "TWN", text: "TCHAJ-WAN" },
  { key: "POL", text: "POLSKO" },
  { key: "OMN", text: "OMÁN" },
  { key: "SUR", text: "SURINAM" },
  { key: "ARE", text: "SPOJENÉ ARABSKÉ EMIRÁTY" },
  { key: "KEN", text: "KEŇA" },
  { key: "ARG", text: "ARGENTINA" },
  { key: "GNB", text: "GUINEA-BISSAU" },
  { key: "ARM", text: "ARMÉNIE" },
  { key: "UZB", text: "UZBEKISTÁN" },
  { key: "BTN", text: "BHÚTÁN" },
  { key: "SEN", text: "SENEGAL" },
  { key: "TGO", text: "TOGO" },
  { key: "IRL", text: "IRSKO" },
  { key: "FLK", text: "FALKLANDY (MALVÍNY)" },
  { key: "IRN", text: "ÍRÁN" },
  { key: "QAT", text: "KATAR" },
  { key: "BDI", text: "BURUNDI" },
  { key: "NLD", text: "NIZOZEMSKO" },
  { key: "IRQ", text: "IRÁK" },
  { key: "SVK", text: "SLOVENSKO" },
  { key: "SVN", text: "SLOVINSKO" },
  { key: "GNQ", text: "ROVNÍKOVÁ GUINEA" },
  { key: "THA", text: "THAJSKO" },
  { key: "ABW", text: "ARUBA" },
  { key: "ASM", text: "AMERICKÁ SAMOA" },
  { key: "SWE", text: "ŠVÉDSKO" },
  { key: "ISL", text: "ISLAND" },
  { key: "MKD", text: "MAKEDONIE" },
  { key: "BEL", text: "BELGIE" },
  { key: "ISR", text: "IZRAEL" },
  { key: "KWT", text: "KUVAJT" },
  { key: "LIE", text: "LICHTENŠTEJNSKO" },
  { key: "BEN", text: "BENIN" },
  { key: "DZA", text: "ALŽÍRSKO" },
  { key: "ATA", text: "ANTARKTIDA" },
  { key: "RUS", text: "RUSKO" },
  { key: "ATF", text: "FRANCOUZSKÁ JIŽNÍ ÚZEMÍ" },
  { key: "ATG", text: "ANTIGUA A BARBUDA" },
  { key: "ITA", text: "ITÁLIE" },
  { key: "SWZ", text: "SVAZIJSKO" },
  { key: "TZA", text: "TANZANIE" },
  { key: "PAK", text: "PÁKISTÁN" },
  { key: "BFA", text: "BURKINA FASO" },
  { key: "CXR", text: "VÁNOČNÍ OSTROV" },
  { key: "PAN", text: "PANAMA" },
  { key: "SGP", text: "SINGAPUR" },
  { key: "UKR", text: "UKRAJINA" },
  { key: "SGS", text: "JIŽNÍ GEORGIE A JIŽNÍ SANDWICHOVY OSTROVY" },
  { key: "KGZ", text: "KYRGYZSTÁN" },
  { key: "BVT", text: "BOUVETŮV OSTROV" },
  { key: "CHE", text: "ŠVÝCARSKO" },
  { key: "DJI", text: "DŽIBUTSKO" },
  { key: "REU", text: "RÉUNION" },
  { key: "CHL", text: "CHILE" },
  { key: "PRI", text: "PORTORIKO" },
  { key: "CHN", text: "ČÍNA" },
  { key: "PRK", text: "KOREA, LIDOVĚ DEMOKRATICKÁ REPUBLIKA" },
  { key: "MLI", text: "MALI" },
  { key: "BWA", text: "BOTSWANA" },
  { key: "HRV", text: "CHORVATSKO" },
  { key: "KHM", text: "KAMBODŽA" },
  { key: "IDN", text: "INDONÉSIE" },
  { key: "PRT", text: "PORTUGALSKO" },
  { key: "MLT", text: "MALTA" },
  { key: "TJK", text: "TADŽIKISTAN" },
  { key: "VNM", text: "VIETNAM" },
  { key: "CYM", text: "KAJMANSKÉ OSTROVY" },
  { key: "PRY", text: "PARAGUAY" },
  { key: "SHN", text: "SVATÁ HELENA" },
  { key: "CYP", text: "KYPR" },
  { key: "SYC", text: "SEYCHELY" },
  { key: "RWA", text: "RWANDA" },
  { key: "BGD", text: "BANGLADÉŠ" },
  { key: "AUS", text: "AUSTRÁLIE" },
  { key: "AUT", text: "RAKOUSKO" },
  { key: "LKA", text: "SRÍ LANKA" },
  { key: "PSE", text: "PALESTINA" },
  { key: "GAB", text: "GABON" },
  { key: "ZWE", text: "ZIMBABWE" },
  { key: "YUG", text: "JUGOSLÁVIE" },
  { key: "BGR", text: "BULHARSKO" },
  { key: "SYR", text: "SÝRIE" },
  { key: "CZE", text: "ČESKÁ REPUBLIKA" },
  { key: "NOR", text: "NORSKO" },
  { key: "UMI", text: "MENŠÍ ODLEHLÉ OSTROVY USA" },
  { key: "CIV", text: "POBŘEŽÍ SLONOVINY" },
  { key: "MMR", text: "MYANMAR" },
  { key: "TKL", text: "TOKELAU" },
  { key: "KIR", text: "KIRIBATI" },
  { key: "TKM", text: "TURKMENISTÁN" },
  { key: "GRD", text: "GRENADA" },
  { key: "GRC", text: "ŘECKO" },
  { key: "PCN", text: "PITCAIRN" },
  { key: "HTI", text: "HAITI" },
  { key: "GRL", text: "GRÓNSKO" },
  { key: "YEM", text: "JEMEN" },
  { key: "AFG", text: "AFGHÁNISTÁN" },
  { key: "MNE", text: "ČERNÁ HORA" },
  { key: "MNG", text: "MONGOLSKO" },
  { key: "NPL", text: "NEPÁL" },
  { key: "BHS", text: "BAHAMY" },
  { key: "BHR", text: "BAHRAJN" },
  { key: "MNP", text: "SEVERNÍ MARIANY" },
  { key: "GBR", text: "VELKÁ BRITÁNIE" },
  { key: "SJM", text: "SVALBARD A OSTROV JAN MAYEN" },
  { key: "DMA", text: "DOMINIKA" },
  { key: "TLS", text: "VÝCHODNÍ TIMOR" },
  { key: "BIH", text: "BOSNA A HERCEGOVINA" },
  { key: "HUN", text: "MAĎARSKO" },
  { key: "AGO", text: "ANGOLA" },
  { key: "WSM", text: "SAMOA" },
  { key: "FRA", text: "FRANCIE" },
  { key: "MOZ", text: "MOSAMBIK" },
  { key: "NAM", text: "NAMIBIE" },
  { key: "PER", text: "PERU" },
  { key: "DNK", text: "DÁNSKO" },
  { key: "GTM", text: "GUATEMALA" },
  { key: "FRO", text: "FAERSKÉ OSTROVY" },
  { key: "SLB", text: "ŠALAMOUNOVY OSTROVY" },
  { key: "VAT", text: "VATIKÁN" },
  { key: "SLE", text: "SIERRA LEONE" },
  { key: "NRU", text: "NAURU" },
  { key: "AIA", text: "ANGUILLA" },
  { key: "GUF", text: "FRANCOUZSKÁ GUYANA" },
  { key: "SLV", text: "SALVADOR" },
  { key: "GUM", text: "GUAM" },
  { key: "FSM", text: "MIKRONÉSIE" },
  { key: "DOM", text: "DOMINIKÁNSKÁ REPUBLIKA" },
  { key: "CMR", text: "KAMERUN" },
  { key: "GUY", text: "GUYANA" },
  { key: "AZE", text: "AZERBAJDŽÁN" },
  { key: "MAC", text: "MACAO" },
  { key: "GEO", text: "GRUZIE" },
  { key: "TON", text: "TONGA" },
  { key: "NCL", text: "NOVÁ KALEDONIE" },
  { key: "SMR", text: "SAN MARINO" },
  { key: "ERI", text: "ERITREA" },
  { key: "KNA", text: "SVATÝ KRYŠTOF A NEVIS" },
  { key: "MAR", text: "MAROKO" },
  { key: "VCT", text: "SVATÝ VINCENC A GRENADINY" },
  { key: "BLR", text: "BĚLORUSKO" },
  { key: "XXK", text: "KOSOVO" },
  { key: "MRT", text: "MAURITÁNIE" },
  { key: "BLZ", text: "BELIZE" },
  { key: "PHL", text: "FILIPÍNY" },
  { key: "COD", text: "KONGO, DEMOKRATICKÁ REPUBLIKA" },
  { key: "COG", text: "KONGO" },
  { key: "ESH", text: "ZÁPADNÍ SAHARA" },
  { key: "PYF", text: "FRANCOUZSKÁ POLYNÉSIE" },
  { key: "URY", text: "URUGUAY" },
  { key: "COK", text: "COOKOVY OSTROVY" },
  { key: "COM", text: "KOMORY" },
  { key: "COL", text: "KOLUMBIE" },
  { key: "USA", text: "SPOJENÉ STÁTY" },
  { key: "ESP", text: "ŠPANĚLSKO" },
  { key: "EST", text: "ESTONSKO" },
  { key: "BMU", text: "BERMUDY" },
  { key: "MSR", text: "MONTSERRAT" },
  { key: "ZMB", text: "ZAMBIE" },
  { key: "KOR", text: "KOREA" },
  { key: "SOM", text: "SOMÁLSKO" },
  { key: "VUT", text: "VANUATU" },
  { key: "ECU", text: "EKVÁDOR" },
  { key: "ALB", text: "ALBÁNIE" },
  { key: "ETH", text: "ETIOPIE" },
  { key: "MCO", text: "MONAKO" },
  { key: "NER", text: "NIGER" },
  { key: "LAO", text: "LAOS" },
  { key: "VEN", text: "VENEZUELA" },
  { key: "GHA", text: "GHANA" },
  { key: "CPV", text: "KAPVERDY" },
  { key: "MDA", text: "MOLDAVSKO" },
  { key: "MTQ", text: "MARTINIK" },
  { key: "MDG", text: "MADAGASKAR" },
  { key: "SPM", text: "SAINT PIERRE A MIQUELON" },
  { key: "NFK", text: "NORFOLK" },
  { key: "LBN", text: "LIBANON" },
  { key: "LBR", text: "LIBÉRIE" },
  { key: "BOL", text: "BOLÍVIE" },
  { key: "MDV", text: "MALEDIVY" },
  { key: "GIB", text: "GIBRALTAR" },
  { key: "LBY", text: "LIBYE" },
  { key: "HKG", text: "HONGKONG" },
  { key: "CAF", text: "STŘEDOAFRICKÁ REPUBLIKA" },
  { key: "LSO", text: "LESOTHO" },
  { key: "NGA", text: "NIGÉRIE" },
  { key: "MUS", text: "MAURICIUS" },
  { key: "LCA", text: "SVATÁ LUCIE" },
  { key: "JOR", text: "JORDÁNSKO" },
  { key: "GIN", text: "GUINEA" },
  { key: "VGB", text: "BRITSKÉ PANENSKÉ OSTROVY" },
  { key: "CAN", text: "KANADA" },
  { key: "TCA", text: "TURKS A CAICOS" },
  { key: "TCD", text: "ČAD" },
  { key: "AND", text: "ANDORRA" },
  { key: "ROU", text: "RUMUNSKO" },
  { key: "CRI", text: "KOSTARIKA" },
  { key: "IND", text: "INDIE" },
  { key: "MEX", text: "MEXIKO" },
  { key: "SRB", text: "SRBSKO" },
  { key: "KAZ", text: "KAZACHSTÁN" },
  { key: "SAU", text: "SAÚDSKÁ ARÁBIE" },
  { key: "ANT", text: "NIZOZEMSKÉ ANTILY" },
  { key: "JPN", text: "JAPONSKO" },
  { key: "LTU", text: "LITVA" },
  { key: "TTO", text: "TRINIDAD A TOBAGO" },
  { key: "PLW", text: "PALAU" },
  { key: "HMD", text: "HEARDŮV OSTROV A MCDONALDOVY OSTROVY" },
  { key: "MWI", text: "MALAWI" },
  { key: "SSD", text: "JIŽNÍ SÚDÁN" },
  { key: "NIC", text: "NIKARAGUA" },
  { key: "CCK", text: "KOKOSOVÉ OSTROVY" },
  { key: "FIN", text: "FINSKO" },
  { key: "TUN", text: "TUNISKO" },
  { key: "LUX", text: "LUCEMBURSKO" },
  { key: "UGA", text: "UGANDA" },
  { key: "IOT", text: "BRITSKÉ INDICKOOCEÁNSKÉ ÚZEMÍ" },
  { key: "BRA", text: "BRAZÍLIE" },
  { key: "TUR", text: "TURECKO" },
  { key: "BRB", text: "BARBADOS" },
  { key: "TUV", text: "TUVALU" },
  { key: "DEU", text: "NĚMECKO" },
  { key: "EGY", text: "EGYPT" },
  { key: "LVA", text: "LOTYŠSKO" },
  { key: "SCG", text: "SRBSKO A ČERNÁ HORA" },
  { key: "JAM", text: "JAMAJKA" },
  { key: "NIU", text: "NIUE" },
  { key: "VIR", text: "AMERICKÉ PANENSKÉ OSTROVY" },
  { key: "ZAF", text: "JIHOAFRICKÁ REPUBLIKA" },
  { key: "BRN", text: "BRUNEJ DARUSSALAM" },
  { key: "HND", text: "HONDURAS" },
];

export interface FunctionOption {
  key: string;
  text: string;
}

export const functionOptions: FunctionOption[] = [
  { key: "PROKURISTA", text: "Prokurista" },
  { key: "CLEN_PREDSTAVENSTVA", text: "Člen představenstva" },
  { key: "PREDSEDA_PREDSTAVENSTVA", text: "Předseda představenstva" },
  { key: "CLEN_SPRAVNI_RADY", text: "Člen správní rady" },
  { key: "PREDSEDA_SPRAVNI_RADY", text: "Předseda správní rady" },
  { key: "JEDNATEL", text: "Jednatel" },
  { key: "REDAKTOR", text: "Ředitel" },
  { key: "STAROSTA", text: "Starosta" },
  { key: "MISTOSTAROSTA", text: "Místostarosta" },
  { key: "PRIMATOR", text: "Primátor" },
  { key: "NAMESTEK_PRIMATORA", text: "Náměstek primátora" },
  { key: "HEJTMAN", text: "Hejtman" },
  { key: "NAMESTEK_HEJTMANA", text: "Náměstek hejtmana" },
  { key: "VEDOUCI_ORGANIZACNI_SLOZKY", text: "Vedoucí organizační složky" },
  { key: "SPOLECNIK", text: "Společník" },
  { key: "KOMPLEMENTAR", text: "Komplementář" },
  { key: "KOMANDITISTA", text: "Komanditista" },
  { key: "CLEN_DRUZSTVA", text: "Člen družstva" },
  { key: "PREDSEDA_DRUZSTVA", text: "Předseda družstva" },
  { key: "CLEN_KONTROLNI_KOMISE", text: "Člen kontrolní komise" },
  { key: "PREDSEDA_KONTROLNI_KOMISE", text: "Předseda kontrolní komise" },
  {
    key: "CLEN_VYBORU_SPOLECENSTVI_VLASTNIKU",
    text: "Člen výboru společenství vlastníků",
  },
  {
    key: "PREDSEDA_VYBORU_SPOLECENSTVI_VLASTNIKU",
    text: "Předseda výboru společenství vlastníků",
  },
  { key: "POVERENY_VLASTNIK", text: "Pověřený vlastník" },
  { key: "SPRAVCE_NADACE", text: "Správce nadace" },
  { key: "REVIZOR_NADACE", text: "Revizor nadace" },
  { key: "CLEN_DOZORCI_RADY_NADACE", text: "Člen dozorčí rady nadace" },
  { key: "PREDSEDA_DOZORCI_RADY_NADACE", text: "Předseda dozorčí rady nadace" },
  {
    key: "REDAKTOR_OBECNE_PROSPESNE_SPOL",
    text: "Ředitel obecně prospěšné společnosti",
  },
  {
    key: "CLEN_SPRAVNI_RADY_OBECNE_PROSPESNE_SPOL",
    text: "Člen správní rady obecně prospěšné společnosti",
  },
  {
    key: "PREDSEDA_SPRAVNI_RADY_OBECNE_PROSPESNE_SPOL",
    text: "Předseda správní rady obecně prospěšné společnosti",
  },
  {
    key: "CLEN_DOZORCI_RADY_OBECNE_PROSPESNE_SPOL",
    text: "Člen dozorčí rady obecně prospěšné společnosti",
  },
  {
    key: "PREDSEDA_DOZORCI_RADY_OBECNE_PROSPESNE_SPOL",
    text: "Předseda dozorčí rady obecně prospěšné společnosti",
  },
  {
    key: "CLEN_ORGANU_OBOROVE_ZDRAVOTNI_POJISTOVNY",
    text: "Člen orgánu oborové zdravotní pojišťovny",
  },
  {
    key: "PREDSEDA_ORGANU_OBOROVE_ZDRAVOTNI_POJISTOVNY",
    text: "Předseda orgánu oborové zdravotní pojišťovny",
  },
  { key: "REDAKTOR_STATNIHO_PODNIKU", text: "Ředitel státního podniku" },
  {
    key: "CLEN_DOZORCI_RADY_STATNIHO_PODNIKU",
    text: "Člen dozorčí rady státního podniku",
  },
  {
    key: "PREDSEDA_DOZORCI_RADY_STATNIHO_PODNIKU",
    text: "Předseda dozorčí rady státního podniku",
  },
  {
    key: "CLEN_ORGANU_ZAJMOVEHO_SDRUZENI_PRAVNICKYCH_OSOB",
    text: "Člen orgánu zájmového sdružení právnických osob",
  },
  {
    key: "PREDSEDA_ORGANU_ZAJMOVEHO_SDRUZENI_PRAVNICKYCH_OSOB",
    text: "Předseda orgánu zájmového sdružení právnických osob",
  },
  {
    key: "CLEN_ORGANU_POLITICKE_STRANY_NEBO_HNUTI",
    text: "Člen orgánu politické strany nebo hnutí",
  },
  {
    key: "PREDSEDA_ORGANU_POLITICKE_STRANY_NEBO_HNUTI",
    text: "Předseda orgánu politické strany nebo hnutí",
  },
  {
    key: "CLEN_ORGANU_OBČANSKEHO_SDRUZENI",
    text: "Člen orgánu občanského sdružení",
  },
  {
    key: "PREDSEDA_ORGANU_OBČANSKEHO_SDRUZENI",
    text: "Předseda orgánu občanského sdružení",
  },
  {
    key: "CLEN_ORGANU_CIRKVE_NEBO_NABOZENSKE_SPOLECNOSTI",
    text: "Člen orgánu církve nebo náboženské společnosti",
  },
  {
    key: "PREDSEDA_ORGANU_CIRKVE_NEBO_NABOZENSKE_SPOLECNOSTI",
    text: "Předseda orgánu církve nebo náboženské společnosti",
  },
  {
    key: "CLEN_ORGANU_ORGANIZACE_ZAMESTNAVATELU",
    text: "Člen orgánu organizace zaměstnavatelů",
  },
  {
    key: "PREDSEDA_ORGANU_ORGANIZACE_ZAMESTNAVATELU",
    text: "Předseda orgánu organizace zaměstnavatelů",
  },
  {
    key: "CLEN_ORGANU_ODBOROVE_ORGANIZACE",
    text: "Člen orgánu odborové organizace",
  },
  {
    key: "PREDSEDA_ORGANU_ODBOROVE_ORGANIZACE",
    text: "Předseda orgánu odborové organizace",
  },
  { key: "CLEN_ORGANU_HONITBY", text: "Člen orgánu honitby" },
  { key: "PREDSEDA_ORGANU_HONITBY", text: "Předseda orgánu honitby" },
  {
    key: "CLEN_ORGANU_JINE_PRAVNICKE_OSOBY",
    text: "Člen orgánu jiné právnické osoby",
  },
  {
    key: "PREDSEDA_ORGANU_JINE_PRAVNICKE_OSOBY",
    text: "Předseda orgánu jiné právnické osoby",
  },
  { key: "LIKVIDATOR", text: "Likvidátor" },
  { key: "INSOLVENCNI_SPRAVCE", text: "Insolvenční správce" },
  { key: "OPATROVNIK", text: "Opatrovník" },
  { key: "NUCENY_SPRAVCE", text: "Nucený správce" },
  { key: "OSTATNI", text: "Ostatní" },
];

export interface TitleOption {
  key: string;
  text: string;
}

export const titleBeforeOptions: TitleOption[] = [
  { key: "", text: "---" },
  { key: "ak. arch.", text: "ak. arch." },
  { key: "ak. mal.", text: "ak. mal." },
  { key: "ak. soch.", text: "ak. soch." },
  { key: "akad.", text: "akad." },
  { key: "arch.", text: "arch." },
  { key: "Bc.", text: "Bc." },
  { key: "Bc. et Bc.", text: "Bc. et Bc." },
  { key: "Bc. Ing.", text: "Bc. Ing." },
  { key: "Bc. Mgr.", text: "Bc. Mgr." },
  { key: "Bc. MUDr.", text: "Bc. MUDr." },
  { key: "BcA.", text: "BcA." },
  { key: "BTh", text: "BTh" },
  { key: "doc.", text: "doc." },
  { key: "doc. Dr.", text: "doc. Dr." },
  { key: "doc. Dr. Ing.", text: "doc. Dr. Ing." },
  { key: "doc. Ing.", text: "doc. Ing." },
  { key: "doc. Ing. Arch.", text: "doc. Ing. Arch." },
  { key: "doc. JUDr.", text: "doc. JUDr." },
  { key: "doc. Mgr.", text: "doc. Mgr." },
  { key: "doc. MUDr.", text: "doc. MUDr." },
  { key: "doc. MVDr.", text: "doc. MVDr." },
  { key: "doc. PaedDr.", text: "doc. PaedDr." },
  { key: "doc. PhDr.", text: "doc. PhDr." },
  { key: "doc. RNDr.", text: "doc. RNDr." },
  { key: "doc. RSDr.", text: "doc. RSDr." },
  { key: "doc. ThDr.", text: "doc. ThDr." },
  { key: "Dipl.", text: "Dipl." },
  { key: "Dipl. arch.", text: "Dipl. arch." },
  { key: "Dipl. ekon.", text: "Dipl. ekon." },
  { key: "Dipl. fyz.", text: "Dipl. fyz." },
  { key: "Dipl. Ing.", text: "Dipl. Ing." },
  { key: "Dipl. Mng.", text: "Dipl. Mng." },
  { key: "Dipl. spec.", text: "Dipl. spec." },
  { key: "Dipl. tech.", text: "Dipl. tech." },
  { key: "Dipl. um.", text: "Dipl. um." },
  { key: "Dipl.-Jur.", text: "Dipl.-Jur." },
  { key: "Dipl.-Psych.", text: "Dipl.-Psych." },
  { key: "Dott. Arch.", text: "Dott. Arch." },
  { key: "Dr.", text: "Dr." },
  { key: "Dr. Ing.", text: "Dr. Ing." },
  { key: "Dr. Mgr.", text: "Dr. Mgr." },
  { key: "Dr. PhDr.", text: "Dr. PhDr." },
  { key: "emer. prof.", text: "emer. prof." },
  { key: "Ing.", text: "Ing." },
  { key: "Ing. arch.", text: "Ing. arch." },
  { key: "Ing. Bc.", text: "Ing. Bc." },
  { key: "Ing. et Ing.", text: "Ing. et Ing." },
  { key: "Ing. MgA.", text: "Ing. MgA." },
  { key: "Ing. Mgr.", text: "Ing. Mgr." },
  { key: "Ing. MSc.", text: "Ing. MSc." },
  { key: "JUDr.", text: "JUDr." },
  { key: "JUDr. Bc.", text: "JUDr. Bc." },
  { key: "JUDr. Ing.", text: "JUDr. Ing." },
  { key: "JUDr. Mgr.", text: "JUDr. Mgr." },
  { key: "JUDr. PhDr.", text: "JUDr. PhDr." },
  { key: "JUDr. RNDr.", text: "JUDr. RNDr." },
  { key: "JUDr. RSDr.", text: "JUDr. RSDr." },
  { key: "Mag.", text: "Mag." },
  { key: "MDDr.", text: "MDDr." },
  { key: "MDDr. MUDr.", text: "MDDr. MUDr." },
  { key: "MgA.", text: "MgA." },
  { key: "MgA. Ing.", text: "MgA. Ing." },
  { key: "Mgr.", text: "Mgr." },
  { key: "Mgr. Arch.", text: "Mgr. Arch." },
  { key: "Mgr. Art.", text: "Mgr. Art." },
  { key: "Mgr. Bc.", text: "Mgr. Bc." },
  { key: "Mgr. Dr.", text: "Mgr. Dr." },
  { key: "Mgr. et Mgr.", text: "Mgr. et Mgr." },
  { key: "Mgr. Ing.", text: "Mgr. Ing." },
  { key: "Mgr. MgA.", text: "Mgr. MgA." },
  { key: "Mgr. PaedDr.", text: "Mgr. PaedDr." },
  { key: "Mgr. PhDr.", text: "Mgr. PhDr." },
  { key: "Mgr. ThDr.", text: "Mgr. ThDr." },
  { key: "Mons.", text: "Mons." },
  { key: "MSc.", text: "MSc." },
  { key: "MUDr.", text: "MUDr." },
  { key: "MUDr. Bc.", text: "MUDr. Bc." },
  { key: "MUDr. Ing.", text: "MUDr. Ing." },
  { key: "MUDr. Mgr.", text: "MUDr. Mgr." },
  { key: "MUDr. PhDr.", text: "MUDr. PhDr." },
  { key: "MUDr. PhMr.", text: "MUDr. PhMr." },
  { key: "MUDr. RNDr.", text: "MUDr. RNDr." },
  { key: "MVDr.", text: "MVDr." },
  { key: "MVDr. Ing.", text: "MVDr. Ing." },
  { key: "prof.", text: "prof." },
  { key: "prof. doc.", text: "prof. doc." },
  { key: "prof. Dr.", text: "prof. Dr." },
  { key: "prof. Dr. Ing.", text: "prof. Dr. Ing." },
  { key: "prof. Ing.", text: "prof. Ing." },
  { key: "prof. JUDr.", text: "prof. JUDr." },
  { key: "prof. Mgr.", text: "prof. Mgr." },
  { key: "prof. MUDr.", text: "prof. MUDr." },
  { key: "prof. MVDr.", text: "prof. MVDr." },
  { key: "prof. PaedDr.", text: "prof. PaedDr." },
  { key: "prof. PharmDr. Mgr.", text: "prof. PharmDr. Mgr." },
  { key: "prof. PhDr.", text: "prof. PhDr." },
  { key: "prof. RNDr.", text: "prof. RNDr." },
  { key: "prof. RSDr.", text: "prof. RSDr." },
  { key: "prof. ThDr.", text: "prof. ThDr." },
  { key: "prom. fyz.", text: "prom. fyz." },
  { key: "prom. hist.", text: "prom. hist." },
  { key: "prom. mat.", text: "prom. mat." },
  { key: "prom. ped.", text: "prom. ped." },
  { key: "prom. práv.", text: "prom. práv." },
  { key: "PaedDr.", text: "PaedDr." },
  { key: "PaedDr. Dr.", text: "PaedDr. Dr." },
  { key: "PaedDr. Mgr.", text: "PaedDr. Mgr." },
  { key: "Pharm. Mgr.", text: "Pharm. Mgr." },
  { key: "PharmDr.", text: "PharmDr." },
  { key: "PhDr.", text: "PhDr." },
  { key: "PhDr. Dr.", text: "PhDr. Dr." },
  { key: "PhDr. Ing.", text: "PhDr. Ing." },
  { key: "PhDr. MgA.", text: "PhDr. MgA." },
  { key: "PhDr. Mgr.", text: "PhDr. Mgr." },
  { key: "PhDr. Mgr. et Mgr.", text: "PhDr. Mgr. et Mgr." },
  { key: "PhDr. RNDr.", text: "PhDr. RNDr." },
  { key: "PhMr.", text: "PhMr." },
  { key: "PhMr. RNDr.", text: "PhMr. RNDr." },
  { key: "RNDr.", text: "RNDr." },
  { key: "RNDr. Dr.", text: "RNDr. Dr." },
  { key: "RNDr. Ing.", text: "RNDr. Ing." },
  { key: "RNDr. PhDr.", text: "RNDr. PhDr." },
  { key: "RNDr. PhMr.", text: "RNDr. PhMr." },
  { key: "RSDr.", text: "RSDr." },
  { key: "ThB.", text: "ThB." },
  { key: "ThBc.", text: "ThBc." },
  { key: "ThDr.", text: "ThDr." },
  { key: "ThDr. Mgr.", text: "ThDr. Mgr." },
  { key: "ThLic.", text: "ThLic." },
  { key: "ThMgr.", text: "ThMgr." },
];

export const titleAfterOptions: TitleOption[] = [
  { key: "", text: "---" },
  { key: "CSc.", text: "CSc." },
  { key: "DiS.", text: "DiS." },
  { key: "DrSc.", text: "DrSc." },
  { key: "DSc.", text: "DSc." },
  { key: "MBA", text: "MBA" },
  { key: "MBA/MSc", text: "MBA/MSc" },
  { key: "Ph.D.", text: "Ph.D." },
  { key: "Th.D.", text: "Th.D." },
];

export interface AssistanceTypeOption {
  key: string;
  text: string;
}

export const assistanceTypeOptions: AssistanceTypeOption[] = [
  { key: "STANDARD", text: "Standardní asistence" },
  { key: "MAX", text: "Max asistence" },
  { key: "MAX_PLUS", text: "Max Plus asistence" },
];

export interface CityOption {
  key: string;
  text: string;
}

export const cityOptions: CityOption[] = [
  { key: "", text: "" },
  { key: "PRAHA", text: "Praha" },
  { key: "BRNO", text: "Brno" },
  { key: "OSTRAVA", text: "Ostrava" },
  { key: "PLZEN", text: "Plzeň" },
  { key: "LIBEREC", text: "Liberec" },
  { key: "OLOMOUC", text: "Olomouc" },
  { key: "CESKE_BUDEJOVICE", text: "České Budějovice" },
  { key: "HRADEC_KRALOVE", text: "Hradec Králové" },
  { key: "USTI_NAD_LABEM", text: "Ústí nad Labem" },
  { key: "PARDUBICE", text: "Pardubice" },
  { key: "ZLIN", text: "Zlín" },
  { key: "HAVIROV", text: "Havířov" },
  { key: "KLADNO", text: "Kladno" },
  { key: "MOST", text: "Most" },
  { key: "OPAVA", text: "Opava" },
  { key: "FRYDEK_MISTEK", text: "Frýdek-Místek" },
  { key: "KARVINA", text: "Karviná" },
  { key: "JIHLAVA", text: "Jihlava" },
  { key: "TEPLICE", text: "Teplice" },
  { key: "DECIN", text: "Děčín" },
  { key: "KARLOVY_VARY", text: "Karlovy Vary" },
  { key: "CHOMUTOV", text: "Chomutov" },
  { key: "JABLONEC_NAD_NISOU", text: "Jablonec nad Nisou" },
  { key: "MLADA_BOLESLAV", text: "Mladá Boleslav" },
  { key: "PROSTEJOV", text: "Prostějov" },
  { key: "PREROV", text: "Přerov" },
  { key: "TREBIC", text: "Třebíč" },
  { key: "CESKA_LIPA", text: "Česká Lípa" },
  { key: "TRUTNOV", text: "Trutnov" },
];

export const zipToCityMap = {
  "69633": ["Archlebov", "Dražůvky"],
  "69632": ["Ždánice"],
  "69635": ["Dambořice"],
  "69634": ["Uhřice", "Žarošice"],
  "69637": ["Nenkovice", "Želetice"],
  "69636": ["Násedlovice"],
  "69639": ["Lovčice"],
  "69638": ["Strážovice", "Stavěšice"],
  "69641": ["Skoronice", "Vlkoš"],
  "69642": ["Vracov"],
  "69647": ["Žeravice"],
  "16400": ["Praha"],
  "69649": ["Žádovice", "Kelčany"],
  "69648": ["Labuty", "Skalka", "Vřesovice", "Ježov"],
  "69651": ["Kostelec", "Čeložnice"],
  "69650": ["Hýsly", "Moravany"],
  "69655": ["Kyjov"],
  "69661": ["Vnorovy"],
  "69663": ["Tasov", "Kozojídky", "Hroznová Lhota", "Žeraviny"],
  "69662": ["Strážnice", "Tvarožná Lhota"],
  "69665": ["Petrov"],
  "69664": ["Kněždub"],
  "69667": ["Radějov"],
  "69666": ["Sudoměřice"],
  "69671": ["Blatnice pod Svatým Antonínkem", "Blatnička", "Suchov"],
  "69673": ["Hrubá Vrbka", "Kuželov", "Malá Vrbka"],
  "69672": ["Lipov"],
  "41002": [
    "Žabovřesky nad Ohří",
    "Keblice",
    "Malé Žernoseky",
    "Lukavec",
    "Čížkovice",
    "Lhotka nad Labem",
    "Slatina",
    "Lovosice",
    "Velemín",
    "Křesín",
    "Černiv",
    "Úpohlavy",
    "Chotiměř",
    "Libochovice",
    "Evaň",
    "Vchynice",
    "Siřejovice",
    "Chotěšov",
    "Radovesice",
  ],
  "69674": ["Nová Lhota", "Velká nad Veličkou", "Javorník", "Suchov"],
  "69676": ["Louka"],
  "69681": ["Bzenec"],
  "69683": ["Domanín"],
  "69685": ["Bzenec", "Moravský Písek"],
  "53301": ["Pardubice"],
  "69684": ["Těmice", "Syrovín"],
  "53303": ["Dašice"],
  "53304": ["Choteč", "Újezd u Sezemic", "Sezemice", "Kunětice", "Rokytno"],
  "53305": ["Dříteč"],
  "61500": ["Brno"],
  "53311": ["Zdechovice"],
  "53312": ["Kojice", "Chvaletice"],
  "53313": ["Řečany nad Labem", "Zdechovice"],
  "53314": ["Kladruby nad Labem"],
  "53315": ["Hlavečník"],
  "53316": [
    "Malé Výkleky",
    "Tetov",
    "Vápno",
    "Újezd u Přelouče",
    "Strašov",
    "Žáravice",
    "Kladruby nad Labem",
    "Sopřeč",
    "Chýšť",
    "Přepychy",
  ],
  "69701": ["Věteřov", "Kyjov", "Sobůlky"],
  "73801": ["Staré Město", "Frýdek-Místek"],
  "53321": ["Vysoké Chvojno"],
  "53322": ["Býšť"],
  "77900": [
    "Samotišky",
    "Bystročice",
    "Daskabát",
    "Krčmaň",
    "Olomouc",
    "Bystrovany",
    "Bukovany",
  ],
  "53332": ["Čepí"],
  "53333": ["Pardubice"],
  "53341": [
    "Živanice",
    "Vyšehněvice",
    "Neratov",
    "Bukovka",
    "Voleč",
    "Kasalice",
    "Lázně Bohdaneč",
    "Přelovice",
    "Černá u Bohdanče",
    "Křičeň",
    "Rohoznice",
    "Vlčí Habřina",
    "Pravy",
  ],
  "53342": ["Živanice"],
  "53343": ["Rohovládova Bělá"],
  "53344": ["Staré Ždánice"],
  "53345": [
    "Opatovice nad Labem",
    "Dolany",
    "Libišany",
    "Srch",
    "Čeperka",
    "Plch",
    "Podůlšany",
    "Staré Ždánice",
    "Stéblová",
  ],
  "53351": ["Pardubice"],
  "53352": [
    "Němčice",
    "Srch",
    "Čeperka",
    "Pardubice",
    "Hrobice",
    "Bukovina nad Labem",
    "Ráby",
    "Staré Hradiště",
  ],
  "53353": ["Pardubice"],
  "53354": ["Rybitví"],
  "53361": ["Choltice"],
  "53362": ["Svojšice"],
  "53363": ["Turkovice"],
  "16500": ["Praha"],
  "53364": ["Lipoltice"],
  "53371": ["Dolní Roveň"],
  "53372": ["Moravany"],
  "53373": ["Uhersko"],
  "53374": ["Horní Jelení"],
  "53375": ["Horní Ředice", "Dolní Ředice"],
  "28802": [
    "Nymburk",
    "Všechlapy",
    "Dvory",
    "Budiměřice",
    "Krchleby",
    "Netřebice",
    "Jizbice",
    "Kovanice",
    "Kamenné Zboží",
  ],
  "37001": [
    "Planá",
    "Rudolfov",
    "Vráto",
    "Závraty",
    "České Budějovice",
    "Boršov nad Vltavou",
    "Litvínovice",
    "Vrábče",
    "Homole",
    "Hradce",
  ],
  "37002": ["České Budějovice"],
  "37004": ["České Budějovice"],
  "37005": ["České Budějovice"],
  "41101": ["Píšťany", "Žalhostice"],
  "37006": [
    "Borovnice",
    "Staré Hodějovice",
    "Ledenice",
    "Heřmaň",
    "Srubec",
    "Dubičné",
    "České Budějovice",
    "Doubravice",
    "Nová Ves",
    "Dobrá Voda u Českých Budějovic",
    "Nedabyle",
  ],
  "37007": [
    "Borovnice",
    "Heřmaň",
    "Římov",
    "Doudleby",
    "Kamenný Újezd",
    "Plav",
    "Vidov",
    "Roudné",
    "České Budějovice",
    "Doubravice",
    "Nedabyle",
  ],
  "41103": ["Libochovany"],
  "37008": [
    "Staré Hodějovice",
    "České Budějovice",
    "Doubravice",
    "Nová Ves",
    "Nedabyle",
  ],
  "37010": ["Úsilné", "Hrdějovice", "České Budějovice"],
  "37011": ["České Budějovice"],
  "41108": [
    "Budyně nad Ohří",
    "Štětí",
    "Hoštka",
    "Snědovice",
    "Bechlín",
    "Račice",
    "Úštěk",
  ],
  "41111": ["Sulejovice"],
  "41112": ["Čížkovice"],
  "41113": ["Třebenice"],
  "53401": [
    "Časy",
    "Chvojenec",
    "Moravany",
    "Trusnov",
    "Horní Jelení",
    "Holice",
    "Jaroslav",
    "Rokytno",
    "Ostřetín",
    "Poběžovice u Holic",
    "Veliny",
    "Radhošť",
    "Uhersko",
    "Borek",
    "Býšť",
  ],
  "41114": ["Vlastislav"],
  "41115": [
    "Třebívlice",
    "Jenčice",
    "Podsedice",
    "Chodovlice",
    "Lkáň",
    "Dlažkovice",
    "Sedlec",
    "Třebenice",
    "Děčany",
  ],
  "41116": ["Klapý"],
  "41117": ["Libochovice"],
  "41118": ["Budyně nad Ohří"],
  "41119": ["Mšené-lázně", "Martiněves"],
  "41120": ["Mšené-lázně"],
  "61600": ["Brno"],
  "41121": ["Vrbičany"],
  "69801": ["Veselí nad Moravou"],
  "41131": ["Velemín"],
  "41132": ["Velemín"],
  "73901": ["Staré Město", "Baška"],
  "41133": ["Prackovice nad Labem"],
  "73904": ["Morávka", "Raškovice", "Krásná", "Pražmo"],
  "41141": ["Žitenice"],
  "41142": ["Ploskovice"],
  "73911": [
    "Malenovice",
    "Janovice",
    "Pstruží",
    "Frýdlant nad Ostravicí",
    "Pržno",
  ],
  "73913": ["Kunčice pod Ondřejníkem"],
  "41145": [
    "Chotiněves",
    "Levín",
    "Lovečkovice",
    "Polepy",
    "Drahobuz",
    "Liběšice",
    "Horní Řepčice",
    "Úštěk",
  ],
  "73912": ["Čeladná"],
  "41146": ["Liběšice"],
  "73915": ["Bílá", "Staré Hamry"],
  "41147": ["Polepy", "Vrutice"],
  "73914": ["Ostravice"],
  "41148": ["Křešice"],
  "73921": ["Paskov"],
  "73923": ["Stará Ves nad Ondřejnicí"],
  "41155": ["Terezín"],
  "41156": ["Bohušovice nad Ohří"],
  "73925": ["Žabeň", "Sviadnov"],
  "73924": ["Krmelín", "Ostrava", "Stará Ves nad Ondřejnicí"],
  "41162": ["Snědovice"],
  "41164": ["Vrbice"],
  "73932": ["Řepiště", "Ostrava", "Vratimov"],
  "73934": ["Václavovice", "Ostrava", "Šenov"],
  "73937": ["Žermanice", "Horní Bludovice"],
  "73936": ["Bruzovice", "Sedliště", "Kaňovice"],
  "73939": ["Lučina"],
  "41171": ["Chodouny"],
  "73938": ["Soběšovice", "Dolní Domaslavice"],
  "41172": ["Hoštka"],
  "73941": ["Palkovice"],
  "41173": ["Štětí"],
  "41174": ["Snědovice"],
  "73943": ["Staříč"],
  "73942": ["Frýdek-Místek"],
  "73945": ["Fryčovice"],
  "73944": ["Brušperk"],
  "73947": ["Kozlovice", "Lhotka", "Palkovice"],
  "73946": ["Hukvaldy", "Fryčovice"],
  "73949": ["Metylovice"],
  "41181": ["Brozany nad Ohří"],
  "41182": ["Doksany"],
  "73951": [
    "Pazderna",
    "Dobrá",
    "Horní Domaslavice",
    "Vojkovice",
    "Dobratice",
    "Nošovice",
    "Nižní Lhoty",
    "Vyšní Lhoty",
  ],
  "41183": ["Hrobce", "Židovice"],
  "41184": ["Straškov-Vodochody"],
  "73953": [
    "Komorní Lhotka",
    "Dolní Tošanovice",
    "Dobratice",
    "Hnojník",
    "Horní Tošanovice",
    "Třanovice",
  ],
  "41185": ["Horní Beřkovice"],
  "41186": ["Bechlín"],
  "73955": ["Smilovice", "Třinec", "Řeka"],
  "41187": ["Krabčice"],
  "28901": ["Chotěšice", "Dymokury", "Činěves", "Velenice"],
  "28902": ["Chroustov", "Chotěšice", "Kněžice"],
  "73959": ["Střítež", "Vělopolí"],
  "28903": [
    "Sloveč",
    "Chroustov",
    "Záhornice",
    "Kněžičky",
    "Chotěšice",
    "Podmoky",
    "Dlouhopolsko",
    "Kněžice",
    "Kolaje",
    "Městec Králové",
  ],
  "28904": [
    "Vrbice",
    "Podmoky",
    "Vlkov pod Oškobrhem",
    "Okřínek",
    "Kolaje",
    "Opočnice",
  ],
  "73961": ["Ropice", "Třinec"],
  "28905": ["Hradčany", "Choťovice", "Dobšice", "Žehuň"],
  "33001": ["Kyšice"],
  "28906": ["Sány", "Opolany"],
  "33002": ["Dýšina"],
  "28907": ["Libice nad Cidlinou", "Opolany", "Odřepsy"],
  "33003": ["Chrást"],
  "28908": ["Kněžičky", "Běrunice"],
  "33005": ["Dobříč"],
  "28911": [
    "Dobřichov",
    "Milčice",
    "Tatce",
    "Radim",
    "Vrbová Lhota",
    "Ratenice",
    "Pečky",
  ],
  "33007": ["Druztová"],
  "28912": ["Hradištko", "Třebestovice", "Kostelní Lhota", "Sadská", "Velenka"],
  "33008": ["Zruč-Senec"],
  "28913": ["Nymburk", "Hořátev", "Zvěřínek", "Písty"],
  "41201": [
    "Chotiněves",
    "Lovečkovice",
    "Bohušovice nad Ohří",
    "Hrobce",
    "Staňkovice",
    "Kamýk",
    "Terezín",
    "Michalovice",
    "Oleško",
    "Malíč",
    "Litoměřice",
    "Liběšice",
    "Travčice",
    "Chudoslavice",
    "Žitenice",
    "Libochovany",
    "Křešice",
    "Úštěk",
    "Libotenice",
    "Trnovany",
    "Brňany",
    "Velké Žernoseky",
    "Miřejovice",
    "Třebušín",
    "Býčkovice",
    "Ploskovice",
    "Polepy",
    "Mlékojedy",
    "Hlinná",
  ],
  "28914": ["Chrást", "Poříčany", "Hořany"],
  "28915": ["Bříství", "Vykáň", "Černíky", "Kounice"],
  "33011": [
    "Tatiná",
    "Dolany",
    "Příšov",
    "Nevřeň",
    "Česká Bříza",
    "Třemošná",
    "Hromnice",
    "Nadryby",
    "Žilov",
    "Všeruby",
  ],
  "28916": ["Přerov nad Labem", "Starý Vestec"],
  "33012": ["Horní Bříza", "Dobříč"],
  "28917": ["Semice"],
  "33013": ["Trnová", "Krašovice"],
  "33014": ["Ledce"],
  "33016": ["Všeruby"],
  "28921": ["Kostomlaty nad Labem", "Kostomlátky"],
  "33017": ["Chotíkov"],
  "28922": ["Ostrá", "Stratov", "Lysá nad Labem", "Stará Lysá", "Jiřice"],
  "28923": ["Milovice"],
  "28924": ["Milovice"],
  "73981": ["Košařiska", "Milíkov"],
  "28925": ["Straky", "Zbožíčko", "Čilec"],
  "33021": ["Líně"],
  "53501": [
    "Jankovice",
    "Brloh",
    "Stojice",
    "Kladruby nad Labem",
    "Jedousov",
    "Trnávka",
    "Urbanice",
    "Jeníkovice",
    "Mokošín",
    "Litošice",
    "Přelouč",
    "Selmice",
    "Semín",
    "Lipoltice",
    "Chrtníky",
    "Turkovice",
    "Sovolusky",
    "Veselí",
    "Svinčany",
    "Valy",
    "Bezděkov",
    "Choltice",
    "Řečany nad Labem",
    "Bukovina u Přelouče",
    "Morašice",
    "Holotín",
    "Zdechovice",
    "Břehy",
    "Poběžovice u Přelouče",
  ],
  "28926": ["Stará Lysá"],
  "33022": ["Zbůch"],
  "33023": [
    "Lochousice",
    "Hněvnice",
    "Kostelec",
    "Úherce",
    "Nýřany",
    "Přehýšov",
    "Zbůch",
    "Heřmanova Huť",
    "Myslinka",
    "Rochlov",
    "Kbelany",
    "Vochov",
  ],
  "33024": ["Heřmanova Huť"],
  "73985": ["Bukovec"],
  "33025": ["Blatnice"],
  "73984": ["Písek"],
  "33026": ["Tlučná"],
  "28931": ["Chleby", "Bobnice"],
  "33027": ["Vejprnice"],
  "28932": ["Nový Dvůr", "Jíkev", "Oskořínek", "Hrubý Jeseník"],
  "61700": ["Brno"],
  "28933": ["Vestec", "Křinec", "Loučeň"],
  "28934": ["Košík", "Chotěšice", "Seletice", "Rožďalovice", "Žitovlice"],
  "73991": ["Jablunkov", "Písečná", "Bocanovice", "Dolní Lomná", "Horní Lomná"],
  "28935": ["Košík"],
  "28936": ["Mcely"],
  "33032": ["Kozolupy", "Bdeněves"],
  "28937": ["Loučeň"],
  "33033": [
    "Újezd nade Mží",
    "Město Touškov",
    "Čeminy",
    "Pňovany",
    "Úlice",
    "Plešnice",
  ],
  "73992": ["Návsí"],
  "73995": ["Nýdek", "Bystřice", "Vendryně"],
  "33035": ["Kunějovice", "Úněšov", "Zahrádka", "Líšťany", "Všeruby"],
  "73994": ["Třinec", "Vendryně"],
  "33036": [
    "Ostrov u Bezdružic",
    "Úněšov",
    "Pernarec",
    "Křelovice",
    "Čerňovice",
  ],
  "73997": ["Hrádek"],
  "28941": ["Pňov-Předhradí", "Oseček"],
  "33038": ["Ostrov u Bezdružic", "Úněšov", "Zahrádka", "Blažim", "Krsy"],
  "73998": ["Mosty u Jablunkova", "Hrčava"],
  "33040": ["Úterý"],
  "33041": ["Úterý", "Bezvěrov"],
  "29001": [
    "Úmyslovice",
    "Kouty",
    "Sokoleč",
    "Pátek",
    "Písková Lhota",
    "Choťánky",
    "Okřínek",
    "Křečkov",
    "Poděbrady",
    "Senice",
  ],
  "33101": ["Plasy", "Hvozd", "Pláně", "Dražeň"],
  "41301": [
    "Budyně nad Ohří",
    "Kostomlaty pod Řípem",
    "Dobříň",
    "Nové Dvory",
    "Račiněves",
    "Mšené-lázně",
    "Dušníky",
    "Kyškovice",
    "Rochov",
    "Vědomice",
    "Černouček",
    "Dolánky nad Ohří",
    "Záluží",
    "Černěves",
    "Chodouny",
    "Libkovice pod Řípem",
    "Bříza",
    "Martiněves",
    "Ctiněves",
    "Krabčice",
    "Brozany nad Ohří",
    "Brzánky",
    "Roudnice nad Labem",
    "Kleneč",
    "Vrbice",
    "Mnetěš",
    "Vrutice",
    "Přestavlky",
    "Vražkov",
  ],
  "61800": ["Brno"],
  "74101": [
    "Starý Jičín",
    "Hostašovice",
    "Nový Jičín",
    "Bernartice nad Odrou",
    "Jeseník nad Odrou",
  ],
  "33141": [
    "Bohy",
    "Kozojedy",
    "Výrov",
    "Mladotice",
    "Bílov",
    "Holovousy",
    "Štichovice",
    "Pláně",
    "Hlince",
    "Kožlany",
    "Vysoká Libyně",
    "Slatina",
    "Liblín",
    "Všehrdy",
    "Chříč",
    "Brodeslavy",
    "Kopidlo",
    "Sedlec",
    "Bujesily",
    "Kočín",
    "Potvorov",
    "Kralovice",
    "Studená",
    "Černíkovice",
  ],
  "33144": ["Kožlany"],
  "33151": [
    "Jarov",
    "Kaznějov",
    "Dobříč",
    "Koryta",
    "Kaceřov",
    "Rybnice",
    "Obora",
    "Dolní Hradiště",
  ],
  "33152": [
    "Líté",
    "Dolní Bělá",
    "Bučí",
    "Horní Bělá",
    "Loza",
    "Nekmíř",
    "Mrtník",
  ],
  "33162": ["Manětín", "Nečtiny", "Krsy"],
  "33165": ["Velečín", "Pastuchovice", "Tis u Blatna", "Žihle"],
  "70030": ["Ostrava"],
  "25001": [
    "Čakovičky",
    "Brandýs nad Labem-Stará Boleslav",
    "Zápy",
    "Dřevčice",
  ],
  "33201": ["Lhůta", "Tymákov", "Mokrouše"],
  "33202": ["Starý Plzenec"],
  "33203": ["Šťáhlavy"],
  "33204": [
    "Nebílovy",
    "Netunice",
    "Milínov",
    "Nezbavětice",
    "Vlčtejn",
    "Nezvěstice",
    "Šťáhlavy",
    "Chlum",
    "Chválenice",
    "Losiná",
    "Žákava",
  ],
  "33205": ["Chválenice"],
  "37301": ["Temelín"],
  "37302": ["Všemyslice"],
  "33207": ["Střížovice"],
  "37304": ["Chrášťany"],
  "33209": ["Štěnovice", "Štěnovický Borek", "Čižice", "Útušice", "Předenice"],
  "37305": ["Temelín"],
  "33211": ["Hradec"],
  "33214": ["Chotěšov"],
  "37311": ["Ledenice"],
  "37312": ["Jílovice", "Ledenice", "Strážkovice", "Borovany", "Mladošovice"],
  "37314": ["Strážkovice", "Komařice"],
  "37315": ["Nová Ves"],
  "37316": ["Srubec", "Dobrá Voda u Českých Budějovic"],
  "53701": [
    "Rabštejnská Lhota",
    "Třibřichy",
    "Lány",
    "Chrudim",
    "Sobětuchy",
    "Slatiňany",
    "Tuněchody",
    "Dřenice",
    "Orel",
  ],
  "53703": ["Chrudim"],
  "37321": ["Slavče"],
  "53705": ["Chrudim"],
  "37322": ["Ločenice"],
  "37323": ["Svatý Jan nad Malší"],
  "37324": ["Římov"],
  "61900": ["Brno"],
  "37331": ["Olešnice"],
  "37332": ["Jílovice"],
  "37333": ["Nové Hrady"],
  "37335": ["Horní Stropnice"],
  "37336": ["Horní Stropnice"],
  "74201": ["Suchdol nad Odrou"],
  "78301": ["Olomouc"],
  "37341": [
    "Pištín",
    "Hosín",
    "Dasný",
    "Břehov",
    "Hluboká nad Vltavou",
    "Strýčice",
    "Radošovice",
    "Vlkov",
    "Drahotěšice",
    "Čejkovice",
    "Dolní Bukovsko",
    "Hrdějovice",
    "Dubné",
    "Sedlec",
    "Olešník",
    "Žabovřesky",
  ],
  "37343": ["Hluboká nad Vltavou"],
  "37344": ["Zliv"],
  "78305": ["Horní Loděnice"],
  "37346": ["Pištín"],
  "78307": ["Město Libavá"],
  "37347": ["Sedlec"],
  "78306": ["Hraničné Petrovice", "Domašov nad Bystřicí"],
  "37348": [
    "Dívčice",
    "Hlavatce",
    "Sedlec",
    "Dříteň",
    "Mydlovary",
    "Zahájí",
    "Nákří",
  ],
  "74213": ["Bartošovice", "Studénka"],
  "25061": ["Zápy"],
  "37349": ["Mydlovary"],
  "37350": ["Olešník"],
  "25063": [
    "Brázdim",
    "Mratín",
    "Čakovičky",
    "Sluhy",
    "Veleň",
    "Nová Ves",
    "Polerady",
  ],
  "37351": ["Dříteň"],
  "25064": ["Hovorčovice", "Měšice", "Zlonín"],
  "78313": ["Štěpánov", "Liboš"],
  "25065": ["Sedlec", "Bašť", "Líbeznice", "Bořanovice"],
  "25066": ["Zdiby"],
  "25067": ["Klecany", "Větrušice"],
  "78314": ["Štarnov", "Bohuňovice", "Hlušovice"],
  "25068": ["Husinec"],
  "74221": ["Závišice", "Kopřivnice"],
  "25069": ["Vodochody", "Klíčany", "Máslovice"],
  "78316": ["Dolany", "Bělkovice-Lašťany", "Jívová", "Tovéř"],
  "25070": ["Odolena Voda", "Veliká Ves", "Postřižín", "Panenské Břežany"],
  "25072": ["Kojetice", "Předboj"],
  "78321": ["Litovel", "Bílá Lhota", "Mladeč", "Haňovice"],
  "25073": ["Přezletice", "Jenštejn", "Radonice", "Podolanka"],
  "37361": ["Hrdějovice", "Hosín"],
  "25074": ["Radonice"],
  "37362": ["Chotýčany"],
  "25075": ["Káraný", "Nový Vestec"],
  "37363": ["Ševětín", "Mazelov", "Vitín"],
  "78322": [
    "Olbramice",
    "Senice na Hané",
    "Cholina",
    "Loučka",
    "Vilémov",
    "Bílsko",
    "Dubčany",
  ],
  "37364": ["Bošilec", "Dynín"],
  "78325": ["Bouzov"],
  "37365": [
    "Bošilec",
    "Neplachov",
    "Dolní Bukovsko",
    "Hartmanice",
    "Ševětín",
    "Dynín",
    "Žimutice",
  ],
  "78324": ["Slavětín", "Litovel", "Luká", "Měrotín", "Bílá Lhota"],
  "37366": ["Žimutice"],
  "74231": ["Starý Jičín"],
  "37367": ["Hrdějovice", "Borek", "Libníč"],
  "74233": ["Jeseník nad Odrou"],
  "25081": ["Nehvizdy"],
  "25082": [
    "Šestajovice",
    "Dobročovice",
    "Úvaly",
    "Horoušany",
    "Květnice",
    "Křenice",
    "Tuklaty",
  ],
  "74235": [
    "Heřmánky",
    "Odry",
    "Luboměř",
    "Vražné",
    "Mankovice",
    "Heřmanice u Oder",
  ],
  "25083": ["Škvorec", "Zlatá"],
  "37371": [
    "Hlincová Hora",
    "Rudolfov",
    "Vráto",
    "Dubičné",
    "Hůry",
    "Jivno",
    "Adamov",
    "Libníč",
  ],
  "25084": ["Sluštice", "Květnice", "Křenice", "Sibřina"],
  "37372": ["Zvíkov", "Hvozdec", "Lišov"],
  "74237": ["Spálov"],
  "78333": ["Příkazy"],
  "25085": ["Bašť"],
  "37373": ["Libín", "Štěpánovice", "Lišov"],
  "74236": ["Jakubčovice nad Odrou", "Odry"],
  "78332": ["Střeň", "Náklo"],
  "78335": ["Skrbeň", "Olomouc", "Horka nad Moravou"],
  "25087": ["Mochov", "Vyšehořovice"],
  "12800": ["Praha"],
  "25088": ["Čelákovice", "Vyšehořovice"],
  "25089": ["Lázně Toušeň"],
  "78336": ["Křelov-Břuchotín"],
  "25090": ["Jirny"],
  "74243": ["Pustějov"],
  "25091": ["Jenštejn", "Svémyslice", "Zeleneč"],
  "74242": ["Šenov u Nového Jičína"],
  "16900": ["Praha"],
  "25092": ["Šestajovice"],
  "74245": ["Fulnek", "Kujavy", "Vrchy"],
  "37381": ["Kamenný Újezd"],
  "37382": ["Kamenný Újezd", "Boršov nad Vltavou", "Včelná"],
  "74247": ["Hladké Životice"],
  "78342": ["Slatinice", "Slatinky", "Lutín"],
  "37384": [
    "Branišov",
    "Čakov",
    "Dubné",
    "Habří",
    "Kvítkovice",
    "Jankov",
    "Záboří",
    "Lipí",
  ],
  "78345": ["Senice na Hané", "Senička"],
  "78344": ["Loučany", "Drahanovice", "Náměšť na Hané"],
  "74251": ["Mošnov"],
  "78347": ["Hněvotín"],
  "78346": ["Těšetice", "Ústín", "Luběnice"],
  "74253": ["Kunín"],
  "78349": ["Lutín"],
  "25101": [
    "Herink",
    "Březí",
    "Popovičky",
    "Tehov",
    "Doubek",
    "Dobřejovice",
    "Světice",
    "Modletice",
    "Nupaky",
    "Čestlice",
    "Babice",
    "Říčany",
  ],
  "74255": ["Albrechtičky"],
  "74254": ["Bartošovice"],
  "74257": ["Libhošť"],
  "78353": ["Velká Bystřice"],
  "74256": ["Sedlnice"],
  "78355": ["Velký Újezd"],
  "74258": [
    "Trnávka",
    "Skotnice",
    "Kateřinice",
    "Hukvaldy",
    "Fryčovice",
    "Příbor",
  ],
  "78354": ["Svésedlice", "Přáslavice"],
  "78357": ["Libavá", "Tršice", "Suchonice"],
  "33301": [
    "Stod",
    "Líšina",
    "Střelice",
    "Honezovice",
    "Kotovice",
    "Ves Touškov",
    "Hradec",
    "Lisov",
    "Chotěšov",
  ],
  "74260": ["Petřvald"],
  "78356": ["Doloplazy", "Přáslavice"],
  "74265": ["Rybí"],
  "78361": ["Hlubočky"],
  "37401": [
    "Strážkovice",
    "Římov",
    "Slavče",
    "Horní Stropnice",
    "Mokrý Lom",
    "Ostrolovský Újezd",
    "Hranice",
    "Svatý Jan nad Malší",
    "Nové Hrady",
    "Komařice",
    "Žár",
    "Ločenice",
    "Olešnice",
    "Petříkov",
    "Čížkrajice",
    "Střížov",
    "Trhové Sviny",
    "Kamenná",
  ],
  "74267": ["Ženklava"],
  "74266": ["Štramberk"],
  "78365": ["Hlubočky", "Olomouc", "Mrsklesy"],
  "41501": [
    "Bžany",
    "Žim",
    "Kladruby",
    "Žalany",
    "Kostomlaty pod Milešovkou",
    "Rtyně nad Bílinou",
    "Bystřany",
    "Újezdeček",
    "Novosedlice",
    "Světec",
    "Dubí",
    "Bořislav",
    "Srbice",
    "Modlany",
    "Ohníč",
    "Teplice",
  ],
  "74271": ["Hodslavice"],
  "41503": ["Teplice"],
  "74273": ["Veřovice"],
  "74272": ["Životice u Nového Jičína", "Mořkov"],
  "74275": ["Lichnov"],
  "74274": ["Tichá"],
  "78373": ["Grygov"],
  "78372": ["Velký Týnec"],
  "41510": ["Teplice"],
  "78375": [
    "Blatec",
    "Dub nad Moravou",
    "Kožušany-Tážaly",
    "Charváty",
    "Věrovany",
  ],
  "74281": ["Bravantice"],
  "53801": ["Bylany"],
  "53802": ["Morašice"],
  "74283": ["Olbramice", "Klimkovice", "Zbyslavice"],
  "53803": [
    "Načešice",
    "Heřmanův Městec",
    "Hošťalovice",
    "Rozhovice",
    "Stolany",
    "Vyžice",
    "Vápenný Podol",
    "Kostelec u Heřmanova Městce",
    "Morašice",
    "Podhořany u Ronova",
    "Míčov-Sušice",
    "Úherčice",
    "Klešice",
  ],
  "74282": ["Jistebník"],
  "53804": ["Prachovice"],
  "74285": ["Klimkovice", "Vřesina"],
  "53805": ["Seč"],
  "78383": ["Medlov", "Nová Hradečná", "Lipinka", "Troubelice"],
  "53807": ["Liboměřice", "Bojanov", "Seč"],
  "62000": ["Brno"],
  "78385": ["Šumvald"],
  "74291": ["Velké Albrechtice"],
  "78386": ["Dlouhá Loučka", "Paseka", "Jiříkov"],
  "74293": ["Slatina"],
  "74292": ["Bílovec"],
  "78391": ["Medlov", "Uničov", "Želechovice"],
  "70200": ["Ostrava"],
  "74301": [
    "Olbramice",
    "Skřipov",
    "Bílov",
    "Bílovec",
    "Slatina",
    "Tísek",
    "Bítov",
  ],
  "78397": ["Paseka"],
  "53821": [
    "Rabštejnská Lhota",
    "Liboměřice",
    "Lukavice",
    "Morašice",
    "Křižanovice",
    "Licibořice",
    "Svídnice",
    "Chrudim",
    "Slatiňany",
    "Žumberk",
    "Mladoňovice",
    "Orel",
  ],
  "78396": ["Újezd"],
  "53823": ["Licibořice"],
  "53824": ["Svídnice"],
  "78401": ["Pňovice", "Litovel", "Strukov", "Žerotín", "Červenka", "Mladeč"],
  "53825": [
    "České Lhotice",
    "Horní Bradlo",
    "Ctětín",
    "Hodonín",
    "Liboměřice",
    "Nasavrky",
    "Miřetice",
    "Libkov",
    "Trhová Kamenice",
    "Krásné",
  ],
  "53826": ["Bojanov"],
  "53831": ["Chrudim"],
  "53832": ["Úhřetice"],
  "53833": ["Trojovice"],
  "25162": ["Mukařov", "Louňovice", "Svojetice", "Tehovec"],
  "53834": ["Rosice"],
  "25163": ["Strančice", "Kunice", "Všestary"],
  "53835": ["Zaječice"],
  "25164": [
    "Strančice",
    "Klokočná",
    "Struhařov",
    "Kaliště",
    "Zvánovice",
    "Kunice",
    "Mnichovice",
    "Všestary",
  ],
  "53836": ["Žumberk"],
  "25165": ["Kaliště", "Zvánovice", "Ondřejov"],
  "25166": ["Senohraby", "Mirošovice", "Hrusice", "Ondřejov"],
  "25167": ["Řehenice", "Pyšely", "Nespeky", "Pětihosty"],
  "25168": [
    "Radějovice",
    "Řehenice",
    "Sulice",
    "Kostelec u Křížků",
    "Týnec nad Sázavou",
    "Kamenice",
    "Křížkový Újezdec",
  ],
  "25169": ["Kunice", "Velké Popovice", "Petříkov"],
  "53841": ["Podhořany u Ronova"],
  "25170": ["Modletice"],
  "53842": ["Ronov nad Doubravou"],
  "53843": [
    "Bousov",
    "Třemošnice",
    "Běstvina",
    "Biskupice",
    "Seč",
    "Žlebské Chvalovice",
    "Ronov nad Doubravou",
    "Lipovec",
    "Kněžice",
  ],
  "53845": ["Běstvina"],
  "53851": [
    "Smrček",
    "Zaječice",
    "Chrast",
    "Zájezdec",
    "Bítovany",
    "Horka",
    "Vrbatův Kostelec",
    "Řestoky",
  ],
  "53854": [
    "Lozice",
    "Střemošice",
    "Luže",
    "Jenišovice",
    "Leština",
    "Řepníky",
    "Hroubovice",
  ],
  "53861": ["Kočí"],
  "53862": [
    "Dvakačovice",
    "Hrochův Týnec",
    "Bořice",
    "Dolní Bezděkov",
    "Nabočany",
    "Honbice",
    "Přestavlky",
    "Rosice",
    "Vejvanovice",
    "Čankovice",
  ],
  "53863": [
    "Ostrov",
    "Chroustovice",
    "Jenišovice",
    "Vinary",
    "Řepníky",
    "Rosice",
    "Stradouň",
  ],
  "17000": ["Praha"],
  "53864": ["Jenišovice"],
  "53865": ["Řepníky"],
  "25202": ["Jíloviště"],
  "25203": ["Líšnice", "Řitka"],
  "25204": ["Čisovice"],
  "25205": ["Hvozdnice", "Bratřínov"],
  "29301": [
    "Kolomuty",
    "Kosmonosy",
    "Dolní Stakory",
    "Vinec",
    "Řepov",
    "Mladá Boleslav",
    "Bukovno",
    "Nepřevázka",
    "Plazy",
    "Dalovice",
  ],
  "25206": ["Petrov", "Bojanovice", "Bratřínov", "Měchenice", "Davle"],
  "25207": ["Štěchovice"],
  "25208": ["Rabyně", "Slapy", "Štěchovice", "Buš"],
  "25209": ["Hradištko"],
  "33401": [
    "Biřkov",
    "Dolní Lukavice",
    "Horšice",
    "Řenče",
    "Lužany",
    "Dnešice",
    "Příchovice",
    "Týniště",
    "Nezdice",
    "Soběkury",
    "Dolce",
    "Otěšice",
    "Přestavlky",
    "Radkovice",
    "Vřeskovice",
    "Chlumčany",
    "Horní Lukavice",
    "Borovy",
    "Bolkov",
    "Oplot",
    "Přeštice",
    "Vlčí",
  ],
  "25210": [
    "Voznice",
    "Mníšek pod Brdy",
    "Čisovice",
    "Líšnice",
    "Hvozdnice",
    "Zahořany",
    "Klínec",
    "Trnová",
    "Černolice",
    "Kytín",
  ],
  "29306": ["Kosmonosy", "Bakov nad Jizerou", "Bradlec"],
  "29307": ["Hrdlořezy", "Josefův Důl"],
  "37501": [
    "Všemyslice",
    "Modrá Hůrka",
    "Bechyně",
    "Albrechtice nad Vltavou",
    "Dražíč",
    "Bečice",
    "Dříteň",
    "Temelín",
    "Týn nad Vltavou",
    "Horní Kněžeklady",
    "Dobšice",
    "Chrášťany",
    "Olešník",
    "Hosty",
    "Žimutice",
  ],
  "25216": ["Nučice"],
  "25217": ["Tachlovice", "Chýnice"],
  "25218": ["Úhonice", "Ptice"],
  "25219": ["Drahelčice", "Chrášťany", "Rudná"],
  "25225": ["Dobříč", "Ořech", "Zbuzany", "Jinočany"],
  "25226": ["Choteč", "Černošice", "Praha", "Třebotov", "Kosoř", "Roblín"],
  "25228": ["Černošice", "Vonoklasy", "Praha", "Třebotov"],
  "25229": ["Dobřichovice", "Karlík", "Lety"],
  "53901": [
    "Dědová",
    "Pokřikov",
    "Vortová",
    "Vysočina",
    "Raná",
    "Vítanov",
    "Všeradov",
    "Hlinsko",
    "Včelákov",
    "Vojtěchov",
    "Kameničky",
    "Krouna",
    "Holetín",
    "Jeníkov",
    "Trhová Kamenice",
    "Studnice",
    "Krucemburk",
    "Mrákotín",
    "Hamry",
    "Kladno",
  ],
  "25230": ["Hlásná Třebaň", "Lety", "Řevnice"],
  "25231": ["Dobřichovice", "Všenory"],
  "58001": [
    "Veselý Žďár",
    "Bartoušov",
    "Květinov",
    "Rozsochatec",
    "Vysoká",
    "Krásná Hora",
    "Michalovice",
    "Radostín",
    "Dolní Krupá",
    "Horní Krupá",
    "Šlapanov",
    "Kojetín",
    "Lípa",
    "Čachotín",
    "Herálec",
    "Knyk",
    "Havlíčkův Brod",
    "Věž",
    "Břevnice",
    "Kyjov",
    "Okrouhlice",
    "Hurtova Lhota",
    "Olešná",
    "Ždírec",
  ],
  "62100": ["Brno"],
  "25241": ["Zlatníky-Hodkovice", "Libeř", "Dolní Břežany"],
  "25242": ["Jesenice", "Vestec"],
  "25243": ["Průhonice"],
  "25244": ["Psáry"],
  "25245": [
    "Březová-Oleško",
    "Vrané nad Vltavou",
    "Ohrobec",
    "Zvole",
    "Dolní Břežany",
  ],
  "70300": ["Ostrava"],
  "25246": ["Vrané nad Vltavou", "Ohrobec", "Dolní Břežany"],
  "74401": ["Bordovice", "Trojanovice", "Frenštát pod Radhoštěm"],
  "33441": ["Nová Ves", "Dobřany", "Vstiš"],
  "25250": ["Vestec"],
  "33442": ["Chlumčany"],
  "33443": ["Dnešice"],
  "33444": ["Dolní Lukavice"],
  "78501": [
    "Libavá",
    "Hlásnice",
    "Komárov",
    "Lipina",
    "Lužice",
    "Hnojice",
    "Mutkov",
    "Řídeč",
    "Babice",
    "Mladějovice",
    "Šternberk",
    "Štěpánov",
    "Domašov u Šternberka",
  ],
  "33452": ["Buková", "Holýšov", "Zemětice", "Ptenín", "Merklín", "Srbice"],
  "25261": ["Dobrovíz", "Jeneč"],
  "33453": ["Roupov"],
  "25262": ["Únětice", "Horoměřice", "Statenice"],
  "33454": ["Lužany"],
  "25263": ["Roztoky"],
  "33455": ["Horšice"],
  "25264": ["Okoř", "Svrkyně", "Úholičky", "Lichoceves", "Velké Přílepy"],
  "25265": ["Holubice", "Tursko"],
  "25266": ["Libčice nad Vltavou", "Máslovice"],
  "25267": ["Tuchoměřice"],
  "25268": ["Kněževes", "Číčovice", "Středokluky"],
  "53941": ["Kameničky"],
  "53942": ["Svratouch"],
  "53943": ["Otradov", "Krouna"],
  "53944": [
    "Proseč",
    "Bor u Skutče",
    "Zderaz",
    "Krouna",
    "Leština",
    "Nové Hrady",
    "Příluka",
    "Perálec",
    "Hluboká",
  ],
  "53945": ["Nové Hrady"],
  "53952": ["Trhová Kamenice"],
  "25281": ["Petrov"],
  "53953": ["Horní Bradlo"],
  "25282": ["Kamenný Přívoz"],
  "53955": ["Miřetice"],
  "53956": ["Vrbatův Kostelec"],
  "53957": ["Včelákov"],
  "13000": ["Praha"],
  "53961": ["Vortová"],
  "53962": ["Hlinsko"],
  "17100": ["Praha"],
  "53971": ["Holetín"],
  "53972": ["Raná"],
  "25301": ["Chýně", "Hostivice"],
  "53973": [
    "Tisovec",
    "Skuteč",
    "Prosetín",
    "Leštinka",
    "Předhradí",
    "Vrbatův Kostelec",
    "Hluboká",
  ],
  "53974": ["Předhradí"],
  "25303": ["Chýně"],
  "53976": ["Prosetín"],
  "29401": ["Bakov nad Jizerou", "Nová Ves u Bakova", "Ptýrov", "Bítouchov"],
  "29402": ["Kněžmost", "Branžež"],
  "29403": ["Obruby"],
  "29404": [
    "Rohatsko",
    "Petkovy",
    "Obrubce",
    "Ujkovice",
    "Prodašice",
    "Řitonice",
    "Osek",
    "Přepeře",
    "Rabakov",
    "Domousnice",
    "Veselice",
    "Dobšín",
    "Dolní Bousov",
  ],
  "29405": ["Dlouhá Lhota"],
  "33501": [
    "Chocenice",
    "Kasejovice",
    "Měčín",
    "Jarov",
    "Třebčice",
    "Klášter",
    "Polánka",
    "Kozlovice",
    "Kramolín",
    "Neurazy",
    "Nepomuk",
    "Srby",
    "Mohelnice",
    "Mileč",
    "Čížkov",
    "Prádlo",
    "Tojice",
    "Žinkovy",
    "Čmelíny",
    "Chlumy",
    "Sedliště",
    "Mladý Smolivec",
    "Oselce",
  ],
  "29406": [
    "Březno",
    "Lhotky",
    "Husí Lhota",
    "Kněžmost",
    "Petkovy",
    "Sukorady",
    "Nová Telib",
    "Židněves",
  ],
  "33503": ["Nepomuk"],
  "29411": [
    "Mnichovo Hradiště",
    "Loukovec",
    "Žďár",
    "Loukov",
    "Sezemice",
    "Koryta",
    "Březina",
    "Chocnějovice",
  ],
  "29412": ["Žďár"],
  "29413": [
    "Mnichovo Hradiště",
    "Strážiště",
    "Všelibice",
    "Mohelnice nad Jizerou",
    "Neveklovice",
    "Chocnějovice",
  ],
  "41701": ["Dubí"],
  "29414": ["Jivina"],
  "41702": ["Dubí"],
  "29415": ["Klášter Hradiště nad Jizerou"],
  "41703": ["Dubí"],
  "41704": ["Hrob"],
  "41705": ["Osek"],
  "29421": ["Bělá pod Bezdězem", "Březovice"],
  "29423": ["Čistá", "Plužná"],
  "29424": ["Březovice"],
  "41712": ["Proboštov"],
  "29425": [
    "Bělá pod Bezdězem",
    "Katusice",
    "Bukovno",
    "Březovice",
    "Krásná Ves",
    "Kováň",
    "Sudoměř",
  ],
  "41713": ["Modlany"],
  "29426": [
    "Kluky",
    "Skalsko",
    "Katusice",
    "Kovanec",
    "Velké Všelisy",
    "Boreč",
    "Kováň",
    "Sudoměř",
    "Vrátno",
  ],
  "29427": ["Velké Všelisy"],
  "29428": ["Chotětov"],
  "29429": ["Sovínky", "Bezno", "Nemyslovice"],
  "29430": ["Pětikozly", "Rokytovec", "Niměřice", "Doubravička", "Strenice"],
  "29431": ["Strašnov", "Jizerní Vtelno", "Krnsko", "Písková Lhota"],
  "41722": ["Háj u Duchcova"],
  "41723": ["Košťany"],
  "41724": ["Jeníkov"],
  "41725": ["Lahošť"],
  "29441": ["Kosořice", "Vinařice", "Dobrovice", "Žerčice"],
  "29442": ["Němčice", "Dobrovice", "Luštěnice", "Smilovice"],
  "29443": ["Čachovice", "Vlkava", "Lipník", "Všejany"],
  "41731": ["Novosedlice"],
  "29445": ["Charvatce", "Jabkenice", "Chudíř"],
  "33541": ["Vrčeň"],
  "29446": [
    "Semčice",
    "Dobrovice",
    "Žerčice",
    "Ctiměřice",
    "Pěčice",
    "Kobylnice",
  ],
  "29447": ["Ledce"],
  "33543": ["Mladý Smolivec"],
  "29448": ["Domousnice"],
  "33544": ["Nezdřev", "Životice", "Kasejovice", "Hradiště"],
  "33546": ["Oselce"],
  "33547": ["Nekvasovy"],
  "41741": ["Krupka"],
  "41742": ["Krupka"],
  "33551": ["Měcholupy"],
  "33554": ["Žinkovy"],
  "33555": ["Neurazy"],
  "41752": ["Hostomice"],
  "33561": ["Borovno", "Spálené Poříčí"],
  "41753": ["Světec"],
  "41754": ["Kostomlaty pod Milešovkou"],
  "33563": ["Míšov", "Nové Mitrovice", "Spálené Poříčí", "Čížkov"],
  "33564": ["Čížkov"],
  "41757": ["Hrobčice"],
  "29471": ["Benátky nad Jizerou", "Zdětín", "Sedlec"],
  "29473": ["Hrušov", "Horky nad Jizerou", "Brodce"],
  "41761": ["Bystřany"],
  "29474": [
    "Předměřice nad Jizerou",
    "Tuřice",
    "Kochánky",
    "Hlavenec",
    "Skorkov",
  ],
  "41762": ["Rtyně nad Bílinou"],
  "29475": ["Sojovice"],
  "41763": ["Žalany"],
  "29476": ["Kostelní Hlavno", "Hlavenec", "Sudovo Hlavno"],
  "29477": ["Mečeříž"],
  "41765": ["Ohníč"],
  "29478": ["Dolní Slivno"],
  "29479": ["Kropáčova Vrutice", "Horní Slivno", "Košátky", "Chotětov"],
  "41771": ["Zabrušany"],
  "41772": ["Ledvice"],
  "41781": ["Moldava"],
  "25401": ["Jílové u Prahy", "Petrov", "Libeř", "Pohoří", "Okrouhlo"],
  "29501": [
    "Mnichovo Hradiště",
    "Strážiště",
    "Dolní Krupá",
    "Rokytá",
    "Bílá Hlína",
    "Mukařov",
    "Březina",
    "Ptýrov",
    "Ralsko",
    "Horní Bukovina",
    "Boseň",
  ],
  "33601": [
    "Blovice",
    "Chocenice",
    "Drahkov",
    "Řenče",
    "Zdemyslice",
    "Skašov",
    "Letiny",
    "Louňová",
    "Únětice",
    "Seč",
    "Žinkovy",
    "Žákava",
    "Ždírec",
  ],
  "37701": [
    "Střížovice",
    "Lodhéřov",
    "Horní Pěna",
    "Dolní Pěna",
    "Polště",
    "Ratiboř",
    "Rodvínov",
    "Jindřichův Hradec",
    "Hospříz",
    "Blažejov",
    "Hatín",
    "Horní Skrýchov",
    "Kačlehy",
    "Velký Ratmírov",
  ],
  "41801": ["Bílina"],
  "41804": ["Měrunice", "Světec", "Lukov", "Hrobčice"],
  "50002": ["Hradec Králové"],
  "50003": ["Divec", "Černilov", "Hradec Králové", "Skalice"],
  "50004": ["Hradec Králové"],
  "54101": [
    "Žacléř",
    "Bernartice",
    "Chvaleč",
    "Trutnov",
    "Lampertice",
    "Mladé Buky",
    "Zlatá Olešnice",
    "Vlčice",
    "Staré Buky",
  ],
  "50006": ["Hradec Králové"],
  "54102": ["Trutnov"],
  "54103": ["Trutnov"],
  "50008": ["Hradec Králové"],
  "50009": ["Hradec Králové"],
  "50011": ["Hradec Králové"],
  "50012": ["Hradec Králové"],
  "62300": ["Brno"],
  "66401": [
    "Řícmanice",
    "Babice nad Svitavou",
    "Kanice",
    "Bílovice nad Svitavou",
  ],
  "66403": ["Podolí"],
  "66402": ["Ochoz u Brna"],
  "66405": ["Tvarožná", "Velatice", "Jiříkovice"],
  "66404": ["Hostěnice", "Mokrá-Horákov"],
  "66407": ["Sivice", "Pozořice"],
  "66406": ["Kovalovice", "Viničné Šumice"],
  "74601": ["Opava", "Stěbořice"],
  "66408": ["Blažovice"],
  "66411": ["Zbýšov"],
  "78701": ["Rapotín", "Rejchartice", "Bratrušov", "Šumperk"],
  "58221": ["Pohled"],
  "66412": ["Oslavany"],
  "58222": [
    "Pohled",
    "Krátká Ves",
    "Přibyslav",
    "Havlíčkova Borová",
    "Dlouhá Ves",
    "Modlíkov",
    "Olešenka",
    "Stříbrné Hory",
    "Žižkovo Pole",
  ],
  "58223": ["Havlíčkova Borová"],
  "58224": ["Oudoleň"],
  "66417": ["Omice", "Tetčice"],
  "66423": ["Čebín"],
  "58231": ["Okrouhlice"],
  "58232": ["Lipnice nad Sázavou"],
  "58233": ["Dolní Město"],
  "66424": ["Drásov"],
  "58234": ["Krásná Hora"],
  "58235": ["Lučice"],
  "66431": ["Lelekovice", "Česká"],
  "58241": ["Skuhrov", "Olešná"],
  "66432": ["Vranov"],
  "58242": ["Kámen"],
  "58243": ["Tis"],
  "66434": ["Moravské Knínice", "Rozdrojovice", "Kuřim", "Jinačovice", "Brno"],
  "58244": ["Sázavka"],
  "58245": ["Uhelná Příbram"],
  "66441": ["Omice", "Popůvky", "Troubsko"],
  "66443": ["Želešice", "Hajany"],
  "58251": ["Šlapanov", "Věžnice"],
  "66442": ["Modřice", "Brno"],
  "58252": ["Věžnice", "Polná"],
  "58253": [
    "Kochánov",
    "Úhořilka",
    "Okrouhlička",
    "Lípa",
    "Úsobí",
    "Skorkov",
    "Štoky",
  ],
  "66444": ["Ořechov"],
  "58254": ["Úsobí"],
  "66447": ["Radostice", "Střelice", "Troubsko"],
  "58255": ["Boňkov", "Herálec", "Květinov", "Slavníč"],
  "66446": ["Radostice", "Silůvky", "Prštice"],
  "58256": ["Herálec", "Věž"],
  "66449": ["Ostopovice"],
  "58257": ["Lípa"],
  "66448": ["Moravany", "Nebovidy"],
  "66451": ["Ponětovice", "Jiříkovice", "Šlapanice", "Kobylnice"],
  "66453": ["Žatčany", "Újezd u Brna"],
  "58261": ["Česká Bělá"],
  "66452": ["Sokolnice"],
  "58262": ["Sobíňov"],
  "66455": ["Moutnice", "Měnín"],
  "58263": [
    "Slavětín",
    "Ždírec nad Doubravou",
    "Slavíkov",
    "Havlíčkova Borová",
    "Sobíňov",
    "Krucemburk",
  ],
  "66454": ["Nesvačilka", "Těšany"],
  "58264": ["Ždírec nad Doubravou", "Podmoklany"],
  "66457": ["Otmarov", "Měnín"],
  "58265": ["Slavíkov"],
  "66456": ["Blučina"],
  "58266": ["Krucemburk"],
  "66459": ["Telnice"],
  "66458": ["Prace"],
  "66461": [
    "Popovice",
    "Opatovice",
    "Rajhrad",
    "Holasice",
    "Rajhradice",
    "Rebešovice",
  ],
  "66463": ["Přísnotice", "Žabčice", "Unkovice"],
  "58271": ["Dolní Krupá"],
  "66462": ["Ledce", "Hrušovany u Brna"],
  "58272": ["Rozsochatec"],
  "66465": ["Odrovice", "Malešovice"],
  "58273": ["Nová Ves u Chotěboře"],
  "66464": [
    "Kupařovice",
    "Odrovice",
    "Mělčany",
    "Pravlov",
    "Malešovice",
    "Trboušany",
    "Dolní Kounice",
    "Nové Bránice",
    "Moravské Bránice",
  ],
  "58274": ["Jeřišno"],
  "66467": ["Sobotovice", "Syrovice", "Bratčice"],
  "66466": ["Medlov", "Němčičky"],
  "58276": ["Maleč"],
  "33701": [
    "Nevid",
    "Sirá",
    "Kamenný Újezd",
    "Hůrky",
    "Raková",
    "Medový Újezd",
    "Svojkovice",
    "Ejpovice",
    "Osek",
    "Veselá",
    "Těškov",
    "Rokycany",
    "Hrádek",
    "Lhota pod Radčem",
    "Dobřív",
    "Litohlavy",
  ],
  "58277": ["Libice nad Doubravou"],
  "66471": [
    "Javůrek",
    "Braníškov",
    "Chudčice",
    "Hvozdec",
    "Lažánky",
    "Brno",
    "Veverská Bítýška",
    "Maršov",
  ],
  "37801": ["Lásenice"],
  "58281": ["Habry"],
  "37802": [
    "Vydří",
    "Novosedly nad Nežárkou",
    "Číměř",
    "Pístina",
    "Dolní Žďár",
    "Hatín",
    "Příbraz",
    "Plavsko",
    "Stráž nad Nežárkou",
  ],
  "58282": [
    "Skryje",
    "Uhelná Příbram",
    "Podmoky",
    "Vilémov",
    "Kámen",
    "Leškovice",
    "Heřmanice",
    "Chrtníč",
    "Rybníček",
    "Habry",
    "Golčův Jeníkov",
    "Vepříkov",
    "Kraborovice",
    "Leština u Světlé",
    "Nová Ves u Leštiny",
    "Borek",
    "Zvěstovice",
  ],
  "66475": ["Deblín"],
  "37803": ["Majdalena"],
  "58283": ["Vilémov"],
  "37804": ["Chlum u Třeboně"],
  "41901": ["Duchcov", "Mikulov"],
  "37806": [
    "Chlum u Třeboně",
    "Suchdol nad Lužnicí",
    "Nová Ves nad Lužnicí",
    "Hamr",
    "Halámky",
    "Staňkov",
  ],
  "58286": ["Leština u Světlé"],
  "37807": ["Rapšach"],
  "58287": ["Číhošť"],
  "37808": ["Dvory nad Lužnicí"],
  "66481": ["Veverské Knínice", "Ostrovačice", "Brno"],
  "37809": ["Nová Ves nad Lužnicí"],
  "46001": ["Stráž nad Nisou", "Kryštofovo Údolí", "Liberec"],
  "37810": ["České Velenice"],
  "66483": [
    "Javůrek",
    "Litostrov",
    "Lesní Hluboké",
    "Přibyslavice",
    "Říčky",
    "Domašov",
    "Rudka",
  ],
  "58291": [
    "Příseka",
    "Světlá nad Sázavou",
    "Lipnice nad Sázavou",
    "Ovesná Lhota",
    "Malčín",
    "Krásná Hora",
    "Trpišovice",
    "Nová Ves u Světlé",
    "Druhanov",
    "Skuhrov",
    "Habry",
    "Bačkov",
    "Dolní Město",
    "Kunemil",
    "Služátky",
    "Pohleď",
    "Vlkanov",
    "Olešná",
    "Tis",
  ],
  "66482": ["Říčany"],
  "58292": ["Kamenná Lhota"],
  "46005": ["Liberec"],
  "58293": ["Kožlí", "Plzeň"],
  "66484": [
    "Příbram na Moravě",
    "Zbraslav",
    "Babice u Rosic",
    "Zálesná Zhoř",
    "Rosice",
    "Stanoviště",
    "Vysoké Popovice",
    "Zastávka",
    "Újezd u Rosic",
    "Zakřany",
    "Lukovany",
  ],
  "46006": ["Liberec"],
  "58294": ["Hněvkovice"],
  "46007": ["Liberec"],
  "37816": ["Lomnice nad Lužnicí", "Krejnice"],
  "46008": ["Liberec"],
  "37817": ["Novosedly nad Nežárkou"],
  "54201": ["Žacléř", "Lampertice"],
  "66488": ["Zbraslav"],
  "37818": ["Stříbřec", "Pístina"],
  "46010": ["Liberec"],
  "66491": [
    "Ketkovice",
    "Hlína",
    "Čučice",
    "Kratochvilka",
    "Ivančice",
    "Nová Ves",
    "Oslavany",
    "Biskoupky",
    "Neslovice",
  ],
  "54203": ["Královec"],
  "54204": ["Bernartice"],
  "37821": [
    "Drahov",
    "Rosička",
    "Záhoří",
    "Újezdec",
    "Višňová",
    "Březina",
    "Ratiboř",
    "Vícemil",
    "Doňov",
    "Pleše",
    "Drunče",
    "Deštná",
    "Světce",
    "Pluhův Žďár",
    "Kardašova Řečice",
    "Velký Ratmírov",
  ],
  "58301": [
    "Dolní Sokolovec",
    "Uhelná Příbram",
    "Lány",
    "Česká Bělá",
    "Slavíkov",
    "Maleč",
    "Jeřišno",
    "Rušinov",
    "Bezděkov",
    "Jilem",
    "Libice nad Doubravou",
    "Sloupno",
    "Nová Ves u Chotěboře",
    "Čachotín",
    "Sedletín",
    "Jitkov",
    "Vepříkov",
    "Nejepín",
    "Víska",
    "Čečkovice",
    "Chotěboř",
    "Klokočov",
  ],
  "46014": ["Liberec"],
  "46015": ["Liberec"],
  "37824": ["Pluhův Žďár"],
  "62400": ["Brno"],
  "37825": ["Deštná"],
  "37826": ["Lodhéřov"],
  "66499": ["Silůvky"],
  "54211": ["Chvaleč"],
  "54212": ["Radvanice"],
  "66501": ["Omice", "Rosice"],
  "54213": ["Jívka"],
  "37831": ["Horní Pěna"],
  "37832": ["Číměř"],
  "37833": ["Člunek", "Číměř", "Kunžak", "Nová Bystřice"],
  "54221": ["Pec pod Sněžkou", "Malá Úpa"],
  "54223": ["Mladé Buky"],
  "54224": ["Mladé Buky", "Svoboda nad Úpou"],
  "74705": ["Opava"],
  "78801": ["Oskava"],
  "37841": ["Jarošov nad Nežárkou"],
  "54225": ["Janské Lázně"],
  "37842": [
    "Bednáreček",
    "Bednárec",
    "Jarošov nad Nežárkou",
    "Žďár",
    "Vlčetínec",
    "Dívčí Kopy",
    "Nová Včelnice",
    "Hadravova Rosička",
    "Okrouhlá Radouň",
    "Kamenný Malíkov",
    "Horní Radouň",
    "Kostelní Radouň",
  ],
  "54226": ["Žacléř", "Horní Maršov"],
  "74707": ["Opava"],
  "78803": ["Nový Malín"],
  "37843": ["Horní Radouň"],
  "54227": ["Malá Úpa"],
  "74706": ["Nové Sedlice", "Chvalíkovice", "Opava"],
  "78805": ["Libina"],
  "78804": ["Hrabišín"],
  "37846": ["Roseč"],
  "74711": ["Kozmice"],
  "54232": [
    "Suchovršice",
    "Úpice",
    "Batňovice",
    "Libňatov",
    "Trutnov",
    "Červený Kostelec",
    "Maršov u Úpice",
    "Velké Svatoňovice",
    "Havlovice",
    "Slatina nad Úpou",
  ],
  "54233": ["Havlovice", "Rtyně v Podkrkonoší"],
  "54234": [
    "Batňovice",
    "Jívka",
    "Velké Svatoňovice",
    "Malé Svatoňovice",
    "Rtyně v Podkrkonoší",
  ],
  "74715": ["Šilheřovice"],
  "78811": ["Loučná nad Desnou"],
  "54235": ["Velké Svatoňovice"],
  "74714": ["Markvartovice", "Ludgeřovice"],
  "37852": ["Blažejov"],
  "54236": ["Libňatov"],
  "74717": ["Darkovice"],
  "78813": ["Rapotín", "Vikýřovice"],
  "37853": [
    "Střížovice",
    "Člunek",
    "Kunžak",
    "Strmilov",
    "Heřmaneč",
    "Bořetín",
    "Zahrádky",
    "Popelín",
    "Jilem",
    "Horní Meziříčko",
    "Nová Olešná",
    "Panské Dubenky",
    "Český Rudolec",
    "Horní Němčice",
    "Studená",
  ],
  "54237": ["Batňovice"],
  "74716": ["Hať"],
  "74719": ["Závada", "Bohuslavice"],
  "78815": ["Velké Losiny", "Vernířovice", "Hraběšice"],
  "37855": ["Popelín"],
  "74718": ["Píšť"],
  "78814": ["Rapotín", "Petrov nad Desnou"],
  "37856": ["Jilem", "Studená"],
  "74721": ["Kravaře"],
  "54241": ["Vlčice"],
  "74720": ["Vřesina"],
  "78816": ["Sobotín", "Petrov nad Desnou"],
  "54242": ["Pilníkov"],
  "74723": ["Bolatice", "Bělá"],
  "54243": ["Staré Buky"],
  "74722": ["Dolní Benešov"],
  "74725": ["Třebom", "Rohov", "Sudice"],
  "78821": ["Sudkov", "Kolšov"],
  "37861": ["Člunek"],
  "74724": ["Strahovice", "Chuchelná"],
  "78820": ["Dolní Studénky"],
  "37862": ["Kunžak"],
  "74727": ["Kobeřice"],
  "78823": ["Jindřichov"],
  "78825": ["Vikantice", "Ostružná", "Branná", "Šléglov"],
  "74728": ["Služovice", "Opava", "Štěpánkovice"],
  "74731": ["Chlebičov", "Velké Hoštice"],
  "74733": ["Oldřišov"],
  "74735": ["Hněvošice"],
  "37871": ["Staré Hobzí"],
  "37872": ["Písečné"],
  "78833": ["Hanušovice", "Malá Morava", "Kopřivná", "Králíky"],
  "37873": ["Dešná"],
  "78832": ["Staré Město", "Hanušovice"],
  "74741": ["Hradec nad Moravicí", "Skřipov", "Branka u Opavy"],
  "74743": ["Větřkovice"],
  "74745": ["Skřipov"],
  "37881": [
    "Dešná",
    "Županovice",
    "Staré Město pod Landštejnem",
    "Staré Hobzí",
    "Slavonice",
    "Český Rudolec",
    "Nová Bystřice",
    "Cizkrajov",
    "Písečné",
  ],
  "74744": ["Březová"],
  "37882": ["Staré Město pod Landštejnem"],
  "74747": ["Vítkov"],
  "37883": ["Český Rudolec"],
  "74751": ["Stěbořice"],
  "74753": ["Jakartovice"],
  "25601": [
    "Neveklov",
    "Soběhrdy",
    "Václavice",
    "Chlístov",
    "Kozmice",
    "Struhařov",
    "Čakov",
    "Bystřice",
    "Chrášťany",
    "Benešov",
    "Bílkovice",
    "Petroupim",
    "Teplýšovice",
  ],
  "74752": ["Hlavnice", "Bratříkovice"],
  "74755": [
    "Jakartovice",
    "Litultovice",
    "Lhotka u Litultovic",
    "Dolní Životice",
    "Jezdkovice",
  ],
  "37891": ["Budíškovice"],
  "74754": ["Mladecko"],
  "37892": ["Budeč"],
  "74757": ["Slavkov"],
  "74756": ["Dolní Životice"],
  "74761": ["Vršovice", "Raduň"],
  "33801": ["Holoubkov", "Těškov", "Hůrky"],
  "74763": ["Hrabyně"],
  "74762": ["Mokré Lazce"],
  "33805": ["Mýto"],
  "37901": [
    "Frahelž",
    "Jílovice",
    "Stříbřec",
    "Dunajovice",
    "Libín",
    "Lomnice nad Lužnicí",
    "Lužnice",
    "Příbraz",
    "Hrachoviště",
    "Cep",
    "Domanín",
    "Záblatí",
    "Novosedly nad Nežárkou",
    "Ponědrážka",
    "Smržov",
    "Chlum u Třeboně",
    "Hatín",
    "Klec",
    "Mladošovice",
    "Ponědraž",
    "Třeboň",
  ],
  "74764": [
    "Budišovice",
    "Těškovice",
    "Velká Polom",
    "Hrabyně",
    "Horní Lhota",
    "Čavisov",
  ],
  "33806": ["Cheznovice"],
  "74767": ["Hrabyně"],
  "74766": ["Dolní Lhota"],
  "33808": [
    "Zbiroh",
    "Drahoňův Újezd",
    "Čilá",
    "Kařez",
    "Kladruby",
    "Líšná",
    "Cekov",
    "Plískov",
    "Sebečice",
    "Kařízek",
    "Mlečice",
    "Zvíkovec",
    "Hlohovice",
    "Terešov",
    "Hradiště",
    "Podmokly",
    "Týček",
    "Ostrovec-Lhotka",
    "Chlum",
  ],
  "74769": ["Hlubočec", "Pustá Polom"],
  "74768": ["Kyjovice"],
  "74771": ["Brumovice"],
  "74770": ["Opava"],
  "74773": ["Opava"],
  "74775": ["Velké Heraltice"],
  "74774": ["Neplachovice", "Holasovice"],
  "74781": ["Otice"],
  "33821": ["Osek"],
  "54301": ["Lánov", "Vrchlabí"],
  "33822": ["Svojkovice", "Volduchy"],
  "54302": ["Vrchlabí"],
  "54303": ["Vrchlabí"],
  "74782": ["Štáblovice"],
  "33824": [
    "Břasy",
    "Smědčice",
    "Bezděkov",
    "Březina",
    "Újezd u Svatého Kříže",
    "Bušovice",
    "Všenice",
    "Lhotka u Radnic",
    "Němčovice",
  ],
  "58401": [
    "Ledeč nad Sázavou",
    "Kouty",
    "Kožlí",
    "Číhošť",
    "Horní Paseka",
    "Bělá",
    "Trpišovice",
    "Kozlov",
    "Prosíčka",
    "Ostrov",
    "Bojiště",
    "Kynice",
    "Dolní Město",
    "Kamenná Lhota",
    "Hradec",
    "Vilémovice",
    "Jedlá",
    "Leština u Světlé",
    "Chřenovice",
    "Hněvkovice",
    "Pavlov",
  ],
  "74784": [
    "Uhlířov",
    "Hradec nad Moravicí",
    "Moravice",
    "Vítkov",
    "Mikolajice",
    "Štáblovice",
    "Melč",
    "Radkov",
  ],
  "74787": ["Svatoňovice", "Budišov nad Budišovkou"],
  "74786": ["Kružberk"],
  "33828": [
    "Přívětice",
    "Kamenec",
    "Vejvanov",
    "Hlohovice",
    "Radnice",
    "Skomelno",
    "Chomle",
  ],
  "62500": ["Brno"],
  "74791": ["Štítina"],
  "66601": [
    "Rohozec",
    "Heroltice",
    "Tišnov",
    "Březina",
    "Deblín",
    "Předklášteří",
    "Vohančice",
    "Lomnička",
    "Všechovice",
    "Skalička",
    "Železné",
    "Nelepeč-Žernůvka",
    "Šerkovice",
    "Svatoslav",
    "Úsuší",
    "Drásov",
  ],
  "74792": ["Háj ve Slezsku"],
  "66603": [
    "Sentice",
    "Všechovice",
    "Hradčany",
    "Skalička",
    "Malhostovice",
    "Tišnov",
    "Březina",
  ],
  "74795": ["Opava"],
  "66602": ["Štěpánovice", "Předklášteří"],
  "74794": ["Dobroslavice", "Děhylov"],
  "74801": ["Hlučín"],
  "33841": ["Klabava"],
  "33842": ["Kamenný Újezd", "Hrádek"],
  "33843": [
    "Milínov",
    "Vísky",
    "Mirošov",
    "Příkosice",
    "Trokavec",
    "Mešno",
    "Štítov",
    "Kakejcov",
    "Kornatice",
    "Skořice",
  ],
  "33844": ["Dobřív"],
  "78901": [
    "Hoštejn",
    "Kosov",
    "Štíty",
    "Chromeč",
    "Hynčina",
    "Zábřeh",
    "Svébohov",
    "Vyšehoří",
    "Postřelmůvek",
    "Drozdov",
    "Jestřebí",
    "Horní Studénky",
    "Hrabová",
    "Lukavice",
    "Krchleby",
    "Rovensko",
    "Zvole",
    "Jedlí",
    "Lesnice",
    "Maletín",
    "Nemile",
    "Rájec",
    "Mírov",
    "Dlouhomilov",
    "Zborov",
  ],
  "33845": ["Těně", "Strašice"],
  "54341": ["Lánov", "Dolní Lánov"],
  "54342": ["Dolní Dvůr"],
  "54344": ["Černý Důl", "Dolní Dvůr"],
  "54351": ["Vrchlabí", "Špindlerův Mlýn"],
  "54352": ["Strážné"],
  "54361": ["Kunčice nad Labem"],
  "54362": ["Dolní Branná"],
  "54371": [
    "Horní Kalná",
    "Čermná",
    "Hostinné",
    "Chotěvice",
    "Dolní Olešnice",
    "Kunčice nad Labem",
    "Horní Olešnice",
    "Klášterská Lhota",
    "Mostek",
    "Dolní Kalná",
  ],
  "54372": ["Rudník", "Černý Důl"],
  "25701": ["Popovice", "Chotýšany", "Postupice", "Veliš"],
  "54373": ["Prosečné"],
  "54374": ["Dolní Kalná"],
  "25703": ["Popovice", "Neustupov", "Ratměřice", "Bystřice", "Jankov"],
  "54375": ["Dolní Olešnice"],
  "54376": ["Chotěvice"],
  "25705": ["Zvěstov"],
  "54377": ["Čermná"],
  "25706": ["Ostrov", "Zvěstov", "Kamberk", "Louňovice pod Blaníkem", "Veliš"],
  "25708": ["Pravonín", "Načeradec"],
  "25709": ["Vracovice", "Pravonín"],
  "33901": [
    "Dlažov",
    "Předslav",
    "Mochtín",
    "Bolešiny",
    "Ostřetice",
    "Mlýnské Struhadlo",
    "Lomec",
    "Poleň",
    "Chudenice",
    "Vrhaveč",
    "Čachrov",
    "Myslovice",
    "Bezděkov",
    "Klatovy",
    "Dolany",
    "Chlistov",
    "Plánice",
    "Běšiny",
    "Újezd u Plánice",
    "Obytce",
    "Strážov",
  ],
  "78961": ["Bludov"],
  "38001": [
    "Hříšice",
    "Budeč",
    "Radkovice u Budče",
    "Budíškovice",
    "Kostelní Vydří",
    "Dačice",
    "Báňovice",
    "Třebětice",
    "Volfířov",
    "Dobrohošť",
    "Staré Hobzí",
    "Peč",
    "Český Rudolec",
    "Horní Slatina",
    "Červený Hrádek",
  ],
  "78963": ["Ruda nad Moravou"],
  "78962": ["Bušín", "Olšany", "Bohutín"],
  "78964": ["Bohdíkov"],
  "78969": ["Postřelmov"],
  "25721": ["Poříčí nad Sázavou", "Mrač", "Bukovany"],
  "25722": [
    "Přestavlky u Čerčan",
    "Čtyřkoly",
    "Poříčí nad Sázavou",
    "Pyšely",
    "Vranov",
    "Mrač",
    "Nespeky",
    "Čerčany",
    "Lštění",
  ],
  "78971": ["Leština"],
  "25723": ["Přestavlky u Čerčan"],
  "25724": [
    "Čakov",
    "Vranov",
    "Ostředek",
    "Hvězdonice",
    "Chocerady",
    "Vodslivy",
  ],
  "78973": ["Úsov", "Klopina", "Police", "Stavenice", "Třeština"],
  "50301": ["Hradec Králové"],
  "78972": ["Bohuslavice", "Dubicko"],
  "25726": [
    "Všechlapy",
    "Radošovice",
    "Ostředek",
    "Třebešice",
    "Divišov",
    "Český Šternberk",
    "Litichovice",
    "Bílkovice",
    "Libež",
    "Slověnice",
    "Drahňovice",
  ],
  "50302": ["Předměřice nad Labem", "Hradec Králové", "Lochenice"],
  "78975": ["Brníčko"],
  "50303": [
    "Výrava",
    "Hořiněves",
    "Benátky",
    "Habřina",
    "Černilov",
    "Sendražice",
    "Smiřice",
    "Skalice",
    "Holohlavy",
    "Máslojedy",
    "Smržov",
    "Račice nad Trotinou",
    "Vrchovnice",
    "Lejšovka",
  ],
  "78974": ["Libina", "Rohle", "Kamenná"],
  "25728": ["Chotýšany"],
  "50304": ["Černožice"],
  "50305": ["Lužany"],
  "54401": [
    "Třebihošť",
    "Dvůr Králové nad Labem",
    "Vítězná",
    "Kohoutov",
    "Heřmanice",
    "Nemojov",
    "Stanovice",
    "Doubravice",
    "Libotov",
    "Kocbeře",
    "Kuks",
    "Lanžov",
    "Bílá Třemešná",
    "Zábřezí-Řečice",
    "Litíč",
    "Zdobín",
    "Vilantice",
    "Vlčkovice v Podkrkonoší",
    "Hajnice",
    "Hřibojedy",
    "Trotina",
  ],
  "50306": ["Hořiněves"],
  "54404": ["Dvůr Králové nad Labem"],
  "78983": ["Palonín", "Loštice"],
  "50311": ["Hradec Králové"],
  "78982": ["Moravičany"],
  "50312": ["Stěžery", "Světí", "Všestary", "Střezetice", "Neděliště"],
  "78985": ["Mohelnice", "Líšnice", "Pavlov"],
  "50313": ["Dohalice"],
  "50314": ["Stračov"],
  "50315": [
    "Lodín",
    "Třesovice",
    "Sovětice",
    "Dohalice",
    "Kunčice",
    "Stračov",
    "Sadová",
    "Všestary",
    "Čistěves",
    "Hněvčeves",
    "Pšánky",
    "Mžany",
    "Puchlovice",
    "Hrádek",
    "Mokrovousy",
    "Myštěves",
    "Nechanice",
    "Petrovice",
    "Dolní Přím",
    "Králíky",
    "Boharyně",
  ],
  "50316": ["Dolní Přím"],
  "66701": ["Židlochovice", "Vojkovice"],
  "25741": [
    "Chleby",
    "Lešany",
    "Týnec nad Sázavou",
    "Krhanice",
    "Bukovany",
    "Kamenný Přívoz",
    "Chářovice",
  ],
  "25742": ["Týnec nad Sázavou", "Krhanice"],
  "78991": ["Písařov", "Janoušov", "Štíty", "Jakubovice"],
  "25744": [
    "Neveklov",
    "Netvořice",
    "Rabyně",
    "Krňany",
    "Vysoký Újezd",
    "Lešany",
    "Chrášťany",
    "Chářovice",
  ],
  "50321": ["Stěžery", "Hradec Králové"],
  "70800": ["Ostrava"],
  "50322": ["Libčany"],
  "50323": ["Boharyně"],
  "50324": ["Kratonohy"],
  "74901": [
    "Libavá",
    "Čermná ve Slezsku",
    "Březová",
    "Nové Lublice",
    "Vítkov",
    "Větřkovice",
    "Staré Těchanovice",
  ],
  "50325": ["Dobřenice"],
  "50326": ["Osice"],
  "25751": ["Bystřice", "Olbramovice", "Maršovice"],
  "50327": [
    "Osičky",
    "Radostov",
    "Lhota pod Libčany",
    "Libčany",
    "Roudnice",
    "Urbanice",
    "Osice",
    "Hvozdnice",
    "Radíkovice",
    "Syrovátka",
    "Praskačka",
    "Těchlovice",
  ],
  "79001": ["Jeseník", "Bělá pod Pradědem"],
  "25753": [
    "Bystřice",
    "Olbramovice",
    "Vrchotovy Janovice",
    "Maršovice",
    "Vojkov",
  ],
  "25754": ["Vojkov"],
  "25755": ["Vrchotovy Janovice", "Maršovice"],
  "50331": ["Vysoká nad Labem"],
  "25756": [
    "Neveklov",
    "Stranný",
    "Tisem",
    "Chrášťany",
    "Křečovice",
    "Maršovice",
  ],
  "50332": ["Hradec Králové"],
  "50333": ["Praskačka"],
  "25763": [
    "Tichonice",
    "Soutice",
    "Javorník",
    "Hulice",
    "Chlum",
    "Trhový Štěpánov",
  ],
  "25764": ["Zdislavice"],
  "25765": [
    "Borovnice",
    "Bernartice",
    "Strojetice",
    "Keblov",
    "Loket",
    "Křivsoudov",
    "Miřetice",
    "Mnichovice",
    "Pravonín",
    "Čechtice",
    "Chmelná",
    "Kuňovice",
  ],
  "50341": ["Hradec Králové"],
  "25766": ["Křivsoudov"],
  "50343": ["Černilov"],
  "25768": [
    "Dolní Kralovice",
    "Vlastějovice",
    "Blažejovice",
    "Dunice",
    "Snět",
    "Studený",
    "Loket",
    "Děkanovice",
    "Šetějovice",
    "Tomice",
  ],
  "50344": ["Libřice"],
  "50346": [
    "Běleč nad Orlicí",
    "Librantice",
    "Blešno",
    "Týniště nad Orlicí",
    "Třebechovice pod Orebem",
    "Černilov",
    "Jeníkovice",
    "Libníkovice",
  ],
  "54442": ["Choustníkovo Hradiště"],
  "25771": ["Soutice"],
  "54443": ["Kuks", "Heřmanice"],
  "50351": [
    "Běrunice",
    "Klamoš",
    "Obědovice",
    "Nepolisy",
    "Písek",
    "Nové Město",
    "Babice",
    "Mlékosrby",
    "Chudeřice",
    "Nový Bydžov",
    "Olešnice",
    "Stará Voda",
    "Kosice",
    "Převýšov",
    "Kratonohy",
    "Chlumec nad Cidlinou",
    "Lišice",
  ],
  "50352": ["Skřivany"],
  "50353": ["Sloupno", "Vinary", "Šaplava", "Smidary"],
  "50354": ["Ohnišťany"],
  "50355": ["Petrovice"],
  "54451": ["Doubravice"],
  "50356": ["Hlušice", "Vinary"],
  "54452": ["Bílé Poličany"],
  "50357": ["Starý Bydžov"],
  "54454": ["Velký Vřešťov"],
  "54455": ["Dubenec"],
  "54456": ["Hřibojedy"],
  "50361": ["Lovčice"],
  "25786": [
    "Neustupov",
    "Ješetice",
    "Miličín",
    "Smilkov",
    "Mezno",
    "Červený Újezd",
  ],
  "50362": ["Lužec nad Cidlinou"],
  "25787": ["Střezimíř"],
  "50363": ["Nepolisy"],
  "25788": ["Červený Újezd"],
  "50364": ["Měník"],
  "25789": [
    "Sedlec-Prčice",
    "Ješetice",
    "Smilkov",
    "Heřmaničky",
    "Červený Újezd",
  ],
  "50365": ["Kosičky"],
  "54461": ["Nemojov"],
  "25790": ["Smilkov"],
  "50366": ["Káranice"],
  "54462": ["Vítězná"],
  "25791": ["Sedlec-Prčice", "Nechvalice", "Střezimíř", "Červený Újezd"],
  "54464": ["Kocbeře"],
  "54466": ["Hajnice"],
  "54472": ["Bílá Třemešná", "Dolní Brusnice"],
  "25801": [
    "Kondrac",
    "Vracovice",
    "Kladruby",
    "Rataje",
    "Pavlovice",
    "Tehov",
    "Zvěstov",
    "Radošovice",
    "Psáře",
    "Hradiště",
    "Ctiboř",
    "Vlašim",
    "Řimovice",
  ],
  "54474": ["Horní Brusnice"],
  "79051": ["Supíkovice"],
  "54475": ["Třebihošť", "Borovnička", "Horní Brusnice", "Mostek"],
  "79053": ["Stará Červená Voda"],
  "54477": ["Borovnice"],
  "79052": ["Velké Kunětice"],
  "79055": ["Vidnava"],
  "79054": ["Černá Voda"],
  "79057": ["Bernartice"],
  "79058": ["Velká Kraš"],
  "34004": ["Železná Ruda"],
  "79061": ["Lipová-lázně"],
  "38101": [
    "Hořice na Šumavě",
    "Větřní",
    "Boletice",
    "Chvalšiny",
    "Kájov",
    "Přídolí",
    "Rožmitál na Šumavě",
    "Český Krumlov",
    "Srnín",
    "Malšín",
    "Bohdalovice",
    "Přísečná",
    "Zlatá Koruna",
  ],
  "79063": ["Lipová-lázně"],
  "79065": ["Kobylá nad Vidnavkou", "Skorošice", "Uhelná", "Vlčice", "Žulová"],
  "79064": ["Vápenná"],
  "34012": [
    "Měčín",
    "Červené Poříčí",
    "Biřkov",
    "Mezihoří",
    "Švihov",
    "Ježovy",
    "Křenice",
    "Chudenice",
    "Kbel",
  ],
  "79069": ["Bílá Voda"],
  "46303": ["Stráž nad Nisou"],
  "79070": ["Uhelná", "Javorník"],
  "50401": [
    "Měník",
    "Humburky",
    "Zachrašťany",
    "Kobylice",
    "Barchov",
    "Králíky",
    "Zdechovice",
    "Prasek",
    "Nový Bydžov",
    "Smidary",
  ],
  "34021": [
    "Dlažov",
    "Klenová",
    "Javor",
    "Dešenice",
    "Janovice nad Úhlavou",
    "Týnec",
    "Strážov",
    "Běhařov",
  ],
  "34022": [
    "Chudenín",
    "Dešenice",
    "Janovice nad Úhlavou",
    "Železná Ruda",
    "Nýrsko",
    "Hamry",
  ],
  "46311": ["Liberec"],
  "46312": ["Jeřmanice", "Šimonovice", "Dlouhý Most", "Liberec"],
  "79081": ["Česká Ves"],
  "58601": ["Rančířov", "Hybrálec", "Čížov", "Měšín", "Jihlava"],
  "58602": ["Vyskytná nad Jihlavou", "Jihlava"],
  "58603": ["Malý Beranov"],
  "79082": ["Písečná"],
  "62700": ["Podolí", "Brno", "Šlapanice"],
  "79084": ["Mikulovice", "Hradec-Nová Ves"],
  "34034": ["Hnačov", "Plánice", "Zavlekov", "Zborovy"],
  "70900": ["Ostrava"],
  "46331": [
    "Bílý Kostel nad Nisou",
    "Frýdlant",
    "Oldřichov v Hájích",
    "Chrastava",
    "Nová Ves",
    "Mníšek",
  ],
  "75002": ["Bochoř", "Beňov", "Přestavlky", "Dobrčice", "Přerov", "Stará Ves"],
  "46334": ["Chotyně", "Hrádek nad Nisou"],
  "46342": ["Hodkovice nad Mohelkou", "Bílá", "Frýdštejn"],
  "46343": [
    "Bílá",
    "Všelibice",
    "Světlá pod Ještědem",
    "Český Dub",
    "Osečná",
    "Proseč pod Ještědem",
    "Kobyly",
    "Cetenov",
  ],
  "46344": [
    "Radimovice",
    "Žďárek",
    "Paceřice",
    "Pěnčín",
    "Vlastibořice",
    "Sychrov",
  ],
  "46345": [
    "Svijanský Újezd",
    "Lažany",
    "Pěnčín",
    "Čtveřín",
    "Soběslavice",
    "Kobyly",
  ],
  "46346": ["Svijany", "Příšovice"],
  "46348": ["Všelibice", "Hlavice", "Cetenov"],
  "46352": ["Janův Důl", "Osečná", "Ralsko", "Cetenov"],
  "46353": ["Janovice v Podještědí", "Rynoltice", "Zdislava", "Křižany"],
  "46362": ["Lázně Libverda", "Bílý Potok", "Hejnice"],
  "46365": ["Jindřichovice pod Smrkem", "Nové Město pod Smrkem"],
  "46373": ["Pertoltice", "Habartice", "Višňová", "Černousy"],
  "25901": ["Votice", "Olbramovice", "Maršovice", "Vojkov"],
  "34101": [
    "Velké Hydčice",
    "Hejná",
    "Svéradice",
    "Myslív",
    "Olšany",
    "Břežany",
    "Kovčín",
    "Slatina",
    "Maňovice",
    "Budětice",
    "Hradešice",
    "Malý Bor",
    "Plánice",
    "Nalžovské Hory",
    "Chanovice",
    "Horažďovice",
    "Kejnice",
    "Velký Bor",
    "Nehodiv",
    "Pačejov",
    "Kvášňovice",
  ],
  "38201": ["Dolní Třebonín"],
  "38202": ["Zlatá Koruna"],
  "38203": ["Brloh", "Chvalšiny", "Křemže", "Holubov", "Nová Ves"],
  "38206": ["Brloh"],
  "38208": ["Chvalšiny", "Boletice"],
  "46401": [
    "Dětřichov",
    "Kunratice",
    "Horní Řasnice",
    "Krásný Les",
    "Frýdlant",
    "Višňová",
    "Dolní Řasnice",
    "Heřmanice",
    "Raspenava",
    "Bulovka",
  ],
  "38211": ["Větřní", "Bohdalovice"],
  "38216": ["Světlík"],
  "38218": ["Rožmberk nad Vltavou"],
  "38221": ["Kájov"],
  "38222": ["Hořice na Šumavě"],
  "38223": ["Černá v Pošumaví"],
  "62800": ["Brno"],
  "38226": ["Černá v Pošumaví", "Horní Planá", "Frymburk", "Boletice"],
  "38229": ["Polná na Šumavě", "Boletice"],
  "66902": [
    "Chvalovice",
    "Znojmo",
    "Lukov",
    "Dyje",
    "Vrbovec",
    "Bezkov",
    "Dyjákovičky",
    "Milíčovice",
    "Suchohrdly",
    "Kuchařovice",
    "Hnanice",
    "Podmolí",
    "Havraníky",
    "Mašovice",
    "Nový Šaldorf-Sedlešovice",
  ],
  "38232": [
    "Zvíkov",
    "Mojné",
    "Dolní Třebonín",
    "Věžovatá Pláně",
    "Netřebice",
    "Střítež",
    "Velešín",
    "Zlatá Koruna",
    "Zubčice",
    "Mirkovice",
    "Chlumec",
    "Kaplice",
  ],
  "66904": ["Znojmo"],
  "71000": ["Ostrava"],
  "75101": ["Oplocany", "Lobodice", "Tovačov"],
  "34142": [
    "Číhaň",
    "Hartmanice",
    "Hlavňovice",
    "Plánice",
    "Velhartice",
    "Hrádek",
    "Nalžovské Hory",
    "Tužice",
    "Zavlekov",
    "Kolinec",
    "Čachrov",
  ],
  "75103": [
    "Čelechovice",
    "Brodek u Přerova",
    "Citov",
    "Nelešovice",
    "Císařov",
    "Majetín",
  ],
  "75102": ["Troubky"],
  "75105": ["Kokory"],
  "79201": [
    "Nová Pláň",
    "Nové Heřminovy",
    "Oborná",
    "Valšov",
    "Široká Niva",
    "Roudno",
    "Milotice nad Opavou",
    "Václavov u Bruntálu",
    "Lomnice",
    "Moravskoslezský Kočov",
    "Staré Město",
    "Razová",
    "Mezina",
    "Bruntál",
    "Dlouhá Stráň",
  ],
  "38241": [
    "Rožmitál na Šumavě",
    "Omlenice",
    "Soběnov",
    "Benešov nad Černou",
    "Malonty",
    "Horní Dvořiště",
    "Besednice",
    "Střítež",
    "Pohorská Ves",
    "Dolní Dvořiště",
    "Bujanov",
    "Kaplice",
  ],
  "75104": ["Rokytnice"],
  "38242": ["Střítež"],
  "75111": [
    "Hradčany",
    "Radslavice",
    "Pavlovice u Přerova",
    "Oldřichov",
    "Sušice",
    "Šišma",
  ],
  "34151": ["Velký Bor"],
  "75115": ["Domaželice", "Beňov", "Čechy", "Líšná"],
  "75114": [
    "Dřevohostice",
    "Nahošovice",
    "Radkovy",
    "Turovice",
    "Křtomil",
    "Radkova Lhota",
    "Lipová",
  ],
  "75117": ["Horní Moštěnice"],
  "75116": ["Želatovice", "Podolí", "Tučín"],
  "75119": ["Věžky", "Vlkoš"],
  "75118": ["Říkovice"],
  "75121": ["Prosenice", "Grymov", "Buk", "Sobíšky", "Radvanice"],
  "75123": ["Dolní Újezd"],
  "75122": ["Osek nad Bečvou"],
  "75125": ["Výkleky", "Veselíčko", "Lazníčky", "Dolní Újezd", "Lazníky"],
  "75124": ["Lhotka", "Přerov"],
  "75127": ["Zábeštní Lhota", "Přerov"],
  "75131": [
    "Libavá",
    "Bohuslávky",
    "Jezernice",
    "Kladníky",
    "Hlinsko",
    "Lipník nad Bečvou",
    "Lhota",
    "Týn nad Bečvou",
  ],
  "38272": ["Dolní Dvořiště"],
  "38273": ["Vyšší Brod", "Přední Výtoň", "Malšín", "Frymburk", "Loučovice"],
  "38276": ["Loučovice"],
  "38278": ["Lipno nad Vltavou"],
  "38279": ["Frymburk"],
  "38281": ["Besednice"],
  "75144": ["Polkovice"],
  "38282": ["Benešov nad Černou"],
  "38283": ["Pohorská Ves"],
  "34192": ["Rejštejn", "Horská Kvilda", "Kašperské Hory", "Srní", "Modrava"],
  "38291": ["Malonty"],
  "30100": ["Plzeň"],
  "38292": ["Rožmitál na Šumavě"],
  "38293": ["Horní Dvořiště"],
  "34201": [
    "Dražovice",
    "Dobršín",
    "Prášily",
    "Nezdice na Šumavě",
    "Dlouhá Ves",
    "Frymburk",
    "Nová Ves",
    "Čímice",
    "Žihobce",
    "Budětice",
    "Hartmanice",
    "Hlavňovice",
    "Petrovice u Sušice",
    "Nezamyslice",
    "Hrádek",
    "Soběšice",
    "Sušice",
    "Domoraz",
    "Mokrosuky",
    "Podmokly",
    "Žichovice",
    "Rabí",
    "Bukovník",
    "Strašín",
  ],
  "38301": [
    "Ktiš",
    "Husinec",
    "Zábrdí",
    "Kratušín",
    "Dub",
    "Křišťanov",
    "Mičovice",
    "Těšovice",
    "Nebahovy",
    "Záblatí",
    "Chroboly",
    "Prachatice",
    "Buk",
    "Volary",
    "Žárovná",
    "Pěčnov",
    "Svatá Maří",
    "Hracholusky",
    "Radhostice",
    "Šumavské Hoštice",
    "Dvory",
    "Lhenice",
    "Drslavice",
    "Strunkovice nad Blanicí",
    "Zbytiny",
    "Vlachovo Březí",
    "Žernovice",
  ],
  "50601": [
    "Ohaveč",
    "Březina",
    "Holenice",
    "Zámostí-Blata",
    "Úlibice",
    "Jičíněves",
    "Samšina",
    "Tuř",
    "Dolní Lochov",
    "Újezd pod Troskami",
    "Mladějov",
    "Podhradí",
    "Chyjice",
    "Kbelnice",
    "Ohařice",
    "Vitiněves",
    "Kněžnice",
    "Podůlší",
    "Jičín",
    "Brada-Rybníček",
    "Kovač",
    "Holín",
    "Konecchlumí",
    "Dílce",
    "Butoves",
    "Bukvice",
    "Ostružno",
    "Troskovice",
    "Kostelec",
    "Střevač",
    "Libošovice",
    "Slatiny",
    "Jinolice",
    "Kacákova Lhota",
    "Staré Místo",
    "Libuň",
    "Nemyčeves",
    "Češov",
  ],
  "54701": [
    "Borová",
    "Dolní Radechová",
    "Náchod",
    "Vysokov",
    "Kramolna",
    "Studnice",
  ],
  "58801": ["Smrčná"],
  "58805": [
    "Dušejov",
    "Dudín",
    "Hojkov",
    "Mirošov",
    "Zbilidy",
    "Boršov",
    "Hubenov",
    "Milíčov",
    "Dvorce",
    "Opatov",
  ],
  "58811": ["Střítež"],
  "58812": ["Dobronín"],
  "58813": [
    "Dobronín",
    "Dobroutov",
    "Brzkov",
    "Kamenná",
    "Věžnička",
    "Polná",
    "Záborná",
    "Ždírec",
  ],
  "71100": ["Šilheřovice", "Ostrava"],
  "75201": [
    "Měrovice nad Hanou",
    "Křenovice",
    "Stříbrnice",
    "Kojetín",
    "Uhřičice",
  ],
  "58821": ["Jamné", "Vysoké Studnice", "Velký Beranov", "Kozlov"],
  "58822": ["Luka nad Jihlavou", "Brtnice", "Bítovčice", "Kamenice"],
  "79303": ["Dětřichov nad Bystřicí"],
  "58823": ["Kamenice"],
  "79302": ["Lomnice"],
  "58824": ["Kamenice"],
  "79305": ["Moravský Beroun", "Dětřichov nad Bystřicí", "Norberčany"],
  "58825": ["Jersín"],
  "58826": ["Zhoř"],
  "58827": [
    "Jamné",
    "Arnolec",
    "Meziříčko",
    "Nadějov",
    "Věžnice",
    "Rybné",
    "Stáj",
  ],
  "58831": ["Puklice"],
  "58832": ["Stonařov", "Brtnice"],
  "58833": [
    "Cerekvička-Rosice",
    "Hladov",
    "Stonařov",
    "Suchá",
    "Otín",
    "Vílanec",
    "Pavlov",
  ],
  "79312": [
    "Staré Heřminovy",
    "Sosnová",
    "Horní Benešov",
    "Horní Životice",
    "Svobodné Heřmanice",
  ],
  "58834": ["Dlouhá Brtnice"],
  "79315": ["Lichnov"],
  "58835": ["Cerekvička-Rosice", "Vílanec"],
  "79316": ["Čaková", "Zátor"],
  "58841": [
    "Ježená",
    "Vyskytná nad Jihlavou",
    "Hybrálec",
    "Bílý Kámen",
    "Plandry",
    "Rantířov",
  ],
  "58842": ["Větrný Jeníkov", "Zbinohy", "Šimanov", "Ústí", "Kalhov"],
  "79323": ["Karlovice", "Krasov"],
  "58844": ["Rohozná"],
  "58845": ["Dolní Cerekev"],
  "79324": ["Karlova Studánka"],
  "79326": ["Ludvíkov", "Vrbno pod Pradědem", "Karlovice", "Krasov"],
  "79331": ["Světlá Hora", "Rudná pod Pradědem", "Andělská Hora"],
  "58851": [
    "Batelov",
    "Kostelec",
    "Kaliště",
    "Dolní Cerekev",
    "Jihlávka",
    "Dvorce",
    "Cejle",
    "Švábov",
    "Klatovec",
    "Rohozná",
  ],
  "58852": ["Horní Dubenky"],
  "58854": ["Mrákotín"],
  "58856": [
    "Borovná",
    "Knínice",
    "Kostelní Myslová",
    "Řídelov",
    "Černíč",
    "Vanov",
    "Vanůvek",
    "Strachoňovice",
    "Bohuslavice",
    "Lhotka",
    "Olšany",
    "Olší",
    "Radkov",
    "Vystrčenovice",
    "Telč",
    "Volevčice",
    "Horní Myslová",
    "Zadní Vydří",
    "Třeštice",
    "Zdeňkov",
    "Hostětice",
    "Dolní Vilímeč",
    "Doupě",
    "Markvartice",
    "Řásná",
    "Zvolenovice",
    "Svojkovice",
    "Vápovice",
    "Krahulčí",
    "Sedlatice",
    "Dyjice",
    "Mysletice",
    "Nová Říše",
    "Mrákotín",
  ],
  "79336": ["Malá Morávka"],
  "58861": ["Kostelec", "Cejle"],
  "58862": [
    "Dyjice",
    "Mysliboř",
    "Ořechov",
    "Urbanov",
    "Žatec",
    "Sedlejov",
    "Nevcehle",
  ],
  "79342": ["Rýmařov"],
  "58864": ["Krasonice"],
  "58865": ["Nová Říše"],
  "79344": ["Tvrdkov", "Horní Město"],
  "58866": ["Rozseč"],
  "58867": ["Stará Říše"],
  "26101": [
    "Drahlín",
    "Příbram",
    "Sádek",
    "Dubno",
    "Hluboš",
    "Občov",
    "Podlesí",
    "Višňová",
    "Narysov",
    "Suchodol",
    "Lhota u Příbramě",
    "Háje",
    "Obecnice",
    "Trhové Dušníky",
    "Dubenec",
    "Drásov",
  ],
  "79351": ["Břidličná", "Velká Štáhle", "Jiříkov", "Huzová", "Rýmařov"],
  "79356": ["Ryžoviště"],
  "38401": ["Nebahovy"],
  "38402": ["Lhenice"],
  "38403": ["Ktiš"],
  "38404": ["Ktiš", "Chroboly"],
  "46601": ["Jablonec nad Nisou"],
  "79368": ["Leskovec nad Moravicí", "Bílčice", "Dvorce", "Křišťanovice"],
  "46602": ["Jablonec nad Nisou", "Lučany nad Nisou"],
  "79371": ["Holčovice"],
  "38411": [
    "Lhenice",
    "Chvalovice",
    "Netolice",
    "Němčice",
    "Hracholusky",
    "Lužice",
    "Malovice",
    "Strunkovice nad Blanicí",
    "Libějovice",
    "Mahouš",
    "Babice",
    "Olšovice",
  ],
  "46604": ["Jablonec nad Nisou"],
  "46605": ["Jablonec nad Nisou"],
  "46606": ["Jablonec nad Nisou"],
  "50702": ["Žeretice"],
  "50703": [
    "Vrbice",
    "Kozojedy",
    "Žeretice",
    "Sekeřice",
    "Volanice",
    "Vinary",
    "Sběř",
    "Vysoké Veselí",
  ],
  "79374": ["Heřmanovice"],
  "50704": ["Třtěnice"],
  "50705": ["Konecchlumí"],
  "79376": ["Zlaté Hory"],
  "50706": ["Lužany"],
  "50707": ["Úlibice"],
  "38421": ["Husinec"],
  "58901": [
    "Jezdovice",
    "Hodice",
    "Růžená",
    "Třešť",
    "Panenská Rozsíčka",
    "Pavlov",
  ],
  "38422": [
    "Bušanovice",
    "Dub",
    "Újezdec",
    "Tvrzice",
    "Chlumany",
    "Lipovice",
    "Bohunice",
    "Vlachovo Březí",
    "Budkov",
  ],
  "79383": ["Jindřichov"],
  "50711": ["Valdice"],
  "79382": ["Třemešná"],
  "50712": ["Radim"],
  "38425": ["Dub"],
  "50713": [
    "Soběraz",
    "Bradlecká Lhota",
    "Železnice",
    "Radim",
    "Dřevěnice",
    "Kyje",
  ],
  "79384": ["Petrovice", "Janov"],
  "38426": ["Strunkovice nad Blanicí"],
  "38427": ["Vitějovice"],
  "50715": ["Libuň"],
  "67101": ["Citonice"],
  "67103": ["Vranov nad Dyjí"],
  "79391": ["Úvalno"],
  "67102": [
    "Lesná",
    "Zálesí",
    "Vracovice",
    "Horní Břečkov",
    "Štítary",
    "Chvalatice",
    "Onšov",
    "Šumná",
  ],
  "38432": ["Lažiště"],
  "79393": ["Brantice"],
  "38433": ["Záblatí"],
  "50721": ["Veliš"],
  "71200": ["Ostrava"],
  "50722": ["Střevač"],
  "67107": [
    "Korolupy",
    "Oslnovice",
    "Vysočany",
    "Vratěnín",
    "Uherčice",
    "Zblovice",
    "Bítov",
    "Lubnice",
  ],
  "79395": ["Město Albrechtice"],
  "50723": [
    "Rokytňany",
    "Bystřice",
    "Markvartice",
    "Staré Hrady",
    "Zelenecká Lhota",
    "Údrnice",
    "Bačalky",
    "Sedliště",
    "Libáň",
    "Dětenice",
  ],
  "67106": [
    "Šafov",
    "Starý Petřín",
    "Lančov",
    "Stálky",
    "Podhradí nad Dyjí",
    "Podmyče",
  ],
  "50724": ["Dětenice"],
  "75301": [
    "Olšovec",
    "Hrabůvka",
    "Ústí",
    "Hranice",
    "Radíkov",
    "Teplice nad Bečvou",
    "Jindřichov",
    "Zámrsky",
    "Partutovice",
  ],
  "79397": ["Bohušov", "Rusín", "Slezské Rudoltice"],
  "79399": [
    "Slezské Pavlovice",
    "Liptaň",
    "Dívčí Hrad",
    "Bohušov",
    "Vysoká",
    "Hlinka",
    "Osoblaha",
  ],
  "67110": ["Bítov"],
  "79401": [
    "Býkov-Láryšov",
    "Hošťálkovy",
    "Krnov",
    "Lichnov",
    "Brantice",
    "Krasov",
  ],
  "38441": ["Zbytiny"],
  "38442": ["Lenora"],
  "38443": ["Strážný"],
  "50731": ["Jičíněves"],
  "38444": ["Stožec"],
  "50732": [
    "Běchary",
    "Budčeves",
    "Slavhostice",
    "Cholenice",
    "Kopidlno",
    "Údrnice",
    "Židovice",
  ],
  "50733": ["Vršce", "Jičíněves"],
  "50734": ["Žlunice"],
  "38451": [
    "Stožec",
    "Nová Pec",
    "Želnava",
    "Lenora",
    "Volary",
    "Horní Planá",
    "Horní Vltavice",
  ],
  "67122": ["Šatov"],
  "67125": ["Tasovice", "Hodonice"],
  "67124": ["Vrbovec"],
  "50742": ["Markvartice"],
  "67127": ["Hrádek"],
  "50743": ["Markvartice", "Sobotka", "Osek"],
  "67126": ["Dyjákovice"],
  "50744": ["Libošovice"],
  "67129": ["Strachotice"],
  "50745": ["Újezd pod Troskami", "Mladějov"],
  "67128": [
    "Valtrovice",
    "Slup",
    "Znojmo",
    "Hrádek",
    "Jaroslavice",
    "Křídlůvky",
    "Krhovice",
    "Velký Karlov",
  ],
  "67131": ["Únanov"],
  "67133": ["Mikulovice"],
  "67132": ["Vevčice", "Plaveč"],
  "38462": ["Nová Pec"],
  "67134": [
    "Výrovice",
    "Tvořihráz",
    "Horní Dunajovice",
    "Žerotice",
    "Želetice",
  ],
  "50752": ["Ostroměř"],
  "50753": ["Chomutice"],
  "50754": ["Podhorní Újezd a Vojice"],
  "67139": ["Běhařovice"],
  "67138": ["Višňové"],
  "67140": [
    "Horní Kounice",
    "Přeskače",
    "Medlice",
    "Běhařovice",
    "Křepice",
    "Tavíkovice",
    "Újezd",
  ],
  "50758": ["Mlázovice"],
  "38471": ["Šumavské Hoštice"],
  "50759": ["Šárovcova Lhota"],
  "67142": ["Vémyslice"],
  "38472": ["Zdíkov"],
  "38473": [
    "Vrbice",
    "Vimperk",
    "Nicov",
    "Stachy",
    "Vacov",
    "Dřešín",
    "Vacovice",
    "Drážov",
    "Zdíkov",
  ],
  "67151": [
    "Kravsko",
    "Olbramkostel",
    "Žerůtky",
    "Znojmo",
    "Plenkovice",
    "Vranovská Ves",
  ],
  "18000": ["Praha"],
  "67153": [
    "Černín",
    "Rozkoš",
    "Střelice",
    "Jevišovice",
    "Bojanovice",
    "Rudlice",
    "Vevčice",
    "Slatina",
    "Němčičky",
  ],
  "38481": [
    "Zálezly",
    "Svatá Maří",
    "Čkyně",
    "Lčovice",
    "Radhostice",
    "Bošice",
    "Bohumilice",
  ],
  "67152": ["Plaveč", "Hluboké Mašůvky"],
  "67155": ["Blížkovice"],
  "50771": ["Rohoznice", "Tetín", "Borek", "Úhlejov", "Miletín", "Vřesník"],
  "67154": [
    "Prokopov",
    "Ctidružice",
    "Hostim",
    "Boskovštejn",
    "Blanné",
    "Jiřice u Moravských Budějovic",
  ],
  "50773": ["Dobrá Voda u Hořic"],
  "67156": ["Grešlové Mýto", "Blížkovice", "Pavlice"],
  "38486": ["Vacov"],
  "67161": [
    "Bantice",
    "Prosiměřice",
    "Vítonice",
    "Kyjovice",
    "Těšetice",
    "Práče",
    "Stošíkovice na Louce",
  ],
  "75353": [
    "Býškovice",
    "Horní Těšice",
    "Všechovice",
    "Malhotice",
    "Dolní Těšice",
    "Provodovice",
    "Rouské",
    "Horní Újezd",
  ],
  "50777": ["Cerekvice nad Bystřicí"],
  "75352": ["Skalička"],
  "26202": ["Dobříš", "Stará Huť"],
  "67163": ["Lechovice"],
  "75355": ["Paršovice"],
  "26203": [
    "Nový Knín",
    "Mokrovraty",
    "Bojanovice",
    "Čím",
    "Chotilsko",
    "Nové Dvory",
    "Malá Hraštice",
    "Borotice",
    "Korkyně",
  ],
  "38491": ["Horní Vltavice"],
  "67162": ["Oleksovice"],
  "75354": [
    "Radotín",
    "Rakov",
    "Soběchleby",
    "Hranice",
    "Oprostovice",
    "Horní Nětčice",
    "Bezuchov",
    "Dolní Nětčice",
    "Žákovice",
  ],
  "26204": ["Malá Hraštice", "Nová Ves pod Pleší"],
  "38492": ["Borová Lada"],
  "67165": ["Břežany"],
  "26205": ["Bojanovice", "Velká Lečice"],
  "38493": ["Kvilda"],
  "50781": [
    "Choteč",
    "Šárovcova Lhota",
    "Svatojanský Újezd",
    "Lázně Bělohrad",
    "Holovousy",
    "Mlázovice",
  ],
  "67164": ["Božice", "Šanov"],
  "75356": ["Opatovice"],
  "26206": ["Korkyně"],
  "50782": ["Pecka", "Vidochov"],
  "67167": ["Šanov", "Hrušovany nad Jevišovkou"],
  "67169": ["Hevlín"],
  "75361": ["Hranice", "Milenov", "Klokočí"],
  "34401": [
    "Mrákov",
    "Stráž",
    "Pelechy",
    "Újezd",
    "Milavče",
    "Nový Kramolín",
    "Díly",
    "Ždánov",
    "Česká Kubice",
    "Zahořany",
    "Pasečnice",
    "Spáňov",
    "Pařezov",
    "Trhanov",
    "Chrastavice",
    "Draženov",
    "Domažlice",
    "Babylon",
    "Klenčí pod Čerchovem",
    "Pec",
    "Všeruby",
    "Luženičky",
    "Nemanice",
    "Nevolice",
    "Tlumačov",
  ],
  "67168": ["Hrabětice", "Hevlín", "Šanov"],
  "67171": ["Morašice", "Trstěnice", "Džbánice", "Hostěradice", "Skalice"],
  "75363": ["Střítež nad Ludinou"],
  "26211": ["Rosovice"],
  "75362": ["Libavá", "Potštát"],
  "26212": ["Obořiště"],
  "67173": [
    "Rešice",
    "Čermákovice",
    "Dolní Dubňany",
    "Tulešice",
    "Horní Dubňany",
  ],
  "75365": ["Polom"],
  "26213": ["Nečín"],
  "38501": [
    "Kvilda",
    "Vimperk",
    "Svatá Maří",
    "Horská Kvilda",
    "Lenora",
    "Nové Hutě",
    "Horní Vltavice",
    "Kubova Huť",
    "Borová Lada",
  ],
  "67172": ["Miroslav", "Miroslavské Knínice", "Suchohrdly u Miroslavi"],
  "75364": ["Polom", "Bělotín"],
  "26214": ["Hřiměždice"],
  "67175": [
    "Moravský Krumlov",
    "Jezeřany-Maršovice",
    "Vedrovice",
    "Olbramovice",
    "Loděnice",
    "Šumice",
  ],
  "75367": ["Milotice nad Bečvou"],
  "26215": ["Borotice"],
  "50791": ["Svojek", "Nová Paka", "Stará Paka", "Levínská Olešnice"],
  "75366": ["Hustopeče nad Bečvou", "Špičky"],
  "50792": ["Úbislavice"],
  "67177": ["Branišovice"],
  "67176": ["Bohutice", "Kubšice", "Našiměřice", "Olbramovice"],
  "75368": ["Černotín"],
  "67178": [
    "Dolenice",
    "Mackovice",
    "Litobratřice",
    "Čejkovice",
    "Troskotovice",
    "Jiřice u Miroslavi",
    "Damnice",
    "Trnové Pole",
    "Borotice",
    "Pravice",
  ],
  "67181": ["Znojmo", "Nový Šaldorf-Sedlešovice"],
  "26221": ["Obecnice"],
  "26222": ["Hluboš"],
  "26223": [
    "Kotenčice",
    "Jince",
    "Hluboš",
    "Křešín",
    "Buková u Příbramě",
    "Čenkov",
    "Bratkovice",
    "Ohrazenice",
    "Pičín",
  ],
  "67182": ["Znojmo", "Dobšice"],
  "26225": ["Pičín"],
  "50801": [
    "Bříšťany",
    "Lukavec u Hořic",
    "Nevratice",
    "Cerekvice nad Bystřicí",
    "Holovousy",
    "Rašín",
    "Milovice u Hořic",
    "Ostroměř",
    "Sukorady",
    "Podhorní Újezd a Vojice",
    "Třebnouševes",
    "Hořice",
    "Šárovcova Lhota",
    "Boháňka",
    "Staré Smrkovice",
    "Petrovičky",
    "Sobčice",
    "Lískovice",
    "Chomutice",
    "Bílsko u Hořic",
    "Jeřice",
    "Červená Třemešná",
    "Bašnice",
  ],
  "54901": [
    "Bohdašín",
    "Vršovka",
    "Přibyslav",
    "Nový Hrádek",
    "Nahořany",
    "Bohuslavice",
    "Slavětín nad Metují",
    "Slavoňov",
    "Černčice",
    "Nové Město nad Metují",
    "Jestřebí",
    "Libchyně",
    "Sendraž",
    "Janov",
  ],
  "26231": [
    "Háje",
    "Lazsko",
    "Těchařovice",
    "Příbram",
    "Zbenice",
    "Bohostice",
    "Lešetice",
    "Radětice",
    "Vrančice",
    "Pečice",
    "Cetyně",
    "Milín",
  ],
  "26232": ["Pečice"],
  "54906": ["Bohuslavice"],
  "54907": ["Nahořany"],
  "54908": ["Provodov-Šonov"],
  "54911": ["Dolní Radechová"],
  "54912": ["Vysokov"],
  "67201": [
    "Moravský Krumlov",
    "Lesonice",
    "Petrovice",
    "Jamolice",
    "Kadov",
    "Rybníky",
    "Tulešice",
    "Dobelice",
    "Dobřínsko",
  ],
  "26241": ["Láz", "Příbram", "Bohutín"],
  "26242": [
    "Březí",
    "Sedlice",
    "Bělčice",
    "Chrást",
    "Nepomuk",
    "Rožmitál pod Třemšínem",
    "Vysoká u Příbramě",
    "Vranovice",
    "Třebsko",
    "Hvožďany",
    "Bezděkov pod Třemšínem",
    "Věšín",
    "Modřovice",
  ],
  "26243": ["Věšín"],
  "26244": ["Hvožďany"],
  "71300": ["Ostrava"],
  "54921": ["Česká Čermná"],
  "54922": ["Nový Hrádek"],
  "26251": ["Dublovice"],
  "54923": ["Mezilesí"],
  "26252": ["Vysoký Chlumec"],
  "79501": ["Dolní Moravice", "Malá Štáhle", "Rýmařov", "Stará Ves"],
  "26255": ["Krásná Hora nad Vltavou", "Petrovice", "Počepice"],
  "26256": [
    "Dublovice",
    "Krásná Hora nad Vltavou",
    "Milešov",
    "Klučenice",
    "Svatý Jan",
  ],
  "54931": [
    "Vysoká Srbská",
    "Česká Metuje",
    "Velké Petrovice",
    "Hronov",
    "Žďárky",
    "Machov",
    "Žďár nad Metují",
    "Bezděkov nad Metují",
    "Stárkov",
    "Velké Poříčí",
  ],
  "54932": ["Velké Poříčí"],
  "26261": ["Višňová"],
  "26262": ["Dolní Hbity"],
  "54934": ["Hronov"],
  "26263": [
    "Solenice",
    "Kamýk nad Vltavou",
    "Bohostice",
    "Jablonná",
    "Smolotely",
    "Dolní Hbity",
    "Svatý Jan",
    "Zduchovice",
    "Milín",
  ],
  "54936": ["Stárkov"],
  "54937": ["Vysoká Srbská", "Žďárky"],
  "54941": [
    "Červená Hora",
    "Červený Kostelec",
    "Hronov",
    "Rtyně v Podkrkonoší",
    "Zábrodí",
    "Horní Radechová",
    "Stárkov",
  ],
  "26272": [
    "Horčápsko",
    "Nestrašovice",
    "Vševily",
    "Kozárovice",
    "Volenice",
    "Koupě",
    "Tušovice",
    "Svojšice",
    "Tochovice",
    "Zalužany",
    "Chraštice",
    "Chrást",
    "Ostrov",
    "Hudčice",
    "Starosedlský Hrádek",
    "Počaply",
    "Těchařovice",
    "Zbenice",
    "Bukovany",
    "Březnice",
    "Hlubyně",
  ],
  "54946": ["Horní Radechová"],
  "54947": ["Slatina nad Úpou"],
  "54948": ["Studnice"],
  "54952": ["Adršpach"],
  "26281": ["Tochovice"],
  "54954": [
    "Suchý Důl",
    "Police nad Metují",
    "Velké Petrovice",
    "Bukovice",
    "Žďár nad Metují",
    "Bezděkov nad Metují",
  ],
  "54955": ["Žďár nad Metují"],
  "26284": ["Kozárovice", "Zalužany"],
  "54956": ["Česká Metuje"],
  "26285": ["Drahenice"],
  "54957": ["Teplice nad Metují", "Vernéřovice", "Adršpach"],
  "14000": ["Praha"],
  "54962": ["Suchý Důl"],
  "26291": ["Kosova Hora"],
  "54963": ["Machov"],
  "18100": ["Praha"],
  "54964": ["Bezděkov nad Metují"],
  "26293": ["Křepenice", "Nalžovice"],
  "54971": ["Šonov"],
  "54972": ["Otovice"],
  "26301": [
    "Obořiště",
    "Dobříš",
    "Županovice",
    "Obory",
    "Ouběnice",
    "Svaté Pole",
    "Drevníky",
    "Chotilsko",
    "Nečín",
    "Rosovice",
    "Voznice",
    "Drhovy",
    "Hřiměždice",
    "Rybníky",
    "Borotice",
    "Dlouhá Lhota",
    "Daleké Dušníky",
  ],
  "54973": ["Martínkovice"],
  "54974": ["Božanov"],
  "34501": ["Mrákov"],
  "54981": ["Meziměstí"],
  "34502": ["Kout na Šumavě"],
  "54982": ["Vernéřovice"],
  "54983": ["Meziměstí", "Jetřichov", "Hynčice"],
  "54984": ["Heřmánkovice"],
  "38601": [
    "Velká Turná",
    "Pracejovice",
    "Nebřehovice",
    "Únice",
    "Slaník",
    "Střelské Hoštice",
    "Štěkeň",
    "Strakonice",
    "Novosedly",
    "Kalenice",
    "Osek",
    "Úlehle",
    "Sousedovice",
    "Jinín",
    "Bratronice",
    "Paračov",
    "Rovná",
    "Čejetice",
    "Radomyšl",
    "Libětice",
    "Mutěnice",
    "Krty-Hradec",
    "Chrášťovice",
    "Přešťovice",
    "Droužetice",
    "Hlupín",
    "Krejnice",
    "Doubravice",
    "Řepice",
    "Radošovice",
    "Třešovice",
    "Horní Poříčí",
    "Skály",
    "Kváskovice",
    "Drachkov",
    "Kuřimany",
    "Čestice",
    "Třebohostice",
    "Miloňovice",
    "Mnichov",
  ],
  "34506": [
    "Úsilov",
    "Kout na Šumavě",
    "Mezholezy",
    "Libkov",
    "Nová Ves",
    "Černíkov",
    "Chodská Lhota",
    "Všeruby",
    "Pocinovice",
    "Brnířov",
    "Němčice",
    "Zahořany",
    "Loučim",
    "Kdyně",
  ],
  "34507": ["Všeruby"],
  "34509": ["Pocinovice"],
  "46801": ["Jablonec nad Nisou", "Maršovice"],
  "46802": ["Pulečný", "Rychnov u Jablonce nad Nisou", "Dalešice"],
  "46803": ["Rádlo"],
  "46804": ["Jablonec nad Nisou"],
  "50901": ["Úbislavice", "Vidochov", "Nová Paka", "Stará Paka"],
  "34521": ["Meclov"],
  "55001": ["Hejtmánkovice", "Broumov", "Heřmánkovice", "Křinice"],
  "34522": [
    "Drahotín",
    "Otov",
    "Poběžovice",
    "Hvožďany",
    "Hora Svatého Václava",
    "Vlkanov",
    "Mnichov",
  ],
  "46811": ["Janov nad Nisou"],
  "46812": ["Bedřichov"],
  "34525": [
    "Rybník",
    "Horšovský Týn",
    "Bělá nad Radbuzou",
    "Mutěnín",
    "Hostouň",
  ],
  "59101": [
    "Vysoké",
    "Vatín",
    "Hamry nad Sázavou",
    "Lhotka",
    "Radenice",
    "Sklené nad Oslavou",
    "Vojnův Městec",
    "Radostín",
    "Sklené",
    "Ostrov nad Oslavou",
    "Žďár nad Sázavou",
    "Rousměrov",
    "Obyčtov",
    "Hodíškov",
    "Počítky",
    "Škrdlovice",
    "Sazomín",
    "Sázava",
  ],
  "34526": ["Bělá nad Radbuzou"],
  "59102": ["Cikháj", "Světnov", "Polnička", "Žďár nad Sázavou"],
  "34532": ["Česká Kubice"],
  "34533": ["Chodov", "Trhanov"],
  "46821": ["Nová Ves nad Nisou", "Pěnčín", "Maršovice"],
  "34534": ["Klenčí pod Čerchovem"],
  "46822": [
    "Líšný",
    "Radčice",
    "Skuhrov",
    "Jílové u Držkova",
    "Vlastiboř",
    "Loužnice",
    "Malá Skála",
    "Zlatá Olešnice",
    "Koberovy",
    "Frýdštejn",
    "Železný Brod",
  ],
  "34535": ["Postřekov"],
  "46824": ["Držkov"],
  "46825": ["Zásada"],
  "46826": ["Pěnčín"],
  "46827": ["Nová Ves nad Nisou"],
  "75501": ["Janová", "Lhota u Vsetína", "Ústí", "Vsetín"],
  "34543": [
    "Kaničky",
    "Únějovice",
    "Úboč",
    "Koloveč",
    "Kanice",
    "Všepadly",
    "Zahořany",
    "Chocomyšl",
    "Hradiště",
    "Srbice",
  ],
  "79601": ["Prostějov"],
  "34545": ["Blížejov"],
  "46833": ["Jenišovice"],
  "79603": ["Prostějov"],
  "79604": ["Prostějov"],
  "79607": ["Držovice"],
  "46841": ["Tanvald", "Desná", "Kořenov"],
  "46843": ["Albrechtice v Jizerských horách", "Jiřetín pod Bukovou"],
  "46844": ["Josefův Důl", "Lučany nad Nisou"],
  "46845": ["Velké Hamry"],
  "46846": ["Plavy"],
  "46847": ["Zlatá Olešnice"],
  "46848": ["Kořenov"],
  "34561": [
    "Čermná",
    "Puclice",
    "Hlohová",
    "Močerady",
    "Křenovy",
    "Osvračín",
    "Hlohovčice",
    "Poděvousy",
    "Staňkov",
  ],
  "46849": ["Kořenov"],
  "34562": [
    "Všekary",
    "Holýšov",
    "Horní Kamenice",
    "Černovice",
    "Bukovec",
    "Štichov",
    "Čečovice",
    "Neuměř",
    "Kvíčovice",
  ],
  "46850": ["Kořenov"],
  "46851": ["Smržovka"],
  "46861": ["Desná"],
  "10000": ["Praha"],
  "14100": ["Praha"],
  "46871": ["Lučany nad Nisou"],
  "18200": ["Praha"],
  "26401": [
    "Sedlec-Prčice",
    "Štětkovice",
    "Nalžovice",
    "Nechvalice",
    "Radíč",
    "Jesenice",
    "Kosova Hora",
    "Nedrahovice",
    "Prosenická Lhota",
    "Vysoký Chlumec",
    "Počepice",
    "Křepenice",
    "Sedlčany",
    "Dublovice",
    "Osečany",
    "Petrovice",
    "Kňovice",
    "Příčovy",
  ],
  "34601": [
    "Srby",
    "Velký Malahov",
    "Semněvice",
    "Blížejov",
    "Mířkov",
    "Horšovský Týn",
    "Mezholezy",
    "Meclov",
    "Vidice",
  ],
  "38701": [
    "Nišovice",
    "Čepřovice",
    "Přední Zborovice",
    "Malenice",
    "Radošovice",
    "Přechovice",
    "Nihošovice",
    "Strunkovice nad Volyňkou",
    "Předslavice",
    "Litochovice",
    "Němětice",
    "Čestice",
    "Volyně",
    "Hoštice",
    "Milejovice",
  ],
  "38706": ["Malenice"],
  "38711": ["Katovice"],
  "38715": ["Střelské Hoštice"],
  "38716": [
    "Pracejovice",
    "Zvotoky",
    "Štěchovice",
    "Krejnice",
    "Volenice",
    "Hoslovice",
    "Kladruby",
    "Novosedly",
    "Kalenice",
    "Kraselov",
    "Strašice",
  ],
  "55101": [
    "Vlkov",
    "Šestajovice",
    "Hořenice",
    "Rasošky",
    "Velká Jesenice",
    "Zaloňov",
    "Nahořany",
    "Jaroměř",
    "Nový Ples",
    "Rožnov",
  ],
  "55102": ["Rasošky", "Jaroměř"],
  "38719": [
    "Němčice",
    "Nihošovice",
    "Zahorčice",
    "Dřešín",
    "Vacovice",
    "Drážov",
    "Hoslovice",
    "Čestice",
    "Nová Ves",
    "Úlehle",
  ],
  "59201": ["Herálec"],
  "59202": ["Chlumětín", "Křižánky", "Svratka", "Sněžné"],
  "59203": [
    "Daňkovice",
    "Nový Jimramov",
    "Kuklík",
    "Kadov",
    "Líšná",
    "Krásné",
    "Javorek",
    "Spělkov",
    "Sněžné",
  ],
  "59204": ["Fryšava pod Žákovou horou", "Tři Studně"],
  "67401": [
    "Okřešice",
    "Kožichovice",
    "Třebíč",
    "Stařeč",
    "Střítež",
    "Trnava",
    "Výčapy",
  ],
  "38731": ["Radomyšl"],
  "59211": ["Malá Losenice", "Vepřová", "Račín", "Velká Losenice", "Sázava"],
  "38732": ["Sedlice"],
  "59212": [
    "Rosička",
    "Nížkov",
    "Nové Dvory",
    "Matějov",
    "Sirákov",
    "Sázava",
    "Újezd",
    "Poděšín",
  ],
  "38733": ["Kadov"],
  "59213": ["Bohdalov"],
  "71500": ["Ostrava"],
  "38734": ["Záboří"],
  "59214": [
    "Budeč",
    "Bohdalov",
    "Březí nad Oslavou",
    "Rudolec",
    "Kotlasy",
    "Kyjov",
    "Pokojov",
    "Nové Veselí",
    "Újezd",
  ],
  "38735": ["Doubravice"],
  "38736": ["Mečichov"],
  "75601": ["Hovězí"],
  "38737": ["Třebohostice"],
  "75603": ["Huslenky", "Halenkov"],
  "75602": ["Huslenky"],
  "75605": ["Karolinka"],
  "59221": ["Karlov", "Polnička"],
  "75604": ["Nový Hrozenkov"],
  "38742": ["Bělčice", "Kocelovice", "Předmíř", "Hornosín", "Lnáře"],
  "75607": ["Zděchov"],
  "38743": ["Bělčice"],
  "75606": ["Velké Karlovice"],
  "75611": [
    "Lužná",
    "Leskovec",
    "Seninka",
    "Pozděchov",
    "Prlov",
    "Valašská Polanka",
  ],
  "75612": [
    "Študlov",
    "Střelná",
    "Francova Lhota",
    "Lidečko",
    "Horní Lideč",
    "Valašské Příkazy",
    "Lačnov",
  ],
  "38751": ["Štěkeň"],
  "59231": [
    "Zubří",
    "Radňovice",
    "Vlachovice",
    "Nová Ves u Nového Města na Moravě",
    "Tři Studně",
    "Křídla",
    "Nové Město na Moravě",
  ],
  "75614": ["Francova Lhota", "Valašská Senice"],
  "38752": ["Cehnice"],
  "59232": ["Jámy"],
  "59233": ["Řečice", "Radešínská Svratka"],
  "38756": ["Čepřovice"],
  "75621": ["Ratiboř", "Kateřinice"],
  "75623": ["Pržno", "Jablůnka"],
  "75622": ["Hošťálková"],
  "75625": ["Růžďka"],
  "59241": ["Dalečín"],
  "75624": ["Oznice", "Bystřička", "Jarcová", "Mikulůvka"],
  "59242": [
    "Borovnice",
    "Strachujov",
    "Nový Jimramov",
    "Unčín",
    "Věcov",
    "Jimramov",
  ],
  "75627": [
    "Rožnov pod Radhoštěm",
    "Valašská Bystřice",
    "Velká Lhota",
    "Malá Bystřice",
  ],
  "59244": ["Věcov"],
  "59245": ["Lísek"],
  "75631": ["Liptál"],
  "38771": ["Číčenice"],
  "59251": [
    "Rozsochy",
    "Rodkov",
    "Dolní Rožínka",
    "Horní Rožínka",
    "Blažkov",
    "Bukov",
    "Zvole",
    "Střítež",
    "Milasín",
  ],
  "10100": ["Praha"],
  "38772": ["Libějovice"],
  "59252": ["Rožná"],
  "38773": [
    "Pivkovice",
    "Radějovice",
    "Bavorov",
    "Měkynec",
    "Bílsko",
    "Hájek",
    "Budyně",
    "Krajníčko",
  ],
  "59253": [
    "Mirošov",
    "Dolní Libochová",
    "Pikárec",
    "Nová Ves",
    "Strážek",
    "Radkov",
    "Moravecké Pavlovice",
  ],
  "59254": ["Moravec"],
  "38775": ["Skočice"],
  "59255": [
    "Dlouhé",
    "Bobrůvka",
    "Bobrová",
    "Podolí",
    "Mirošov",
    "Bohdalec",
    "Radešín",
    "Račice",
  ],
  "14200": ["Praha"],
  "59256": ["Zvole"],
  "75641": ["Lešná"],
  "59257": ["Rozsochy"],
  "75643": ["Kelč", "Kladeruby"],
  "75642": ["Choryně", "Valašské Meziříčí"],
  "75645": ["Branky"],
  "59261": ["Pernštejnské Jestřabí", "Borač", "Doubravník", "Olší", "Drahonín"],
  "75644": ["Loučka", "Podolí", "Kunovice", "Police"],
  "59262": [
    "Sejřek",
    "Býšovec",
    "Nedvědice",
    "Skorotice",
    "Doubravník",
    "Ujčov",
    "Věžná",
    "Moravecké Pavlovice",
    "Černvír",
  ],
  "59263": ["Štěpánov nad Svratkou"],
  "59264": ["Prosetín"],
  "59265": [
    "Rovečné",
    "Sulkovec",
    "Velké Tresné",
    "Dalečín",
    "Nyklovice",
    "Ubušínek",
    "Chlum-Korouhvice",
    "Věstín",
  ],
  "59266": ["Vír"],
  "75651": ["Zašová"],
  "75653": ["Vidče"],
  "75652": ["Střítež nad Bečvou"],
  "75655": ["Dolní Bečva"],
  "75654": ["Zubří", "Zašová"],
  "75657": ["Horní Bečva"],
  "75656": ["Prostřední Bečva"],
  "75661": ["Rožnov pod Radhoštěm", "Vigantice", "Dolní Bečva"],
  "34701": [
    "Lesná",
    "Tachov",
    "Studánka",
    "Milíře",
    "Tisová",
    "Dlouhý Újezd",
    "Lom u Tachova",
    "Ctiboř",
    "Obora",
    "Halže",
  ],
  "75663": ["Krhová"],
  "75662": ["Hutisko-Solanec"],
  "38801": [
    "Sedlice",
    "Bělčice",
    "Tchořovice",
    "Lažánky",
    "Lom",
    "Buzice",
    "Mačkov",
    "Blatná",
    "Myštice",
    "Bezdědovice",
    "Lažany",
    "Škvořetice",
    "Uzeničky",
    "Bratronice",
    "Kadov",
    "Čečelovice",
    "Chlum",
    "Hajany",
    "Uzenice",
    "Chobot",
  ],
  "47001": [
    "Kvítkov",
    "Stvolínky",
    "Sosnová",
    "Kozly",
    "Stružnice",
    "Česká Lípa",
  ],
  "47002": [
    "Blíževedly",
    "Stvolínky",
    "Holany",
    "Velenice",
    "Zahrádky",
    "Dubá",
    "Žandov",
    "Zákupy",
    "Kozly",
    "Stružnice",
    "Horní Police",
    "Kravaře",
    "Bohatice",
    "Česká Lípa",
  ],
  "51101": [
    "Lomnice nad Popelkou",
    "Všeň",
    "Loučky",
    "Olešnice",
    "Radostná pod Kozákovem",
    "Vyskeř",
    "Hrubá Skála",
    "Modřišice",
    "Rakousy",
    "Kacanovy",
    "Karlovice",
    "Mírová pod Kozákovem",
    "Turnov",
    "Rovensko pod Troskami",
    "Ohrazenice",
    "Klokočí",
  ],
  "47006": ["Česká Lípa"],
  "55203": [
    "Žernov",
    "Říkov",
    "Provodov-Šonov",
    "Rychnovek",
    "Dolany",
    "Nahořany",
    "Česká Skalice",
    "Vysokov",
    "Studnice",
    "Velký Třebešov",
  ],
  "55204": ["Dolany", "Chvalkovice", "Brzice"],
  "55205": [
    "Vestec",
    "Litoboř",
    "Mezilečí",
    "Lhota pod Hořičkami",
    "Slatina nad Úpou",
    "Brzice",
    "Hořičky",
  ],
  "59301": [
    "Bystřice nad Pernštejnem",
    "Lísek",
    "Prosetín",
    "Louka",
    "Věchnov",
    "Bohuňov",
    "Věstín",
    "Koroužné",
    "Věžná",
    "Rožná",
    "Velké Janovice",
    "Býšovec",
    "Ždánice",
    "Písečné",
    "Štěpánov nad Svratkou",
  ],
  "63400": ["Brno"],
  "55211": ["Velichovky"],
  "55212": ["Heřmanice"],
  "67501": [
    "Smrk",
    "Vladislav",
    "Číměř",
    "Kožichovice",
    "Zárubice",
    "Slavičky",
  ],
  "67503": [
    "Pozďatín",
    "Valdíkov",
    "Budišov",
    "Kamenná",
    "Kojatín",
    "Kamenice",
    "Studnice",
    "Hodov",
    "Nárameč",
  ],
  "67502": ["Koněšín", "Kozlany", "Okarec", "Studenec", "Třesov"],
  "67505": [
    "Rudíkov",
    "Přeckov",
    "Vlčatín",
    "Oslavička",
    "Rohy",
    "Bochovice",
    "Hroznatín",
    "Nový Telečkov",
    "Horní Heřmanice",
  ],
  "67504": ["Hodov"],
  "71600": ["Ostrava"],
  "67507": [
    "Horní Smrčné",
    "Radošov",
    "Červená Lhota",
    "Čechtín",
    "Číhalín",
    "Benetice",
    "Svatoslav",
    "Chlum",
    "Horní Vilémovice",
  ],
  "67506": ["Benetice"],
  "75701": [
    "Poličná",
    "Růžďka",
    "Valašské Meziříčí",
    "Lešná",
    "Jarcová",
    "Velká Lhota",
    "Mikulůvka",
  ],
  "55221": ["Rasošky"],
  "67508": ["Kouty"],
  "55222": ["Jasenná"],
  "55224": ["Velká Jesenice"],
  "55225": ["Rychnovek"],
  "79803": [
    "Prostějovičky",
    "Malé Hradisko",
    "Ohrozim",
    "Krumsín",
    "Vícov",
    "Březina",
    "Stínava",
    "Ptení",
    "Plumlov",
  ],
  "79802": ["Mostkovice"],
  "79805": ["Březina", "Myslejovice"],
  "79804": [
    "Dětkovice",
    "Vincencov",
    "Alojzov",
    "Určice",
    "Seloutky",
    "Myslejovice",
  ],
  "79807": [
    "Želeč",
    "Dobrochov",
    "Brodek u Prostějova",
    "Hradčany-Kobeřice",
    "Ondratice",
  ],
  "79806": ["Otaslavice"],
  "67521": [
    "Číchov",
    "Bransouze",
    "Nová Ves",
    "Kněžice",
    "Okříšky",
    "Radonín",
    "Zašovice",
    "Hvězdoňovice",
    "Krahulov",
    "Přibyslavice",
    "Petrovice",
    "Pokojovice",
    "Heraltice",
    "Chlum",
  ],
  "79809": ["Výšovice", "Vřesovice"],
  "79808": ["Vranovice-Kelčice"],
  "67523": ["Kojetice"],
  "79811": ["Prostějov"],
  "67522": [
    "Mikulovice",
    "Římov",
    "Rokytnice nad Rokytnou",
    "Markvartice",
    "Mastník",
    "Stařeč",
    "Čechočovice",
    "Chlístov",
    "Loukovice",
    "Horní Újezd",
  ],
  "67525": ["Rokytnice nad Rokytnou"],
  "79813": ["Vrbátky"],
  "67524": ["Čáslavice"],
  "79812": ["Hrdibořice", "Biskupice", "Vrbátky", "Kralice na Hané"],
  "67527": ["Štěměchy", "Brtnička", "Předín", "Hrutov"],
  "67526": [
    "Jindřichovice",
    "Lesná",
    "Štěpkov",
    "Meziříčko",
    "Cidlina",
    "Komárovice",
    "Želetava",
  ],
  "79814": ["Olšany u Prostějova"],
  "67529": ["Kněžice"],
  "79817": ["Smržice"],
  "67528": ["Opatov"],
  "79816": ["Čelechovice na Hané"],
  "67531": [
    "Slavíkovice",
    "Jemnice",
    "Lovčovice",
    "Chotěbudice",
    "Menhartice",
    "Lomy",
    "Lhotice",
    "Pálovice",
  ],
  "67533": ["Dešov"],
  "79821": ["Bedihošť", "Hrubčice", "Klopotovice", "Čehovice"],
  "67532": [
    "Kdousov",
    "Třebelovice",
    "Radotice",
    "Kostníky",
    "Oponešice",
    "Kojatice",
    "Bačkovice",
    "Hornice",
    "Mladoňovice",
    "Rácovice",
    "Jiratice",
  ],
  "79823": ["Tvorovice", "Klenovice na Hané", "Ivaň", "Obědkovice", "Čelčice"],
  "67534": ["Police"],
  "79825": ["Dobromilice"],
  "79824": ["Pivín", "Skalka"],
  "79827": [
    "Hruška",
    "Srbce",
    "Němčice nad Hanou",
    "Pavlovice u Kojetína",
    "Vitčice",
    "Vrchoslavice",
  ],
  "79826": ["Doloplazy", "Dřevnovice", "Nezamyslice", "Víceměřice"],
  "67541": [
    "Nimpšov",
    "Dědice",
    "Láz",
    "Moravské Budějovice",
    "Nové Syrovice",
    "Kojatice",
  ],
  "79829": ["Koválovice-Osíčany", "Tištín"],
  "79828": ["Mořice"],
  "67543": ["Domamil"],
  "67542": ["Budkov"],
  "79830": ["Pavlovice u Kojetína"],
  "10200": ["Praha"],
  "67545": ["Šebkovice"],
  "67544": [
    "Martínkov",
    "Moravské Budějovice",
    "Litohoř",
    "Jakubov u Moravských Budějovic",
    "Lesonice",
    "Babice",
    "Cidlina",
  ],
  "14300": ["Praha"],
  "67551": [
    "Blatnice",
    "Dolní Lažany",
    "Lesůňky",
    "Bohušice",
    "Jaroměřice nad Rokytnou",
    "Výčapy",
    "Příštpo",
  ],
  "67550": ["Dukovany"],
  "18400": ["Praha"],
  "67553": ["Valeč"],
  "79841": [
    "Stařechovice",
    "Čelechovice na Hané",
    "Hluchov",
    "Bílovice-Lutotín",
    "Kostelec na Hané",
  ],
  "67552": [
    "Myslibořice",
    "Lipník",
    "Klučov",
    "Zárubice",
    "Ostašov",
    "Petrůvky",
    "Třebenice",
    "Dolní Vilémovice",
  ],
  "67555": [
    "Slavětice",
    "Stropešín",
    "Odunec",
    "Hrotovice",
    "Račice",
    "Krhov",
    "Bačice",
  ],
  "79843": ["Stražisko", "Zdětín", "Ptení"],
  "67554": ["Dalešice"],
  "79842": ["Lešany"],
  "67557": ["Přešovice", "Litovany", "Rouchovany", "Biskupice-Pulkov"],
  "79845": ["Brodek u Konice", "Suchdol", "Lipová"],
  "67556": ["Dukovany"],
  "79844": ["Stražisko"],
  "67559": ["Radkovice u Hrotovic"],
  "79847": ["Horní Štěpánov"],
  "79846": ["Brodek u Konice"],
  "79849": ["Malé Hradisko"],
  "26601": [
    "Chyňava",
    "Svatý Jan pod Skalou",
    "Nenačovice",
    "Tetín",
    "Trubská",
    "Beroun",
    "Hudlice",
    "Železná",
    "Koněprusy",
  ],
  "67560": ["Myslibořice"],
  "79848": ["Buková", "Protivanov"],
  "79851": ["Přemyslovice"],
  "79853": ["Dzbel", "Jesenec"],
  "79852": [
    "Březsko",
    "Hvozd",
    "Budětsko",
    "Kladky",
    "Ochoz",
    "Konice",
    "Ludmírov",
    "Přemyslovice",
    "Skřípov",
    "Šubířov",
  ],
  "79855": ["Polomí", "Hačky", "Hvozd", "Ludmírov"],
  "79854": ["Kladky"],
  "79857": ["Raková u Konice", "Pěnčín", "Rakůvka", "Laškov"],
  "34801": ["Bor", "Staré Sedliště", "Tisová", "Částkov"],
  "79856": ["Bohuslavice"],
  "34802": ["Bor", "Staré Sedlo", "Ošelín", "Stráž"],
  "67571": [
    "Krokočín",
    "Zahrádka",
    "Náměšť nad Oslavou",
    "Jasenice",
    "Ocmanice",
    "Vícenice u Náměště nad Oslavou",
    "Hluboké",
    "Jinošov",
    "Sedlec",
    "Kralice nad Oslavou",
    "Pucov",
    "Pyšel",
    "Naloučany",
  ],
  "79858": ["Čechy pod Kosířem"],
  "67573": ["Lesní Jakubov", "Kralice nad Oslavou", "Rapotice", "Sudice"],
  "79861": ["Drahany", "Otinoves", "Niva", "Rozstání", "Bousín"],
  "38901": [
    "Drahonice",
    "Skočice",
    "Truskovice",
    "Cehnice",
    "Pohorovice",
    "Chelčice",
    "Bavorov",
    "Vodňany",
    "Krašlovice",
    "Stožice",
    "Libějovice",
    "Čejetice",
    "Číčenice",
  ],
  "34806": ["Třemešné", "Stráž", "Přimda", "Rozvadov", "Hošťka"],
  "67575": [
    "Kladeruby nad Oslavou",
    "Kuroslepy",
    "Lhánice",
    "Popůvky",
    "Senorady",
    "Mohelno",
  ],
  "67574": ["Březník"],
  "79862": ["Rozstání"],
  "67577": ["Kramolín"],
  "43001": [
    "Málkov",
    "Blatno",
    "Místo",
    "Bílence",
    "Černovice",
    "Všehrdy",
    "Křimov",
    "Nezabylice",
    "Spořice",
    "Hora Svatého Šebestiána",
    "Údlice",
    "Chomutov",
    "Hrušovany",
  ],
  "67576": ["Hartvíkovice"],
  "67579": ["Tasov"],
  "43003": ["Chomutov"],
  "67578": ["Čikov"],
  "43004": ["Chomutov"],
  "34813": ["Chodová Planá"],
  "47101": ["Zahrádky"],
  "47102": ["Stvolínky", "Kravaře"],
  "34815": [
    "Planá",
    "Bor",
    "Zadní Chodov",
    "Kočov",
    "Broumov",
    "Chodský Újezd",
    "Brod nad Tichou",
    "Ctiboř",
  ],
  "47103": ["Kravaře"],
  "47104": ["Blíževedly"],
  "47105": ["Žandov"],
  "51201": ["Slaná"],
  "47106": ["Horní Police"],
  "51202": ["Košťálov"],
  "47107": ["Žandov"],
  "51203": ["Libštát"],
  "47108": ["Stružnice"],
  "51204": ["Peřimov", "Mříčná"],
  "51206": ["Benešov u Semil", "Semily", "Slaná"],
  "47111": ["Horní Libchava", "Česká Lípa"],
  "47112": ["Volfartice"],
  "47113": ["Nový Oldřichov"],
  "59401": [
    "Lavičky",
    "Otín",
    "Petráveč",
    "Ruda",
    "Stránecká Zhoř",
    "Horní Radslavice",
    "Velké Meziříčí",
    "Březejc",
    "Martinice",
    "Oslavice",
    "Baliny",
    "Dolní Heřmanice",
    "Osové",
    "Jabloňov",
    "Sviny",
    "Vídeň",
    "Pavlínov",
    "Uhřínov",
  ],
  "47114": ["Kamenický Šenov"],
  "47115": ["Prysk"],
  "51211": ["Vysoké nad Jizerou"],
  "47116": ["Polevsko"],
  "51212": ["Jesenný"],
  "63500": ["Brno"],
  "47117": ["Skalice u České Lípy"],
  "51213": ["Bozkov"],
  "47118": ["Nový Bor"],
  "47121": ["Česká Lípa"],
  "47123": ["Zákupy"],
  "67602": [
    "Moravské Budějovice",
    "Zvěrkovice",
    "Vícenice",
    "Častohostice",
    "Lukov",
  ],
  "47124": ["Mimoň", "Pertoltice pod Ralskem", "Noviny pod Ralskem", "Ralsko"],
  "47125": ["Jablonné v Podještědí", "Velký Valtinov"],
  "71700": ["Ostrava"],
  "47126": ["Dubnice"],
  "47127": ["Stráž pod Ralskem"],
  "47128": ["Hamr na Jezeře"],
  "47129": ["Brniště"],
  "51231": ["Roztoky u Jilemnice"],
  "51232": ["Roztoky u Jilemnice", "Martinice v Krkonoších"],
  "51233": ["Studenec"],
  "51234": ["Horka u Staré Paky"],
  "51235": ["Čistá u Horek"],
  "51236": ["Horní Branná"],
  "47141": ["Dubá"],
  "51237": ["Vítkovice", "Benecko"],
  "51238": ["Vítkovice"],
  "51241": ["Víchová nad Jizerou"],
  "51242": ["Poniklá"],
  "51243": ["Vysoké nad Jizerou", "Jablonec nad Jizerou"],
  "51244": ["Rokytnice nad Jizerou"],
  "51245": ["Rokytnice nad Jizerou"],
  "51246": ["Harrachov"],
  "47151": ["Svor"],
  "51247": ["Paseky nad Jizerou"],
  "47152": ["Sloup v Čechách"],
  "47153": ["Svojkov"],
  "59441": ["Uhřínov"],
  "47154": ["Cvikov"],
  "59442": ["Blízkov", "Otín", "Chlumek", "Stránecká Zhoř", "Černá", "Měřín"],
  "47155": ["Kunratice u Cvikova"],
  "51251": ["Lomnice nad Popelkou", "Košťálov", "Stružinec", "Syřenov"],
  "47156": ["Cvikov", "Mařenice"],
  "51252": ["Veselá"],
  "59444": [
    "Kněževes",
    "Krásněves",
    "Netín",
    "Radostín nad Oslavou",
    "Znětínek",
    "Zadní Zhořec",
    "Pavlov",
  ],
  "47157": ["Krompach", "Mařenice"],
  "51253": ["Tatobity"],
  "59445": ["Ostrov nad Oslavou"],
  "47158": ["Cvikov"],
  "47161": ["Jestřebí", "Chlum"],
  "47162": ["Okna"],
  "47163": ["Doksy"],
  "59451": [
    "Horní Libochová",
    "Kadolec",
    "Křižanov",
    "Heřmanov",
    "Radňoves",
    "Kozlov",
    "Nová Ves",
    "Tišnovská Nová Ves",
    "Lubné",
    "Rojetín",
    "Dobrá Voda",
    "Kundratice",
    "Žďárec",
    "Sviny",
    "Jívoví",
    "Vratislávka",
    "Milešín",
    "Rozseč",
    "Borovník",
    "Řikonín",
  ],
  "10300": ["Praha"],
  "59452": ["Ořechov"],
  "51261": ["Přepeře"],
  "59453": [
    "Březí",
    "Vlkov",
    "Záblatí",
    "Křižínkov",
    "Osová Bítýška",
    "Velká Bíteš",
    "Skřinářov",
    "Březské",
  ],
  "59454": ["Křoví"],
  "47167": ["Provodín"],
  "51263": [
    "Radostná pod Kozákovem",
    "Troskovice",
    "Žernov",
    "Lomnice nad Popelkou",
    "Hrubá Skála",
    "Veselá",
    "Ktová",
    "Rovensko pod Troskami",
    "Újezd pod Troskami",
    "Tatobity",
  ],
  "59455": [
    "Horní Loučky",
    "Kaly",
    "Skryje",
    "Kuřimská Nová Ves",
    "Kuřimské Jestřabí",
    "Níhov",
    "Dolní Loučky",
    "Katov",
    "Újezd u Tišnova",
  ],
  "51264": ["Vyskeř"],
  "59456": ["Žďárec"],
  "51265": ["Všeň"],
  "59457": ["Vidonín"],
  "59458": ["Heřmanov"],
  "59461": ["Bory"],
  "51271": ["Nová Ves nad Popelkou"],
  "26701": [
    "Málkov",
    "Libomyšl",
    "Vinařice",
    "Suchomasty",
    "Tmaň",
    "Trubín",
    "Králův Dvůr",
    "Bykoš",
  ],
  "26703": ["Otročiněves", "Hudlice", "Nový Jáchymov"],
  "26705": ["Nižbor"],
  "26706": ["Hýskov"],
  "26707": ["Chyňava", "Unhošť"],
  "34901": [
    "Vranov",
    "Sytno",
    "Horní Kozolupy",
    "Stříbro",
    "Erpužice",
    "Benešovice",
    "Kladruby",
    "Olbramov",
    "Sulislav",
    "Únehle",
    "Kostelec",
    "Zhoř",
    "Záchlumí",
    "Ošelín",
    "Pňovany",
    "Svojšín",
    "Trpísty",
    "Černošín",
    "Kšice",
    "Skapce",
    "Prostiboř",
  ],
  "26711": ["Vráž", "Svatý Jan pod Skalou"],
  "26712": ["Chrustenice", "Loděnice"],
  "39001": ["Řípec", "Tábor"],
  "39002": [
    "Planá nad Lužnicí",
    "Slapy",
    "Ústrašice",
    "Košice",
    "Zhoř u Tábora",
    "Lom",
    "Radimovice u Želče",
    "Libějice",
    "Tábor",
  ],
  "39003": ["Tábor"],
  "26716": ["Vysoký Újezd", "Mezouň", "Lužce"],
  "26717": ["Mořina"],
  "39005": ["Tábor"],
  "43101": ["Spořice"],
  "26718": [
    "Bubovice",
    "Karlštejn",
    "Srbsko",
    "Vysoký Újezd",
    "Hlásná Třebaň",
    "Mořina",
    "Mořinka",
    "Mezouň",
    "Lužce",
  ],
  "43102": ["Málkov"],
  "26721": ["Tmaň"],
  "47201": [
    "Blatce",
    "Dubá",
    "Vrchovany",
    "Bezděz",
    "Doksy",
    "Tachov",
    "Skalka u Doks",
    "Tuhaň",
    "Jestřebí",
    "Luka",
    "Chlum",
    "Ždírec",
  ],
  "26722": ["Suchomasty"],
  "26723": ["Libomyšl", "Lhotka", "Lochovice"],
  "26724": [
    "Skřipel",
    "Vižina",
    "Lážovice",
    "Hostomice",
    "Běštín",
    "Velký Chlumec",
    "Neumětely",
  ],
  "26725": ["Skřipel", "Osov"],
  "51301": [
    "Bystrá nad Jizerou",
    "Vysoké nad Jizerou",
    "Roprachtice",
    "Záhoří",
    "Jablonec nad Jizerou",
    "Háje nad Jizerou",
    "Roztoky u Semil",
    "Chuchelna",
    "Jesenný",
    "Příkrý",
    "Semily",
    "Slaná",
  ],
  "26726": ["Všeradice"],
  "26727": [
    "Podbrdy",
    "Skuhrov",
    "Svinaře",
    "Korno",
    "Liteň",
    "Nesvačily",
    "Měňany",
  ],
  "43111": ["Otvice", "Pesvice", "Vrskmaň", "Vysoká Pec", "Jirkov", "Všestudy"],
  "26728": ["Svinaře"],
  "26729": ["Zadní Třebaň"],
  "43114": ["Strupčice"],
  "43115": ["Vrskmaň"],
  "59501": ["Nové Sady", "Velká Bíteš", "Březské"],
  "63600": ["Brno"],
  "43121": ["Boleboř"],
  "26741": ["Kublov"],
  "26742": ["Broumy"],
  "26743": ["Bzová"],
  "71800": ["Ostrava"],
  "43132": ["Kalek"],
  "26751": [
    "Žebrák",
    "Zdice",
    "Hředle",
    "Svatá",
    "Chodouň",
    "Libomyšl",
    "Březová",
    "Točník",
    "Bavoryně",
    "Chlustina",
    "Lochovice",
    "Otmíče",
    "Stašov",
  ],
  "26753": ["Žebrák"],
  "26754": ["Praskolesy"],
  "43141": ["Údlice"],
  "43143": ["Hrušovany"],
  "34952": [
    "Cebiv",
    "Konstantinovy Lázně",
    "Horní Kozolupy",
    "Křelovice",
    "Kokašice",
  ],
  "43144": ["Droužkovice"],
  "26761": ["Záluží", "Drozdov", "Cerhovice", "Újezd"],
  "34953": [
    "Konstantinovy Lázně",
    "Lestkov",
    "Bezdružice",
    "Olbramov",
    "Kokašice",
  ],
  "43145": ["Březno"],
  "26762": [
    "Jivina",
    "Komárov",
    "Chaloupky",
    "Hvozdec",
    "Malá Víska",
    "Zaječov",
    "Osek",
  ],
  "26763": ["Zaječov"],
  "26764": ["Olešná"],
  "34958": ["Černošín"],
  "43151": [
    "Domašín",
    "Klášterec nad Ohří",
    "Okounov",
    "Perštejn",
    "Stráž nad Ohří",
  ],
  "34961": ["Kladruby"],
  "43153": ["Pětipsy"],
  "43154": ["Vilémov"],
  "43155": ["Radonice"],
  "43156": ["Mašťov"],
  "43157": ["Chbany"],
  "43158": ["Místo"],
  "43159": ["Vysoká Pec"],
  "43163": ["Perštejn"],
  "34972": ["Trpísty"],
  "10400": ["Praha"],
  "18600": ["Praha"],
  "43182": ["Hora Svatého Šebestiána"],
  "43183": ["Výsluní"],
  "43184": ["Měděnec"],
  "26801": ["Hořovice", "Tlustice", "Felbabka", "Rpety", "Kotopeky", "Podluhy"],
  "43186": ["Kovářská"],
  "43191": ["Kryštofovy Hamry", "Vejprty", "Loučná pod Klínovcem"],
  "35002": [
    "Třebeň",
    "Cheb",
    "Milhostov",
    "Nebanice",
    "Dolní Žandov",
    "Odrava",
    "Lipová",
    "Poustka",
    "Stará Voda",
    "Okrouhlá",
    "Tuřany",
    "Františkovy Lázně",
    "Libá",
    "Pomezí nad Ohří",
    "Vojtanov",
    "Milíkov",
  ],
  "39101": ["Sezimovo Ústí"],
  "39102": ["Planá nad Lužnicí", "Sezimovo Ústí"],
  "43201": ["Domašín", "Rokle", "Radonice", "Vilémov", "Kadaň"],
  "47301": [
    "Svor",
    "Okrouhlá",
    "Radvanec",
    "Zákupy",
    "Slunečná",
    "Nový Bor",
    "Chotovice",
    "Krompach",
    "Cvikov",
  ],
  "39111": ["Planá nad Lužnicí"],
  "51401": [
    "Bukovina u Čisté",
    "Jilemnice",
    "Košťálov",
    "Horka u Staré Paky",
    "Jablonec nad Jizerou",
    "Horní Branná",
    "Víchová nad Jizerou",
    "Bělá",
    "Jestřabí v Krkonoších",
    "Roztoky u Jilemnice",
    "Kruh",
    "Studenec",
    "Poniklá",
    "Levínská Olešnice",
    "Benecko",
  ],
  "39116": ["Myslkovice"],
  "39117": ["Košice"],
  "39118": ["Choustník"],
  "39120": ["Radenín"],
  "39121": ["Turovec"],
  "63700": ["Brno"],
  "39126": ["Tučapy"],
  "39127": ["Dírná"],
  "67801": ["Blansko", "Šebrov-Kateřina"],
  "39131": [
    "Jistebnice",
    "Svrabov",
    "Dražice",
    "Nasavrky",
    "Drhovice",
    "Radimovice u Tábora",
    "Meziříčí",
    "Radkov",
    "Balkova Lhota",
    "Tábor",
  ],
  "39132": ["Jistebnice"],
  "39133": ["Jistebnice", "Borotín"],
  "71900": ["Ostrava"],
  "39135": ["Borotín"],
  "39136": ["Sudoměřice u Tábora"],
  "76001": ["Velký Ořechov", "Racková", "Zlín", "Březnice"],
  "39137": ["Jedlany", "Košín", "Chotoviny", "Tábor"],
  "76005": ["Zlín"],
  "39142": ["Ratibořské Hory"],
  "39143": [
    "Nová Ves u Mladé Vožice",
    "Smilovy Hory",
    "Bradáčov",
    "Vilice",
    "Pojbuky",
    "Rodná",
    "Ratibořské Hory",
    "Pohnánec",
    "Řemíčov",
    "Pohnání",
    "Šebířov",
    "Mladá Vožice",
    "Nemyšl",
    "Slapsko",
    "Zadní Střítež",
    "Hlasivo",
    "Oldřichov",
    "Dolní Hrachovice",
    "Zhoř u Mladé Vožice",
    "Běleč",
  ],
  "39152": ["Smilovy Hory"],
  "39153": ["Vodice"],
  "39155": [
    "Nová Ves u Chýnova",
    "Radenín",
    "Dolní Hořice",
    "Turovec",
    "Vodice",
    "Chrbonín",
    "Dlouhá Lhota",
    "Chýnov",
  ],
  "39156": ["Sezimovo Ústí", "Turovec", "Tábor"],
  "39161": ["Opařany", "Řepeč", "Stádlec"],
  "39162": ["Stádlec"],
  "39165": [
    "Černýšovice",
    "Hodonice",
    "Záhoří",
    "Bechyně",
    "Radětice",
    "Haškovcova Lhota",
    "Sudoměřice u Bechyně",
    "Dobronice u Bechyně",
    "Hodětín",
    "Čenkov u Bechyně",
    "Rataje",
    "Stádlec",
  ],
  "39171": ["Březnice"],
  "39172": ["Sudoměřice u Bechyně"],
  "39173": ["Hlavatce"],
  "39174": ["Želeč"],
  "39175": [
    "Skrýchov u Malšic",
    "Želeč",
    "Slapy",
    "Hlavatce",
    "Dražičky",
    "Bečice",
    "Malšice",
  ],
  "39176": ["Slapy"],
  "39181": [
    "Val",
    "Drahov",
    "Žíšov",
    "Vlkov",
    "Zlukov",
    "Řípec",
    "Veselí nad Lužnicí",
    "Borkovice",
    "Hodětín",
    "Sviny",
    "Mažice",
    "Zálší",
  ],
  "26901": [
    "Lišany",
    "Lužná",
    "Nový Dům",
    "Ruda",
    "Pavlíkov",
    "Olešná",
    "Rakovník",
  ],
  "35101": ["Františkovy Lázně"],
  "39201": [
    "Komárov",
    "Řípec",
    "Hlavatce",
    "Vlastiboř",
    "Skalice",
    "Vesce",
    "Sedlečko u Soběslavě",
    "Mlýny",
    "Mezná",
    "Soběslav",
    "Tučapy",
    "Chotěmice",
    "Roudná",
    "Skopytce",
    "Krtov",
    "Krátošice",
    "Třebějice",
    "Choustník",
    "Katov",
    "Zvěrotice",
    "Budislav",
    "Klenovice",
    "Přehořov",
    "Dírná",
    "Košice",
    "Vlčeves",
    "Psárov",
    "Dráchov",
  ],
  "35124": ["Hranice"],
  "63800": ["Brno"],
  "35131": ["Libá"],
  "35132": ["Hazlov"],
  "67901": [
    "Boskovice",
    "Voděrady",
    "Jabloňany",
    "Skalice nad Svitavou",
    "Lysice",
    "Lhota Rapotina",
    "Obora",
    "Krhov",
  ],
  "35134": [
    "Třebeň",
    "Cheb",
    "Milhostov",
    "Luby",
    "Nový Kostel",
    "Skalná",
    "Velký Luh",
    "Plesná",
    "Vojtanov",
    "Křižovatka",
  ],
  "67903": ["Blansko", "Olomučany"],
  "35135": ["Plesná"],
  "67902": [
    "Blansko",
    "Rájec-Jestřebí",
    "Žďár",
    "Petrovice",
    "Kuničky",
    "Ráječko",
    "Spešov",
  ],
  "67905": [
    "Křtiny",
    "Hostěnice",
    "Bukovinka",
    "Březina",
    "Bukovina",
    "Habrůvka",
  ],
  "35137": ["Luby"],
  "67904": ["Olomučany", "Habrůvka", "Adamov"],
  "72000": ["Ostrava"],
  "67907": ["Kotvrdovice"],
  "67906": [
    "Senetářov",
    "Jedovnice",
    "Rudice",
    "Kulířov",
    "Krasová",
    "Vilémovice",
    "Lipovec",
    "Kotvrdovice",
  ],
  "67911": ["Doubravice nad Svitavou"],
  "67913": [
    "Vysočany",
    "Sloup",
    "Ostrov u Macochy",
    "Holštejn",
    "Vavřinec",
    "Šošůvka",
  ],
  "67915": ["Lipovec"],
  "67914": ["Ostrov u Macochy"],
  "67921": [
    "Malá Lhota",
    "Lubě",
    "Černá Hora",
    "Bořitov",
    "Brťov-Jeneč",
    "Žernovník",
  ],
  "67923": [
    "Lomnice",
    "Synalov",
    "Brumov",
    "Ochoz u Tišnova",
    "Rohozec",
    "Zhoř",
    "Hluboké Dvory",
    "Strhaře",
    "Bukovice",
    "Osiky",
    "Rašov",
    "Běleč",
  ],
  "67922": [
    "Lažany",
    "Závist",
    "Černá Hora",
    "Lipůvka",
    "Újezd u Černé Hory",
    "Svinošice",
    "Šebrov-Kateřina",
    "Milonice",
  ],
  "67924": ["Unín"],
  "67931": ["Sebranice", "Svitávka"],
  "67933": ["Vísky"],
  "67932": ["Svitávka"],
  "67935": ["Světlá", "Šebetov"],
  "67934": ["Knínice"],
  "67937": ["Borotín"],
  "67936": ["Vanovice"],
  "67939": ["Úsobrno"],
  "67938": ["Cetkovice"],
  "10600": ["Praha"],
  "14700": ["Praha"],
  "67951": ["Němčice"],
  "67953": ["Okrouhlá", "Benešov"],
  "67952": ["Žďárná"],
  "67961": [
    "Míchov",
    "Pamětice",
    "Nýrov",
    "Horní Smržov",
    "Skrchov",
    "Stvolová",
    "Roubanina",
    "Vanovice",
    "Deštná",
    "Letovice",
    "Velké Opatovice",
  ],
  "27001": ["Kněževes", "Chrášťany", "Přílepy"],
  "27002": ["Kolešovice"],
  "67963": ["Světlá", "Malá Roudka", "Uhřice", "Šebetov", "Velké Opatovice"],
  "67962": [
    "Horní Poříčí",
    "Petrov",
    "Sulíkov",
    "Křetín",
    "Lazinov",
    "Vranová",
    "Prostřední Poříčí",
  ],
  "27004": [
    "Kolešovice",
    "Milostín",
    "Hořesedly",
    "Kolešov",
    "Děkov",
    "Svojetín",
    "Hořovičky",
  ],
  "27006": ["Kounov", "Janov"],
  "27007": ["Nesuchyně", "Mutějovice", "Kounov"],
  "27008": ["Hředle", "Krupá"],
  "27009": ["Krupá"],
  "35201": ["Aš", "Krásná", "Hranice", "Hazlov", "Podhradí"],
  "67971": [
    "Hodonín",
    "Kozárov",
    "Žerůtky",
    "Býkovice",
    "Lhota u Lysic",
    "Bedřichov",
    "Štěchov",
    "Kunice",
    "Kunčina Ves",
    "Lysice",
    "Dlouhá Lhota",
  ],
  "67973": ["Rozseč nad Kunštátem"],
  "39301": [
    "Dubovice",
    "Božejov",
    "Horní Cerekev",
    "Bácovice",
    "Leskovice",
    "Ústrašín",
    "Nová Buková",
    "Krasíkovice",
    "Červená Řečice",
    "Putimov",
    "Mezná",
    "Nový Rychnov",
    "Rynárec",
    "Vyskytná",
    "Střítež",
    "Zajíčkov",
    "Žirov",
    "Jankov",
    "Kojčice",
    "Černov",
    "Bělá",
    "Proseč pod Křemešníkem",
    "Střítež pod Křemešníkem",
    "Velký Rybník",
    "Zachotín",
    "Dehtáře",
    "Pelhřimov",
    "Moraveč",
    "Nová Cerekev",
    "Svépravice",
    "Čelistná",
    "Dobrá Voda",
    "Horní Ves",
    "Vokov",
    "Čížkov",
    "Ondřejov",
    "Olešná",
    "Pavlov",
  ],
  "67972": ["Kunštát", "Zbraslavec", "Makov", "Nýrov"],
  "67975": ["Tasovice", "Hodonín", "Černovice"],
  "67974": [
    "Křtěnov",
    "Ústup",
    "Kněževes",
    "Crhov",
    "Lhota u Olešnice",
    "Louka",
    "Rozsíčka",
    "Olešnice",
  ],
  "43401": [
    "Bečov",
    "Bělušice",
    "Braňany",
    "Lužice",
    "Most",
    "Lišnice",
    "Patokryje",
    "Volevčice",
    "Havraň",
    "Skršín",
    "Korozluky",
    "Horní Jiřetín",
    "Obrnice",
    "Polerady",
    "Želenice",
    "Malé Březno",
  ],
  "67976": ["Drnovice"],
  "27021": ["Všetaty", "Pavlíkov", "Panoší Újezd", "Lašovice"],
  "27023": [
    "Branov",
    "Roztoky",
    "Křivoklát",
    "Pustověty",
    "Městečko",
    "Karlova Ves",
    "Nezabudice",
    "Velká Buková",
  ],
  "27024": ["Zbečno", "Sýkořice", "Račice"],
  "51601": [
    "Zdobnice",
    "Javornice",
    "Vamberk",
    "Rychnov nad Kněžnou",
    "Rokytnice v Orlických horách",
    "Solnice",
    "Jahodov",
    "Liberk",
    "Synkov-Slemeno",
    "Třebešov",
    "Černíkovice",
  ],
  "51603": ["Lukavice", "Rychnov nad Kněžnou"],
  "27031": ["Pšovlky", "Senomaty", "Šanov"],
  "27032": ["Oráčov"],
  "27033": ["Žďár", "Švihov", "Jesenice", "Oráčov", "Drahouš", "Krty"],
  "27034": ["Čistá", "Velká Chmelištná", "Šípy", "Všesulov", "Břežany"],
  "27035": [
    "Malinová",
    "Řeřichy",
    "Příčina",
    "Hvozd",
    "Krakov",
    "Senomaty",
    "Zavidov",
    "Petrovice",
    "Krakovec",
    "Senec",
    "Václavy",
  ],
  "27036": ["Lubná", "Senec", "Rakovník"],
  "63900": ["Brno"],
  "68001": [
    "Knínice",
    "Újezd u Boskovic",
    "Boskovice",
    "Okrouhlá",
    "Valchov",
    "Kořenec",
    "Sudice",
    "Vážany",
    "Suchý",
    "Chrudichromy",
    "Ludíkov",
    "Velenov",
  ],
  "27041": ["Hracholusky", "Hřebečníky", "Slabce"],
  "27042": ["Skryje"],
  "72100": ["Ostrava"],
  "27051": ["Lužná"],
  "27052": ["Lišany"],
  "27053": ["Krušovice"],
  "27054": [
    "Kozojedy",
    "Přerubenice",
    "Třeboc",
    "Řevničov",
    "Milý",
    "Smilovice",
    "Bdín",
    "Kalivody",
    "Kroučová",
  ],
  "27055": ["Pochvalov"],
  "27061": ["Lány"],
  "27062": ["Rynholec"],
  "27064": ["Mšecké Žehrovice", "Mšec"],
  "27065": ["Srbeč"],
  "10700": ["Praha"],
  "14800": ["Praha"],
  "27101": [
    "Nové Strašecí",
    "Lány",
    "Ruda",
    "Třtice",
    "Řevničov",
    "Rynholec",
    "Lhota",
  ],
  "31200": ["Plzeň"],
  "35301": [
    "Drmoul",
    "Prameny",
    "Mariánské Lázně",
    "Nová Ves",
    "Stará Voda",
    "Valy",
    "Zádub-Závišín",
    "Velká Hleďsebe",
    "Tři Sekery",
    "Trstěnice",
    "Teplá",
    "Ovesné Kladruby",
    "Mnichov",
    "Vlkovice",
  ],
  "39401": ["Rynárec"],
  "39403": ["Horní Cerekev"],
  "39404": ["Nový Rychnov"],
  "39405": ["Vyskytná"],
  "43501": ["Havraň"],
  "43502": ["Most"],
  "39409": ["Kojčice"],
  "39411": ["Cetoraz"],
  "39412": ["Obrataň"],
  "39413": ["Kámen"],
  "51701": ["Solnice"],
  "39414": ["Leskovice"],
  "51702": ["Solnice", "Kvasiny"],
  "39415": ["Nová Cerekev"],
  "43511": ["Lom"],
  "51703": ["Lukavice", "Skuhrov nad Bělou", "Osečnice", "Liberk"],
  "51704": ["Černíkovice"],
  "43513": ["Meziboří"],
  "39421": ["Hořepník"],
  "39422": ["Košetice"],
  "51711": ["Javornice"],
  "39424": ["Křešín"],
  "51712": ["Liberk"],
  "43521": ["Obrnice"],
  "39426": ["Lukavec"],
  "43522": ["Braňany"],
  "39427": ["Vyklantice"],
  "39428": ["Velká Chyška"],
  "43524": ["Lužice"],
  "43526": ["Bečov"],
  "51721": [
    "Voděrady",
    "Lično",
    "Týniště nad Orlicí",
    "Borohrádek",
    "Lípa nad Orlicí",
    "Žďár nad Orlicí",
    "Zdelov",
    "Nová Ves",
    "Olešnice",
  ],
  "72200": ["Ostrava"],
  "51722": ["Albrechtice nad Orlicí"],
  "51723": ["Žďár nad Orlicí"],
  "43532": ["Mariánské Radčice"],
  "51724": ["Borohrádek"],
  "76301": ["Hostišová", "Machová", "Sazovice", "Mysločovice"],
  "43533": ["Louka u Litvínova"],
  "51725": ["Čermná nad Orlicí"],
  "76302": ["Karlovice", "Zlín", "Tečovice", "Lhota"],
  "76307": ["Dobrkovice", "Velký Ořechov", "Hřivínův Újezd", "Kelníky"],
  "39443": ["Mladé Bříště"],
  "51731": ["Bolehošť"],
  "39444": ["Želiv"],
  "51732": ["Trnov", "Přepychy"],
  "39445": ["Křelovice"],
  "51733": ["Trnov"],
  "39446": ["Červená Řečice"],
  "43542": ["Litvínov"],
  "51734": ["Voděrady"],
  "76311": ["Želechovice nad Dřevnicí", "Lípa", "Zlín", "Ostrata"],
  "43543": ["Horní Jiřetín"],
  "51735": ["Lično"],
  "76310": ["Hvozdná"],
  "51736": ["Olešnice"],
  "76313": ["Lutonina", "Jasenná"],
  "43545": ["Nová Ves v Horách"],
  "76312": [
    "Lhotsko",
    "Zádveřice-Raková",
    "Bratřejov",
    "Lutonina",
    "Ublo",
    "Vizovice",
    "Jasenná",
  ],
  "43546": ["Hora Svaté Kateřiny"],
  "76315": [
    "Všemina",
    "Dešná",
    "Veselá",
    "Březová",
    "Slušovice",
    "Neubuz",
    "Hrobice",
  ],
  "39451": ["Kaliště"],
  "43547": ["Brandov"],
  "76314": ["Zlín"],
  "39452": ["Kejžlice"],
  "76317": ["Lukov"],
  "51741": [
    "Borovnice",
    "Krchleby",
    "Častolovice",
    "Chleny",
    "Proruby",
    "Libel",
    "Lupenice",
    "Kostelecké Horky",
    "Polom",
    "Vrbice",
    "Vamberk",
    "Lično",
    "Svídnice",
    "Koldín",
    "Hřibiny-Ledská",
    "Čestice",
    "Lhoty u Potštejna",
    "Tutleky",
    "Kostelec nad Orlicí",
    "Čermná nad Orlicí",
  ],
  "76316": ["Fryšták", "Lukoveček"],
  "51742": ["Doudleby nad Orlicí"],
  "76319": ["Vlčková", "Kašava", "Držková"],
  "51743": ["Potštejn", "Záměl"],
  "76318": ["Podkopná Lhota", "Trnava"],
  "39456": ["Senožaty"],
  "76321": [
    "Bohuslavice nad Vláří",
    "Petrůvka",
    "Rudimov",
    "Slavičín",
    "Šanov",
    "Lipová",
    "Rokytnice",
  ],
  "51745": ["Chleny"],
  "76323": ["Sehradice", "Dolní Lhota", "Slopné", "Horní Lhota"],
  "39459": ["Koberovice"],
  "76325": ["Loučka", "Drnovice", "Vysoké Pole", "Újezd"],
  "39461": ["Božejov"],
  "76324": ["Haluzice", "Vlachovice"],
  "39462": ["Libkova Voda"],
  "51750": ["Častolovice"],
  "39463": ["Častrov"],
  "76326": ["Dolní Lhota", "Podhradí", "Luhačovice", "Pozlovice"],
  "39464": ["Polesí", "Počátky"],
  "51754": ["Vamberk"],
  "76331": ["Brumov-Bylnice"],
  "51755": ["Vamberk", "Rybná nad Zdobnicí"],
  "39468": ["Polesí", "Častrov", "Stojčín", "Počátky", "Žirovnice"],
  "51756": ["Slatina nad Zdobnicí"],
  "76333": ["Štítná nad Vláří-Popov", "Jestřabí"],
  "51757": ["Slatina nad Zdobnicí", "Pěčín"],
  "76332": ["Nedašov", "Nedašova Lhota", "Návojná"],
  "39470": [
    "Nová Cerekev",
    "Veselá",
    "Častrov",
    "Kamenice nad Lipou",
    "Včelnička",
    "Černovice",
    "Lhota-Vlasenice",
    "Rodinov",
    "Střítež",
    "Těmice",
    "Mnich",
    "Bořetín",
  ],
  "76334": ["Brumov-Bylnice"],
  "10800": ["Praha"],
  "51761": [
    "Říčky v Orlických horách",
    "Rokytnice v Orlických horách",
    "Kunvald",
    "Bartošovice v Orlických horách",
    "Pěčín",
  ],
  "14900": ["Praha", "Jesenice"],
  "51764": ["Orlické Záhoří"],
  "76341": ["Ludkovice", "Biskupice", "Kaňovice", "Luhačovice"],
  "19000": ["Praha"],
  "76345": ["Provodov", "Březůvky", "Doubravy"],
  "51771": [
    "Králova Lhota",
    "Mokré",
    "České Meziříčí",
    "Ledce",
    "Očelice",
    "Vysoký Újezd",
    "Rohenice",
  ],
  "51772": ["Jílovice"],
  "51773": ["Opočno"],
  "76351": ["Šarovy", "Zlín", "Bohuslavice u Zlína"],
  "27201": ["Kladno"],
  "19011": ["Praha"],
  "27203": ["Kladno"],
  "39491": ["Bohdalín"],
  "19012": ["Praha"],
  "27204": ["Kladno"],
  "39492": ["Mnich"],
  "39493": ["Mnich"],
  "19014": ["Praha"],
  "27206": ["Libušín"],
  "39494": ["Černovice"],
  "19015": ["Praha"],
  "39495": ["Křeč"],
  "51783": ["Olešnice v Orlických horách"],
  "19016": ["Praha"],
  "39496": ["Těmice"],
  "51784": ["Ohnišov"],
  "76361": [
    "Spytihněv",
    "Komárov",
    "Pohořelice",
    "Žlutava",
    "Napajedla",
    "Oldřichovice",
  ],
  "19017": ["Praha"],
  "76363": ["Halenkovice"],
  "76362": ["Tlumačov"],
  "39501": [
    "Mezilesí",
    "Litohošť",
    "Vyklantice",
    "Černovice",
    "Čáslavsko",
    "Křešín",
    "Chyšná",
    "Lidmaň",
    "Pošná",
    "Hořepník",
    "Zlátenka",
    "Samšín",
    "Pacov",
    "Věžná",
    "Košetice",
    "Útěchovice",
    "Vysoká Lhota",
    "Útěchovičky",
    "Martinice u Onšova",
    "Útěchovice pod Stražištěm",
    "Rovná",
    "Hojovice",
    "Důl",
    "Obrataň",
    "Lukavec",
    "Těchobuz",
    "Arneštovice",
    "Kámen",
    "Chýstovice",
    "Bořetice",
    "Bratřice",
    "Dobrá Voda u Pacova",
    "Salačova Lhota",
    "Lesná",
    "Zhořec",
    "Vlčeves",
    "Onšov",
    "Eš",
    "Buřenice",
  ],
  "76364": ["Spytihněv"],
  "51791": ["Deštné v Orlických horách", "Sedloňov", "Liberk"],
  "51792": ["Kounov"],
  "43601": ["Litvínov", "Klíny", "Český Jiřetín"],
  "51793": ["Dobré"],
  "43603": ["Litvínov"],
  "51801": [
    "Val",
    "Bačetín",
    "Bohdašín",
    "Dobruška",
    "Trnov",
    "Bílý Újezd",
    "Podbřezí",
    "Kounov",
    "Pohoří",
    "Chlístov",
    "Semechnice",
    "Opočno",
    "Sněžné",
    "Bystré",
    "Ohnišov",
    "Skuhrov nad Bělou",
    "Byzhradec",
    "Dobré",
    "Dobřany",
    "Janov",
  ],
  "51803": ["Podbřezí"],
  "64100": ["Brno"],
  "68201": [
    "Lysovice",
    "Moravské Málkovice",
    "Křižanovice u Vyškova",
    "Březina",
    "Vážany",
    "Kučerov",
    "Rybníček",
    "Rostěnice-Zvonovice",
    "Hlubočany",
    "Hoštice-Heroltice",
    "Orlovice",
    "Topolany",
    "Medlovice",
    "Prusy-Boškůvky",
    "Vyškov",
  ],
  "72300": ["Ostrava"],
  "10900": ["Praha"],
  "15000": ["Praha"],
  "35491": ["Lázně Kynžvart"],
  "27301": ["Žilina", "Kamenné Žehrovice", "Lhota"],
  "35493": ["Dolní Žandov"],
  "27302": ["Tuchlovice"],
  "27303": ["Stochov"],
  "27304": ["Hradečno", "Stochov", "Kačice"],
  "27305": ["Ledce", "Přelíc", "Smečno", "Svinařov"],
  "27306": ["Třebichovice", "Libušín", "Hrdlív"],
  "27307": ["Vinařice"],
  "27308": ["Pchery", "Třebichovice"],
  "27309": ["Kladno"],
  "39601": [
    "Komorovice",
    "Mladé Bříště",
    "Senožaty",
    "Koberovice",
    "Horní Rápotice",
    "Kaliště",
    "Staré Bříště",
    "Syrov",
    "Jiřice",
    "Mysletín",
    "Hojanovice",
    "Sedlice",
    "Řečice",
    "Budíkov",
    "Humpolec",
    "Vystrkov",
    "Čejov",
    "Píšť",
    "Ježov",
    "Hořice",
    "Proseč",
    "Vojslavice",
    "Bystrá",
    "Křelovice",
    "Želiv",
  ],
  "27321": ["Žižice", "Hobšovice"],
  "27322": ["Kmetiněves", "Hospozín"],
  "27323": ["Černuc"],
  "27324": ["Loucká", "Černuc", "Chržín", "Velvary", "Uhy", "Sazená"],
  "27325": ["Zvoleněves", "Žižice", "Olovnice", "Slatina", "Podlešín"],
  "27326": ["Neuměřice", "Olovnice", "Kamenný Most", "Slatina"],
  "27327": ["Otvovice"],
  "27328": ["Zákolany", "Blevice"],
  "27329": ["Koleč"],
  "56002": [
    "Němčice",
    "Česká Třebová",
    "Rybník",
    "Semanín",
    "Vlčkov",
    "Přívrat",
  ],
  "64200": ["Brno"],
  "68301": [
    "Kovalovice",
    "Habrovany",
    "Dražovice",
    "Podbřežice",
    "Velešovice",
    "Olšany",
    "Tučapy",
    "Rousínov",
    "Komořany",
  ],
  "27341": ["Brandýsek", "Cvrčovice", "Třebusice", "Želenice", "Kladno"],
  "27342": ["Libochovičky", "Stehelčeves", "Dřetovice"],
  "68303": ["Nemojany", "Luleč"],
  "27343": ["Zájezd", "Buštěhrad"],
  "68305": ["Račice-Pístovice"],
  "27345": ["Hřebeč"],
  "68304": ["Ruprechtov", "Podomí", "Ježkovice", "Krásensko", "Drnovice"],
  "72400": ["Ostrava"],
  "68308": ["Nové Sady", "Studnice"],
  "27351": [
    "Svárov",
    "Dolany",
    "Pletený Újezd",
    "Horní Bezděkov",
    "Malé Kyšice",
    "Malé Přítočno",
    "Braškov",
    "Kyšice",
    "Pavlov",
    "Unhošť",
    "Velké Přítočno",
    "Červený Újezd",
  ],
  "76502": ["Otrokovice"],
  "27353": ["Běloky", "Hostouň"],
  "27354": ["Lidice", "Makotřasy"],
  "68321": ["Pustiměř", "Zelená Hora", "Radslavice", "Drysice", "Podivice"],
  "27361": ["Velká Dobrá"],
  "27362": ["Doksy", "Bratronice", "Družec"],
  "68323": ["Dětkovice", "Švábenice", "Ivanovice na Hané"],
  "27363": ["Bratronice", "Běleč"],
  "27364": ["Doksy"],
  "27371": [
    "Beřovice",
    "Stradonice",
    "Zlonice",
    "Jarpice",
    "Dřínov",
    "Páleč",
    "Šlapanice",
  ],
  "27372": ["Poštovice", "Vraný", "Jarpice"],
  "68333": [
    "Malínky",
    "Snovídky",
    "Nemotice",
    "Brankovice",
    "Nemochovice",
    "Uhřice",
    "Mouchnice",
    "Nesovice",
    "Dobročkovice",
    "Kožušice",
    "Milonice",
  ],
  "27373": ["Vraný"],
  "27374": [
    "Bílichov",
    "Hořešovice",
    "Klobuky",
    "Hořešovičky",
    "Vrbičany",
    "Zichovec",
  ],
  "68335": ["Letonice"],
  "27375": ["Neprobylice", "Kutrovice", "Třebíz", "Kvílice", "Plchov"],
  "68334": ["Snovídky"],
  "27376": ["Pozdeň", "Líský"],
  "27377": ["Drnek", "Malíkovice"],
  "27378": ["Řisuty", "Jedomělice"],
  "27379": ["Tuřany", "Slaný", "Studeněves", "Libovice"],
  "68341": ["Bohdalice-Pavlovice", "Kozlany", "Hvězdlice", "Chvalkovice"],
  "11000": ["Praha"],
  "68351": ["Holubice"],
  "68352": ["Křenovice", "Zbýšov", "Hostěrádky-Rešov", "Šaratice", "Hrušky"],
  "68354": ["Bošovice", "Milešovice", "Lovčičky", "Otnice"],
  "27401": ["Jemníky", "Slaný", "Žižice", "Dřínov", "Královice", "Knovíz"],
  "35601": [
    "Lomnice",
    "Dolní Nivy",
    "Jindřichovice",
    "Královské Poříčí",
    "Těšovice",
    "Sokolov",
    "Březová",
    "Staré Sedlo",
    "Šabina",
    "Rovná",
    "Citice",
  ],
  "35604": ["Dolní Rychnov"],
  "39701": [
    "Oslov",
    "Smetanova Lhota",
    "Kestřany",
    "Záhoří",
    "Temešvár",
    "Albrechtice nad Vltavou",
    "Drhovle",
    "Písek",
    "Varvažov",
    "Putim",
    "Čížová",
    "Kluky",
    "Ostrovec",
    "Vráž",
    "Vrcovice",
    "Vojníkov",
    "Dobev",
    "Dolní Novosedly",
    "Předotice",
    "Vlastec",
    "Zvíkovské Podhradí",
  ],
  "43801": [
    "Březno",
    "Libořice",
    "Tuchořice",
    "Pětipsy",
    "Blšany",
    "Holedeč",
    "Staňkovice",
    "Velemyšleves",
    "Žatec",
    "Deštnice",
    "Podbořany",
    "Čeradice",
    "Zálužice",
    "Chbany",
    "Bitozeves",
    "Lipno",
    "Račetice",
    "Nové Sedlo",
    "Libědice",
    "Liběšice",
    "Žiželice",
    "Měcholupy",
  ],
  "56101": ["Dolní Dobrouč", "Hnátnice", "Žampach"],
  "56102": ["Dolní Dobrouč"],
  "60200": ["Brno"],
  "64300": ["Brno"],
  "56112": ["Brandýs nad Orlicí"],
  "68401": [
    "Kobeřice u Brna",
    "Heršpice",
    "Němčany",
    "Vážany nad Litavou",
    "Slavkov u Brna",
    "Hodějice",
    "Nížkovice",
  ],
  "56113": ["Sudslava"],
  "56114": ["České Libchavy"],
  "56115": ["Sopotnice"],
  "56116": ["Libchavy"],
  "56117": ["Dlouhá Třebová"],
  "56118": ["Němčice"],
  "76601": ["Křekov", "Poteč", "Vlachova Lhota", "Valašské Klobouky", "Tichov"],
  "56122": ["Ostrov"],
  "56123": ["Damníkov", "Luková"],
  "56124": ["Třebovice"],
  "56125": ["Rudoltice"],
  "56131": ["Tatenice"],
  "56132": ["Cotkytle"],
  "56133": ["Horní Heřmanice"],
  "56134": ["Výprachtice"],
  "72525": ["Ostrava"],
  "56141": ["Řetůvka", "Řetová"],
  "72527": ["Ostrava"],
  "72526": ["Ostrava"],
  "72529": ["Ostrava"],
  "72528": ["Ostrava"],
  "56151": ["Lukavice", "Letohrad"],
  "56152": ["Verměřovice"],
  "56153": ["Dolní Čermná"],
  "56154": ["Bystřec"],
  "56155": ["Orličky"],
  "56156": ["Horní Čermná"],
  "11101": ["Praha"],
  "15200": ["Praha"],
  "56161": ["Červená Voda"],
  "56162": ["Červená Voda"],
  "56163": ["Nekoř"],
  "19300": ["Praha"],
  "56164": [
    "Sobkovice",
    "Mistrovice",
    "Mladkov",
    "Nekoř",
    "Jablonné nad Orlicí",
    "Studené",
    "Jamné nad Orlicí",
    "Bystřec",
    "Čenkovice",
    "Těchonín",
  ],
  "56165": ["Jamné nad Orlicí"],
  "56166": ["Těchonín"],
  "56167": ["Mladkov"],
  "56168": ["Lichkov"],
  "56169": ["Králíky", "Dolní Morava", "Červená Voda"],
  "56170": ["Písečná"],
  "31600": ["Plzeň"],
  "35701": ["Rotava"],
  "56181": ["Kunvald"],
  "56182": ["Klášterec nad Orlicí"],
  "35703": ["Svatava"],
  "56184": ["Líšnice", "Žamberk"],
  "39801": ["Mirotice"],
  "56185": ["Česká Rybná"],
  "56186": ["Záchlumí"],
  "35707": ["Oloví"],
  "35708": ["Krajková"],
  "39804": [
    "Králova Lhota",
    "Myslín",
    "Kožlí",
    "Smetanova Lhota",
    "Mišovice",
    "Varvažov",
    "Mirovice",
    "Boudy",
    "Horosedly",
    "Rakovice",
    "Mirotice",
    "Nerestce",
    "Nevězice",
    "Cerhonice",
    "Minice",
    "Probulov",
    "Lety",
    "Čimelice",
  ],
  "35709": [
    "Krajková",
    "Oloví",
    "Dasnice",
    "Habartov",
    "Chlum Svaté Maří",
    "Josefov",
    "Citice",
  ],
  "43901": ["Černčice"],
  "39806": ["Mirovice", "Horosedly"],
  "43902": ["Cítoliby"],
  "39807": ["Orlík nad Vltavou"],
  "43903": ["Chlumčany"],
  "43904": ["Hříškov"],
  "43905": ["Panenský Týnec"],
  "43906": ["Vrbno nad Lesy"],
  "39811": [
    "Paseky",
    "Heřmaň",
    "Žďár",
    "Skály",
    "Albrechtice nad Vltavou",
    "Protivín",
    "Tálín",
    "Ražice",
  ],
  "43907": ["Peruc"],
  "43908": ["Peruc"],
  "43909": ["Slavětín"],
  "39815": ["Tálín"],
  "39816": ["Albrechtice nad Vltavou"],
  "39817": ["Albrechtice nad Vltavou"],
  "56201": [
    "Orlické Podhůří",
    "Ústí nad Orlicí",
    "Jehnědí",
    "Oucmanice",
    "Dolní Dobrouč",
    "Hrádek",
    "Podlesí",
    "Seč",
    "Velká Skrovnice",
    "Sudislav nad Orlicí",
  ],
  "39818": ["Záhoří"],
  "43914": ["Smolnice"],
  "39819": ["Kluky"],
  "43915": ["Vinařice"],
  "56203": ["Ústí nad Orlicí"],
  "56204": ["Ústí nad Orlicí"],
  "60300": ["Brno"],
  "39821": ["Kestřany"],
  "39822": ["Ražice"],
  "56206": ["Ústí nad Orlicí"],
  "64400": ["Brno"],
  "43921": ["Koštice"],
  "43922": ["Chožov"],
  "35731": ["Krásno", "Loket", "Horní Slavkov"],
  "43923": ["Lenešice"],
  "43924": ["Raná"],
  "68501": [
    "Letonice",
    "Heršpice",
    "Křižanovice",
    "Bohaté Málkovice",
    "Ždánice",
    "Bučovice",
    "Nevojice",
    "Kojátky",
    "Rašovice",
    "Hodějice",
    "Mouřínov",
  ],
  "35733": ["Loket"],
  "35734": ["Nové Sedlo"],
  "43926": ["Libčeves"],
  "35735": [
    "Chodov",
    "Nové Sedlo",
    "Vintířov",
    "Tatrovice",
    "Vřesová",
    "Mírová",
  ],
  "39831": ["Čížová"],
  "39832": ["Vráž"],
  "39833": ["Ostrovec"],
  "39834": ["Kučeř"],
  "39835": ["Oslov"],
  "43931": ["Měcholupy"],
  "76701": [
    "Bezměrov",
    "Šelešovice",
    "Lutopecny",
    "Bařice-Velké Těšany",
    "Skaštice",
    "Lubná",
    "Kroměříž",
    "Kostelany",
  ],
  "39842": ["Veselíčko"],
  "39843": [
    "Branice",
    "Bernartice",
    "Křižanov",
    "Jetětice",
    "Slabčice",
    "Křenovice",
    "Okrouhlá",
    "Podolí I",
    "Stehlovice",
    "Veselíčko",
    "Zběšičky",
    "Borovany",
    "Olešná",
  ],
  "43942": ["Postoloprty"],
  "35751": ["Kynšperk nad Ohří", "Šabina", "Kaceřov", "Libavské Údolí"],
  "39847": ["Slabčice"],
  "39848": ["Jetětice"],
  "35755": ["Bukovany"],
  "39851": ["Sepekov", "Božetice"],
  "39852": ["Nadějkov"],
  "39853": ["Chyšky"],
  "43949": ["Staňkovice"],
  "39855": ["Kovářov"],
  "39858": ["Kostelec nad Vltavou"],
  "39859": ["Hrejkovice"],
  "43963": ["Liběšice"],
  "43965": ["Hřivice"],
  "43967": ["Ročov"],
  "43968": ["Domoušice"],
  "43969": ["Tuchořice"],
  "43971": ["Nepomyšl"],
  "15300": ["Praha"],
  "43972": ["Krásný Dvůr"],
  "43975": ["Libočany"],
  "43981": ["Kryry"],
  "43982": ["Vroutek"],
  "43983": ["Lubenec"],
  "43984": ["Blatno"],
  "27601": [
    "Lužec nad Vltavou",
    "Mělník",
    "Obříství",
    "Býkev",
    "Hořín",
    "Velký Borek",
  ],
  "43985": ["Petrohrad"],
  "43986": ["Kryry"],
  "43987": ["Očihov"],
  "43988": ["Blšany"],
  "35801": [
    "Jindřichovice",
    "Kraslice",
    "Bublava",
    "Rotava",
    "Přebuz",
    "Šindelová",
    "Stříbrná",
  ],
  "39901": [
    "Kostelec nad Vltavou",
    "Nechvalice",
    "Přeborov",
    "Božetice",
    "Jickovice",
    "Milevsko",
    "Osek",
    "Nadějkov",
    "Chyšky",
    "Hrazany",
    "Vlksice",
    "Zhoř",
    "Sepekov",
    "Kovářov",
    "Květov",
    "Zbelítov",
    "Petrovice",
    "Přeštěnice",
    "Hrejkovice",
  ],
  "44001": [
    "Toužetín",
    "Domoušice",
    "Pnětluky",
    "Vršovice",
    "Blažim",
    "Staňkovice",
    "Zbrašín",
    "Žerotín",
    "Obora",
    "Nová Ves",
    "Ročov",
    "Lišany",
    "Počedělice",
    "Bitozeves",
    "Lipno",
    "Kozly",
    "Veltěže",
    "Břvany",
    "Chožov",
    "Peruc",
    "Jimlín",
    "Louny",
    "Líšťany",
    "Blšany u Loun",
    "Slavětín",
    "Dobroměřice",
    "Raná",
    "Libčeves",
    "Želkovice",
    "Výškov",
    "Hříškov",
    "Opočno",
    "Úherce",
    "Koštice",
    "Brodec",
    "Chlumčany",
    "Chraberce",
    "Hřivice",
    "Postoloprty",
  ],
  "56301": [
    "Horní Třešňovec",
    "Anenská Studánka",
    "Trpík",
    "Cotkytle",
    "Strážná",
    "Horní Heřmanice",
    "Luková",
    "Horní Čermná",
    "Výprachtice",
    "Lanškroun",
    "Dolní Čermná",
    "Žichlínek",
    "Koruna",
    "Krasíkov",
    "Petrovice",
    "Albrechtice",
    "Lubník",
    "Sázava",
  ],
  "68601": [
    "Staré Město",
    "Kostelany nad Moravou",
    "Staré Hutě",
    "Uherské Hradiště",
    "Stupava",
  ],
  "68603": ["Staré Město"],
  "68605": ["Uherské Hradiště"],
  "68604": ["Popovice", "Podolí", "Uherské Hradiště", "Kunovice"],
  "68606": ["Uherské Hradiště"],
  "68609": ["Uherské Hradiště"],
  "76801": ["Jarohněvice"],
  "76803": ["Roštín"],
  "76802": [
    "Šelešovice",
    "Troubky-Zdislavice",
    "Zdounky",
    "Zborovice",
    "Cetechovice",
    "Soběsuky",
  ],
  "76805": ["Chvalnov-Lísky", "Koryčany", "Zástřizly"],
  "76804": ["Střílky"],
  "76811": ["Chropyně", "Záříčí", "Kyselovice"],
  "76813": ["Kunkovice", "Nítkovice", "Honětice", "Litenčice", "Hoštice"],
  "76812": ["Rataje"],
  "76821": [
    "Střížovice",
    "Kvasice",
    "Sulimov",
    "Nová Dědina",
    "Vrbka",
    "Bělov",
    "Karolín",
  ],
  "76823": ["Žalkovice", "Břest"],
  "76824": ["Pravčice", "Hulín"],
  "76831": ["Zlobice"],
  "76833": [
    "Věžky",
    "Uhřice",
    "Dřínov",
    "Morkovice-Slížany",
    "Pačlavice",
    "Počenice-Tetětice",
    "Prasklice",
  ],
  "76832": ["Zborovice"],
  "76834": ["Pačlavice"],
  "15400": ["Praha"],
  "76841": ["Bystřice pod Hostýnem", "Lukoveček", "Rusava"],
  "76843": ["Němčice", "Pacetluky", "Kostelec u Holešova", "Roštění"],
  "76842": ["Prusinovice"],
  "76845": ["Rusava"],
  "27701": ["Dolní Beřkovice"],
  "76852": ["Kurovice", "Lechotice", "Míškovice", "Ludslavice"],
  "27703": ["Horní Počaply"],
  "27704": ["Cítov"],
  "31800": ["Plzeň"],
  "27705": ["Jeviněves", "Spomyšl"],
  "27706": ["Lužec nad Vltavou"],
  "27707": ["Vraňany"],
  "27708": ["Ledčice"],
  "76861": [
    "Loukov",
    "Brusné",
    "Vítonice",
    "Chomýž",
    "Bystřice pod Hostýnem",
    "Lukoveček",
    "Slavkov pod Hostýnem",
    "Mrlínek",
    "Osíčko",
    "Blazice",
    "Rusava",
  ],
  "27711": ["Libiš", "Neratovice"],
  "27713": ["Kostelec nad Labem", "Ovčáry", "Záryby"],
  "40001": ["Ústí nad Labem"],
  "27714": [
    "Dřísy",
    "Nedomice",
    "Křenek",
    "Ovčáry",
    "Borek",
    "Konětopy",
    "Lhota",
  ],
  "40002": [
    "Řehlovice",
    "Chuderov",
    "Tašov",
    "Stebno",
    "Velké Chvojno",
    "Trmice",
    "Malečov",
    "Habrovany",
    "Libouchec",
    "Velké Březno",
    "Homole u Panny",
    "Ústí nad Labem",
    "Malé Březno",
    "Povrly",
    "Zubrnice",
  ],
  "27715": ["Tišice"],
  "40003": ["Ústí nad Labem"],
  "27716": ["Všetaty", "Nedomice"],
  "40004": ["Trmice"],
  "44101": [
    "Valeč",
    "Blatno",
    "Krásný Dvůr",
    "Nepomyšl",
    "Veliká Ves",
    "Lubenec",
    "Podbořanský Rohozec",
    "Petrohrad",
    "Vroutek",
    "Podbořany",
    "Mašťov",
    "Kryry",
  ],
  "76871": ["Rajnochovice", "Podhradní Lhota", "Komárno"],
  "40007": ["Ústí nad Labem"],
  "27721": [
    "Dobřeň",
    "Želízy",
    "Dolní Zimoř",
    "Tupadly",
    "Liběchov",
    "Vidim",
    "Vysoká",
    "Medonosy",
  ],
  "76872": ["Chvalčov"],
  "40010": ["Ústí nad Labem", "Chlumec"],
  "76875": ["Loukov"],
  "27723": ["Dobřeň", "Kokořín"],
  "40011": ["Ústí nad Labem"],
  "27724": ["Vysoká"],
  "56401": [
    "Dlouhoňovice",
    "Pastviny",
    "Líšnice",
    "České Petrovice",
    "Kameničná",
    "Šedivec",
    "Kunvald",
    "Hejnice",
    "Helvíkovice",
    "Klášterec nad Orlicí",
    "Žamberk",
    "Žampach",
  ],
  "27731": ["Mělník", "Lhotka", "Střemy", "Malý Újezd", "Velký Borek"],
  "27732": ["Hostín", "Čečelice", "Byšice", "Liblice"],
  "27733": ["Řepín"],
  "27734": ["Nebužely", "Střemy"],
  "27735": [
    "Kanina",
    "Stránka",
    "Dobřeň",
    "Chorušice",
    "Lobeč",
    "Nosálov",
    "Mšeno",
    "Kadlín",
  ],
  "27736": ["Lobeč"],
  "27737": ["Chorušice"],
  "27738": ["Mělnické Vtelno"],
  "27741": ["Mělník", "Tuhaň", "Kly", "Velký Borek"],
  "27742": ["Obříství"],
  "68703": ["Kudlovice", "Huštěnovice", "Babice"],
  "27743": ["Chlumín"],
  "27744": ["Hostín u Vojkovic", "Vojkovice", "Všestudy", "Zlosyň"],
  "68705": ["Jalubí"],
  "27745": [
    "Zálezlice",
    "Vojkovice",
    "Újezdec",
    "Úžice",
    "Dřínov",
    "Kozomín",
    "Neratovice",
  ],
  "68704": ["Traplice", "Jankovice", "Košíky", "Sušice"],
  "27746": ["Veltrusy", "Všestudy"],
  "68707": ["Tupesy"],
  "68706": ["Modrá", "Salaš", "Velehrad"],
  "68709": ["Boršice", "Stříbrnice", "Tučapy", "Osvětimany"],
  "76901": [
    "Horní Lapač",
    "Zahnašovice",
    "Bořenovice",
    "Jankovice",
    "Třebětice",
    "Žeranovice",
    "Holešov",
    "Roštění",
    "Martinice",
    "Rymice",
    "Přílepy",
  ],
  "68708": ["Buchlovice", "Břestek"],
  "68711": ["Topolná"],
  "27751": ["Nelahozeves", "Nová Ves"],
  "68710": ["Zlechov"],
  "27752": ["Nová Ves"],
  "68713": ["Březolupy"],
  "68712": [
    "Bílovice",
    "Kněžpole",
    "Svárov",
    "Zlámanec",
    "Nedachlebice",
    "Mistřice",
    "Částkov",
  ],
  "68723": ["Ostrožská Lhota"],
  "68722": ["Ostrožská Nová Ves"],
  "68725": ["Hluk"],
  "68724": ["Uherský Ostroh"],
  "68731": ["Šumice"],
  "68733": ["Veletiny", "Drslavice", "Hradčovice"],
  "68732": ["Nezdenice", "Rudice"],
  "68734": ["Uherský Brod"],
  "68737": ["Ořechov", "Vážany", "Polešovice"],
  "68738": ["Nedakonice"],
  "68741": ["Hostějov", "Újezdec", "Medlovice"],
  "68742": ["Osvětimany"],
  "15500": ["Praha"],
  "68751": ["Nivnice"],
  "19600": ["Praha"],
  "68753": ["Suchá Loz"],
  "68752": ["Korytná"],
  "68755": ["Bystřice pod Lopeníkem"],
  "68754": ["Bánov"],
  "68756": ["Prakšice", "Pašovice"],
  "68761": ["Vlčnov"],
  "27801": [
    "Zlončice",
    "Dolany nad Vltavou",
    "Chvatěruby",
    "Kralupy nad Vltavou",
  ],
  "68763": ["Boršice u Blatnice"],
  "68762": ["Dolní Němčí"],
  "68765": ["Strání"],
  "68764": ["Horní Němčí", "Slavkov"],
  "68767": ["Březová", "Lopeník", "Bystřice pod Lopeníkem"],
  "68766": ["Strání"],
  "15521": ["Praha"],
  "36001": [
    "Sadov",
    "Březová",
    "Kolová",
    "Jenišov",
    "Pila",
    "Stanovice",
    "Hory",
    "Karlovy Vary",
    "Otovice",
  ],
  "68771": ["Záhorovice", "Bojkovice", "Pitín", "Komňa", "Hostětín"],
  "36004": ["Karlovy Vary"],
  "36005": ["Karlovy Vary"],
  "36006": ["Hradiště", "Karlovy Vary"],
  "36007": ["Karlovy Vary"],
  "68774": ["Žítková", "Lopeník", "Vápenice", "Starý Hrozenkov", "Vyškovec"],
  "36010": ["Karlovy Vary"],
  "15531": ["Praha"],
  "36017": ["Karlovy Vary"],
  "36018": ["Karlovy Vary"],
  "56501": [
    "Nasavrky",
    "Běstovice",
    "Bošín",
    "Svatý Jiří",
    "Zářecká Lhota",
    "Zálší",
    "Újezd u Chocně",
    "Kosořín",
    "Plchovice",
    "Koldín",
    "Skořenice",
    "Choceň",
    "Mostek",
  ],
  "68801": ["Uherský Brod"],
  "56542": ["Vraclav"],
  "56543": ["Zámrsk"],
  "56544": ["Sruby"],
  "56552": ["České Heřmanice"],
  "56553": ["Sloupnice"],
  "56555": ["Hrušová"],
  "15600": ["Praha"],
  "19700": ["Praha"],
  "56601": [
    "Týnišťko",
    "Vraclav",
    "Vysoké Mýto",
    "Tisová",
    "Řepníky",
    "Sruby",
    "Javorník",
    "Slatina",
    "Bučina",
    "Dobříkov",
    "Zámrsk",
    "České Heřmanice",
    "Pustina",
    "Voděrady",
    "Džbánov",
    "Zádolí",
    "Libecina",
    "Vračovice-Orlov",
  ],
  "19800": ["Praha"],
  "28002": [
    "Tři Dvory",
    "Veletov",
    "Plaňany",
    "Bělušice",
    "Vrbčany",
    "Ovčáry",
    "Polní Chrčice",
    "Zalešany",
    "Křečhoř",
    "Velim",
    "Cerhenice",
    "Kořenice",
    "Volárna",
    "Polní Voděrady",
    "Břežany I",
    "Nebovidy",
    "Němčice",
    "Libodřice",
    "Třebovle",
    "Kolín",
    "Žabonosy",
    "Lošany",
    "Krychnov",
    "Dománovice",
    "Radim",
    "Svojšice",
    "Konárovice",
    "Nová Ves I",
    "Býchory",
    "Veltruby",
    "Pašinka",
    "Polepy",
    "Grunta",
    "Libenice",
    "Jestřabí Lhota",
    "Kbel",
    "Ratboř",
    "Červené Pečky",
    "Radovesnice I",
  ],
  "32100": ["Plzeň", "Dobřany"],
  "40301": ["Dolní Zálezly"],
  "40302": ["Ústí nad Labem"],
  "40313": ["Řehlovice"],
  "36221": ["Vysoká Pec", "Nejdek", "Nové Hamry", "Černava"],
  "40317": ["Krupka", "Přestanov", "Chabařovice"],
  "36222": ["Nejdek"],
  "36225": ["Smolné Pece", "Božičany", "Nejdek", "Nová Role", "Děpoltovice"],
  "40321": ["Ústí nad Labem"],
  "40322": ["Ústí nad Labem"],
  "40323": ["Velké Březno"],
  "40327": ["Malečov"],
  "36233": ["Hroznětín"],
  "36234": ["Merklín"],
  "69003": ["Břeclav"],
  "36235": ["Abertamy", "Pernink", "Potůčky", "Horní Blatná"],
  "40331": ["Ryjice", "Ústí nad Labem"],
  "69002": ["Břeclav"],
  "36236": ["Pernink"],
  "40332": ["Povrly"],
  "40334": ["Velké Chvojno"],
  "40335": ["Libouchec"],
  "69006": ["Břeclav"],
  "40336": ["Tisá"],
  "40337": ["Petrovice"],
  "40338": ["Telnice", "Petrovice"],
  "40339": ["Chlumec"],
  "40340": ["Ústí nad Labem"],
  "36251": ["Ostrov", "Jáchymov"],
  "36262": ["Boží Dar"],
  "36263": ["Dalovice"],
  "36272": ["Kyselka", "Doupovské Hradiště", "Šemnice"],
  "36273": ["Vojkovice"],
  "15800": ["Praha"],
  "19900": ["Praha"],
  "28101": ["Velim"],
  "28102": ["Cerhenice"],
  "28103": ["Chotutice", "Radim"],
  "28104": ["Plaňany"],
  "32200": ["Plzeň"],
  "28106": ["Vitice"],
  "28107": ["Svojšice"],
  "36301": [
    "Ostrov",
    "Jáchymov",
    "Velichov",
    "Vojkovice",
    "Krásný Les",
    "Hájek",
    "Hradiště",
    "Hroznětín",
    "Stráž nad Ohří",
    "Merklín",
  ],
  "28121": ["Červené Pečky"],
  "28123": ["Starý Kolín"],
  "28125": ["Konárovice"],
  "28126": [
    "Uhlířská Lhota",
    "Lipec",
    "Radovesnice II",
    "Labské Chrčice",
    "Týnec nad Labem",
    "Žiželice",
  ],
  "28127": ["Krakovany"],
  "28128": ["Radovesnice II"],
  "28129": ["Žiželice"],
  "28130": ["Radovesnice II", "Polní Chrčice", "Ohaře"],
  "56802": [
    "Kamenná Horka",
    "Dětřichov",
    "Sklené",
    "Svitavy",
    "Březová nad Svitavou",
    "Mikuleč",
    "Opatovec",
    "Javorník",
    "Karle",
    "Kukle",
    "Banín",
    "Pohledy",
  ],
  "69101": ["Moravský Žižkov"],
  "28141": ["Ratboř"],
  "69103": ["Rakvice"],
  "28143": ["Bečváry"],
  "69102": ["Velké Bílovice"],
  "28144": [
    "Bečváry",
    "Dolní Chvatliny",
    "Skvrňov",
    "Zásmuky",
    "Kořenice",
    "Toušice",
    "Drahobudice",
    "Církvice",
  ],
  "69105": ["Zaječí"],
  "69104": ["Přítluky"],
  "28146": ["Horní Kruty"],
  "69107": ["Němčičky"],
  "69106": ["Velké Pavlovice"],
  "69109": ["Vrbice"],
  "69108": ["Bořetice"],
  "69111": ["Brumovice"],
  "28151": ["Velký Osek", "Oseček"],
  "69110": ["Kobylí"],
  "69112": ["Boleradice"],
  "69121": ["Sedlec"],
  "28161": ["Kouřim"],
  "28162": ["Oleška"],
  "69123": ["Cvrčovice", "Ivaň", "Pohořelice"],
  "28163": [
    "Stříbrná Skalice",
    "Kozojedy",
    "Nučice",
    "Štíhlice",
    "Kostelec nad Černými lesy",
    "Toušice",
    "Černé Voděrady",
    "Vitice",
    "Třebovle",
    "Malotice",
    "Výžerky",
    "Barchovice",
    "Konojedy",
    "Jevany",
    "Oleška",
    "Klášterní Skalice",
    "Horní Kruty",
    "Přehvozdí",
    "Vlkančice",
    "Krupá",
    "Oplany",
    "Prusice",
    "Svojšice",
    "Vyžlovka",
    "Ždánice",
    "Kouřim",
  ],
  "69122": ["Pasohlávky"],
  "69125": ["Vranovice"],
  "69124": ["Přibice"],
  "28166": ["Jevany"],
  "69127": ["Popice"],
  "28167": ["Stříbrná Skalice"],
  "69126": ["Pouzdřany"],
  "69129": ["Dolní Věstonice"],
  "28171": ["Rostoklaty"],
  "69130": ["Vlasatice"],
  "69141": ["Břeclav"],
  "69143": ["Hlohovec"],
  "69142": ["Valtice"],
  "11800": ["Praha"],
  "69145": ["Podivín"],
  "69144": ["Břeclav", "Lednice"],
  "69146": ["Břeclav", "Ladná"],
  "15900": ["Praha"],
  "69151": ["Lanžhot"],
  "69153": ["Tvrdonice"],
  "69152": ["Tvrdonice", "Kostice"],
  "69155": ["Moravská Nová Ves"],
  "69154": ["Týnec"],
  "69156": ["Hrušky"],
  "28201": [
    "Masojedy",
    "Tismice",
    "Klučov",
    "Mrzky",
    "Břežany II",
    "Doubravčice",
    "Přistoupim",
    "Rostoklaty",
    "Český Brod",
    "Chrášťany",
    "Vrátkov",
    "Tuchoraz",
    "Přišimasy",
    "Kšely",
    "Hradešín",
  ],
  "69163": ["Velké Němčice"],
  "69162": ["Uherčice"],
  "32300": ["Plzeň"],
  "69165": ["Nikolčice", "Křepice"],
  "69164": ["Velké Němčice", "Nosislav"],
  "69167": ["Šakvice"],
  "36401": ["Toužim", "Otročín", "Útvina", "Krásné Údolí"],
  "69168": ["Starovičky"],
  "69171": ["Diváky", "Nikolčice"],
  "69173": ["Dambořice", "Krumvíř"],
  "69172": ["Kašnice", "Morkůvky", "Klobouky u Brna"],
  "40502": [
    "Malšovice",
    "Františkov nad Ploučnicí",
    "Bynovec",
    "Starý Šachov",
    "Dobkovice",
    "Benešov nad Ploučnicí",
    "Merboltice",
    "Kunratice",
    "Horní Habartice",
    "Valkeřice",
    "Veselé",
    "Jílové",
    "Dolní Habartice",
    "Janov",
    "Janská",
    "Hřensko",
    "Růžová",
    "Heřmanov",
    "Malá Veleň",
    "Česká Kamenice",
    "Labská Stráň",
    "Huntířov",
    "Verneřice",
    "Jetřichovice",
    "Děčín",
    "Těchlovice",
  ],
  "69175": ["Borkovany"],
  "69174": ["Velké Hostěrádky"],
  "40505": ["Děčín"],
  "69176": ["Šitbořice"],
  "69181": [
    "Březí",
    "Brod nad Dyjí",
    "Dobré Pole",
    "Nový Přerov",
    "Horní Věstonice",
  ],
  "69183": ["Drnholec", "Jevišovka"],
  "69182": ["Novosedly"],
  "69185": ["Dolní Dunajovice"],
  "69186": ["Perná"],
  "69189": ["Bulhary"],
  "56901": ["Hradec nad Svitavou"],
  "69188": ["Milovice"],
  "56902": ["Březová nad Svitavou", "Brněnec"],
  "56903": ["Rozhraní"],
  "56904": [
    "Lavičné",
    "Študlov",
    "Želivsko",
    "Brněnec",
    "Bohuňov",
    "Chrastavec",
    "Rudná",
  ],
  "56905": ["Bělá nad Svitavou"],
  "56906": ["Vítějeves"],
  "56907": ["Radiměř"],
  "56911": ["Koclířov"],
  "56912": ["Opatov"],
  "69201": ["Bavory", "Přítluky", "Milovice", "Mikulov", "Klentnice", "Pavlov"],
  "56914": ["Vendolí"],
  "73301": ["Karviná"],
  "56921": ["Moravská Třebová"],
  "56922": ["Křenov"],
  "56923": ["Březina"],
  "56924": ["Kunčina"],
  "36452": [
    "Valeč",
    "Pšov",
    "Verušičky",
    "Štědrá",
    "Čichalov",
    "Žlutice",
    "Hradiště",
  ],
  "56932": ["Staré Město"],
  "36453": ["Valeč", "Vrbice", "Čichalov", "Žlutice", "Chyše"],
  "56933": ["Třebařov"],
  "56934": ["Rychnov na Moravě"],
  "56935": ["Mladějov na Moravě"],
  "36461": ["Teplá"],
  "56941": ["Městečko Trnávka"],
  "56942": ["Chornice"],
  "56943": [
    "Jaroměřice",
    "Víska u Jevíčka",
    "Janůvky",
    "Vrážné",
    "Březinky",
    "Jevíčko",
    "Vysoká",
    "Březina",
    "Slatina",
    "Městečko Trnávka",
    "Dlouhá Loučka",
    "Hartinkov",
    "Biskupice",
    "Bezděčí u Trnávky",
    "Bělá u Jevíčka",
    "Chornice",
  ],
  "36464": [
    "Chodov",
    "Bečov nad Teplou",
    "Otročín",
    "Teplička",
    "Nová Ves",
    "Karlovy Vary",
  ],
  "56944": ["Jaroměřice"],
  "36471": [
    "Bochov",
    "Bražec",
    "Stružná",
    "Žlutice",
    "Hradiště",
    "Andělská Hora",
  ],
  "56951": ["Morašice"],
  "56953": ["Cerekvice nad Loučnou"],
  "56955": ["Janov"],
  "11900": ["Praha"],
  "56956": ["Čistá"],
  "56957": ["Čistá", "Trstěnice"],
  "16000": ["Praha"],
  "56961": ["Dolní Újezd"],
  "56962": ["Sebranice"],
  "56963": ["Lubná"],
  "56965": ["Budislav"],
  "56966": ["Jarošov"],
  "56967": ["Litomyšl", "Osík"],
  "56971": ["Pomezí"],
  "56972": ["Rohozná"],
  "56973": ["Svojanov"],
  "56974": ["Trpín"],
  "56982": ["Pustá Kamenice", "Borová", "Krouna", "Pustá Rybná", "Oldřiš"],
  "56991": ["Jedlová"],
  "56992": ["Bystré", "Hartmanice", "Trpín", "Svojanov", "Nedvězí", "Rohozná"],
  "56993": ["Korouhev"],
  "56994": ["Telecí"],
  "57001": [
    "Nová Sídla",
    "Nová Ves u Jarošova",
    "Vidlatá Seč",
    "Chotěnov",
    "Poříčí u Litomyšle",
    "Suchá Lhota",
    "Desná",
    "Cerekvice nad Loučnou",
    "Němčice",
    "Dolní Újezd",
    "Sedliště",
    "Janov",
    "Horní Újezd",
    "Tržek",
    "Bohuňovice",
    "Chmelík",
    "Újezdec",
    "Benátky",
    "Chotovice",
    "Litomyšl",
    "Strakov",
    "Horky",
    "Makov",
    "Morašice",
    "Řídký",
  ],
  "69301": [
    "Starovice",
    "Horní Bojanovice",
    "Hustopeče",
    "Strachotín",
    "Starovičky",
    "Kurdějov",
  ],
  "73401": ["Karviná"],
  "12000": ["Praha"],
  "16100": ["Praha"],
  "28401": [
    "Kutná Hora",
    "Štipoklasy",
    "Rohozec",
    "Chlístovice",
    "Záboří nad Labem",
    "Suchdol",
    "Nové Dvory",
    "Vidice",
    "Malešov",
    "Zbraslavice",
    "Svatý Mikuláš",
    "Horušice",
    "Miskovice",
    "Bernardov",
    "Černíny",
    "Křesetice",
    "Kobylnice",
  ],
  "28403": ["Kutná Hora"],
  "28404": ["Kutná Hora"],
  "40701": ["Jílové"],
  "40702": ["Jílové"],
  "40703": ["Malšovice", "Dobkovice"],
  "40711": ["Děčín"],
  "40713": ["Ludvíkovice", "Kámen"],
  "40714": ["Arnoltice", "Růžová"],
  "53002": [
    "Mikulovice",
    "Moravany",
    "Čeperka",
    "Dašice",
    "Pardubice",
    "Kostěnice",
    "Ostřešany",
    "Barchov",
    "Třebosice",
    "Úhřetická Lhota",
    "Staré Jesenčany",
    "Jezbořice",
    "Dolní Roveň",
    "Dubany",
    "Slepotice",
    "Srnojedy",
    "Spojil",
    "Hradec Králové",
    "Lány u Dašic",
    "Starý Mateřov",
  ],
  "40715": ["Srbská Kamenice"],
  "53003": ["Pardubice"],
  "40716": ["Jetřichovice"],
  "40717": ["Hřensko"],
  "57101": [
    "Gruna",
    "Rozstání",
    "Radkov",
    "Útěchov",
    "Staré Město",
    "Vranová Lhota",
    "Linhartice",
    "Moravská Třebová",
    "Městečko Trnávka",
    "Kunčina",
    "Dětřichov u Moravské Třebové",
    "Malíkov",
    "Bezděčí u Trnávky",
    "Borušov",
    "Koclířov",
  ],
  "53006": ["Pardubice"],
  "61200": ["Brno"],
  "40721": ["Česká Kamenice"],
  "53009": ["Pardubice"],
  "40722": ["Benešov nad Ploučnicí"],
  "40723": ["Františkov nad Ploučnicí"],
  "40724": ["Valkeřice"],
  "53012": ["Pardubice"],
  "40725": ["Verneřice"],
  "40729": ["Velká Bukovina"],
  "73503": ["Karviná"],
  "73506": ["Karviná"],
  "40741": ["Dobrná"],
  "40742": ["Markvartice"],
  "73511": ["Petřvald", "Orlová"],
  "40744": ["Chřibská"],
  "40745": ["Kytlice"],
  "40746": ["Krásná Lípa"],
  "40747": [
    "Rybniště",
    "Velký Šenov",
    "Doubice",
    "Varnsdorf",
    "Staré Křečany",
    "Dolní Poustevna",
    "Lipová",
    "Krásná Lípa",
    "Lobendava",
    "Šluknov",
  ],
  "73514": ["Orlová", "Rychvald"],
  "40751": ["Rybniště"],
  "40752": ["Varnsdorf"],
  "40753": ["Jiříkov"],
  "40755": ["Dolní Podluží"],
  "40756": ["Jiřetín pod Jedlovou"],
  "40757": ["Horní Podluží"],
  "40760": ["Staré Křečany"],
  "40761": ["Staré Křečany"],
  "73531": ["Bohumín", "Dolní Lutyně"],
  "73533": ["Doubrava"],
  "73532": ["Rychvald"],
  "73535": ["Horní Suchá"],
  "73534": ["Stonava"],
  "73541": ["Petřvald"],
  "73543": ["Albrechtice"],
  "73542": ["Těrlicko"],
  "16200": ["Praha"],
  "40777": ["Šluknov"],
  "40778": ["Velký Šenov"],
  "40779": ["Mikulášovice"],
  "40780": ["Vilémov"],
  "40781": ["Lipová"],
  "40782": ["Dolní Poustevna"],
  "73551": ["Bohumín"],
  "40784": ["Lobendava"],
  "73553": ["Dolní Lutyně"],
  "73552": ["Bohumín"],
  "28501": ["Miskovice"],
  "28502": ["Suchdol"],
  "28504": [
    "Bečváry",
    "Petrovice II",
    "Chlístovice",
    "Uhlířské Janovice",
    "Staňkovice",
    "Úžice",
    "Onomyšl",
    "Košice",
    "Sudějov",
    "Nepoměřice",
    "Rašovice",
    "Vavřinec",
    "Zbizuby",
  ],
  "32600": ["Letkov", "Plzeň"],
  "73561": ["Chotěbuz"],
  "28506": [
    "Ledečko",
    "Podveky",
    "Soběšín",
    "Úžice",
    "Xaverov",
    "Rataje nad Sázavou",
    "Samopše",
    "Choratice",
    "Sázava",
    "Zbizuby",
  ],
  "28507": ["Rataje nad Sázavou"],
  "73562": ["Český Těšín"],
  "28509": ["Soběšín", "Kácov"],
  "73564": ["Havířov"],
  "28510": ["Čestín"],
  "28511": ["Nepoměřice"],
  "40801": ["Rumburk", "Staré Křečany", "Jiřetín pod Jedlovou"],
  "73571": ["Dětmarovice"],
  "73572": ["Petrovice u Karviné"],
  "28521": ["Zbraslavice"],
  "28522": [
    "Petrovice II",
    "Čestín",
    "Petrovice I",
    "Dolní Pohleď",
    "Vlastějovice",
    "Zbraslavice",
    "Pertoltice",
    "Třebětín",
    "Bohdaneč",
    "Slavošov",
    "Chabeřice",
    "Zruč nad Sázavou",
    "Řendějov",
    "Kácov",
    "Horka II",
  ],
  "28523": ["Vlastějovice"],
  "73581": ["Bohumín"],
  "28525": ["Bohdaneč"],
  "57201": [
    "Sebranice",
    "Korouhev",
    "Březiny",
    "Široký Důl",
    "Kamenec u Poličky",
    "Polička",
    "Sádek",
    "Pustá Rybná",
    "Oldřiš",
    "Květná",
    "Telecí",
    "Stašov",
  ],
  "28531": ["Ovčáry", "Nové Dvory"],
  "28532": ["Kutná Hora", "Hlízov"],
  "61300": ["Brno"],
  "28533": ["Církvice"],
  "69501": ["Hodonín", "Starý Poddvorov"],
  "28541": ["Malešov"],
  "28542": ["Červené Janovice"],
  "28543": ["Paběnice"],
  "73601": ["Havířov", "Kaňovice"],
  "28545": ["Kluky"],
  "28546": ["Úmonín"],
  "28547": ["Křesetice"],
  "28561": ["Žleby"],
  "28562": ["Hostovlice"],
  "28563": ["Tupadly", "Potěhy"],
  "28564": ["Vlkaneč"],
  "28565": ["Zbýšov"],
  "28571": ["Vrdy"],
  "28572": ["Bílé Podolí"],
  "28573": ["Horušice"],
  "28574": ["Záboří nad Labem"],
  "28575": ["Žehušice"],
  "28576": ["Chotusice"],
  "16300": ["Praha"],
  "28601": [
    "Červené Janovice",
    "Zbýšov",
    "Žáky",
    "Vodranty",
    "Čáslav",
    "Horka I",
    "Chotusice",
    "Dobrovítov",
    "Vinaře",
    "Adamov",
    "Kluky",
    "Čejkovice",
    "Starkoč",
    "Třebětín",
    "Černíny",
    "Vrdy",
    "Semtěš",
    "Okřesaneč",
    "Hraběšín",
    "Vlačice",
    "Žehušice",
    "Petrovice I",
    "Krchleby",
    "Třebešice",
    "Žleby",
    "Úmonín",
    "Bludov",
    "Opatovice I",
    "Souňov",
    "Schořov",
    "Močovice",
    "Šebestěnice",
    "Horky",
    "Drobovice",
    "Horušice",
    "Brambory",
    "Bratčice",
    "Bílé Podolí",
    "Třebonín",
    "Vlkaneč",
  ],
  "61400": ["Brno"],
  "69601": ["Rohatec"],
  "69603": ["Dubňany"],
  "69602": ["Ratíškovice"],
  "69605": ["Milotice"],
  "73701": ["Český Těšín"],
  "69604": ["Svatobořice-Mistřín"],
  "69606": ["Vacenovice"],
  "69611": ["Mutěnice"],
  "69613": ["Šardice"],
  "69612": ["Hovorany"],
  "69615": ["Čejkovice"],
  "69614": ["Karlín", "Čejč", "Terezín"],
  "69617": ["Dolní Bojanovice"],
  "69616": ["Dolní Bojanovice", "Nový Poddvorov", "Starý Poddvorov"],
  "69619": ["Mikulčice"],
  "69618": ["Lužice"],
  "69621": ["Prušánky", "Josefov"],
  "69631": ["Ostrovánky", "Nechvalín", "Bukovany"],
};

export const vehicleMarksAndModels = {
  PILOTE: [""],
  PEIDU: [""],
  KANDI: [""],
  CAPIRELLI: [""],
  KTM: [
    "",
    "250 EXC",
    "500 EXC",
    "690 SMC R",
    "990 ADVENTURE S",
    "950 ADVENTURE S",
    "990 DUKE",
    "625 SXC",
    "FREERIDE E-SM",
    "50 SX",
    "690 ENDURO",
    "450 SMR",
    "990 SUPERDUKE R",
    "690 DUKE",
    "790 DUKE",
    "200 EXC",
    "1190 ADVENTURE",
    "1390 SUPER DUKE R",
    "1390 SUPER DUKE R EVO",
    "1190 ADVENTURE R",
    "1190 RC8",
    "1090 ADVENTURE",
    "250 EXC-F",
    "790 ADVENTURE",
    "950 SUPERMOTO",
    "1290 SUPER DUKE GT",
    "350 FREERIDE",
    "530 EXC-R",
    "250 SX-F",
    "125 SX",
    "200 DUKE",
    "890 DUKE R",
    "390 ADVENTURE",
    "1290 SUPER DUKE R",
    "640 LC4 ADVENTURE",
    "300 EXC-E",
    "1090 ADVENTURE R",
    "520 EXC",
    "450 SX-F",
    "300 EXC",
    "FREERIDE E-XC",
    "FREERIDE E-SX",
    "560 SMR",
    "1190 RC8 R",
    "690 DUKE R",
    "950 SUPERENDURO R",
    "85 SX",
    "400 EXC RACING",
    "390 RC",
    "250 R FREERIDE",
    "SUPER DUKE R SPECIAL EDITION",
    "250 SX",
    "790 ADVENTURE R",
    "250 EXC RACING",
    "950 SUPERMOTO R",
    "450 EXC RACING",
    "950 SUPERENDURO",
    "640 DUKE",
    "1290 SUPER ADVENTURE",
    "950 ADVENTURE",
    "450 EXC-F",
    "990 SUPERMOTO R",
    "125 EXC",
    "1050 ADVENTURE",
    "690 SMC",
    "990 SUPERMOTO T",
    "505 SX-F",
    "640 LC4 SUPERMOTO",
    "990 ADVENTURE",
    "660 SMS",
    "990 SUPERDUKE",
    "450 EXC-R",
    "144 SX",
    "690 SUPERMOTO R",
    "150 SX",
    "350 SX-F",
    "690 SUPERMOTO",
    "890 ADVENTURE R",
    "390 DUKE",
    "125 RC",
    "350 EXC-F",
    "690 SMR",
    "525 EXC RACING",
    "125 DUKE",
    "65 SX",
    "640 LC4 ENDURO",
    "1290 SUPER ADVENTURE S",
    "890 DUKE GP",
    "990 SUPERMOTO",
    "1290 SUPER ADVENTURE R",
  ],
  VOYAH: ["PASSION", "COURAGE", "DREAM", "FREE"],
  LAMBORGHINI: ["GALLARDO", "DIABLO", "HURACAN"],
  LIFAN: ["LF"],
  "VDL JONCKHEERE": [""],
  XUANMA: [""],
  EHO: [""],
  IPS: [""],
  KAMAZ: [""],
  OLTCIT: ["CLUB, LUX"],
  THINK: ["THINK CITY"],
  AVIA: [""],
  KAROSA: [""],
  MONDO: [""],
  FIAT: [
    "",
    "MAREA",
    "CROMA",
    "PUNTO CABRIO",
    "TEMPRA",
    "DUCATO 250",
    "ABARTH 500",
    "DOBLO CARGO",
    "PUNTO VAN",
    "BARCHETTA",
    "GRANDE PUNTO",
    "MULTIPLA",
    "TIPO",
    "FREEMONT",
    "BRAVA",
    "IDEA",
    "QUBO",
    "UNO",
    "500 C",
    "ABARTH 500 C",
    "LINEA",
    "500 L",
    "SEICENTO",
    "FIORINO",
    "SCUDO",
    "BRAVO",
    "STRADA",
    "TALENTO",
    "PALIO",
    "ULYSSE",
    "ABARTH 124 SPIDER",
    "500E",
    "PUNTO",
    "CINQUECENTO",
    "500 X",
    "124 SPIDER",
    "STILO",
    "SEDICI",
    "FULLBACK",
    "500",
    "600",
    "COUPÉ",
    "DOBLO",
    "PUNTO ABARTH",
    "DUCATO",
    "PANDA",
    "500 ELEKTRO",
    "PANDA VAN",
  ],
  CITROËN: [
    "DS4",
    "DS3",
    "E-C4 X",
    "DS5",
    "GRAND C4 PICASSO",
    "C-ZERO",
    "C5 X",
    "C3 ELLE",
    "DS3 RACING",
    "BERLINGO XL",
    "SAXO VAN",
    "XANTIA",
    "SPACETOURER",
    "C15",
    "C3 AIRCROSS",
    "C4 CACTUS",
    "C2 ENTREPRISE",
    "XSARA",
    "DS3 CABRIO",
    "C4 SPACETOURER",
    "C4 PICASSO",
    "XSARA VAN",
    "AX",
    "E-SPACETOURER",
    "NEMO",
    "ZX",
    "XSARA PICASSO",
    "E-BERLINGO",
    "JUMPER",
    "C25",
    "GRAND C4 SPACETOURER",
    "C1",
    "C4 AIRCROSS",
    "C2",
    "BERLINGO",
    "C3 PLURIEL",
    "C3",
    "JUMPY SPACETOURER",
    "JUMPY",
    "C4",
    "C5",
    "C6",
    "C8",
    "C4 X",
    "BX",
    "C-ELYSÉE",
    "SAXO",
    "EVC J10 ELECTRIC II",
    "EVASION",
    "C-CROSSER",
    "C5 AIRCROSS",
    "XM",
    "E-C3",
    "E-C4",
    "C3 PICASSO",
  ],
  SHERCO: [""],
  MAZDA: [
    "CX-7",
    "CX-5",
    "MX-5 ROADSTER COUPE",
    "CX-3",
    "CX-80",
    "CX-60",
    "DEMIO",
    "MPV",
    "TRIBUTE",
    "MX-30",
    "B-FIGHTER",
    "MX-5 RF",
    "PREMACY",
    "E 2000",
    "E 2200",
    "CX-30",
    "MX-6",
    "121",
    "XEDOS 9",
    "2",
    "3",
    "323",
    "5",
    "MX-3",
    "6",
    "121 VAN",
    "XEDOS 6",
    "MX-5",
    "RX 8",
    "626",
    "RX 7",
    "3 MPS",
    "BT-50",
    "CX-9",
  ],
  GILERA: [
    "NEXUS",
    "SMT 50",
    "DNA",
    "RCR 50",
    "COUGAR",
    "STAKLER",
    "GP 800",
    "RUNNER",
  ],
  DANDY: [""],
  GMC: ["SIERRA"],
  GOKA: [""],
  LAMBRETTA: [""],
  MONDIAL: ["HPS", "SMX"],
  DERBI: [
    "CROSS CITY",
    "HUNTER PADDOCK",
    "GPR",
    "GP1",
    "BOULEVARD",
    "SENDA",
    "VARIANT",
    "125 VARIANT",
    "PREDATOR",
    "TERRA",
    "SONAR",
    "ATLANTIS",
    "MULHACÉN",
    "RAMBLA",
  ],
  SIAMOTO: [
    "LF 400",
    "FAVOURITE",
    "KD 125",
    "CADDY",
    "FMC CITY HOOPER",
    "GECO",
    "BD 125",
    "SX1",
    "BIRDIE",
  ],
  "ROLLER TEAM": [""],
  XIONGTAI: [""],
  TGB: ["BULLET", "EXPRESS", "BM1", "RB8", "BR8", "BH1", "HAWK", "X-MOTION"],
  "BLUE BIRD": [""],
  VICTORY: [
    "VISION TOUR ARLEN NESS",
    "CROSS ROADS CLASSIC",
    "GUNNER",
    "BOARDWALK",
    "MAGNUM",
    "VEGAS 8-BALL",
    "VISION TOUR",
    "CROSS ROADS CORY NESS",
    "JUDGE",
    "KINGPIN",
    "HIGH-BALL",
    "KINGPIN 8-BALL",
    "VEGAS ZACH NESS",
    "HAMMER",
    "HAMMER S",
    "VEGAS",
    "HAMMER 8-BALL",
    "CROSS ROADS",
    "CROSS COUNTRY",
    "JACKPOT",
    "EMPULSE TT",
    "OCTANE",
  ],
  LYNX: [""],
  SKYJET: [""],
  TESLA: ["MODEL S", "MODEL 3", "CYBERTRUCK", "MODEL X", "MODEL Y"],
  DNĚPR: [""],
  GASOLONE: [""],
  SEEYES: [""],
  WUBEN: [""],
  JONWAY: ["LY", "CB"],
  DINLI: [""],
  "E-TON": [""],
  BINZ: [""],
  FUXIN: [""],
  "ROSERO-P": [""],
  GOUPIL: ["", "G4L"],
  "CLUB CAR": [""],
  RENAULT: [
    "",
    "RAFALE",
    "DUSTER",
    "TALISMAN",
    "TRAFIC",
    "MEGANE SCENIC",
    "AVANTIME",
    "R21",
    "TWINGO",
    "R25",
    "EXPRESS",
    "MÉGANE COUPÉ-CABRIOLET",
    "THALIA",
    "ALASKAN",
    "KANGOO",
    "MÉGANE VAN",
    "WIND",
    "KADJAR",
    "MASTER MA",
    "LAGUNA VAN",
    "ARKANA",
    "R19 CABRIO",
    "5 E-TECH",
    "TWIZY",
    "ZOE",
    "ESPACE",
    "MÉGANE COUPÉ",
    "MÉGANE",
    "LATITUDE",
    "MASTER",
    "GRAND SCÉNIC",
    "SAFRANE",
    "CLIO",
    "KANGOO Z.E.",
    "GRAND MODUS",
    "VEL SATIS",
    "THEAULT",
    "KANGOO EXPRESS",
    "SCÉNIC",
    "MODUS",
    "GRAND ESPACE",
    "FLUENCE",
    "CLIO VAN",
    "CAPTUR",
    "MASTER Z.E.",
    "AUSTRAL",
    "R11",
    "LAGUNA",
    "TWINGO VAN",
    "MÉGANE CABRIO",
    "SYMBIOZ",
    "KOLEOS",
    "MEGANE E-TECH",
    "MEGANE",
    "R19",
    "LAGUNA COUPÉ",
    "RAPID",
    "MEGANE GRANDCOUPÉ",
  ],
  XGJAO: [""],
  ARCA: [""],
  JIAJUE: [""],
  DODGE: [
    "DURANGO",
    "CHARGER",
    "VIPER GTS",
    "RAM 1500 CREW CAB SPORT",
    "CALIBER",
    "MAGNUM",
    "DAKOTA",
    "AVENGER",
    "RAM 2500",
    "JOURNEY",
    "CHALLENGER",
    "RAM 1500",
    "GRAND CARAVAN",
    "VIPER",
    "RAM 1500 CREW CAB REBEL",
    "SRT VIPER GTS",
    "NITRO",
    "RAM 1500 CREW CAB LARAMIE",
    "RAM 1500 CREW CAB",
  ],
  "VUT SUPERBEL": [""],
  "STEYR-PUCH": [""],
  MEGA: [""],
  HAMANN: [""],
  "BMW ALPINA": [""],
  "MS STEWARD": [""],
  "E-MAX": [""],
  FMC: ["SPEED", "WINDHUNTER", "JC250 JAMES BOND", "RACING"],
  STELLA: [""],
  WESTFIELD: [""],
  WANGYE: ["WY125T", "WY50QT", "NAVAJO"],
  CI: [""],
  YINMU: [""],
  "DAIMLER DOUBLE SIX": [""],
  XMOTOS: [""],
  MINI: [
    "COUNTRYMAN E",
    "COOPER SD COUNTRYMAN ALL4",
    "ONE COUNTRYMAN",
    "CLUBMAN JCW ALL4",
    "COOPER D",
    "COOPER SD",
    "JOHN COOPER WORKS",
    "MINI COOPER PACEMAN JCW",
    "ONE D",
    "COOPER S PACEMAN ALL4",
    "JOHN COOPER WORKS COUNTRYMAN",
    "CLUBMAN ONE",
    "COOPER SE",
    "MINI COOPER ROADSTER",
    "COOPER ALL4",
    "MINI COOPER PACEMAN",
    "COOPER S ALL4",
    "MINI COOPER COUNTRYMAN",
    "COOPER D CLUBMAN",
    "COOPER SE COUNTRYMAN ALL4",
    "MINI COOPER CABRIO JCW",
    "COOPER SD COUNTRYMAN",
    "COOPER D COUNTRYMAN",
    "COOPER SD CLUBMAN",
    "COOPER S COUNTRYMAN ALL4",
    "COOPER S COUNTRYMAN",
    "COUNTRYMAN JCW ALL4",
    "COOPER D COUNTRYMAN ALL4",
    "MINI COOPER COUNTRYMAN JCW",
    "COOPER COUNTRYMAN",
    "COOPER S CLUBMAN",
    "MINI ONE CABRIO",
    "COOPER S",
    "JCW CLUBMAN ALL4",
    "COOPER D ALL4",
    "MINI ONE COUNTRYMAN",
    "MINI COOPER JCW",
    "COOPER CLUBMAN",
    "COOPER S CABRIO",
    "COOPER SE COUNTRYMAN",
    "MINI COOPER",
    "MINI COOPER CLUBMAN",
    "ONE",
    "MINI COOPER COUPÉ",
    "COUNTRYMAN SE ALL4",
    "ACEMAN E",
    "MINI COOPER CLUBMAN JCW",
    "JOHN COOPER WORKS CABRIO",
    "JOHN COOPER WORKS ALL4",
    "ACEMAN SE",
    "MINI COOPER CABRIO",
    "COOPER SD CLUBMAN ALL4",
    "MINI COOPER ROADSTER JCW",
    "CLUBMAN ONE D",
    "COOPER COUNTRYMAN ALL4",
    "COOPER",
    "ONE CABRIO",
    "ONE D COUNTRYMAN",
    "COOPER SD ALL4",
    "COOPER S CLUBMAN ALL4",
    "MINI ONE",
    "MINI",
    "MINI COOPER COUPÉ JCW",
    "COOPER SD CABRIO",
    "ONE D CLUBMAN",
    "COOPER D CABRIO",
    "COOPER CABRIO",
    "MINI ONE CLUBMAN",
  ],
  MOTOWELL: [
    "MAGNET",
    "YOYO",
    "MEX-ON",
    "CROGEN CITY",
    "MAGNET SPORT",
    "CROGEN SPORT",
    "KID 2",
    "MAGNET CITY",
    "MAGNET RS",
    "RETROSA",
    "CROGEN RS",
  ],
  ZEEKR: ["001", "X"],
  GARELLI: [""],
  MARCOS: [""],
  STRATOS: [""],
  ZHEJIANG: ["LK50QT-17"],
  ELA: ["SAMURAI 150"],
  REX: [""],
  "IO FAHRZEUGE": [
    "SCOOBY",
    "MANHATTAN",
    "KING KONG",
    "1500 GT",
    "VIENNA",
    "VIENNA XE",
    "FLORENZ",
  ],
  "ASIA MOTORS": [""],
  BOROSSI: [""],
  ROVER: [
    "45",
    "25",
    "MGF",
    "220",
    "111",
    "200",
    "420",
    "114",
    "620",
    "214",
    "623",
    "414",
    "216",
    "416",
    "825",
    "618",
    "75",
  ],
  DR: ["3.0", "5.0", "6.0", "PK8"],
  DS: [
    "",
    "DS 3",
    "DS 4",
    "DS 5",
    "DS 3 CROSSBACK",
    "DS 9",
    "DS 3 CABRIO",
    "DS 3 RACING",
    "DS 4 CROSSBACK",
    "DS 7 CROSSBACK",
  ],
  FRANKIA: [""],
  SIMSON: [""],
  LADA: [
    "NIVA",
    "2111",
    "2110",
    "VESTA",
    "2172",
    "2171",
    "GRANTA",
    "2170",
    "NIVA PRAKTIK",
    "2107",
    "111 PRAKTIK",
    "111",
    "112",
    "2105",
    "2104",
    "2111 PRAKTIK",
    "KALINA",
    "2112",
    "LADA 4X4",
    "2109 SAMARA",
    "2108 SAMARA",
    "PRIORA",
  ],
  LEXUS: [
    "RZ 450E",
    "LS 460",
    "RX 450H L",
    "LS 500",
    "UX 250H",
    "IS 200",
    "GS 350",
    "LS 600H",
    "GS 430",
    "GS 350 F",
    "RX 350 F",
    "RC 200T",
    "LM 350H",
    "SC 430",
    "RX 330",
    "LBX",
    "LC 500",
    "UX 250H F",
    "LS 430",
    "IS 220D",
    "IS 350",
    "RC 300H",
    "IS 200D",
    "LX 450",
    "LX 570",
    "GX 460",
    "RC F",
    "GS F",
    "RX 450H",
    "NX 350H",
    "IS 200T",
    "LS 500H",
    "GS 300H",
    "RX 200T",
    "GS 200T",
    "ES 350",
    "UX 200",
    "RX 500H",
    "IS 300H",
    "IS 220",
    "LS 400",
    "NX 450H+",
    "RX 450H+",
    "RX 300",
    "LS 600H L",
    "IS 300",
    "RX 350H",
    "GS 250",
    "GX 470",
    "NX 200T",
    "GS 450H",
    "CT 200H",
    "RX 350",
    "NX 300H",
    "UX 300H",
    "IS 250",
    "RX 400H",
    "ES 300H",
    "LX 470",
    "IS 250C",
    "IS F",
    "GS 250 F",
    "GS 460",
    "LC 500H",
    "GS 300",
    "UX 300E",
  ],
  MARUTI: [""],
  KÖENIGSEGG: [""],
  SAITING: [""],
  ITALJET: ["MILLENNIUM", "FR2", "FORMULA"],
  FORD: [
    "",
    "SPORTKA",
    "TRANSIT",
    "TOURNEO",
    "B-MAX",
    "TRANSIT FAD",
    "EXPLORER",
    "BRONCO",
    "EXCURSION",
    "ESCORT CABRIO",
    "KA+",
    "AEROSTAR",
    "MUSTANG",
    "EXPRESS",
    "F 250",
    "SCORPIO",
    "EDGE",
    "PROBE",
    "TRANSIT COURIER",
    "GRANADA",
    "CAPRI",
    "FIESTA VAN",
    "ESCORT VAN",
    "TRANSIT 350L",
    "RAPTOR",
    "ESCORT",
    "SIERRA",
    "ESCORT EXPRESS",
    "FOCUS C-MAX",
    "MAVERICK",
    "CROWN",
    "TRANSIT CONNECT",
    "TOURNEO CUSTOM",
    "FUSION",
    "CONNECT TOURNEO",
    "FIESTA",
    "FIESTA COURIER",
    "FOCUS",
    "TRANSIT FCD",
    "MUSTANG MACH-E",
    "VARIO BUS",
    "F 150 RAPTOR",
    "CONNECT TRANSIT",
    "GALAXY",
    "FAIRLANE",
    "TRANSIT CUSTOM",
    "MERCURY",
    "KA",
    "FLEX",
    "ORION",
    "F 150",
    "TOURNEO CONNECT",
    "F 350",
    "MONDEO",
    "ECONOVAN",
    "RANGER RAPTOR",
    "ECONOLINE",
    "FIVE HUNDRED",
    "KUGA",
    "TRANSIT 300S",
    "COURIER",
    "GT",
    "S-MAX",
    "ESCAPE",
    "FOCUS C-C",
    "RANGER",
    "THUNDERBIRD",
    "EXPEDITION",
    "TAUNUS",
    "WINDSTAR",
    "TOURNEO COURIER",
    "TAURUS",
    "COUGAR",
    "ECOSPORT",
    "FALCON",
    "PUMA",
    "EDGE SPORT",
    "STREETKA",
    "GRAND C-MAX",
    "C-MAX",
  ],
  BUELL: [
    "FIREBOLT XB12R",
    "CITY XB9SX",
    "1125R",
    "LIGHTNING S1",
    "XB9SX LIGHTNING CITY X",
    "LIGHTNING XB12SCG",
    "LIGHTNING XB12STT",
    "LIGHTNING XB9S",
    "LIGHTNING XB12S",
    "ULYSSES XB12X",
    "LIGHTNING X1",
    "LIGHTNING XB9SX",
    "THUNDERBOLT S3",
    "CYCLONE M2",
    "FIREBOLT XB9R",
    "LIGHTNING XB12SS",
  ],
  BIMOTA: ["DB5 R", "DB5 S", "TESI 3D", "DB6 R", "DB7", "DB6"],
  DONGMA: ["DONGMA M6", "DONGMA R1", "DONGMA T4", "DONGMA VESPO"],
  "CF MOTO": [""],
  STEYR: [""],
  "MERCEDES-BENZ": [
    "S 580",
    "",
    "EQA 300",
    "VITO 208",
    "CLS 280",
    "E 240",
    "GLS 400",
    "VITO 200",
    "S 65L AMG",
    "E 200 CABRIO",
    "GLE 450 AMG",
    "ML 320",
    "ML 55 AMG",
    "SLC 43 AMG",
    "S 450",
    "GLA 35 AMG",
    "E 250",
    "ML 550",
    "CLK 240",
    "ML 430",
    "VITO 220",
    "GLE 300",
    "R 300",
    "GLE 63 AMG S",
    "CLC 200",
    "CLK 240 CABRIO",
    "VITO 109",
    "CLS 55 AMG",
    "VITO 108",
    "CLK 55 AMG",
    "E 220",
    "CLK 270",
    "T",
    "VITO 111",
    "E 63 S AMG",
    "VITO 110",
    "VITO 230",
    "V",
    "CLC 230",
    "GLE 43 AMG",
    "CLC 350",
    "C 32 AMG",
    "GLS 600 4MATIC MAYBACH",
    "GLC 300 4MATIC",
    "S 350",
    "CLK 350 CABRIO",
    "ML 63 AMG",
    "E 350",
    "C 400",
    "VITO 115",
    "VITO 114",
    "VITO 113",
    "VITO 112",
    "EQV 300",
    "VITO 119",
    "ML 450",
    "VITO 116",
    "E 230",
    "GLC 220 D 4MATIC",
    "R 320",
    "GLE 400",
    "GLC 63 AMG",
    "VITO 122",
    "GLS 63 AMG",
    "VITO 120",
    "CLC 220",
    "CITAN TOURER/T-CLASS",
    "S 420",
    "S 300",
    "G 290",
    "VITO 126",
    "GLE 350",
    "VITO 124",
    "VITO 123",
    "E 200",
    "E 320",
    "G 63 AMG",
    "ML 400",
    "A 45 AMG",
    "SL 65 AMG",
    "E 53 AMG",
    "E 450 CABRIO",
    "GLS 450",
    "CLK 500 CABRIO",
    "CLK 320 CABRIO",
    "EQB 300",
    "CLS 250",
    "G 280",
    "E 43 AMG",
    "GLE 580",
    "R 63 AMG",
    "CLK 280",
    "E 450",
    "R 500",
    "C 55 AMG",
    "S 55 AMG",
    "S 560",
    "G 300 CABRIO",
    "E 300",
    "S 320",
    "G 270",
    "GLE 450",
    "GL 63 AMG",
    "E 420",
    "AMG GLE 53 4MATIC+",
    "S 65 AMG",
    "ML 300",
    "S 580L",
    "ML 420",
    "CLE 200 4MATIC",
    "S 350L",
    "GLS 350",
    "CLS 63 AMG",
    "CLK 63 AMG",
    "S 550",
    "EQE 43 AMG",
    "S 430",
    "E 430",
    "G 55 AMG CABRIO",
    "GLS 580",
    "VITO 280",
    "CL 65 AMG",
    "SL 55 AMG",
    "C 300 AMG CABRIO",
    "CLE 220",
    "E 400",
    "CLK 280 CABRIO",
    "GLA 250",
    "CLK 430 CABRIO",
    "A 190",
    "SLR",
    "C 450 AMG",
    "B 250 E",
    "S 580 4MATIC MAYBACH",
    "SLK 200",
    "SLK 320",
    "EQT",
    "A 180",
    "EQV",
    "GL 350",
    "EQE 53 AMG",
    "AMG GT R",
    "AMG GT S",
    "E 500",
    "G 350",
    "CLE 200",
    "CL 55 AMG",
    "SLC 300",
    "EQE 500",
    "AMG GT C",
    "R 280",
    "ML 500",
    "CLE 300 4MATIC",
    "G 580",
    "SLS AMG",
    "MARCO POLO",
    "A 35 AMG",
    "GL 450",
    "CLK 230 CABRIO",
    "GLA 45 AMG",
    "GLB 180",
    "CLA 35 AMG",
    "S 600L",
    "G 450",
    "SL 280",
    "SLC 200",
    "E 220 CABRIO",
    "SL 63 AMG",
    "A 150",
    "C 30 AMG",
    "EVITO TOURER",
    "ECITAN",
    "E 400 ALL-TERRAIN",
    "A 140",
    "G 320",
    "GLE 500",
    "E 55 AMG",
    "B 180",
    "208",
    "CL 63 AMG",
    "E 400 CABRIO",
    "EVITO",
    "A 170",
    "EQE 300",
    "210",
    "R 350",
    "CLS 63 S AMG",
    "SLK 300",
    "G 65 AMG",
    "GLA 180",
    "G 300",
    "A 160",
    "100",
    "GLE 63 AMG",
    "S 280",
    "CITAN TOURER",
    "SLK 280",
    "CLK 55 AMG CABRIO",
    "GL 400",
    "B 150",
    "CITAN 112",
    "V 200",
    "SLC 250",
    "GLC 43 AMG",
    "CITAN 111",
    "CITAN 110",
    "SL 350",
    "GLK 280",
    "G 400",
    "CL 500",
    "G 350 CABRIO",
    "A 220",
    "C 180",
    "GLB 200",
    "G 500 CABRIO",
    "C 63 S AMG",
    "VANEO",
    "S 400L",
    "S 400D",
    "SPRINTER",
    "A 250",
    "CLS 500",
    "CLA 180",
    "CITAN 109",
    "S 560 MAYBACH",
    "V-KLASSE",
    "CITAN 108",
    "GL 500",
    "B 170",
    "GLC 250",
    "V 300",
    "X 250",
    "G 500",
    "GLB 220",
    "E 200 ALL-TERRAIN",
    "SL 60 AMG",
    "B 160",
    "G 320 CABRIO",
    "SLK 230",
    "SLK 350",
    "CITAN",
    "GLK 250",
    "SL 320",
    "S 680 4MATIC MAYBACH",
    "E 63 AMG",
    "GL 320",
    "C 270",
    "SLS 63 AMG",
    "ECITAN TOURER",
    "GLB 250",
    "A 53 CABRIO AMG",
    "EQS 500",
    "SLK 32 AMG",
    "E 320 CABRIO",
    "GLA 200",
    "X 350",
    "B 220",
    "EQE 350",
    "EQE 350+",
    "C 43 AMG",
    "SL 550",
    "E 350 CABRIO",
    "EQC 400",
    "CLA 250",
    "GL 550",
    "SLK 250",
    "SLC 180",
    "S 500 MAYBACH",
    "SL 300",
    "X 220",
    "GL 420",
    "A 210",
    "S 500L",
    "AMG GT",
    "B 250",
    "GLA 220",
    "C 220 ALL-TERRAIN",
    "CL 600",
    "A 200",
    "VIANO",
    "C 160",
    "C 280",
    "CLK 500",
    "GLC 300 E 4MATIC",
    "S 500",
    "SPRINTER 224",
    "CLS 320",
    "ML 280",
    "C 230",
    "SL 400",
    "C 350",
    "E 220 ALL-TERRAIN",
    "SPRINTER 218",
    "SPRINTER 219",
    "S 550L",
    "GLC 300",
    "G 400 CABRIO",
    "CLA 200",
    "GLK 200",
    "CLK 200 CABRIO",
    "E 300 CABRIO",
    "ML 270",
    "AMG CLE 53 4MATIC",
    "V 280",
    "CLS 450",
    "EQA 250",
    "CLE 450 4MATIC",
    "C 220",
    "GLK 320",
    "S 600 MAYBACH",
    "CLC 160",
    "CLK 63 AMG CABRIO",
    "EQV 250",
    "S 400",
    "E 400 D 4MATIC",
    "V 250",
    "CLS 220",
    "GLE 250",
    "GLK 350",
    "CLS 53 AMG",
    "SL 500",
    "C 250",
    "GLE 53 AMG",
    "CLK 430",
    "S 560L",
    "GLC 400",
    "CLA 220",
    "B 200",
    "EQA 350",
    "CLS 350",
    "GLK 220",
    "C 240",
    "EQS 350",
    "CLC 180",
    "S 450L",
    "GLC 63 S AMG",
    "GLC 220",
    "CLS 400",
    "V 230",
    "SL 600",
    "C 63 AMG",
    "E 500 CABRIO",
    "EQS 450+",
    "EQS 580",
    "E 280",
    "CLA 45 AMG",
    "S 300L",
    "VITO TOURER",
    "SLK 55 AMG",
    "GLC 350",
    "CL 420",
    "SPRINTER 311",
    "SPRINTER 312",
    "C 300",
    "SPRINTER 310",
    "SPRINTER 315",
    "SPRINTER 316",
    "ML 230",
    "SPRINTER 313",
    "ML 350",
    "SPRINTER 314",
    "SPRINTER 308",
    "SPRINTER 309",
    "CLK 320",
    "EQS 450",
    "G 55 AMG",
    "EQB 250",
    "E 290",
    "CLK 200",
    "EQS 53 AMG",
    "E 550 CABRIO",
    "E 250 CABRIO",
    "S 650 MAYBACH",
    "GLS 500",
    "S 600",
    "CL 550",
    "SPRINTER 324",
    "CLS 300",
    "SPRINTER 319",
    "CLK 350",
    "SPRINTER 317",
    "X-KLASSE",
    "SPRINTER 318",
    "CLK 230",
    "GLC 200",
    "C 200 ALL-TERRAIN",
    "GLK 300",
    "GLB 35 AMG",
    "GLC 450",
    "CLS 550",
    "SPRINTER 212",
    "S 63 AMG",
    "SPRINTER 213",
    "SPRINTER 210",
    "C 200",
    "SPRINTER 211",
    "E 270",
    "C 320",
    "SPRINTER 216",
    "V 220",
    "SPRINTER 214",
    "ML 250",
    "SPRINTER 215",
    "SPRINTER 209",
    "CLK 220",
    "ESPRINTER",
    "EQB 350",
    "SPRINTER 208",
  ],
  VESPA: [
    "PX 80E ELESTART-NESSO",
    "ET2",
    "PRIMAVERA",
    "S",
    "ET4",
    "SPRINT",
    "GTS",
    "GTV",
    "946",
    "LXV",
    "LX",
    "GT",
  ],
  LVNENG: [""],
  EMU: [""],
  "VDL BERKHOF": [""],
  ABARTH: ["GRANDE PUNTO", "500", "500C", "PUNTO EVO"],
  BARKAS: [""],
  RADICAL: [""],
  FAUN: [""],
  SPORTEQUIPE: ["X K2"],
  VOR: ["EN", "SM"],
  "EMU ALLTRAC": [""],
  TAZARRI: [""],
  ZHONGYU: ["ZY50QT"],
  JMSTAR: [
    "JSD50QT-27",
    "JSD125-27",
    "JSD50QT-21A",
    "JSD50QT-15",
    "JSD150T-15",
    "JSD150T-18",
    "JSD125T-4",
  ],
  NEOPLAN: [""],
  GONOW: ["GX 6", "GA 200"],
  "ŠOA - SPORT": [""],
  HSUN: [""],
  KINETIC: ["NOVA", "GF125"],
  AKUMOTO: [""],
  ASIAWING: [""],
  ISUZU: ["", "D-MAX", "TROOPER", "MIDI VAN"],
  CHAMP: ["XY-50"],
  ČZ: [""],
  IRISBUS: [""],
  CFMOTO: ["700MT", "CFORCE 850XC"],
  CORVETTE: [""],
  "SUN LIVING": [""],
  XINLING: ["CXM250A"],
  BUREKO: [""],
  HYOSUNG: ["XRX125", "AQUILA", "COMET", "SF50R", "SF50", "RT125"],
  MINAUTO: [""],
  GINAF: [""],
  DAIHATSU: [
    "HIJET",
    "APPLAUSE",
    "SIRION",
    "TREVIS",
    "TERIOS",
    "FEROZA",
    "CUORE",
    "GRAND MOVE",
    "MATERIA",
    "CHARADE",
    "MOVE",
    "COPEN",
    "YRV",
    "ROCKY",
  ],
  UNU: [""],
  RIDE: [""],
  MACK: [""],
  BUYANG: [""],
  "MERCEDES-AMG": [""],
  AGM: [""],
  JINLING: [""],
  EOS: [""],
  CHARMING: [""],
  ELNAGH: [""],
  FORT: [""],
  ENERGICA: ["EVA 80", "ESSEESSE 9", "EVA 107", "ESSEESSE 9 SPECIAL", "EGO"],
  ADLY: ["SUPERSONIC"],
  TMEC: ["BETKA"],
  CHALLENGER: [""],
  MCLAREN: [""],
  "SKI-DOO": [""],
  "GARDNER DOUGLAS": ["GD427", "MK3", "MK4", "GDT70", "GD350"],
  HAOTIAN: [""],
  WIESMANN: [""],
  GIANTCO: [""],
  "MV AGUSTA": [
    "F4 RR",
    "RIVALE 800",
    "BRUTALE 1090 R",
    "BRUTALE 675",
    "BRUTALE 1090",
    "F4 910 BRUTALE S",
    "F4 910 BRUTALE R",
    "F4 750 BRUTALE",
    "F4 1000 TAMBURINI",
    "F4 1000 R",
    "F3 675 RC REPARTO CORSE",
    "F4 RC",
    "TURISMO VELOCE 800",
    "BRUTALE 1078 RR",
    "F3 800",
    "F4 750 AGO",
    "RVS#1",
    "F4 1000 S1+1",
    "BRUTALE 800 DRAGSTER",
    "F4 1000 S",
    "DRAGSTER 800 RR LH44",
    "BRUTALE 800 RR",
    "BRUTALE 990 R",
    "BRUTALE 920",
    "BRUTALE 800",
    "F4 1000",
    "F4 1078 RR 312",
    "TURISMO VELOCE LUSSO",
    "BRUTALE 1090 RR",
    "STRADALE",
    "F4 750 SPR",
    "BRUTALE 800 DRAGSTER RR LH44",
    "F4 750 BRUTALE S",
    "F3 800 RC REPARTO CORSE",
    "F4 750 SENNA",
    "F3 675",
    "F4 1000 R1+1",
    "F4 750 BRUTALE S/ORO",
    "DRAGSTER 800",
    "DRAGSTER 800 RR",
    "F4 750 S1+1",
    "F4 1000 RR",
    "BRUTALE 800 DRAGSTER RR",
    "BRUTALE 1090 RR CORSA",
  ],
  "HERO PUCH": [""],
  FEISHEN: [""],
  JIAYUAN: [""],
  JINLUN: ["JL"],
  RICH: [""],
  VICTORIA: [""],
  PETERBILT: [""],
  IRIZAR: [""],
  "R.F.MOTO": [""],
  KYMCO: [
    "ZING",
    "SENTO",
    "CK1",
    "XCITING",
    "VISAR 125I",
    "SUPER 8",
    "AGILITY CITY",
    "AK550",
    "TOP BOY",
    "MYROAD 700I",
    "DJ50REFINER",
    "DJ 50S",
    "NEW DOWNTOWN",
    "NEXXON",
    "SUPER 9 LC",
    "HIPSTER",
    "FEVER",
    "AGILITY",
    "QUANNON",
    "DINK",
    "LIKE II",
    "YAGER",
    "PULSAR",
    "AGILITY CARRY",
    "K-PIPE",
    "X-TOWN",
    "PEOPLE GT",
    "NEW PEOPLE S",
    "MOVIE S",
    "DOWNTOWN",
    "K-XCT",
    "SUPER 9 AC",
    "DJ 125S",
    "MOVIE",
    "LIKE",
    "YUP",
    "YAGER GT",
    "CK 125",
    "VITALITY",
    "STRYKER",
    "PEOPLE",
    "GRAND DINK",
  ],
  DRÖGMÖLLER: [""],
  JINCHENG: [
    "JC125-17B",
    "JC150-Y",
    "JC150T-A",
    "JC50QT-20",
    "JC125T",
    "JC250-6",
    "JC110-9",
    "JC100-7",
    "DOGGY 50",
    "JC50Q-8",
    "JC50QT-15",
  ],
  HM: [""],
  POLESTAR: ["POLESTAR 2"],
  VOLKSWAGEN: [
    "ID.5",
    "",
    "ID.3",
    "ID.4",
    "ID.7",
    "LT 28",
    "ID. BUZZ PURE",
    "PHAETON",
    "JETTA",
    "T-ROC",
    "GOLF CABRIO",
    "UP",
    "CADDY MAXI",
    "LT 32",
    "BORA",
    "POLO VAN",
    "BEETLE",
    "ROUTAN",
    "FOX",
    "LT 35",
    "TAYRON",
    "CALIFORNIA",
    "GOLF PLUS",
    "KOMBI",
    "PASSAT",
    "CRAFTER SYN1E",
    "AMAROK",
    "TRANSPORTER",
    "GOLF",
    "SHARAN",
    "SCIROCCO",
    "ID.4 GTX",
    "T-CROSS",
    "GOLF VARIANT",
    "TARO",
    "CRAFTER",
    "PASSAT ALLTRACK",
    "ATLAS",
    "CARAVELLE",
    "GOLF SPORTSVAN",
    "MULTIVAN",
    "ARTEON",
    "TAIGO",
    "CORRADO",
    "ID.5 GTX",
    "TOURAN",
    "NEW BEETLE CABRIO",
    "BEETLE CABRIO",
    "CC",
    "GOLF ALLTRACK",
    "VENTO",
    "ID. BUZZ CARGO",
    "NEW BEETLE",
    "POLO",
    "EOS",
    "LUPO",
    "TOUAREG",
    "TIGUAN",
    "PASSAT CC",
    "ID. BUZZ LONG GTX",
    "ID. BUZZ PRO",
    "ID. BUZZ GTX",
    "CADDY",
    "ID. BUZZ LONG PRO",
  ],
  "ROLLS ROYCE": ["GHOST FAMILY"],
  CHUNLAN: ["TIGER", "CL 125-10"],
  CLS: ["THOR", "PRIME", "MAX", "CRUISE", "BLADE", "GRIM", "OZZY"],
  TIANMA: [""],
  PUCH: ["G 500 CABRIO"],
  DENNIS: [""],
  DAFIER: [""],
  "NICRO-VETT": [""],
  ADAMS: ["JL125T", "JL50QT"],
  "CRDCAR RESEARCH": [""],
  CATERHAM: [""],
  SMART: [
    "",
    "FORTWO COUPE",
    "EQ FORFOUR",
    "ROADSTER 60",
    "FORFOUR",
    "1",
    "3",
    "CABRIO",
    "ROADSTER COUPE 60",
    "ROADSTER 45",
    "FORTWO COUPE BRABUS",
    "EQ FORTWO",
    "FORTWO CABRIO",
  ],
  AEON: ["PULSAR", "TORCH", "TRX"],
  AIE: [""],
  DACIA: [
    "LODGY",
    "DUSTER",
    "SPRING",
    "LOGAN",
    "SOLENZA",
    "SANDERO",
    "DOKKER VAN",
    "SUPERNOVA",
    "PICK-UP",
    "BIGSTER",
    "JOGGER",
    "LOGAN PICK-UP",
    "LOGAN VAN",
    "DOKKER",
    "LOGAN MCV",
  ],
  "SKY TEAM": [""],
  SHANYANG: [""],
  BERKHOF: [""],
  SCANIA: [""],
  SMC: [""],
  ARTEGA: [""],
  SPYKER: [""],
  WONJAN: [""],
  PGO: ["", "G-MAX 50", "T-REX 50", "G-MAX 125", "T-REX 125"],
  MELEX: [""],
  MAN: [""],
  TRIUMPH: [
    "",
    "TIGER 800 XR",
    "SCRAMBLER",
    "ADVENTURER",
    "EXPLORER XCA",
    "TROPHY SE",
    "ROCKET 3 STORM GT",
    "BONNEVILLE BOBBER BLACK",
    "TIGER 800 XCX",
    "TIGER 1200 XRX",
    "TT 600",
    "TIGER EXPLORER XCA",
    "SPEED TRIPLE",
    "TIGER 1200 XR",
    "TIGER 1200 XCA",
    "SPEED 400",
    "THRUXTON 900",
    "BONNEVILLE T120",
    "BONNEVILLE BOBBER",
    "TIGER 1200 XCX",
    "THUNDERBIRD COMMANDER",
    "THRUXTON 1200 R",
    "SPEED FOUR",
    "AMERICA",
    "SPEED TWIN",
    "BONNEVILLE SPEEDMASTER",
    "DAYTONA R",
    "BONNEVILLE T120 BLACK",
    "BONNEVILLE T100 BLACK",
    "STREET TRIPLE RX",
    "TIGER 800 XCA",
    "ROCKET III",
    "SPEED TRIPLE RS",
    "TIGER SPORT",
    "STREET TRIPLE RS",
    "STREET SCRAMBLER",
    "THRUXTON 1200",
    "TIGER XC",
    "T100 MCQUEEN",
    "ROCKET III TOURING",
    "ROCKET 3 STORM R",
    "TIGER EXPLORER XRT",
    "TIGER SPORT 1050",
    "THUNDERBIRD HORIZON",
    "T100",
    "EXPLORER XCX",
    "TIGER EXPLORER XRX",
    "ROCKET III ROADSTER",
    "TIGER EXPLORER XC SE",
    "STREET TRIPLE R",
    "STREET TRIPLE S",
    "SPEED TRIPLE S",
    "TIGER EXPLORER XC",
    "TIGER 900 GT PRO",
    "SPEED TRIPLE R",
    "DAYTONA",
    "SPEEDMASTER",
    "STREET TWIN",
    "TROPHY",
    "TIGER SE",
    "TIGER EXPLORER XR",
    "THUNDERBIRD STORM",
    "SPRINT RS",
    "EXPLORER XC SE",
    "TIGER 955I",
    "TRIDENT 660",
    "TIGER 800 XRT",
    "TIGER",
    "BONNEVILLE T100",
    "TIGER 800 XRX",
    "SCRAMBLER 1200XC",
    "STREET CUP",
    "SPRINT GT",
    "THUNDERBIRD LT",
    "T100-110TH ANNIVERSARY",
    "EXPLORER XC",
    "EXPLORER XRT",
    "EXPLORER XRX",
    "TIGER EXPLORER",
    "TIGER EXPLORER XCX",
    "SCRAMBLER 1200XE",
    "STREET TRIPLE",
    "BONNEVILLE",
    "AMERICA LT",
    "EXPLORER XR",
    "THUNDERBIRD",
    "TIGER 1200 XRT",
    "LEGEND TT",
    "SPRINT ST",
    "TIGER 800 XC",
    "BONNEVILLE SE",
  ],
  SAKURA: ["EV2000"],
  AMBITION: [""],
  SUZUKI: [
    "BOULEVARD C90T",
    "INTRUDER",
    "GSF (BANDIT)",
    "MARAUDER (VL)",
    "JIMNY",
    "DR",
    "HAYABUSA 1300",
    "GPZ",
    "SIXTEEN 125",
    "EPICURO",
    "V-STROM",
    "1000 GTR",
    "DL650",
    "VL 1500",
    "GSX-S 750",
    "SAMURAI",
    "SUPER CARRY",
    "INAZUMA",
    "RF",
    "CARRY",
    "ADDRESS",
    "GSX-S 1000F",
    "GSX 1300R",
    "DL (V-STROM)",
    "RM",
    "MARAUDER (VZ)",
    "IGNIS",
    "AN650",
    "ACROSS",
    "GSX-R",
    "LIANA VAN",
    "XF (FREEWIND)",
    "SWACE",
    "GRAND VITARA XL-7",
    "LIANA",
    "VZ 1500",
    "SWIFT",
    "GRAND VITARA",
    "SPLASH",
    "GW250",
    "BOULEVARD M800",
    "KATANA 50",
    "VITARA S",
    "GLADIUS",
    "VITARA",
    "S-CROSS",
    "SV",
    "VZR 1800",
    "VITARA X-90",
    "GSX-S 1000",
    "GSR",
    "GN",
    "LS 650",
    "UK110",
    "MARAUDER (GZ)",
    "GS",
    "GSX",
    "VLR 1800",
    "BALENO",
    "SX4",
    "CELERIO",
    "KIZASHI",
    "ALTO",
    "TL",
    "KATANA R50",
    "VAN VAN",
    "RM - Z",
    "DR-Z",
    "WAGON R+",
    "BURGMAN",
    "B-KING",
  ],
  HUONIAO: [""],
  BRILLIANCE: ["BS2", "BS4", "BC3", "BS6"],
  SETRA: [""],
  ZIPP: [
    "VEGA",
    "QUANTUM",
    "TRIAD",
    "PRO",
    "BASIC",
    "ROOSTER",
    "ROADSTAR",
    "MANIC",
    "STORM",
    "SALMO",
    "RANGER",
    "SHOCK",
    "VAPOR",
    "RAVEN",
    "TRACKER",
    "NEKEN",
    "TOPS",
    "NITRO",
    "SIMPLI",
    "AXIS",
  ],
  K1: [""],
  AJP: [
    "PR5 250 ENDURO EXTREME",
    "PR3 125 SUPERMOTO",
    "PR5 250 ENDURO",
    "PR4 240 ULTRAPASSAR",
    "PR3 240 ENDURO PRO",
    "PR7 650 ADVENTURE",
    "PR4 240 ENDURO",
    "PR4 125 SUPERMOTO",
    "PR4 125 ENDURO PRO",
    "PR3 125 TRIAL",
    "PR3 125 ENDURO",
    "PR3 240 SUPERMOTO",
    "PR3 240 ENDURO",
    "PR4 240 ENDURO EXTREME",
    "PR5 250 SUPERMOTO",
    "PR4 240 SUPERMOTO",
    "PR4 200 ENDURO",
    "PR4 240 ENDURO PRO",
    "PR3 125 ENDURO PRO",
    "PR4 125 ENDURO",
  ],
  MAZ: [""],
  "EQUI-TREK": [""],
  HUSABERG: ["TE", "FE"],
  DESTACAR: [""],
  BÜRSTNER: [""],
  CHANGSHU: ["FD"],
  TARO: [""],
  SAMPO: [""],
  MAHINDRA: ["GOA PICK UP", "GOA"],
  JAECOO: ["J7"],
  MERCURY: [""],
  YUKI: [
    "CSR 125",
    "GY2",
    "MANXMAN",
    "GY4",
    "DUEL TT",
    "RUNNER",
    "WHIP",
    "HAWK II.",
    "SNAKE",
    "50",
    "V3",
    "TWINSPORT",
    "ENDURO",
    "DUEL SM",
    "MANXMAN S",
    "HAWK",
    "YK250-B",
    "VISTA",
    "RMC II.",
    "SWAN",
    "GRAMPUS",
    "MANXCAFE",
    "SPEEDY",
    "DOUBLEXX",
    "SPREE",
    "RX",
    "RACING 42",
    "DAYTONA",
    "TINE",
    "FAIRY",
    "SPIDER",
    "SPACE",
    "YK50QT-26",
    "SG",
    "BUG",
    "SM",
    "RS 125",
    "SMILE",
    "SR",
    "DARKER",
    "MATRIX",
    "SPORT",
    "MOTARD",
    "RALLY",
    "PRISMA",
    "SM EFI",
    "BOSS",
    "STAR",
    "CITY",
    "CROSS",
    "NEW SPEEDY",
    "JET",
    "CSR 250",
    "FALCON",
    "VICE",
    "TR",
    "TOUR",
  ],
  RAPIDO: [""],
  ACHLEITNER: [""],
  TERRIER: [""],
  MBK: [
    "MACH G AC",
    "STUNT",
    "FIZZ",
    "FORTE",
    "EVOLIS",
    "NITRO NAKED",
    "X-POWER",
    "DOODO",
    "FLAME",
    "CW 50 RS",
    "MACH G LC",
    "SKYLINER",
    "BOOSTER",
    "OVETTO",
    "NITRO",
    "THUNDER",
    "FLIPPER",
    "SKYCRUISER",
  ],
  BMC: [""],
  CHUANL: [""],
  BURSTNER: [""],
  SHINERAY: [""],
  "KSR MOTO": [""],
  TRABANT: [""],
  SANYOU: [""],
  "VDL BOVA": [""],
  BIAGINNI: [""],
  ODES: [""],
  DELOREAN: [""],
  ZHWEKI: [""],
  QSTRONG: [""],
  MCC: [""],
  UNIMOG: [""],
  BMW: [
    "440I CABRIO",
    "X3 3.0SI",
    "X3 3.0SD",
    "420D XDRIVE GRAN COUPÉ",
    "420D XDRIVE COUPÉ",
    "Z4 SDRIVE 35IS",
    "I8 ROADSTER",
    "230I",
    "R 1100 RT",
    "645 CABRIO",
    "730LD XDRIVE",
    "535I XDRIVE",
    "328 COUPÉ",
    "X3 M40D",
    "X6 XDRIVE 30D",
    "325 CABRIO",
    "X1 XDRIVE 20I",
    "X3 M40I",
    "216D ACTIVE TOURER",
    "318D GRAN TURISMO",
    "S 1000 R",
    "X4 M",
    "K 1600 GTL",
    "128TI",
    "X6 XDRIVE 40I",
    "340I",
    "HP4",
    "330I GRAN TURISMO",
    "X1 XDRIVE 20D",
    "X5 3.0 SD",
    "IX M60",
    "630I GRAN TURISMO",
    "530D GRAN TURISMO",
    "550E XDRIVE",
    "550I XDRIVE",
    "520D GRAN TURISMO",
    "F 850 GS ADVENTURE",
    "220D",
    "G 450 X",
    "X6 M COMPETITION",
    "X REIHE",
    "IX XDRIVE45",
    "530 GRAN TURISMO",
    "F 800 GT",
    "F 800 GS",
    "220I",
    "R NINET PURE",
    "C1",
    "840D XDRIVE",
    "X1 XDRIVE 30E",
    "IX XDRIVE50",
    "R NINET",
    "X6 XDRIVE 40D",
    "M6 GRAN COUPÉ",
    "X1 M35I XDRIVE",
    "K 1200 RS",
    "220I XDRIVE",
    "X3 M",
    "328I XDRIVE GRAN TURISMO",
    "4ER REIHE",
    "430D GRAN COUPÉ",
    "330E",
    "R 1250 R",
    "R 1150 GS",
    "330D",
    "560L",
    "X1 SDRIVE 25I",
    "M8 GRAN COUPÉ",
    "X3 XDRIVE 25I",
    "X6 XDRIVE 50I",
    "X3 XDRIVE 25D",
    "I4 M50",
    "328I XDRIVE",
    "330I",
    "IX XDRIVE40",
    "Z4 M ROADSTER",
    "440I",
    "125I",
    "M235I XDRIVE",
    "228I CABRIO",
    "S 1000 XR",
    "Z3 ROADSTER",
    "125D",
    "220I GRAN TOURER",
    "I3S",
    "IX1 XDRIVE 30",
    "X1 XDRIVE 25E",
    "435I GRAN COUPÉ",
    "X1 XDRIVE 25D",
    "520D XDRIVE",
    "X1 XDRIVE 25I",
    "650I CABRIO",
    "X6 M50I",
    "123 CABRIO",
    "7ER REIHE",
    "420I XDRIVE",
    "R 850",
    "M440I XDRIVE CABRIO",
    "535I GRAN TURISMO XDRIVE",
    "135 COUPÉ",
    "550I",
    "114I",
    "320E",
    "Z3 COUPÉ",
    "320D",
    "630 CABRIO",
    "G 650 XMOTO",
    "114D",
    "X7 M50I",
    "X3 XDRIVE 35I",
    "X3 XDRIVE 35D",
    "X6 M50D",
    "320I",
    "X1 XDRIVE 23I",
    "528I XDRIVE",
    "Z4 SDRIVE 30I",
    "840",
    "Z4 M40I",
    "F 650 GS",
    "230E XDRIVE ACTIVE TOURER",
    "X5 M COMPETITION",
    "420I XDRIVE GRAN COUPÉ",
    "440I GRAN COUPÉ",
    "725",
    "M4 GTS",
    "530XD",
    "X3 2.5SI",
    "728",
    "X1 SDRIVE 16D",
    "M2 CS",
    "430I",
    "X1 SDRIVE 28I",
    "640D XDRIVE COUPÉ",
    "ACTIVEHYBRID 7",
    "M140I XDRIVE",
    "ACTIVEHYBRID 5",
    "X3 XDRIVE 20D",
    "ACTIVEHYBRID 3",
    "430D",
    "328 GRAN TURISMO",
    "X1 XDRIVE 23D",
    "218I CABRIO",
    "850",
    "730",
    "225XE IPERFORMANCE",
    "732",
    "2002",
    "X7 M50D",
    "735",
    "X3 SDRIVE 18D",
    "320I GRAN TURISMO",
    "120 COUPÉ",
    "540I",
    "R 1250 RS",
    "225I",
    "116I",
    "IX3",
    "M550D XDRIVE",
    "318 GRAN TURISMO",
    "R 1150 R",
    "750E XDRIVE",
    "650I GRAN COUPÉ",
    "Z4 M",
    "R 1250 RT",
    "420D GRAN COUPÉ",
    "740",
    "430I CABRIO",
    "840I CABRIO",
    "Z4 SDRIVE 20I",
    "X3 XDRIVE 20I",
    "335I XDRIVE",
    "225D",
    "745",
    "X1 SDRIVE 18D",
    "116D",
    "628",
    "X5 XDRIVE 35D",
    "335I",
    "M850I XDRIVE CABRIO",
    "420D",
    "I3",
    "X3 XDRIVE 30D",
    "745LE XDRIVE",
    "X5 XDRIVE 35I",
    "X3 XDRIVE 30E",
    "M2 COMPETITION",
    "420I",
    "I8",
    "C EVOLUTION",
    "750LI",
    "750",
    "630",
    "X5 SDRIVE 25D",
    "IX1 EDRIVE20",
    "M5 COMPETITION",
    "R 1250 GS ADVENTURE",
    "R 1200 CL",
    "633",
    "635",
    "518",
    "M140I",
    "X4 M COMPETITION",
    "M3 CS",
    "X5 4.8I",
    "540I XDRIVE",
    "760I",
    "I3S REX",
    "225E XDRIVE ACTIVE TOURER",
    "320 CABRIO",
    "118I",
    "530D",
    "530E",
    "223I XDRIVE ACTIVE TOURER",
    "535I GRAN TURISMO",
    "X1 XDRIVE 28I",
    "530I",
    "M3 GTS",
    "Z3 M",
    "760",
    "425D CABRIO",
    "640",
    "520",
    "545E XDRIVE",
    "523",
    "524",
    "X3 XDRIVE 30I",
    "645",
    "525",
    "R 1150 RT",
    "440I XDRIVE",
    "X6 ACTIVEHYBRID",
    "F 650 CS",
    "R 1150 RS",
    "118D",
    "528",
    "328I GRAN TURISMO",
    "335D XDRIVE",
    "X5 XDRIVE 25D",
    "Z3 M COUPÉ",
    "740LI XDRIVE",
    "325I",
    "R 850 RT",
    "228I",
    "225I XDRIVE ACTIVE TOURER",
    "R 1150 GS ADVENTURE",
    "640D",
    "HP4 COMPETITION",
    "320 GRAN TURISMO",
    "760LI",
    "K 1600 B",
    "650",
    "R18 CLASSIC",
    "530",
    "750D XDRIVE",
    "K 1300 GT",
    "123 COUPÉ",
    "535",
    "IX2 XDRIVE30",
    "X4 M40D",
    "F 900 R",
    "325D",
    "8ER REIHE",
    "135 CABRIO",
    "X4 M40I",
    "335I XDRIVE GRAN TURISMO",
    "R 1100 S BOXERCUP REPLIKA",
    "520D",
    "520E",
    "435I",
    "X5 XDRIVE 48I",
    "520I",
    "750I",
    "G 310 R",
    "540",
    "R NINET SCRAMBLER",
    "R 1200 GS ADVENTURE",
    "218D ACTIVE TOURER",
    "X6 XDRIVE 35I",
    "X5 M60I XDRIVE",
    "545",
    "620D XDRIVE GRAN TURISMO",
    "X6 XDRIVE 35D",
    "220D ACTIVE TOURER",
    "R 1150 R ROCKSTER",
    "535 GRAN TURISMO",
    "220I ACTIVE TOURER",
    "R NINET URBAN G",
    "M2",
    "M3",
    "M4",
    "218I",
    "M5",
    "M6",
    "630D XDRIVE GRAN TURISMO",
    "550",
    "330E XDRIVE",
    "R NINET URBAN S",
    "120 CABRIO",
    "R 1200 GS",
    "315",
    "316",
    "125 COUPÉ",
    "125 CABRIO",
    "318",
    "HP2 ENDURO",
    "X2 XDRIVE 20D",
    "218D",
    "225XE ACTIVE TOURER",
    "3ER REIHE",
    "435D XDRIVE GRAN COUPÉ",
    "316I",
    "220I CABRIO",
    "328I",
    "740D",
    "750LD XDRIVE",
    "740E",
    "740I",
    "M6 CABRIO",
    "ACTIVEHYBRID 7L",
    "320",
    "Z8 ROADSTER",
    "630 COUPÉ",
    "323",
    "425D",
    "324",
    "325",
    "328",
    "316D",
    "640I XDRIVE GRAN COUPÉ",
    "I5 EDRIVE 40",
    "ACTIVEHYBRID X6",
    "F 900 XR",
    "X1 SDRIVE 20D",
    "K 1600 GRAND AMERICA",
    "535I",
    "X1 SDRIVE 20I",
    "330",
    "320D XDRIVE GRAN TURISMO",
    "640D GRAN COUPÉ",
    "650I XDRIVE COUPÉ",
    "335",
    "535D",
    "M235I CABRIO",
    "I4 EDRIVE 40",
    "S 1000 RR",
    "X2 XDRIVE 20I",
    "420D CABRIO",
    "340I XDRIVE",
    "650I XDRIVE CABRIO",
    "750LI XDRIVE",
    "X1 XDRIVE 18D",
    "730D",
    "440I XDRIVE CABRIO",
    "750I XDRIVE",
    "I4 EDRIVE 35",
    "318I",
    "R18",
    "C 400 GT",
    "M4 CS",
    "M240I",
    "318D",
    "M3 CSL",
    "Z4 SDRIVE 18I",
    "F 650 GS SERTAO",
    "640D XDRIVE GRAN COUPÉ",
    "216I ACTIVE TOURER",
    "R 1200 C",
    "X5 SDRIVE 40I",
    "335 COUPÉ",
    "840I",
    "K 1600 GT",
    "435I XDRIVE",
    "525D",
    "114",
    "X5 XDRIVE 50I",
    "G 650 XCOUNTRY",
    "640I XDRIVE GRAN TURISMO",
    "116",
    "428I",
    "118",
    "218I GRAN TOURER",
    "X2 M35I",
    "M760LI XDRIVE",
    "525D XDRIVE",
    "X5 XDRIVE 50E",
    "218D GRAN TOURER",
    "640I COUPÉ",
    "330D XDRIVE GRAN TURISMO",
    "120",
    "123",
    "535D GRAN TURISMO",
    "M440I",
    "650 CABRIO",
    "318D XDRIVE",
    "125",
    "G 310 GS",
    "HP2 SPORT",
    "R 1200 R",
    "R 1200 S",
    "430D CABRIO",
    "F 800 GS ADVENTURE",
    "330 COUPÉ",
    "130",
    "418D",
    "730LD",
    "135",
    "745E",
    "X5 XDRIVE 40I",
    "220D CABRIO",
    "330XD",
    "420I CABRIO",
    "540D XDRIVE",
    "640D COUPÉ",
    "Z3 M ROADSTER",
    "223I ACTIVE TOURER",
    "M3 CRT",
    "X5 XDRIVE 40E",
    "323 CABRIO",
    "X5 XDRIVE 40D",
    "330 CABRIO",
    "528I",
    "M135I",
    "X2 XDRIVE 25E",
    "440I XDRIVE GRAN COUPÉ",
    "M760E XDRIVE",
    "X2 XDRIVE 25D",
    "740LD XDRIVE",
    "X5 M50I",
    "X7 XDRIVE 40D",
    "Z4 M COUPÉ",
    "K 1300 S",
    "330I XDRIVE",
    "K 1300 R",
    "I7 XDRIVE 60",
    "218I ACTIVE TOURER",
    "X2 SDRIVE 20D",
    "X4 XDRIVE 25D",
    "M240I CABRIO",
    "330D XDRIVE",
    "530D GRAN TURISMO XDRIVE",
    "428I XDRIVE",
    "K 1600 GTL EXCLUSIVE",
    "F 850 GS",
    "640D XDRIVE GRAN TURISMO",
    "X2 SDRIVE 20I",
    "330D GRAN TURISMO",
    "630D GRAN TURISMO",
    "430I XDRIVE GRAN COUPÉ",
    "F 700 GS",
    "428I XDRIVE GRAN COUPÉ",
    "I7 EDRIVE 50",
    "420D XDRIVE",
    "G 650 GS SERTAO",
    "F 800 R",
    "X5 XDRIVE 30D",
    "F 800 S",
    "M4 CABRIO",
    "R 1100 R",
    "740LI",
    "R 1100 S",
    "518D",
    "530E IPERFORMANCE",
    "320I XDRIVE",
    "740LE",
    "340I XDRIVE GRAN TURISMO",
    "X7 XDRIVE 40I",
    "220D XDRIVE ACTIVE TOURER",
    "F 800 ST",
    "X7 XDRIVE 30D",
    "530E XDRIVE",
    "X5 XDRIVE 45E",
    "M235I",
    "X2 XDRIVE 18D",
    "640D XDRIVE CABRIO",
    "X1",
    "335I GRAN TURISMO",
    "X3",
    "X5",
    "X6",
    "F 750 GS",
    "435D XDRIVE",
    "335D XDRIVE GRAN TURISMO",
    "118 CABRIO",
    "K 1200 GT",
    "740D XDRIVE",
    "XM",
    "118D XDRIVE",
    "635 COUPÉ",
    "X3 M COMPETITION",
    "2ER REIHE",
    "X4 XDRIVE 28I",
    "X1 SDRIVE 18I",
    "K 1200 LT",
    "120D XDRIVE",
    "225I ACTIVE TOURER",
    "X4 XDRIVE 20I",
    "M3 COMPETITION",
    "328 CABRIO",
    "X7 M60I XDRIVE",
    "535D XDRIVE",
    "325 COUPÉ",
    "435I XDRIVE GRAN COUPÉ",
    "535D GRAN TURISMO XDRIVE",
    "318 COUPÉ",
    "M4 COMPETITION",
    "Z1",
    "Z3",
    "Z4",
    "R 1200 ST",
    "Z8",
    "I3 REX",
    "220D XDRIVE",
    "I7 M70 XDRIVE",
    "550I GRAN TURISMO XDRIVE",
    "F 650 ST",
    "X3 XDRIVE M50",
    "840I XDRIVE CABRIO",
    "5ER REIHE",
    "430D XDRIVE GRAN COUPÉ",
    "I4 EDRIVE 40 GRAN COUPE",
    "M550I XDRIVE",
    "R 1250 GS",
    "R NINET RACER",
    "740LE XDRIVE",
    "420I GRAN COUPÉ",
    "R 1200 RT",
    "840D XDRIVE CABRIO",
    "R 1200 RS",
    "645 COUPÉ",
    "Z4 COUPÉ",
    "C 650 GT",
    "320 COUPÉ",
    "I5 M60 XDRIVE",
    "635 CABRIO",
    "435I XDRIVE CABRIO",
    "Z4 SDRIVE 23I",
    "M850I XDRIVE GRAN COUPÉ",
    "Z4 SDRIVE 35I",
    "218D XDRIVE GRAN TOURER",
    "X4 XDRIVE 35I",
    "428I GRAN COUPÉ",
    "430I XDRIVE CABRIO",
    "X4 XDRIVE 35D",
    "320I XDRIVE GRAN TURISMO",
    "650I COUPÉ",
    "435I CABRIO",
    "R 1100 GS",
    "320D GRAN TURISMO",
    "620D GRAN TURISMO",
    "430D XDRIVE",
    "745LE",
    "M240I XDRIVE",
    "X6 M60I XDRIVE",
    "X3 2.0D",
    "640I GRAN COUPÉ",
    "550I GRAN TURISMO",
    "G 650 GS",
    "1M COUPÉ",
    "218D XDRIVE ACTIVE TOURER",
    "M8 COMPETITION GRAN COUPÉ",
    "550 GRAN TURISMO",
    "K 1200 R",
    "320D XDRIVE",
    "730D XDRIVE",
    "K 1200 S",
    "220D GRAN TOURER",
    "X3 XDRIVE 18D",
    "C 400 X",
    "M340I XDRIVE",
    "X5 M50D",
    "I5 XDRIVE 40",
    "X5 3.0 D",
    "418D GRAN COUPÉ",
    "M340D XDRIVE",
    "I4 XDRIVE 35",
    "M8 COMPETITION CABRIO",
    "650I XDRIVE GRAN COUPÉ",
    "525 XD",
    "R 850 GS",
    "M135I XDRIVE",
    "X6 M",
    "M440I XDRIVE",
    "M850I XDRIVE",
    "316 COUPÉ",
    "330I XDRIVE GRAN TURISMO",
    "K 1200 R SPORT",
    "216D GRAN TOURER",
    "430I XDRIVE",
    "520 GRAN TURISMO",
    "840I XDRIVE",
    "M8 CABRIO",
    "X2 SDRIVE 16D",
    "IX XDRIVE60",
    "G 650 XCHALLENGE",
    "R 80 GC BASIC",
    "530D XDRIVE",
    "R 1300 GS",
    "HP2 MEGAMOTO",
    "650 COUPÉ",
    "X4 XDRIVE 30D",
    "230I CABRIO",
    "C 650 SPORT",
    "428I XDRIVE CABRIO",
    "640I GRAN TURISMO",
    "640I CABRIO",
    "340I GRAN TURISMO",
    "430I GRAN COUPÉ",
    "530I XDRIVE",
    "X4 XDRIVE 30I",
    "428I CABRIO",
    "335 CABRIO",
    "X3 XDRIVE 28I",
    "318 CABRIO",
    "X3 3.0D",
    "F 900 GS",
    "M3 COMPETITION M XDRIVE",
    "630D XDRIVE",
    "M5CS",
    "323 COUPÉ",
    "X3 3.0I",
    "220D XDRIVE GRAN TOURER",
    "X3 SDRIVE 20I",
    "120D",
    "X5 M",
    "C 600 SPORT",
    "435D XDRIVE CABRIO",
    "M240I XDRIVE CABRIO",
    "6ER REIHE",
    "Z4 ROADSTER",
    "X2 SDRIVE 18D",
    "X2 SDRIVE 18I",
    "120I",
    "M3 CABRIO",
    "640 CABRIO",
    "R 1200 C CLASSIC",
    "325D GRAN TURISMO",
    "M440D XDRIVE",
    "X4 XDRIVE 20D",
    "425D GRAN COUPÉ",
    "M8 COMPETITION COUPÉ",
    "Z4 SDRIVE 28I",
    "IX2 EDRIVE20",
    "640D CABRIO",
  ],
  PÖSSL: [""],
  LONGJIA: [
    "TREVIS",
    "RAPTUR",
    "POLLY",
    "MAXX",
    "CEASAR",
    "INSETTO",
    "SONNY",
    "FORMULA",
    "SPEEDJET",
  ],
  DETHLEFFS: [""],
  BOMBARDIER: [""],
  "BUS KHMC": [""],
  GRECAV: [""],
  SOR: [""],
  LAURETA: [""],
  NORTON: [""],
  CPI: [
    "ARAGON GTX",
    "POPCORN",
    "GTR",
    "OLIVER",
    "ARAGON GP",
    "ARAGON",
    "FORMULA",
  ],
  NYSA: [""],
  EVOBUS: [""],
  AERO: [""],
  VOGE: ["300AC", "500R", "500DS", "500AC", "300R", "500DSX", "650DSX"],
  MOTORRO: [""],
  HARTGA: [""],
  "CR&amp;S": [""],
  LUBLIN: [""],
  LAIKA: [""],
  BAIC: [
    "SENOVA D20",
    "SENOVA X35",
    "X75",
    "SENOVA X25",
    "SENOVA X55",
    "BJ20",
    "X55",
    "BJ30",
    "BJ40",
    "SENOVA X65",
    "X3",
    "BJ60",
    "X5",
    "X7",
  ],
  VIAGO: ["BERLIN", "BOLOGNA", "VENICE"],
  LINCOLN: [""],
  INEOS: ["INEOS GRENADIER"],
  "SFM GMBH": [""],
  "EURA MOBIL": [""],
  MEGELLI: ["125 M", "125 R"],
  NFM: [""],
  GIOTTILINE: [""],
  MG: [
    "EHS",
    "CYBERSTER",
    "ZS EV",
    "MG4 ELECTRIC",
    "MG3",
    "ZS",
    "MG5",
    "HS",
    "MG4",
    "MG HS",
    "MG5 ELECTRIC",
    "MG4 XPOWER",
  ],
  BENTLEY: [
    "BROOKLANDS",
    "EIGHT",
    "FLYING SPUR",
    "TURBO R",
    "CONTINENTAL GT V8",
    "TURBO S",
    "TURBO RT",
    "CONTINENTAL",
    "BENTAYGA",
    "ARNAGE",
    "AZURE",
    "CONTINENTAL SUPERSPORTS",
    "BENTAYGA S",
    "FLYING SPUR V8",
    "CONTINENTAL GT",
    "CONTINENTAL FLYING SPUR",
    "AZURE CONVE",
    "CONTINENTAL GTC",
    "BENTAYGA V8",
    "MULSANNE",
  ],
  CHRYSLER: [
    "SEBRING CABRIO",
    "VISION",
    "300 M",
    "SEBRING",
    "PT CRUISER",
    "GRAND VOYAGER",
    "NEON",
    "200",
    "300 C",
    "300",
    "STRATUS CABRIO",
    "PT CRUISER CABRIO",
    "PACIFICA",
    "VOYAGER",
    "180 GC",
    "STRATUS",
    "CROSSFIRE",
    "TOWN&amp;COUNTRY",
  ],
  WEINSBERG: [""],
  SPY: [""],
  TOROS: [""],
  BRONTO: [""],
  LINGYUN: [""],
  "MAGIRUS DEUTZ": [""],
  "MOTO MORINI": [
    "SPORT 1200",
    "GRANPASSO",
    "SCRAMBLER 1200",
    "CORSARO",
    "CORSARO VELOCE",
    "9 1/2",
    "REBELLO 1200",
  ],
  "SUPER SOCO": [""],
  KINROAD: ["XT50 KING", "XT125 KING", "XT250 BLACK CYCLONE", "HUNTER"],
  YINXIANG: [""],
  HOBBY: [""],
  TAJGA: [""],
  PARAGAN: ["EUROBOX-R-XXL"],
  MZ: ["1000 SF", "125 SM", "125 SX", "125 RT", "1000 S"],
  HUATIAN: [
    "CAPIRELLI PORTO",
    "HT50QT-36",
    "CAPIRELLI MAXIMUS",
    "CAPIRELLI PIA VENTO",
  ],
  SUNDIRO: [""],
  JIANSHE: [""],
  KENWORTH: [""],
  DAELIM: [
    "S3",
    "NS 125",
    "E-FIVE",
    "STEEZER",
    "DAYSTAR",
    "S1 OTELLO",
    "S-FIVE",
    "ROADWIN LE ROADSTER",
    "VJ",
    "VL",
    "CORDI",
    "S1",
    "ROADWIN",
    "S2",
  ],
  MEITIAN: [""],
  TATA: [""],
  NEMO: [""],
  PAGANI: [""],
  "PIAGGIO PORTER": [""],
  EVO: ["5", "7", "CROSS 4"],
  ŠKODA: [
    "",
    "TUDOR",
    "FORMAN",
    "CITIGO",
    "FELICIA VANPLUS",
    "FABIA",
    "FAVORIT",
    "ENYAQ RS",
    "130",
    "PICK UP (FELICIA)",
    "PICK UP (FAVORIT)",
    "OCTAVIA",
    "SCALA",
    "FABIA PRAKTIK",
    "FELICIA",
    "ELROQ",
    "PRAKTIK",
    "KAMIQ",
    "KAROQ",
    "ENYAQ IV",
    "LAURETA M1B / M3B",
    "YETI",
    "KODIAQ",
    "ECV R3 ELECTRIC",
    "120",
    "ENYAQ",
    "SUPERB",
    "125",
    "105",
    "ROOMSTER",
    "CITIGOE",
    "FORMAN VAN (PRAKTIK)",
    "GARDE",
    "RAPID",
  ],
  EVT: [""],
  PLA: [""],
  QINGQI: ["QM50QT", "YUKI 125 RS", "QM125T-10R", "QM200GY"],
  JOYEAR: ["U-TOUR"],
  XUFENG: [""],
  VONROAD: ["SPEED 125"],
  MICROCAR: [""],
  SUKIDA: [""],
  COBRA: [""],
  TEDOM: [""],
  CARTHAGO: [""],
  THUNDERBOLT: [""],
  "MOTO GUZZI": [
    "V7 SPECIAL",
    "V7 III ROUGH",
    "NORGE 1200",
    "V85 TT",
    "V7 STORNELLO",
    "V7 III MILANO",
    "CALIFORNIA STONE TOURING",
    "CALIFORNIA 1400 TOURING",
    "NEVADA 750 TOURING",
    "V11 CAFÉ SPORT",
    "GRISO",
    "MGX-21",
    "CALIFORNIA 1400 CUSTOM",
    "NORGE 1200 GT",
    "BREVA",
    "V9 BOBBER",
    "CALIFORNIA EV TOURING",
    "CALIFORNIA TITANIUM",
    "NORGE 1200 GTL",
    "V7 III RACER",
    "NEVADA 750 CLASSIC",
    "V11 LE MANS CORSA",
    "CALIFORNIA AUDACE CARBON",
    "V7 III ANNIVERSARIO",
    "V7 ANNIVERSARIO",
    "CALIFORNIA VINTAGE",
    "STELVIO NTX",
    "V7 RACER",
    "V11 COPPA ITALIA",
    "CALIFORNIA 1400 ELDORADO",
    "CALIFORNIA STONE",
    "V7 CLASSIC",
    "CALIFORNIA MGX-21",
    "QUOTA",
    "CALIFORNIA 1400 TOURING SE",
    "AUDACE CARBON",
    "V7 CAFÉ",
    "BELLAGIO",
    "V11 LE MANS",
    "STELVIO",
    "V7 III SPECIAL",
    "V11 BALLABIO",
    "V7 III CARBON",
    "NORGE 1200 T",
    "V7 STONE",
    "QUOTA 1100 ES",
    "AUDACE",
    "NEVADA 750 CLUB",
    "CALIFORNIA EV",
    "V7 III CARBON DARK",
    "CALIFORNIA CLASSIC",
    "1200 SPORT",
    "V7 III STONE",
    "V9 ROAMER",
    "ELDORADO",
  ],
  GARIA: [""],
  VAUXHALL: [""],
  LIGIER: [""],
  LOTUS: ["EVORA"],
  FYM: [""],
  BAODIAO: [""],
  GORDON: [""],
  MEIDUO: ["YB 50QT-3"],
  DANGEL: [""],
  LDV: [""],
  OTOKAR: [""],
  LINGBEN: [
    "LB125T-2",
    "LB50QT-39",
    "LB50QT-38",
    "LB50QT-21",
    "LB125T-13",
    "LB125T-38",
  ],
  CSR: [""],
  LANCIA: [
    "THESIS",
    "THEMA",
    "DELTA",
    "PRISMA",
    "DEDRA",
    "ZETA",
    "MUSA",
    "FLAVIA",
    "KAPPA",
    "VOYAGER",
    "Y",
    "LYBRA",
    "YPSILON",
    "PHEDRA",
  ],
  BENDA: [""],
  CAMPELL: [""],
  ITALCAR: [""],
  "SCANIA IRIZAR": [""],
  JAC: ["IEV7S"],
  BETA: [
    "RR",
    "JONATHAN 350",
    "ALP 125",
    "EURO 350",
    "ALP 4.0",
    "ARK",
    "ALP 200",
    "MOTARD 4.0",
  ],
  BENZHOU: [""],
  NIO: ["EL7", "ET7", "ET5 TOURING", "EL6"],
  ATTACK: [""],
  MOBILVETTA: [""],
  DFLONG: [""],
  NIU: ["M1 PRO", "N1 SPORT"],
  RIMOR: [""],
  MASAI: [""],
  BRP: [""],
  ADIVA: [""],
  CARAVELAIR: [""],
  VANHOOL: [""],
  MASERATI: [
    "QUATTROPORTE",
    "GRECALE",
    "3200 GT",
    "MC20 CIELO",
    "SPYDER",
    "GHIBLI",
    "INDY",
    "GRANTURISMO",
    "GRANCABRIO",
    "LEVANTE",
    "COUPE",
    "GRANSPORT",
  ],
  EAGLE: [""],
  BONETTI: [""],
  TVR: [""],
  "T.E.C.": [""],
  PLYMOUTH: [""],
  OMODA: ["OMODA5"],
  "ROYAL ENFIELD": [
    "INTERCEPTOR INT 650",
    "HIMALAYAN",
    "BULLET CLASSIC EFI",
    "BULLET ELECTRA EFI",
    "CONTINENTAL GT",
    "CONTINENTAL GT 650",
    "HIMALAYAN EFI",
  ],
  YAMASAKI: ["YB 50QT-3", "YM125-A2", "YM125T-U", "F-22", "YM 50-9", "YM 150T"],
  "HN SCHÖRLING": [""],
  PIONEER: ["XF125GY-2B GENESIS"],
  KNAUS: [""],
  BSI: [""],
  RIEJU: ["MRX", "RS 3", "RS 2", "TANGO", "RRX", "MRT", "MARATHON", "SMX"],
  DETOMASO: [""],
  SKIPI: [
    "PANTHER",
    "G150",
    "SUPERSONIC 100",
    "ST200",
    "SUPERSONIC 50",
    "ST125",
    "G125",
    "SUPERSONIC 125",
  ],
  MORGAN: [""],
  BLATA: ["125 ENDURO", "125 MOTARD"],
  SHENKE: [
    "SHOTGUN",
    "VIA 50 MP KORADO",
    "YUKI 250 ARROW",
    "RT 125",
    "SOLANA",
    "MP KORADO 125 ADMIRAL",
  ],
  PALFINGER: [""],
  SHUPA: ["SWA 125"],
  "MOTO ZETA": [""],
  SEAT: [
    "TARRACO",
    "INCA",
    "CORDOBA",
    "ALTEA XL",
    "X-PERIENCE",
    "CUPRA LEON",
    "ATECA",
    "ARONA",
    "TOLEDO",
    "MII",
    "TERRA",
    "ALTEA",
    "ALHAMBRA",
    "IBIZA",
    "CUPRA ATECA",
    "AROSA",
    "LEON",
    "LEON ST",
    "EXEO",
    "MARBELLA",
    "MALAGA",
  ],
  LUCID: ["AIR"],
  KORADO: [""],
  STEELHEAD: [""],
  SENKE: ["SK125-22A"],
  INSANE: [""],
  CHATENET: [""],
  GAMAX: [""],
  "GREAT WALL": [""],
  LINTEX: ["HT125T-22"],
  SCHMIDT: [""],
  CAETANO: [""],
  "BIG DOG": [""],
  XPENG: ["G9"],
  MOSKVIČ: [""],
  LANDWIND: [""],
  CHEVROLET: [
    "AVEO",
    "EVANDA",
    "ORLANDO",
    "EXCALIBUR",
    "LACETTI",
    "NOVA",
    "SPARK",
    "SPECIAL",
    "TRAX",
    "HHR",
    "CORVETTE",
    "EXPRESS",
    "BUREKO",
    "NUBIRA",
    "TRAVERSE",
    "EQUINOX",
    "CAMARO",
    "BOLT EV",
    "KALOS",
    "CRUZE",
    "VOLT",
    "CAPTIVA",
    "MATIZ",
    "EPICA",
    "SILVERADO",
    "TAHOE",
    "AVALANCHE",
    "SPARK EV",
    "SSR",
    "SUBURBAN",
    "MALIBU",
    "TRANS SPORT",
    "TRAILBLAZER",
    "TACUMA",
  ],
  "TATRA BETA": [""],
  ARO: ["ŘADA 24", "ŘADA 10", "ŘADA 32"],
  "MICRO-VETT": [""],
  "ASTON MARTIN": [
    "DB12",
    "AR1",
    "VANQUISH",
    "VIRAGE",
    "V8 VANTAGE",
    "RAPIDE",
    "CYGNET",
    "DBS",
    "DB7",
    "DBR9",
    "DB9",
    "VANTAGE",
    "LAGONDA",
    "V12 VANTAGE",
    "DB",
  ],
  HARTFORD: ["VR 125"],
  RADAR: ["RD6"],
  DFSK: [
    "RICH 6",
    "GLORY 500",
    "SERES 3",
    "DF 6",
    "FENGON 7",
    "T5 EVO EV",
    "FENGON 500",
    "FENGON 5",
    "T5 EVO",
    "EV200",
    "SHINE",
    "EV18",
    "U-TOUR",
    "GLORY 580",
  ],
  "MARTIN MOTORS": ["MM 520", "COOLCAR", "MM 520I", "FREEDOM"],
  SUBARU: [
    "OUTBACK",
    "LEVORG",
    "ASCENT",
    "BAJA",
    "LIBERO",
    "BRZ",
    "LEVORG GT",
    "B9 TRIBECA",
    "TRIBECA",
    "TREZIA",
    "LEGACY",
    "CROSSTREK",
    "SVX",
    "FORESTER",
    "WRX STI",
    "JUSTY",
    "LEVORG GT-S",
    "SOLTERRA",
    "XV",
    "IMPREZA",
  ],
  VOLVO: [
    "V90 T8 TWIN ENGINE",
    "",
    "V60 PLUG-IN HYBRID",
    "XC60 T8 TWIN ENGINE",
    "S80",
    "S60",
    "XC60",
    "S40",
    "XC40",
    "EX40",
    "V60",
    "V40",
    "XC90 T8 TWIN ENGINE",
    "850",
    "V60 CROSS COUNTRY",
    "C70",
    "XC90 PLUG-IN HYBRID",
    "C30",
    "S60 CROSS COUNTRY",
    "EX90",
    "S90",
    "XC90",
    "V90",
    "480",
    "S70",
    "XC70",
    "240",
    "V70",
    "460",
    "S90 T8 TWIN ENGINE",
    "EX30",
    "440",
    "V50",
    "V40 CROSS COUNTRY",
    "960",
    "940",
    "V90 CROSS COUNTRY",
    "EC40",
    "C40",
  ],
  "AEON MOTOR": [""],
  ACURA: [
    "MDX",
    "INTEGRA",
    "NSX",
    "RSX",
    "EL",
    "TSX",
    "TL",
    "NSX-T",
    "CL",
    "RL",
  ],
  HOYSUNG: [""],
  JDM: [""],
  BUGATTI: ["VEYRON", "EB 110"],
  TOMOS: [""],
  ADRIA: [""],
  YIBEN: ["YB150T-15", "YB50QT-9", "YB50QT-15"],
  "ECO ZONE": ["LIEYING"],
  DOOHAN: ["DH-05-12"],
  ČEZETA: [""],
  SCAM: [""],
  HEALEY: [""],
  KAIPAN: [""],
  BASHAN: [""],
  MAGMA: [""],
  BRAMMO: ["ENERTIA PLUS"],
  MITSUBISHI: [
    "",
    "L300",
    "SPACE STAR",
    "L200",
    "LANCER EVOLUTION VIII",
    "LANCER EVOLUTION",
    "3000",
    "GALANT",
    "SPACE GEAR",
    "COLT CZT",
    "L400",
    "OUTLANDER",
    "ECLIPSE",
    "PAJERO",
    "LANCER EVOLUTION IX",
    "GRANDIS",
    "COLT CZC",
    "SPACE WAGON",
    "CARISMA",
    "I-MIEV",
    "PAJERO PICK-UP",
    "ASX",
    "COLT",
    "ECLIPSE CROSS",
    "PAJERO PININ",
    "SIGMA",
    "LANCER EVOLUTION VII",
    "SPACE RUNNER",
    "LANCER",
  ],
  APRILIA: [
    "RSV 1000 R FACTORY",
    "ETV CAPONORD",
    "SHIVER 750 GT",
    "MINI RX EXPERIENCE",
    "RSV 1000 TUONO",
    "SHIVER 750",
    "ETV CAPONORD ABS",
    "ETV 1000 ABS",
    "SXV",
    "SPORT CITY",
    "RS4",
    "RSV4 FACTORY",
    "ETV CAPONORD RALLY RAID",
    "TUAREG 660",
    "RSV MILLE SP",
    "MINI RX CHALLENGE",
    "SL 750 SHIVER",
    "RSV 1000 TUONO FIGHTER",
    "DORSODURO 750 FACTORY",
    "RSV 1000 FUTURA",
    "SHIVER 900",
    "DORSODURO 750",
    "RSV 1000 R NERO",
    "RSV4 RR RACE PACK",
    "MX",
    "MINI RX ENTRY",
    "LEONARDO",
    "TUONO 1000 FACTORY",
    "RSV4 R",
    "TUONO 1000 R",
    "DORSODURO 1200",
    "RSV4",
    "SONIC",
    "SMV 750 DORSODURO",
    "TUONO V4",
    "TUONO V4 1100 FACTORY",
    "RS",
    "RSV MILLE",
    "RX",
    "DORSODURO 900",
    "PEGASO TUSCANY-TIBET",
    "TUONO V4 1100 RR",
    "RXV",
    "CAPONORD RALLY",
    "RSV4 RR",
    "SRV 850",
    "PEGASO",
    "SCARABEO",
    "CAPONORD TRAVEL PACK",
    "SR",
    "MOJITO CUSTOM",
    "RSV 1000 TUONO RACING",
    "RSV4 RF",
    "MANA",
    "RST FUTURA",
    "SX",
    "RSV 1000 R",
    "RSV MILLE R",
    "RALLY",
    "TUONO",
    "ATLANTIC",
    "SL 1000 FALCO",
    "AMICO",
    "MANA GT",
    "CAPONORD",
    "MOTO 6.5",
    "MOJITO",
  ],
  IKARUS: [""],
  CAGIVA: [
    "1000 NAVIGATOT T",
    "RAPTOR",
    "XTRA RAPTOR 1000",
    "CANYON 500",
    "CANYON 600",
    "PLANET 125",
    "V-RAPTOR",
    "MITO 125",
    "RIVER 500",
    "1000 NAVIGATOR",
    "CUCCIOLO",
  ],
  RUF: [""],
  JAWA: [
    "PIONÝR",
    "DAKAR",
    "CHOOPER",
    "MINARELLI",
    "SPECIAL",
    "650 OHC",
    "BASIC",
    "592",
    "593",
    "353",
    "354",
    "ROBBY",
    "632",
    "BIZON",
    "634",
    "500 OHC",
    "559",
    "DANDY",
    "VINTAGE",
    "638",
    "639",
    "CLASSIC",
    "CHIC",
    "TRAVEL",
    "TRAMP",
    "SPORT",
    "PÉRÁK",
    "STYLE",
    "CHOPPER",
    "360",
    "660",
    "SPORTARD",
    "CALIFORNIA",
    "350 CL",
    "SKÚTR",
    "300 CL",
    "350 OHC",
    "JAWETTA",
  ],
  HECHT: [""],
  MULTICAR: [""],
  SWM: [
    "SM 125R",
    "RS 500R",
    "SM 650R",
    "RS 300R",
    "SILVER VASE",
    "SM 500R",
    "RS 125R",
    "G01",
    "G05",
    "G03F",
    "RS 650R",
    "GRAN MILANO",
    "G01F",
    "SUPERDUAL",
  ],
  OPEL: [
    "SINTRA",
    "",
    "ASTRA CABRIO",
    "TIGRA TWINTOP",
    "ADAM S",
    "SPEEDSTER",
    "ASTRA VAN",
    "CALIBRA",
    "COMBO LIFE",
    "CROSSLAND X",
    "CASCADA",
    "ASCONA",
    "GRANDLAND X",
    "ZAFIRA",
    "ADAM",
    "ANTARA",
    "CORSA-E",
    "FRONTERA",
    "GRANDLAND",
    "SIGNUM",
    "MOKKA",
    "AMPERA",
    "INSIGNIA",
    "SENATOR",
    "TIGRA",
    "CAMPO",
    "ASTRA TWINTOP",
    "CORSA",
    "VECTRA",
    "MOKKA X",
    "CROSSLAND",
    "MOVANO",
    "MONTEREY",
    "KADETT E VAN",
    "ZAFIRA LIFE",
    "ASTRA",
    "MERIVA",
    "GT",
    "AGILA",
    "COMBO TOUR",
    "KARL",
    "AGILA VAN",
    "VIVARO",
    "KADETT",
    "COMBO",
    "OMEGA",
    "CORSA VAN",
    "ADAM ROCKS",
  ],
  "LYNK&amp;CO": ["LYNK&amp;CO 01"],
  "TODAY SUNSHINE": [""],
  "LA STRADA": [""],
  SHUANGHUAN: ["CEO"],
  MAXON: [
    "SCUOLA",
    "JJ125T-15",
    "JJ125T-17",
    "JJ50QT-23A",
    "JJ50QT-17T2",
    "JJ125T-23A",
    "JJ50QT-23B",
    "JJ125T-23B",
    "MATADOR",
    "FORCER",
    "ARDOUR",
    "JJ125T-13",
    "JJ50QT-23",
  ],
  CECTEK: [""],
  SSANGYONG: [
    "TIVOLI GRAND",
    "KORANDO",
    "XLV",
    "MUSSO",
    "ACTYON",
    "RODIUS",
    "MUSSO GRAND",
    "KYRON",
    "KG MOBILITY KORANDO",
    "REXTON",
    "TORRES",
    "TIVOLI",
  ],
  GROVE: [""],
  ZERO: [
    "FXS ZF6.5",
    "FXS ZF7.2",
    "SR/F ZF14.4",
    "S ZF14.4",
    "S ZF12.5",
    "S ZF9.4",
    "S ZF7.2",
    "FX ZF3.3",
    "DS ZF7.2",
    "FXS ZF3.3",
    "S ZF9.8",
    "FX ZF5.7",
    "DS ZF9.8",
    "FX ZF2.8",
    "FX ZF6.5",
    "FX ZF7.2",
    "DS ZF9.4",
    "SR ZF12.5",
    "SR ZF14.4",
    "SR ZF13.0",
    "DSR ZF14.4",
    "DSR ZF13.0",
    "S ZF13.0",
    "DS ZF12.5",
    "DS ZF14.4",
    "DS ZF13.0",
  ],
  MAYBACH: [""],
  MOTORHISPANIA: [
    "KN1 AIR COOLED",
    "KN1 LIQUID COOLED",
    "DUNA",
    "MH7 AIR COOLED",
    "RX125R",
    "FURIA",
    "SM125",
  ],
  PRI: [""],
  FORTHING: ["SX5G", "T5 EVO", "FORTHING 5"],
  TISONG: [""],
  RVM: [""],
  REWACO: [""],
  HIGER: [""],
  SXT: [""],
  BAJAJ: [""],
  "MPM MOTORS": ["PS 160"],
  SATURN: [""],
  UM: [
    "RENEGADE SCRAMBLER S",
    "DSR EX",
    "DSR ADVENTURE TT",
    "RENEGADE SCRAMBLER CLASSIC",
    "RENEGADE SPORT S",
    "RENEGADE SPORT",
    "DSR SM",
    "XTREET RC",
    "DSR ADVENTURE",
    "RENEGADE COMMANDO",
    "RENEGADE CLASSICS",
  ],
  CASALINI: [""],
  FREIGHTLINER: [""],
  ZHONGNENG: [""],
  SANILI: [""],
  CYR: ["ROUTE 151"],
  BAVARIA: [""],
  SANTANA: ["PS 10", "PS 300", "PS 350"],
  KIA: [
    "RETONA",
    "PICANTO",
    "SORENTO",
    "PRIDE",
    "VENGA",
    "SHUMA",
    "CEED SW",
    "K5",
    "CERATO",
    "STINGER",
    "CARNIVAL",
    "PRO_CEE'D",
    "SOUL",
    "PROCEED",
    "CARENS",
    "CLARUS",
    "STINGER GT LINE",
    "NIRO",
    "E-NIRO",
    "CEED",
    "SEDONA",
    "BESTA",
    "EV3",
    "EV6",
    "PRIDE VAN",
    "E-SOUL",
    "SPORTAGE",
    "EV9",
    "MOHAVE",
    "MAGENTIS",
    "PREGIO",
    "K 2500",
    "XCEED",
    "K 2700",
    "CEE'D",
    "OPIRUS",
    "JOICE",
    "SEPHIA",
    "OPTIMA",
    "RIO",
    "CADENZA",
    "STONIC",
    "TELLURIDE",
  ],
  BORILE: [""],
  SONIK: [""],
  ZHENHUA: [""],
  SYM: [
    "MAXSYM",
    "GTS 125I JOYMAX",
    "JOYRIDE",
    "HD 2 SPORTY",
    "CROX",
    "XS125-K",
    "TONIC",
    "CITYCOM",
    "GTS 250I",
    "MASK",
    "GTS 125I",
    "ORBIT",
    "GTS 300I JOYMAX",
    "GTS 250 JOYMAX",
    "SYMPHONY",
    "COMBIZ",
    "MIO 50",
    "DD 50",
    "MIO 115I",
    "GTS 300I",
    "FIDDLE",
    "SHARK",
    "JET",
    "AZ",
    "HD 125",
    "WOLF",
    "CRUISYM",
  ],
  PROTON: [""],
  JAGUAR: [
    "X-TYPE",
    "E-PACE",
    "SV PROJECT 8",
    "XE S",
    "XKR CONVERTIBLE",
    "XFR-S",
    "XKR-S CONVERTIBLE",
    "XJS",
    "XJR",
    "XFR",
    "I-PACE",
    "E-PACE R-DYNAMIC",
    "F-PACE",
    "XK8 COUPÉ",
    "F-PACE S",
    "XKR COUPÉ",
    "XK CONVERTIBLE",
    "XE",
    "XF",
    "XK8 CONVERTIBLE",
    "XKR-S COUPÉ",
    "XJ",
    "F-TYPE",
    "S-TYPE",
    "F-TYPE S",
    "F-TYPE SVR",
    "F-TYPE R",
    "XK COUPÉ",
  ],
  JUNESUN: [""],
  "MICRO COMPACT": [""],
  HANWAY: ["E-COOL"],
  YANMAR: [""],
  HYUNDAI: [
    "LANTRA",
    "I40",
    "I30 N",
    "STARIA",
    "GENESIS",
    "SANTAMO",
    "IX20",
    "BAYON",
    "ELANTRA",
    "H 100",
    "VELOSTER",
    "SONATA",
    "VERACRUZ",
    "I20 N",
    "I10",
    "GENESIS COUPE",
    "IX55",
    "PONY",
    "KONA",
    "IONIQ",
    "GRANDEUR",
    "TERRACAN",
    "SANTA CRUZ",
    "GRAND STAREX",
    "GALLOPER",
    "GETZ",
    "IONIQ 6",
    "I30CW",
    "I20",
    "IONIQ 5",
    "ATOS",
    "NEXO",
    "PALISADE",
    "XG 30",
    "AVANTE",
    "SANTA FE",
    "MATRIX",
    "GRAND SANTA FE",
    "STAREX",
    "I30",
    "H350",
    "H1",
    "S-COUPÉ",
    "TRAJET",
    "INSTER",
    "ACCENT",
    "IX35",
    "TUCSON",
    "EQUUS",
    "COUPÉ",
    "KONA N",
    "XG 350",
  ],
  CAPRON: [""],
  RHON: [
    "LH50QT-C",
    "COBI",
    "EAGLE",
    "TRIA",
    "LH50QT-9",
    "SPRINT",
    "SHARK",
    "POLLY",
    "LH50QT-6",
    "DESIRE",
    "CEASAR",
    "CLEA",
    "SPEEDY",
    "KOYOT",
  ],
  SIGMA: [""],
  "MITSUBISHI FUSO": [""],
  FULU: ["A01"],
  MAXUS: ["MAXUS EV80", "E-DELIVER 3", "E-DELIVER 9"],
  SONIC: [""],
  QUADRO: ["350D", "350S"],
  CENNTRO: [""],
  GAZ: [
    "GAZELLE (2310)",
    "GAZELLE (2705)",
    "GAZELLE (27057)",
    "GAZTERRA ECO",
    "GAZTERRA",
    "GAZELLE (2752)",
  ],
  PEUGEOT: [
    "V-CLIC",
    "",
    "E-2008",
    "EXPERT TEPEE",
    "307 CC",
    "E-RIFTER",
    "SATELIS",
    "SUM-UP",
    "EXPERT",
    "LUDIX TREND",
    "TWEET",
    "4007",
    "4008",
    "EXPERT TRAVELLER",
    "306 CABRIO",
    "207 XA",
    "PARTNER",
    "RIFTER",
    "LOOXOR",
    "406 COUPÉ",
    "TRAVELLER",
    "TKR WRC (TREKKER WRC)",
    "508 RXH",
    "LUDIX BLASTER",
    "KISBEE",
    "ELYSTAR",
    "3008",
    "LUDIX ELEGANCE",
    "X6R",
    "207 CC",
    "205",
    "206",
    "207",
    "405",
    "208",
    "406",
    "TKR",
    "407",
    "605",
    "408",
    "607",
    "TKR (TREKKER OFFROAD)",
    "BIPPER",
    "806",
    "807",
    "XP6",
    "CITYSTAR",
    "LUDIX ONE",
    "206 CC",
    "205 CABRIO",
    "RCZ",
    "VIVACITY",
    "107 XA",
    "LXR 125",
    "FB50QT-6A",
    "LXR 200",
    "E-TRAVELLER",
    "2008",
    "E-208",
    "E-EXPERT",
    "106 VAN",
    "GEOPOLIS",
    "J 5",
    "VOGUE",
    "SPEEDFIGHT",
    "BOXER",
    "308 CC",
    "DJANGO",
    "ION",
    "LUDIX SNAKE",
    "PARTNER TEPEE",
    "1007",
    "206 VAN",
    "301",
    "106",
    "LUDIX CLASSIC",
    "107",
    "XP",
    "108",
    "306",
    "307",
    "5008",
    "407 COUPÉ",
    "308",
    "JET FORCE",
    "309",
    "TREKKER",
    "ELYSEO",
    "508",
  ],
  AUSTIN: [""],
  TALBOT: [""],
  YES: [""],
  BENIMAR: [""],
  DONGFANG: ["DF 50 SAKYA"],
  SAAB: [
    "9-5",
    "9-4X",
    "9-3X",
    "9-3 CABRIO",
    "900",
    "9000",
    "900 CABRIO",
    "9-3",
    "9-7X",
  ],
  LAVERDA: [""],
  BENELLI: [
    "BN 251",
    "TREK 1130",
    "ADIVA",
    "MACIS",
    "BN 600 GT",
    "491 ST",
    "BX 250",
    "TNT 1130 TITANIUM",
    "TNT 899",
    "TORNADO 900 TRE",
    "BN 600 R",
    "X 125",
    "TRK 502X",
    "TRK 502 ADVENTURE",
    "NEW PEPE",
    "PEPE",
    "ZENZERO",
    "BN 600 I",
    "VELVET",
    "BN 125",
    "BN 302",
    "QUATRONOVE",
    "BN 302 R",
    "TNT 1130 SPORT",
    "752S",
    "502C CRUISER",
    "TNT 1130 CAFE RACER",
    "NEW 49 X",
    "LEONCINO 500",
    "CAFFÉNERO",
    "TNT 1130 R",
    "TORNADO 900 RS",
    "TRK 502 TRAVELER",
    "CAFE NERO",
    "TNT 125",
    "TNT 1130",
    "NAKED",
  ],
  BYD: [
    "TANG",
    "SEALION 7",
    "SONG",
    "ATTO 3",
    "HAN",
    "SEAGULL",
    "DOLPHIN",
    "ETP 3",
    "SEAL",
    "QIN PLUS",
  ],
  DEMAG: [""],
  "ARCTIC CAT": [""],
  JINLANG: [""],
  ELMOTO: [""],
  KLASSEN: ["SPRINTER"],
  MOTOGINO: [""],
  "PERAVES CZ": [""],
  EFUN: [""],
  ALKE: [""],
  YADEA: [""],
  "VENTUS MOTO": [""],
  "HARLEY-DAVIDSON": [
    "FXDWG",
    "FLHXS STREET GLIDE SPECIAL",
    "FLHRC",
    "FLTRX ROAD GLIDE CUSTOM",
    "FLTRUSE CVO ROAD GLIDE ULTRA",
    "ROAD GLIDE",
    "FLHXSANX STREET GLIDE",
    "FLSB SOFTAIL SPORT GLIDE",
    "FLTRI ROAD GLIDE",
    "LOW RIDER",
    "FLFB",
    "ULTRA CLASSIC ELECTRA GLIDE",
    "SOFTAIL NIGHT TRAIN",
    "SWITCHBACK",
    "SOFTAIL DEUCE",
    "FAT BOY S",
    "FLHXSANX",
    "FLSTF 103 FAT BOY",
    "FLHRCI ROAD KING CLASSIC",
    "ROAD KING CLASSIC",
    "FXDB 103 STREET BOB",
    "FXBRSANX",
    "ROAD GLIDE LIMITED",
    "DYNA SUPER GLIDE CUSTOM",
    "LIVEWIRE",
    "FLDE DELUXE",
    "FLS",
    "SOFTAIL BREAK OUT",
    "FXDWG WIDE GLIDE",
    "ROAD KING SPECIAL S",
    "FXDF 103 FAT BOB",
    "FLHTKSEANV ULTRA LIMITED CVO",
    "STREET GLIDE",
    "SOFTAIL STANDARD",
    "FXSTB NIGHT TRAIN",
    "FXSTSSE2 SCREAM. EAGLE SOFT.",
    "ROAD KING",
    "FLSTF FAT BOY",
    "FXDBB 103 STREET BOB LIMITED",
    "FLSTN SOFTAIL DELUXE",
    "FLHC",
    "FLSTN SOFTAIL",
    "SPORTSTER",
    "FLSTFB FAT BOY SPECIAL",
    "XL 883",
    "FLHR",
    "FAT BOB S",
    "ROAD KING110TH ANNIV.EDITION",
    "FLTRXS",
    "XL 1200T SUPERLOW",
    "FLSTN",
    "FLHR ROAD KING",
    "SOFTAIL SPRINGER",
    "VRSCR STREET ROD",
    "DYNA SUPER GLIDE",
    "FLTRU ROAD GLIDE ULTRA",
    "SOFTAIL CUSTOM",
    "FXSB",
    "SOFTAIL CROSS BONES",
    "FXDBA 103 STREET BOB",
    "FLSTC",
    "FXBR",
    "FXSE",
    "FLSTFBS FAT BOY S",
    "FAT BOY",
    "HERITAGE CLASSIC S",
    "FLHRXS",
    "ELW",
    "VRSCDXA NIGHT ROD SPECIAL",
    "FLHC HERITAGE CLASSIC",
    "FXFBS FAT BOB",
    "FXBRSANX BREAKOUT",
    "FLSTNSE CVO DELUXE",
    "FXDL LOW RIDER",
    "FLTRXSE ROAD GLIDE CVO",
    "FXBR BREAKOUT",
    "VRSCAWA V-ROD",
    "CVO SOFTAIL CONVERTIBLE",
    "XL1200XS",
    "XL 1200V SEVENTY-TWO",
    "VRSCFA V-ROD MUSCLE",
    "FLS SOFTAIL SLIM",
    "FORTY-EIGHT SPECIAL",
    "XL 1200N NIGHTSTER",
    "BREAKOUT",
    "SOFTAIL HERITAGE CLASSIC",
    "FXBB",
    "CVO STREET GLIDE",
    "FXDLS",
    "FLFBSANX",
    "FXDF FAT BOB",
    "FLFBSANV",
    "FXDR",
    "STREET GLIDE SPECIAL",
    "ROAD KING SCREAMING EAGLE",
    "FXD SE2 EAGLE",
    "FLHCSANV",
    "VRSCDX NIGHT ROD SPECIAL",
    "VRSCDX",
    "ULTRA CLASSIC TRI GLIDE",
    "POLICE ELECTRA GLIDE",
    "FLSL SLIM",
    "FXCWC ROCKER",
    "SUPER GLIDE CUSTOM",
    "XL 1200XS",
    "FLHCSANV HERITAGE",
    "FXDB 103",
    "XG750 STREET",
    "FLHC HERITAGE",
    "FLHR 103 ROAD KING",
    "SOFTAIL DELUXE",
    "SOFTAIL SLIM S",
    "CVO ULTRA CLASSIC E-GLIDE",
    "FLHXSE STREET GLIDE CVO",
    "FLTRX",
    "DYNA SUPER GLIDE SPORT",
    "ROAD KING CUSTOM",
    "FLHXSE",
    "FLTRU",
    "CVO ROAD GLIDE",
    "FXDB",
    "XG750A",
    "FXDF",
    "FLHTKL",
    "VRSCF V-ROD MUSCLE",
    "FLTRK",
    "FXDL",
    "FLSL SOFTAIL SLIM",
    "STREET ROD VRSCR",
    "FLHCSANV HERITAGE CLASSIC",
    "FXBB STREET BOB",
    "FLFB FAT BOY",
    "PAN AMERICA 1250 SPECIAL",
    "LOW RIDER S",
    "FS2",
    "FXDB STREET BOB",
    "CVO ROAD GLIDE CUSTOM",
    "FXFBS",
    "SOFTAIL BREAKOUT",
    "XL 1200T SUPER LOW",
    "FXCW ROCKER",
    "VRSCD NIGHT ROD",
    "SOFTAIL BLACKLINE",
    "ULTRA LIMITED LOW",
    "FXLR LOW RIDER",
    "DYNA SWITCHBACK",
    "ELECTRA GLIDE STANDARD",
    "SOFTAIL ROCKER C",
    "SUPERLOW",
    "FLHTK ULTRA LIMITED",
    "FLHCS HERITAGE",
    "STREET BOB",
    "FLHTKSE CVO ULTRA LIMITED",
    "XL 883N IRON",
    "FLTRX ROAD GLIDE",
    "SOFTAIL SPRINGER CUSTOM",
    "BREAKOUT S",
    "FLHX STREET GLIDE",
    "XL 1200",
    "SOFTAIL FAT BOY",
    "FXSB 103 BREAKOUT",
    "XL 1200CX ROADSTER",
    "VRSCAW V-ROD",
    "FXDL 103 LOW RIDER",
    "FXFB",
    "XL 1200CA",
    "DYNA LOW RIDER S",
    "FLHRC ROAD KING CLASSIC",
    "CVO ROAD KING",
    "FLTRXS ROAD GLIDE SPECIAL",
    "XL 1200CB",
    "XG750",
    "XL 1200T",
    "FXFB FAT BOB",
    "ELECTRA GLIDE CLASSIC",
    "FLHXS",
    "XL 1200N",
    "FXSB BREAKOUT",
    "FLSTFBS",
    "XL 1200X",
    "XL 1200V",
    "FLHTKL ULTRA LIMITED LOW",
    "FLHCS HERITAGE CLASSIC",
    "FLFBSANV FAT BOY",
    "SOFTAIL SPRINGER CLASSIC",
    "VRSCX V-ROD",
    "ROAD GLIDE SPECIAL",
    "VRSCF",
    "FLHRXS ROAD KING SPECIAL",
    "XL 1200CX",
    "FAT BOB",
    "FXBRS BREAKOUT",
    "FLSTFB",
    "XL1200NS",
    "FLFBS",
    "FXS BLACKLINE",
    "SPRINGER",
    "XL 1200C",
    "FXDRS",
    "FLHRCI",
    "FLHTKANV ULTRA LIMITED",
    "FLSS SOFTAIL SLIM S",
    "DYNA LOW RIDER",
    "FLHXANV",
    "FXLRS",
    "SOFTAIL SPORT GLIDE",
    "ULTRA LIMITED",
    "FLHTKANV",
    "FXDBC 103 STREET BOB LIMITED",
    "RH1250S",
    "VRSCB V-ROD",
    "XG750A STREET ROD",
    "FXDR 114",
    "FLSS",
    "CVO ULTRA LIMITED",
    "CVO ULTRA ROAD GLIDE",
    "FXSTSSE SOFTAIL SPRINGER",
    "FLHTKSE ULTRA LIMITED CVO",
    "XL 883L",
    "CVO SOFTAIL BREAKOUT",
    "XL 883N",
    "XL 883R",
    "FLFBS FAT BOY",
    "BREAKOUT 114",
    "IRON 1200",
    "CVO BREAKOUT",
    "ROAD KING 110 ANNIVERSARY",
    "CVO SOFTAIL DELUXE",
    "FXDWG 103 WIDE GLIDE",
    "STREET 750",
    "XL 1200X FORTY-EIGHT",
    "XR 1200",
    "XL 883C",
    "SOFTAIL HERITAGE CLASSIC S",
    "XL 1200C CUSTOM",
    "FLSB",
    "FXDLS LOW RIDER S",
    "CVO ELECTRA GLIDE CLASSIC",
    "FLSL",
    "FLHTP",
    "SOFTAIL SLIM",
    "FLHTK",
    "FLFBSANX FAT BOY",
    "FLHCS",
    "XL 883L SUPERLOW",
    "VRSCA V-ROD",
    "NIGHT ROD SPECIAL",
    "FLDE",
    "SOFTAIL FAT BOY SPECIAL",
    "DYNA WIDE GLIDE",
    "DYNA STREET BOB",
    "DYNA FAT BOB",
    "FXBRS",
    "FLHXANV STREET GLIDE",
    "FXD DYNA SUPER GLIDE",
    "HERITAGE SPRINGER",
    "FLTRUSE CVO ULTRA LIMITED",
    "FXSTBI NIGHT TRAIN",
    "FXLR",
    "ROAD GLIDE ULTRA",
    "RA1250S",
    "FLSTSB",
  ],
  HAOSTONE: [""],
  INFINITI: [
    "QX60",
    "FX50",
    "FX30",
    "Q60 COUPÉ",
    "G37 COUPÉ",
    "JX35",
    "FX35",
    "FX37",
    "G37 CABRIO",
    "QX30",
    "QX50",
    "QX70",
    "G35",
    "G37",
    "Q70",
    "M30",
    "Q50",
    "M35",
    "G35X",
    "QX56",
    "Q30",
    "EX30",
    "M37",
    "FX45",
    "EX35",
    "EX37",
    "QX80",
    "Q60 CABRIO",
  ],
  SKYWELL: ["ET5"],
  LMC: [""],
  "ZASTAVA YUGO": [""],
  MIKILON: [""],
  AIXAM: ["", "CITY", "CROSSLINE", "SCOUTY R", "ROADLINE"],
  INDIAN: [
    "SUPER CHIEF LIMITED",
    "FTR",
    "CHIEFTAIN DARK HORSE",
    "ROADMASTER DARK HORSE",
    "ROADMASTER CLASSIC",
    "SCOUT BOBBER TWENTY",
    "CHIEF BOBBER DARK HORSE",
    "PURSUIT DARK HORSE",
    "CHALLENGER DARK HORSE",
    "CHIEFTAIN",
    "ROADMASTER ELITE",
    "ROADMASTER",
    "SPRINGFIELD DARK HORSE",
    "SCOUT SIXTY",
    "PURSUIT LIMITED",
    "ROADMASTER LIMITED",
    "SCOUT BOBBER",
    "CHIEF DARK HORSE",
    "SPRINGFIELD",
    "CHIEFTAIN CLASSIC",
    "CHIEFTAIN LIMITED",
    "SCOUT",
    "CHIEF VINTAGE",
    "CHIEF",
    "FTR S",
    "CHALLENGER LIMITED",
    "SCOUT ROGUE",
    "FTR RALLY",
    "CHIEF CLASSIC",
    "FTR R CARBON",
    "DARK HORSE",
  ],
  HOLDEN: [""],
  MARO: [""],
  WARTBURG: [""],
  BOOM: [""],
  BUICK: [
    "LE SABRE",
    "LA CROSSE",
    "RIVIERA",
    "PARK AVENUE",
    "ELECTRA",
    "SKYLARK",
    "ENCLAVE",
    "CENTURY",
    "ROADMASTER",
    "REGAL",
  ],
  ROMET: [""],
  ZNEN: [
    "ZN125T-18",
    "ZN50QT-6",
    "ZN150T-5A",
    "ZN150T-9",
    "ZN125T-H",
    "ZN125T-32",
    "ZN125T-11",
    "ZN50QT-7A",
    "ZN125T-15",
  ],
  GEELY: [
    "GOLC FENIX",
    "GOLC RACING",
    "GOLC TRAVEL",
    "GOLC CITY",
    "GOLC SPORT",
    "JL50QT-2",
    "GOLC FOREST",
  ],
  BABETA: [""],
  HONDA: [
    "CBF 600S ABS",
    "CB 600FA",
    "SES 150 DYLAN",
    "X8R-S (X8R-X)",
    "VT 750 S",
    "INSIGHT",
    "NSC110MPD",
    "GOLD WING",
    "SW-T600",
    "PILOT",
    "CIVIC",
    "ODYSSEY",
    "VT 600 C SHADOW",
    "FJS 600A",
    "VFR 1200FD",
    "XL 1000V VARADERO",
    "NC 750SA",
    "CRF1000L AFRICA TWIN DCT",
    "WW125EX2",
    "MONKEY",
    "NES @125",
    "CG 125",
    "PES 150",
    "WW125A",
    "CB 650FA",
    "ANF 125 INNOVA",
    "XL 125V VARADERO",
    "FES 125 PANTHEON",
    "SH 125",
    "PES 125",
    "ACCORD COUPÉ",
    "ADV350",
    "X8R-S",
    "VALKYRIE",
    "NHX110",
    "NC750J",
    "X8R-X",
    "NX 650 DOMINATOR",
    "XL 700VA",
    "ACURA",
    "CBR 650F",
    "@150",
    "GLR1251WH",
    "CB 650R SPORT",
    "NSS250 FORZA",
    "VTX 1800",
    "CBR 650R",
    "CTX 700",
    "CBF 1000F",
    "VTR 1000F FIRESTORM",
    "FMX 650",
    "CB 1100RS",
    "CR-V",
    "CIVIC HYBRID",
    "FORZA",
    "CR",
    "HR-V",
    "CBR 600 RR",
    "VFR 1200X CROSSTOURER",
    "VFR 1200XD",
    "CB 1300",
    "X11",
    "ACCORD",
    "CB 1000R",
    "CBR 300R",
    "SH 300",
    "NSS300 FORZA",
    "CB 650F",
    "CBR 1100 XX SUPER BLACKBIRD",
    "CMX500A",
    "CB 1100EX",
    "CBF 125",
    "VT 125 C SHADOW",
    "JAZZ",
    "SUPER CUB 125",
    "CB 600F HORNET",
    "VF 750 C MAGNA",
    "VALKYRIE RUNE",
    "NM4 VULTUS",
    "FJS 400D",
    "GL1800B",
    "NC 750D",
    "ST 1100 PAN EUROPEAN",
    "VFR 800F",
    "CTX 700N",
    "NSA700A",
    "CROSSRUNNER",
    "NSR 125R",
    "CB 1000RA",
    "VFR 800X",
    "CBF 250",
    "VTR 250",
    "SUPER CUB C125",
    "CBR 250R",
    "SHUTTLE",
    "NSS125D",
    "WW150EX2",
    "PANTHEON 125",
    "NTV650 DEAUVILLE",
    "FES 125",
    "NSC110WH",
    "CB 300R",
    "CB 650R+",
    "WW125 PCX",
    "GL1800DA",
    "CB 600 S HORNET",
    "CBR 1000RR FIREBLADE SP",
    "FES 250",
    "GL 1800C",
    "E:NY1",
    "XR",
    "CB 1100 SF",
    "CB 650R",
    "CB 900F HORNET",
    "NC700D",
    "CB 125R",
    "VISION",
    "CROSSTOUR",
    "CB 125F",
    "CB 250",
    "ST 1300 PAN EUROPEAN",
    "NT700VA DEAUVILLE",
    "E EV ADVANCE",
    "NC700S",
    "VT 1300CX",
    "NES 125",
    "NC700X",
    "XR 125L",
    "VTR 1000 SP-2",
    "VTR 1000 SP-1",
    "PRELUDE",
    "INTEGRA",
    "CB 600 HORNET",
    "SLR 650",
    "FORESIGHT",
    "FES 150 S-WING",
    "VFR 1200X",
    "ZR-V",
    "VT 750 C SHADOW",
    "ACCORD CROSSTOUR",
    "NSX",
    "VFR 1200F",
    "S2000",
    "CBR 500R",
    "NSS125AD",
    "NC 750X",
    "SES 125 DYLAN",
    "NSS 250 JAZZ",
    "ADV750",
    "MSX 125",
    "NSC50WH",
    "NC 750S",
    "CBF300NA",
    "WAVE 110I",
    "VT 750 DC BLACK WIDOW",
    "CTX 1300",
    "FJS 600 SILVER WING",
    "NT 1100",
    "CBR 600F",
    "X-ADV",
    "CITY",
    "NC 750X DCT",
    "CRF1100L AFRICA TWIN",
    "PCX 125",
    "900F",
    "FES 150 PANTHEON",
    "CB 500XA",
    "LEAD",
    "50 TACT",
    "CRF1000A",
    "XL 700V TRANSALP",
    "VT 750 C2B",
    "CRF1000D",
    "CBF 600N",
    "XL 750",
    "CBF 1000",
    "CBF 600S",
    "LEGEND",
    "CB 1100NA",
    "SW-T400",
    "F6C",
    "CMX1100D",
    "CBR 900 RR - FIREBLADE",
    "CB 500X",
    "CBR 600",
    "RIDGELINE",
    "PCX 150",
    "VFR",
    "CBR 1000RA",
    "GL 1800",
    "NC 750S DCT",
    "WW150 PCX",
    "CB 500F",
    "CTX 1300DX",
    "CB 500",
    "PS 125",
    "FR-V",
    "CRF",
    "CRE",
    "NC 750XDG DCT",
    "MONTESA 4RIDE",
    "VTX 1300S",
    "VTX 1300R",
    "CRF1000L AFRICA TWIN",
    "DN-01",
    "NT700VA",
    "CRX",
    "NC 750XA",
    "CRZ",
    "PS 150",
    "NC 750XD",
    "CRF1100A2",
    "CBR 1000RR",
    "ZOOMER",
    "CBR 1000RR FIREBLADE",
    "VT 1100 C SHADOW",
    "CB 750",
    "CBR 1000S1",
    "CBF 500",
    "CBR 125R",
    "CROSSTOURER",
    "GOLD WING F6B",
    "DEAUVILLE",
    "BALI",
    "GOLD WING F6C",
    "STREAM",
    "XL 650V TRANSALP",
    "SH 150",
    "ANC125",
    "VTX 1300C",
    "HONDA E",
    "XL 1000V VARADERO ABS",
    "REBEL",
    "XRV 750 AFRICA TWIN",
    "CB 1100",
  ],
  ZIP: [""],
  POSSL: [""],
  XY: [""],
  HANGLONG: ["HL50QT-21"],
  YAMAHA: [
    "XQ 125 MAXSTER",
    "MT-09 TRACER",
    "VMAX",
    "D'ELIGHT",
    "GTS",
    "PW",
    "XVZ 1300 ROYAL STAR",
    "X-MAX 300",
    "TENERE 700",
    "FJR",
    "R1M",
    "CW 50 BWŚ ORIGINAL",
    "MT-125",
    "XVS",
    "XT 125R",
    "XT 125X",
    "XC125R MAJESTY S",
    "TRACER 9 GT",
    "R3",
    "XV 1700 ROAD STAR",
    "XT 1200Z",
    "N-MAX",
    "R7",
    "YP 400A MAJESTY",
    "YP125R X-MAX",
    "YBR 250",
    "TRX 850",
    "BT 1100 BULDOG",
    "XC115S DELIGHT",
    "XC 300 VERSITY",
    "XC 125E VITY",
    "YN 50 NEOS",
    "YQ 100 AEROX",
    "NEOS EASY",
    "TÉNÉRÉ 700",
    "YZF",
    "XSR 900",
    "TEO'S",
    "MXT850",
    "X-CENTER",
    "XP530 TMAX DX",
    "XV1900 A",
    "MT-07 MOTO CAGE",
    "XVZ 1300 ROYAL STAR VENTURE",
    "YP 180 MAJESTY",
    "XP 500 TMAX",
    "YP 150 MAJESTY",
    "TRACER 7 GT",
    "XP530 TMAX SX",
    "YP250R",
    "MTT690-A",
    "MT-10",
    "TRACER 700",
    "YP125R",
    "YP400R",
    "YQ 50 AEROX R",
    "XC 125F CYGNUS",
    "GPD125-A",
    "GIGGLE",
    "NMAX125",
    "YP 125 MAJESTY",
    "CS 50Z JOG RR",
    "XENTER",
    "TRICITY 125",
    "MT-10 SP",
    "TT",
    "R6 RACE",
    "TW",
    "MT-01",
    "XJ6",
    "XV 950",
    "XT 660X  SUPERMOTARD",
    "MT-03",
    "MT-09",
    "TZR",
    "MTT850D",
    "NXC 125 CYGNUS",
    "MT-07",
    "YW125 BW´S",
    "DT",
    "XP 500 BLACK MAX",
    "MXT850 (NIKEN)",
    "XT 1200Z SUPER TÉNÉRÉ",
    "NITRO",
    "GPD150-A",
    "BWS",
    "TRACER 900 GT",
    "XJR",
    "AEROX",
    "XG 250 TRICKER",
    "XT 600E",
    "MTM850",
    "YP 400 MAJESTY",
    "YS 125",
    "FZ 750",
    "MTT890D",
    "YQ 50 AEROX REPLICA GP1",
    "MTN1000D",
    "TMAX SX",
    "MTN320-A",
    "XTZ690 (TENERE700)",
    "LTS125 C",
    "XP530-A TMAX SX",
    "NS50 AEROX",
    "YBR 125",
    "FJ",
    "X-CITY 250",
    "SR 400",
    "SR 125",
    "XSR700 XTRIBUTE",
    "X-MAX 125",
    "X-MAX 400",
    "YN 100 NEOS",
    "X-MAX 250",
    "TDR 125",
    "XT 660R",
    "CYGNUS-X",
    "FJR 1300 A",
    "XQ 150 MAXSTER",
    "XT 660Z TENERE",
    "XSR 700",
    "WR",
    "XTZ690",
    "TDM",
    "FZ1",
    "XT 1200ZE SUPER TÉNÉRÉ",
    "NMAX155",
    "YH 50 WHY",
    "MT-09 SP",
    "XV 950R",
    "FZ6",
    "FZ8",
    "TRACER 900",
    "TMAX DX",
    "CS 50 JOG R",
    "TRICITY",
    "XP 500 NIGHT MAX",
    "XJ",
    "VP 300 VERSITY",
    "YP125RA",
    "YP 250 MAJESTY",
    "NIKEN",
    "FJR 1300 AE",
    "FJR 1300 AS",
    "TRACER 7",
    "SCR 950",
    "TRACER 9",
    "X-CITY 125",
    "XV",
    "FZS",
    "EW 50 SLIDER",
    "FZR",
  ],
  JEEP: [
    "AVENGER",
    "RENEGADE",
    "COMPASS",
    "GLADIATOR",
    "WRANGLER",
    "WAGONEER",
    "CHEROKEE",
    "GRAND CHEROKEE",
    "COMMANDER",
    "PATRIOT",
  ],
  LEIKE: [""],
  IVECO: [
    "",
    "35S18",
    "MASSIF",
    "35C16",
    "DAILY",
    "MASSIF PICK UP",
    "35S14",
    "35S16",
  ],
  HAIZHIMENG: [""],
  KUBA: ["MYFORCE 4000E"],
  JIALING: ["JL150T", "JL125T", "JL50"],
  CADILLAC: [
    "ATS",
    "ESCALADE",
    "STS-V",
    "CTS",
    "CT6",
    "BLS",
    "ATS-V",
    "STS",
    "XTS",
    "XT5",
    "SRX",
    "XT4",
    "XT6",
    "CTS-V",
    "XLR",
  ],
  HYMERMOBIL: [""],
  PRAGA: ["", "R1R", "CD 450", "CD 610", "ED 250", "ED 430", "ED 610"],
  HUSQVARNA: [
    "701 SUPERMOTO",
    "TR650 TERRA",
    "TR650 STRADA",
    "NUDA 900",
    "WRE",
    "TC",
    "CR",
    "TE",
    "VITPILEN 401",
    "701 ENDURO",
    "SM",
    "NUDA 900R",
    "WR",
    "VITPILEN 701",
    "SVARTPILEN 401",
    "FE",
  ],
  CUPRA: ["FORMENTOR", "BORN", "TAVASCAN", "ATECA", "LEON", "TERRAMAR"],
  DADYW: ["STAR 250"],
  PENZPERFORMANCE: [
    "BLUE STEEL",
    "PERSEPTION",
    "RED BARON",
    "CINDERELLA",
    "TIKKICHOPPER",
    "FLAMING THUNDER",
    "MEGADEATH",
    "EREBUS",
    "COOPER FLAME",
    "GAMBLER",
    "OVERKILL",
    "ERIC CLAPTON",
    "LORD OF THE RING",
    "GAME OVER",
    "FORCE FEEDBACK",
    "EVIL SPIRIT CHOPPER",
    "LET'S PLAY",
    "STRONG LEADER",
    "GO WILD",
    "BLACK POISON",
    "IMPOSSIBLE BRUTALITY",
    "MILWAUKEE FLOWER",
    "VIVERE MORI",
    "EXODUS",
    "EVIL SPIRIT",
    "LIEBES",
    "AURORA",
    "GOLD CUT",
    "ROCKSTEADY",
    "POCOLOCO",
    "RED STEEL",
    "MARILYN",
    "JUST IN TIME",
    "BLUE MARLIN",
    "KENTOYA SPIRIT",
    "3D",
    "RELAXED ATMOSPHERE",
    "REAL PLAYER",
    "ROYAL FLUSH",
    "BLACK SPEED",
  ],
  ALPINE: ["A110"],
  TOYOTA: [
    "",
    "MIRAI",
    "FORTUNER",
    "GR86",
    "AVALON HYBRID",
    "GT86",
    "YARIS CROSS",
    "YARIS VERSO",
    "PICNIC",
    "PROACE",
    "4-RUNNER",
    "IQ",
    "SCION",
    "AYGO X",
    "PASEO",
    "PREVIA",
    "URBAN CRUISER",
    "HIGHLANDER",
    "SIENNA",
    "CELICA",
    "VENZA",
    "AVALON",
    "PROACE CITY",
    "AYGO",
    "FJ CRUISER",
    "COROLLA",
    "COROLLA VAN",
    "YARIS GR",
    "VERSO",
    "C-HR",
    "YARIS GRMN",
    "PRIUS+",
    "TUNDRA",
    "MR 2",
    "HILUX",
    "CARINA E",
    "HIACE",
    "PROACE MAX",
    "STARLET",
    "SOLARA",
    "COROLLA CROSS",
    "BZ4X",
    "SUPRA",
    "VERSO-S",
    "AVENSIS VERSO",
    "TACOMA",
    "PRIUS",
    "COROLLA VERSO",
    "LAND CRUISER",
    "PROACE CITY VERSO",
    "GR SUPRA",
    "YARIS",
    "SEQUOIA",
    "AURIS",
    "PROACE VERSO",
    "CAMRY",
    "RAV 4",
    "AVENSIS",
  ],
  ALPINA: [
    "B10",
    "BMW ALPINA B3",
    "BMW ALPINA B4",
    "B12",
    "D 10",
    "XD3",
    "BMW ALPINA B5",
    "D3",
    "BMW ALPINA B8",
    "B3",
    "D5",
    "B4",
    "B5",
    "B6",
    "B7",
    "BMW ALPINA XD4",
    "B8",
    "ROADSTER S",
    "BMW ALPINA XB7",
  ],
  SCION: [""],
  HYMER: [""],
  "AUSTIN HEALEY": [""],
  KEEWAY: [
    "FACT EVO",
    "EXCEED",
    "MILAN",
    "F-ACT",
    "SILVERBLADE",
    "ZAHARA",
    "FOCUS",
    "SUPERLIGHT",
    "SILVER BLADE",
    "RY6",
    "SPEED",
    "TX MOTARD",
    "LOGIK",
    "CITYBLADE TOUR",
    "SMART",
    "K-LIGHT 125",
    "CITYBLADE SPORT",
    "TX ENDURO",
    "MATRIX",
    "HURRICANE",
    "CRUISER",
    "CITYBLADE",
    "BLACKSTER",
    "KNIGHT",
    "V-BLADE",
    "SUPERSHADOW",
    "LAND CRUISER",
    "RKF",
    "FLASH",
    "AGORA",
    "PONY",
    "RKS SPORT",
    "VIVA",
    "SWAN",
    "X-BLADE",
    "TX125",
    "RK",
    "RKS",
    "RKV",
    "BLADE",
    "ARN",
    "TX SUPERMOTO",
  ],
  SACHS: [
    "LT50",
    "LN125",
    "MAD ASS",
    "LT125",
    "AMICI",
    "QUATTRO 400",
    "X-ROAD",
  ],
  NSU: [""],
  FCM: [""],
  MANET: ["KORADO"],
  ZONGSHEN: ["ZS 125T-7"],
  PONTIAC: [""],
  GUEWER: [""],
  BITTER: [""],
  MOTOBI: ["IMOLA RS", "IMOTO RS", "PESARO", "MODENA", "IMOLA", "IMOTO"],
  "TM RACING": [""],
  TATRA: ["", "BETA"],
  SOLARIS: [""],
  BAROSSA: [""],
  VECTRIX: [""],
  UAZ: [
    "3162 SIMBIR",
    "2360 RANCHER",
    "3160 COMBAT",
    "23632 PICKUP",
    "UAZ HUNTER AMC",
    "23602 CARGO",
    "3163 PATRIOT",
    "PATRIOT SPORT AMC",
    "3164 PATRIOT SPORT",
    "2206",
    "UAZ AMC 4X4",
    "3164 COMBAT",
    "23602 RANCHER",
    "3151 HUNTER",
  ],
  ERIDER: [""],
  KAWASAKI: [
    "VN1500 CLASSIC TOURER",
    "ER-6F",
    "VULCAN S",
    "KLE",
    "ER-6N",
    "Z 1000",
    "KLR",
    "KLV",
    "KLX",
    "Z 900 RS CAFE",
    "VN1500 CLASSIC",
    "Z 1000 R",
    "ZRX",
    "VULCAN 900 CLASSIC",
    "VN1600 MEAN STREAK",
    "NINJA ZX-6R",
    "VULCAN 1700 NOMAD",
    "VN1700 VOYAGER",
    "NINJA H2 SX SE",
    "VN1700 CLASSIC TOURER",
    "ZZ-R",
    "Z 900",
    "ER-5",
    "W 800",
    "ER-6",
    "KMX",
    "Z900SE",
    "ZX",
    "VN1700 LIGHT TOURER",
    "NINJA 250R",
    "VN800 CLASSIC",
    "NINJA ZX-6R 636",
    "ELIMINATOR",
    "NINJA ZX-10R SE",
    "VN1700 CLASSIC",
    "Z 750",
    "VN2000",
    "GTR 1400",
    "VN1700 TOURER",
    "Z",
    "GTR 1000",
    "VN800",
    "D-TRACKER",
    "NINJA 400",
    "NINJA 125",
    "ZX 1400A",
    "ZZR1400",
    "KX",
    "NINJA 650 SE",
    "Z 400",
    "Z 125",
    "VN1500 CLASSIC TOURER FI",
    "VN800 DRIFTER",
    "Z 800",
    "VN1500 DRIFTER",
    "VULCAN 1700 VOYAGER",
    "NINJA 300 PERFORMANCE",
    "VULCAN S CAFE",
    "NINJA H2 CARBON",
    "VN900 CUSTOM",
    "NINJA 650",
    "GPZ 500",
    "J125",
    "Z 650",
    "NINJA H2 SX",
    "NINJA ZX-10R",
    "VULCAN 900 CUSTOM",
    "BN 125",
    "Z650RS",
    "VN1600 CLASSIC TOURER",
    "NINJA 300",
    "VN2000 CLASSIC",
    "EL 252",
    "Z 300",
    "NINJA 1000SX",
    "NINJA H2 SX SE+",
    "NINJA ZX-10RR",
    "Z 900 RS",
    "ZR-7",
    "J300",
    "VN1700 VOYAGER CUSTOM",
    "VN1500 MEAN STREAK",
    "VERSYS-X",
    "W 650",
    "Z 750 S",
    "Z 750 R",
    "ZZR1400 PERFOMANCE SPORT",
    "NINJA 400 SE",
    "NINJA 125 SE",
    "EN 500",
    "Z 1000 SX",
    "NINJA H2",
    "VN900 CLASSIC",
    "Z650RS SE",
    "VULCAN S SE",
    "VN1500 CLASSIC FI",
    "VN1600 CLASSIC",
    "VERSYS",
  ],
  KENTOYA: [
    "LION-I",
    "SHARKY",
    "PHOENIX-I",
    "EXTRA",
    "YOYO",
    "TRIGGER",
    "FIGHTER",
    "SPEED",
    "HT125T-25",
    "HT125T-24",
    "SHUTTER",
    "APACHEE",
    "MAXIMUS-I",
    "FEVER",
    "WINNER",
    "SONIK",
    "VIKING",
    "MAXIMUS",
    "SLIDE",
    "ZOOM2",
    "IDEO",
    "FLASH",
    "ASPHYX-I",
    "FREE WIND",
    "HAMMER II",
    "MIU",
    "DARKNESS",
    "XOR",
    "LION",
    "VIRON",
    "TY125T-N",
    "BLOW UP",
    "TWINSHOT",
    "HAMSTER",
    "EAGLE KING",
    "SUNNY",
    "C5",
    "HAMMER",
    "TRIGGER GENERIC",
    "LENS",
    "BROADWAY",
    "IMAD",
    "POWER MAX",
    "SPILLO",
    "TWIN CUP",
    "SOLE MIO",
    "CITY ONE",
    "HAMSTER-I",
    "VIRON SPORT",
    "HT125T-11",
    "VIKING-I",
    "SHINE",
    "ZOOM",
    "TY125T-F",
  ],
  FASPIDER: [""],
  PIAGGIO: [
    "ZIP",
    "X EVO 250",
    "VESPA SPRINT",
    "NRG",
    "VESPA GT 125",
    "VESPA GT 200",
    "VESPA PX 125",
    "MEDLEY",
    "VESPA PRIMAVERA",
    "VESPA GTV 250",
    "VESPA LX 151",
    "TPH",
    "SFERA 50",
    "VESPA LX 50",
    "FLY",
    "SKIPPER",
    "VESPA ELETTRICA",
    "BEVERLY",
    "VESPA PX 150",
    "SR",
    "X7",
    "VESPA GTS 250",
    "X8",
    "X9",
    "VESPA S 125",
    "SR MAX 125",
    "VESPA LX 125",
    "NEW TYPHOON",
    "BEVERLY 500 CRUISER",
    "TYPHOON",
    "SR MAX 300",
    "VESPA LXV 125",
    "X EVO 400",
    "X EVO 125",
    "VESPA 946",
    "CARNABY",
    "PORTER",
    "MAXXI",
    "VESPA GTV 300",
    "MP3",
    "DIESIS",
    "VESPA S 50",
    "X10",
    "VESPA GTS 125",
    "VESPA GTS 300",
    "LIBERTY",
  ],
  RIYA: [""],
  ORION: [""],
  BEULAS: [""],
  VDL: [""],
  FOSTI: ["KENTOYA FT50QT-12"],
  MAVE: [""],
  ARIEL: ["", "ARIEL NOMAD"],
  QUANTUM: [""],
  TAURIS: [
    "BROADWAY",
    "FIERA 125 XTREME",
    "SAMBA 50",
    "CUBANA 125",
    "CUBANA 50",
    "FIERA 50 XTREME",
    "RUMBA 125",
    "FIERA 125",
    "FUEGO 50",
    "FIERA 50",
    "CAPRI 125",
    "BRIO 50",
    "MISTRAL 50",
    "CAPRI 50",
  ],
  DAF: [""],
  PORSCHE: [
    "918",
    "MACAN",
    "CAYENNE",
    "CAYENNE E-HYBRID",
    "CAYMAN",
    "PANAMERA",
    "CARRERA GT",
    "TAYCAN",
    "BOXSTER",
    "962",
    "911",
    "944",
    "912",
    "968",
    "924",
    "914",
    "959",
    "928",
  ],
  "HILL COOPER": [""],
  JOURNEYMAN: [""],
  STEWARD: [""],
  HUMMER: [""],
  CHAUSSON: [""],
  POLINI: [""],
  DAYANG: [""],
  "KH MC": [""],
  MARBUS: [""],
  "FANTIC MOTOR": [""],
  "JIAYUAN EV": [""],
  OLDSMOBILE: [""],
  "LAND ROVER": [
    "DEFENDER 90",
    "RANGE ROVER VELAR",
    "RANGE ROVER",
    "RANGE ROVER EVOQUE CABRIOLET",
    "DEFENDER SVX",
    "RANGE ROVER SPORT",
    "DISCOVERY SPORT",
    "FREELANDER",
    "DEFENDER 110",
    "DISCOVERY",
    "DEFENDER 130",
    "RANGE ROVER EVOQUE",
  ],
  LINHAI: [""],
  TEMSA: [""],
  SUPERBYKE: [""],
  TAZ: ["1203", "1500", "1900"],
  NISSAN: [
    "",
    "TRADE",
    "100 NX",
    "X-TRAIL",
    "PRAIRIE",
    "URVAN",
    "ROGUE",
    "PIXO",
    "PATHFINDER",
    "NV200",
    "NAVARA",
    "INTERSTAR",
    "200 SX",
    "NV400",
    "PULSAR",
    "E-NV200",
    "CUBE",
    "EVALIA",
    "TITAN",
    "350 Z",
    "TIIDA",
    "TOWNSTAR",
    "KUBISTAR",
    "NP300 PICKUP",
    "TERRANO",
    "QASHQAI",
    "PRIMERA",
    "JUKE",
    "MICRA",
    "300 ZX",
    "ALMERA",
    "VANETTE",
    "SUNNY",
    "ARMADA",
    "GT-R",
    "NOTE",
    "NV300",
    "PICKUP",
    "MURANO",
    "PRIMASTAR",
    "SERENA",
    "MICRA C+C",
    "370 Z",
    "PATROL",
    "SUNNY VAN",
    "EX35",
    "ARIYA",
    "MAXIMA",
    "LEAF",
  ],
  "RENAULT ALPINE": [""],
  BRABUS: ["GLE900 ROCKET EDITION"],
  MTX: [""],
  WESTFALIA: [""],
  EXPLORER: [""],
  BAOTIAN: [
    "CYBORG",
    "BT125QT-12C1",
    "BT151T-B2",
    "BT125QT-12F1",
    "BT49QT-12F1",
    "BT151T-2B2",
    "BT49QT-12G1",
    "BT49QT-9",
    "BT49QT-28B",
    "SPORTY",
    "BT49QT-12C1",
    "BT49QT-12",
  ],
  "ADLY MOTO": [""],
  "ALFA ROMEO": [
    "CROSSWAGON Q4",
    "GIULIA",
    "GTV",
    "8C",
    "SPIDER",
    "4C",
    "155",
    "156",
    "159",
    "90",
    "STELVIO",
    "75",
    "33",
    "ALFASUD",
    "BRERA",
    "CROSSWAGON",
    "GT",
    "164",
    "166",
    "JUNIOR",
    "145",
    "146",
    "TONALE",
    "MITO",
    "147",
    "SPRINT",
    "149",
    "ALFETTA",
    "GIULIETTA",
    "156 CROSSWAGON",
  ],
  "CHRYSLER JEEP": [
    "COMPASS",
    "WRANGLER",
    "CHEROKEE",
    "GRAND CHEROKEE",
    "COMMANDER",
    "PATRIOT",
  ],
  "MOTO STAR": [""],
  BORGWARD: [""],
  AUDI: [
    "TT",
    "Q2",
    "Q3",
    "Q4",
    "Q5",
    "Q6",
    "Q7",
    "Q8",
    "S8 PLUS",
    "RS2",
    "A1",
    "A2",
    "RS4",
    "A3",
    "RS3",
    "A4",
    "RS6",
    "A5",
    "SQ2",
    "RS5",
    "A6",
    "SQ5",
    "A7",
    "90",
    "A8",
    "RS7",
    "SQ7",
    "SQ6",
    "SQ8",
    "CABRIOLET",
    "V8",
    "A6 ALLROAD",
    "RSQ3",
    "R8",
    "TT RS",
    "R8 SPYDER",
    "A3 CABRIO",
    "A5 CABRIO",
    "RSQ8",
    "S4 CABRIO",
    "200",
    "A6 AVANT",
    "A4 ALLROAD",
    "E-TRON",
    "S6 AVANT",
    "S1",
    "S2",
    "S3",
    "S4",
    "S5",
    "S6",
    "S7",
    "S8",
    "S6 SB E-TRON",
    "A5 COUPÉ",
    "TTS",
    "Q8 55 E-TRON",
    "RS E-TRON GT",
    "A4 CABRIO",
    "S5 CABRIO",
    "100",
    "E-TRON GT",
    "COUPÉ",
    "80",
    "QUATTRO",
  ],
  BOVA: [""],
  KINGWAY: ["BLACK HORSE", "EUROBOY"],
  ROBUR: [""],
  CONCORDE: [""],
  URAL: [
    "RANGER",
    "VLK",
    "RETRO (SIDE)",
    "SOLO KLASIK",
    "SOLO",
    "RETRO",
    "TOURIST",
  ],
  FGR: [""],
  DAEWOO: [
    "KORANDO",
    "EVANDA",
    "RACER",
    "FSO TRUCK",
    "LUBLIN",
    "KALOS",
    "TICO",
    "LACETTI",
    "MATIZ",
    "CHAIRMAN",
    "LANOS",
    "NEXIA",
    "ESPERO",
    "TACUMA",
    "NUBIRA",
    "LEGANZA",
  ],
  DUCATI: [
    "DIAVEL STRIPE",
    "MULTISTRADA MTS1100",
    "SCRAMBLER 1100 SPORT PRO",
    "MONSTER 797",
    "MONSTER 796",
    "SCRAMBLER FULL THROTTLE",
    "HYPERMOTARD 1100 EVO SP",
    "STREETFIGHTER S",
    "HYPERMOTARD 821",
    "998 MATRIX",
    "MULTISTRADA 950",
    "MONSTER 1100 EVO",
    "SCRAMBLER CLASSIC",
    "HYPERSTRADA",
    "HYPERMOTARD 950 SP",
    "MONSTER 821 STRIPE",
    "SCRAMBLER 1100 SPECIAL",
    "996",
    "MULTISTRADA 1200S",
    "SCRAMBLER SIXTY 2",
    "900 SS",
    "MULTISTRADA 1200 ENDURO PRO",
    "999",
    "MULTISTRADA MTS1100S DS",
    "DIAVEL AMG",
    "996 SPS",
    "MONSTER M750",
    "DESMOSEDICI RR",
    "DESERTX RALLY",
    "MONSTER 821 STEALTH",
    "1098S TRICOLORE",
    "HYPERMOTARD 1100SP",
    "MULTISTRADA 1200 PIKES PEAK",
    "MULTISTRADA 1260 ENDURO",
    "MONSTER 620 DARK",
    "HYPERMOTARD 939",
    "1299 PANIGALE S",
    "MULTISTRADA 1260 PIKES PEAK",
    "1198",
    "XDIAVEL S",
    "999R XEROX",
    "GT 1000 TOURING",
    "MULTISTRADA 1260",
    "1098R BAYLISS REPLICA",
    "749 S",
    "999 S",
    "749 R",
    "MONSTER 796 20TH ANNIVERSARY",
    "SPORT 1000",
    "SCRAMBLER ICON",
    "MONSTER 620 CAPIREX",
    "MULTISTRADA 1200S PIKES PEAK",
    "800 SS FF",
    "999 R",
    "MONSTER 821",
    "1198S",
    "MULTISTRADA 950 S",
    "SUPERSPORT",
    "PANIGALE V4 S",
    "MONSTER 821 DARK",
    "MONSTER 696",
    "MONSTER S2R DARK",
    "MONSTER 695",
    "1198R CORSE",
    "HYPERMOTARD 1100 EVO",
    "DIAVEL DIESEL",
    "SPORT 1000S",
    "MONSTER 1100S",
    "MONSTER 1000",
    "MONSTER 1100 EVO DIESEL",
    "749 DARK",
    "HYPERMOTARD 1100S",
    "PAUL SMART 1000 LE",
    "PANIGALE V2",
    "1098S",
    "1098R",
    "PANIGALE V4",
    "MULTISTRADA 1260 S",
    "MULTISTRADA MTS1100S",
    "1198S CORSE",
    "MONSTER M900",
    "ST3S ABS",
    "848 EVO",
    "1098",
    "MULTISTRADA 620",
    "998 S FE",
    "HYPERMOTARD 950",
    "HYPERMOTARD 796",
    "748 S",
    "748 R",
    "MONSTER S2R 1000",
    "959 PANIGALE CORSE",
    "HYPERMOTARD 821 SP",
    "SCRAMBLER DS",
    "PAUL SMART 1000",
    "SUPERSPORT S",
    "DESERTX",
    "1199 PANIGALE S TRICOLORE",
    "959 PANIGALE",
    "HYPERMOTARD 939 SP",
    "MULTISTRADA V4 S",
    "DIAVEL",
    "MONSTER 1100",
    "STREETFIGHTER",
    "MONSTER 797+",
    "SCRAMBLER CAFÉ RACER",
    "STREETFIGHTER 848",
    "DIAVEL CARBON",
    "DIAVEL STRADE",
    "MONSTER 1100 EVO ANNIVERSARY",
    "SCRAMBLER URBAN ENDURO",
    "HYPERMOTARD 1100",
    "MONSTER S2R",
    "DIAVEL CROMO",
    "MONSTER 620",
    "848 EVO CORSE SE",
    "1199 PANIGALE R",
    "XDIAVEL",
    "MONSTER 1200R",
    "1199 PANIGALE S",
    "MONSTER 620DARK SINGLE DISK",
    "SCRAMBLER DESERT SLED",
    "SCRAMBLER 1100",
    "MONSTER 1200S",
    "MONSTER 696 20TH ANNIVERSARY",
    "MONSTER 620DARK DOUBLE DISK",
    "MONSTER S4RS",
    "1299 SUPERLEGGERA",
    "HYPERSTRADA 939",
    "1198SP",
    "MONSTER M600",
    "SCRAMBLER ITALIA INDEPENDENT",
    "GT 1000",
    "848",
    "MULTISTRADA 1200 ENDURO",
    "DIAVEL DARK",
    "899 PANIGALE",
    "PANIGALE R",
    "DIAVEL TITANIUM",
    "SCRAMBLER MACH 2.0",
    "MULTISTRADA 620 DARK",
    "MONSTER 1200",
    "STREETFIGHTER V4S",
    "SCRAMBLER 1100 SPORT",
    "DIAVEL 1260 S",
    "MULTISTRADA 1000 DS",
    "1299 PANIGALE",
    "HYPERMOTARD SP",
    "MONSTER S4",
    "ST4 S",
    "MULTISTRADA 1000S DS",
    "HYPERMOTARD",
    "MONSTER +",
    "MULTISTRADA 1200",
    "SCRAMBLER FLAT TRACK PRO",
    "1199 PANIGALE",
    "1000 SS FF",
    "MONSTER S4R",
    "SS 1000 DS",
    "MONSTER 1200S STRIPE",
    "ST2",
    "ST4",
    "ST3",
    "996 S",
    "DIAVEL 1260",
    "996 R",
    "750 SS",
    "MULTISTRADA1200S GRANTURISMO",
    "MONSTER 800",
    "748",
    "749",
  ],
  GENERIC: ["ZION", "IDEO", "XOR", "ONYX"],
  LONCIN: [
    "VENUS",
    "SNS250 JEDI",
    "LX125T",
    "XM250",
    "XM125",
    "TH125A",
    "LX250Y",
    "LX50QT",
    "S3R125 SPITZER",
  ],
  "GAS GAS": [
    "TXT 250 RACING",
    "TXT 80 RACING",
    "EC 250 RACING SIX DAYS",
    "EC 250 RACING",
    "TXT 300 GP",
    "TRIAL SCHOOL 125",
    "EC 300 GP",
    "EC 300 RACING SIX DAYS",
    "ENDUCROSS 200",
    "ENDUCROSS 300",
    "ENDUCROSS 125",
    "CONTACT 280 ES",
    "EC 300 RACING",
    "TXT 300 RACING",
    "CG",
    "EC 250 GP",
    "TXT 125 GP",
    "EC CAMÍ 250",
    "TXT 280 GP",
    "TXT 125 RACING",
    "TXT 250 GP",
    "CONTACT 250 ES",
    "TG",
    "TXT 280 RACING",
    "ENDUCROSS 450",
    "ENDUCROSS 250",
  ],
  GOES: [""],
  BABETTA: [""],
  IMZ: [""],
  INTRALL: [""],
  TRIGANO: [""],
  APOLLO: [""],
  MOTORBIKE: [""],
  SAM: [""],
  "GENERIC MOTOR": [""],
  BELLIER: [""],
  TIANYING: [""],
  DAIMLER: ["DOUBLE SIX"],
  DONGFENG: [
    "MINI COMBI",
    "MINI CARGO",
    "MINI VAN",
    "DF 6",
    "SHINE",
    "MHERO 917",
    "MINI TRUCK",
    "BOX",
  ],
  XUAN: [""],
  FERRARI: [
    "458 SPIDER",
    "F12 BERLINETTA",
    "550",
    "275",
    "750",
    "ENZO FERRARI",
    "512",
    "MONDIAL",
    "F430",
    "360",
    "F355",
    "288",
    "365",
    "F8",
    "CALIFORNIA",
    "246",
    "DINO GT4",
    "400",
    "CALIFORNIA T",
    "ROMA",
    "SF90 SPIDER",
    "328",
    "GTC4LUSSO",
    "208",
    "FF",
    "F40",
    "SF90 STRADALE",
    "488 SPIDER",
    "DAYTONA",
    "599 GTB",
    "250",
    "330",
    "488 PISTA",
    "575",
    "456",
    "412",
    "612",
    "458",
    "LAFERRARI",
    "PORTOFINO",
    "TESTAROSSA",
    "F50",
    "458 SPECIALE",
    "F12",
    "SUPERAMERICA",
    "MONZA",
    "488 GTB",
    "812 GTS",
    "348",
    "458 ITALIA",
    "812 COMPETIZIONE",
    "308",
  ],
  POLARIS: [""],
  HURTAN: [""],
  VALENTI: [""],
  SAIC: [""],
  DRESEL: [""],
  TAOTAO: ["CY125T-3"],
  TAVRIA: [""],
  YIYING: ["BIAGINNI DRAGON", "BIAGINNI DIABLO", "50QT-6"],
  LIEBHERR: [""],
  FISKER: [""],
  HERO: ["AUTOMATIC", "GIZMO", "WINNER"],
  ANGELL: [""],
  KAZUMA: [""],
  XINGYUE: [""],
  ACCESS: [""],
  "MB UNIMOG": [""],
  HONKER: ["42", "54"],
  CCM: [""],
  KANGCHAO: [""],
  MCLOUIS: [""],
  "SUNNY-EBIKE": [""],
  VORTEX: [""],
  JINBAWANG: ["JBW 50QT"],
  HAILI: [""],
  RAG: ["GAZELLE (2705)", "GAZELLE (27057)", "GAZELLE AMC"],
  MALAGUTI: [
    "F10 JETLINE (FAST TIME)",
    "F10 JETLINE (WAP)",
    "F15 FIRE FOX",
    "F18 WARRIOR",
    "CENTRO SL",
    "SPIDERMAX",
    "XTM",
    "MADISON",
    "XSM",
    "PASSWORD",
    "F12 PHANTOM",
    "F12 PHANTOM MAX",
    "CIAK MASTER",
    "DRAKON",
    "CENTRO 125",
  ],
  PEGASUS: [""],
  TEM: [""],
  RAM: [""],
};
// Function to find city by postal code
export const findCityByPostalCode = (postalCode: string): string => {
  if (!postalCode || postalCode.length < 5) {
    console.log(`[CityLookup] Incomplete postal code: ${postalCode}`);
    return "";
  }

  // Normalize the postal code format - remove spaces and get only digits
  const normalizedPostalCode = postalCode.replace(/\D/g, "");
  console.log(`[CityLookup] Normalized postal code: ${normalizedPostalCode}`);

  // Check if we have exactly 5 digits
  if (normalizedPostalCode.length !== 5) {
    console.log(
      `[CityLookup] Invalid postal code length: ${normalizedPostalCode.length}`
    );
    return "";
  }

  // Check if the postal code exists in our zipToCityMap
  if (zipToCityMap[normalizedPostalCode]) {
    const cities = zipToCityMap[normalizedPostalCode];
    console.log(
      `[CityLookup] Found cities for postal code: ${JSON.stringify(cities)}`
    );

    // If multiple cities are associated with this postal code, take the first one
    const cityName = cities[0];
    console.log(`[CityLookup] Selected city name: ${cityName}`);

    // Common city mappings - expand this list as needed
    const cityMapping: Record<string, string> = {
      Praha: "PRAHA",
      Brno: "BRNO",
      Ostrava: "OSTRAVA",
      Plzeň: "PLZEN",
      Liberec: "LIBEREC",
      Olomouc: "OLOMOUC",
      "České Budějovice": "CESKE_BUDEJOVICE",
      "Hradec Králové": "HRADEC_KRALOVE",
      "Ústí nad Labem": "USTI_NAD_LABEM",
      Pardubice: "PARDUBICE",
      Zlín: "ZLIN",
      Havířov: "HAVIROV",
      Kladno: "KLADNO",
      Most: "MOST",
      Opava: "OPAVA",
      "Frýdek-Místek": "FRYDEK_MISTEK",
    };

    // Check if city is in our direct mapping
    if (cityMapping && cityMapping[cityName]) {
      console.log(
        `[CityLookup] Found in direct mapping: ${cityMapping[cityName]}`
      );
      return cityMapping[cityName] || "";
    }

    // First try to find an exact match by text
    let cityOption = cityOptions.find(
      (city) => city.text.toUpperCase() === cityName.toUpperCase()
    );

    if (cityOption) {
      console.log(`[CityLookup] Found exact match: ${cityOption.key}`);
      return cityOption.key;
    }

    // If no exact match found, try to find a city option where this city name is part of the city text
    cityOption = cityOptions.find((city) =>
      city.text.toUpperCase().includes(cityName.toUpperCase())
    );

    if (cityOption) {
      console.log(`[CityLookup] Found partial match: ${cityOption.key}`);
      return cityOption.key;
    }

    // Try the inverse - see if the zipToCityMap city contains any city option text
    // This handles cases where zipToCityMap has more specific names (e.g., "Praha 1" vs "Praha")
    cityOption = cityOptions.find(
      (city) =>
        cityName.toUpperCase().includes(city.text.toUpperCase()) &&
        city.text.length > 2 // Avoid matching short city names that could be part of many names
    );

    if (cityOption) {
      console.log(`[CityLookup] Found inverse match: ${cityOption.key}`);
      return cityOption.key;
    }

    // Nothing matched, log this for debugging
    console.log(`[CityLookup] No match found for city: ${cityName}`);
    return "";
  }

  // If nothing is found, return an empty string
  console.log(`[CityLookup] No postal code match found`);
  return "";
};

// Function to format postal code in the format XXXXX
export const formatPostalCode = (input: string): string => {
  if (!input) return "";

  // Remove all non-digits
  const digits = input.replace(/\D/g, "");

  // Format as XXXXX (without spaces) if there are 5 digits
  if (digits.length === 5) {
    return digits;
  }

  // Format as XXXXX if there are more than 5 digits, taking just the first 5
  if (digits.length > 5) {
    return digits.substring(0, 5);
  }

  // Return the input as is if it can't be formatted
  // (less than 5 digits, so the user might still be typing)
  return input;
};

// Convert zipToCityMap to options for Select component
export const postalCodeOptions = Object.keys(zipToCityMap).map(
  (postalCode) => ({
    key: postalCode,
    text: `${postalCode} - ${zipToCityMap[postalCode][0]}${
      zipToCityMap[postalCode].length > 1
        ? ` (+${zipToCityMap[postalCode].length - 1})`
        : ""
    }`,
  })
);

// Function to find postal codes by city
export const findPostalCodesByCity = (cityKey: string): string[] => {
  if (!cityKey) {
    console.log(`[PostalCodeLookup] Empty city key provided`);
    return [];
  }

  // First find the city text based on the key
  const cityOption = cityOptions.find((city) => city.key === cityKey);
  if (!cityOption) {
    console.log(`[PostalCodeLookup] No city found for key: ${cityKey}`);
    return [];
  }

  const cityName = cityOption.text;
  console.log(`[PostalCodeLookup] Looking up postal codes for: ${cityName}`);

  // Find all postal codes that have this city name in their array
  const matchingPostalCodes: string[] = [];

  Object.entries(zipToCityMap).forEach(([postalCode, cities]) => {
    // Check if any of the cities for this postal code match or include our target city name
    const cityMatch = cities.some(
      (city) =>
        // Check for direct match first
        city.toUpperCase() === cityName.toUpperCase() ||
        // Handle cases like "Praha" matching "Praha 1"
        (cityName.length > 2 &&
          city.toUpperCase().includes(cityName.toUpperCase()))
    );

    if (cityMatch) {
      matchingPostalCodes.push(postalCode);
    }
  });

  console.log(
    `[PostalCodeLookup] Found ${matchingPostalCodes.length} matching postal codes`
  );
  return matchingPostalCodes;
};

// Function to get city options for a given postal code
export const getCitiesByPostalCode = (postalCode: string): CityOption[] => {
  if (!postalCode || postalCode.length !== 5) {
    // If no valid postal code is provided, return all city options
    return cityOptions;
  }

  // Check if the postal code exists in our zipToCityMap
  if (!zipToCityMap[postalCode]) {
    console.log("[CityFilter] No cities found for postal code: ");
    return cityOptions;
  }

  // Get the city names for this postal code
  const cityNames = zipToCityMap[postalCode];
  console.log("[CityFilter] Cities for postal code: ");

  // Create a mapping from city name to city key
  const cityNameToKey: Record<string, string> = {};
  cityOptions.forEach((city) => {
    cityNameToKey[city.text.toUpperCase()] = city.key;
  });

  // Filter city options to only include those that match our postal code
  const filteredCityOptions: CityOption[] = [];

  // Always include the empty option
  const firstOption = cityOptions[0];
  if (firstOption) {
    filteredCityOptions.push(firstOption);
  }

  cityNames.forEach((cityName) => {
    // Try to find an exact match
    let foundMatch = false;

    // First check the direct mapping
    for (const city of cityOptions) {
      if (city.text.toUpperCase() === cityName.toUpperCase()) {
        filteredCityOptions.push(city);
        foundMatch = true;
        break;
      }
    }

    // If no exact match, try to find by inclusion
    if (!foundMatch) {
      for (const city of cityOptions) {
        if (
          (city.text.length > 2 &&
            cityName.toUpperCase().includes(city.text.toUpperCase())) ||
          (cityName.length > 2 &&
            city.text.toUpperCase().includes(cityName.toUpperCase()))
        ) {
          filteredCityOptions.push(city);
          foundMatch = true;
          break;
        }
      }
    }
  });

  console.log("[CityFilter] Filtered to city options");

  // If we didn't find any matches, return all options to avoid empty dropdown
  return filteredCityOptions.length > 1 ? filteredCityOptions : cityOptions;
};
